<template>
    <div
        :class="[
            WIDGET.class,
            {
                'widget-hidden': WIDGET.hidden,
                'widget-visible': !WIDGET.hidden,
                'widget-reveal-pending': WIDGET._revealPending,
                'widget-first-loading': WIDGET.firstBackendCheck || WIDGET._firstLoading || WIDGET._gridTitlesPending > 0,
                'widget-restoring': WIDGET._restoring,
                'widget-inline': !['dock', 'popout'].includes(WIDGET.styleWidget?.dock),
                'widget-pop-out': WIDGET.styleWidget?.dock === 'popout',
                // R10: docked-виджет невидим, пока раскладка не выдала ему px
                // (calculateWidget_px → _placed) — не мелькает неспозиционированным
                // в потоке; страховка снимает флаг через 1.5с (mounted).
                // Popout: то же до применения pct-ректа (checkPopout сбрасывает
                // setWidgetRect и ставит _placed) — иначе первый кадр окна
                // рисуется у левого-верха минимальным (первое открытие страницы,
                // геометрия ещё не посчитана)
                'widget-unplaced': (WIDGET.styleWidget?.dock === 'dock' && !WIDGET._placed
                        || WIDGET.styleWidget?.dock === 'popout' && !!WIDGET.styleWidget?.setWidgetRect && !WIDGET._placed)
                    && store.fastEntry?.geomPresets !== false,
                'drag-source': WIDGET.isDragging,
                'drag-over': WIDGET.isDragOver,
                // IE 2026 08 20 / ODOO-336291 (mobile UX) (замечание Игоря): панель команд грида
                // на телефоне скрыта и раскрывается листом по боковой кнопке
                'mobile-bar-open': mobileBarOpen,
                'mobile-tabs-open': mobileTabsOpen,
                'chart-axes-on': chartAxesOn,
                'grid-heads-on': gridHeadsOn,

                'widget-hide-header':    !WIDGET.styleWidget.minMode && !!WIDGET.styleWidget.hideHeader    && !WIDGET.styleWidget.show_hidden,
                'widget-hide-tabs':      !WIDGET.styleWidget.minMode && !!WIDGET.styleWidget.hideTabs      && !WIDGET.styleWidget.show_hidden,
                'widget-hide-gridpanel': !WIDGET.styleWidget.minMode && !!WIDGET.styleWidget.hideGridPanel && !WIDGET.styleWidget.show_hidden,

                'widget-hide-header0':    !WIDGET.styleWidget.minMode && !!WIDGET.styleWidget.hideHeader,
                'widget-hide-tabs0':      !WIDGET.styleWidget.minMode && !!WIDGET.styleWidget.hideTabs,
                'widget-hide-gridpanel0': !WIDGET.styleWidget.minMode && !!WIDGET.styleWidget.hideGridPanel,

                'widget-cellview-wait': !!WIDGET._cellViewWait,   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2): ждём данные вида ячеек — грид приглушён, карточка поверх
                'widget-geomap': !!WIDGET._geomap,   // IE 2026 09 14 / ODOO-… (замечание Игоря: карта — одно значение, островки): виджет с картой
                // IE 2026 09 14 / ODOO-… (замечание Игоря: парящий заголовок): универсальный режим островков (кнопка Float в hover-форме; у карты без полосы табов — по умолчанию)
                'widget-float-header':  !WIDGET.styleWidget.minMode && floatHeaderOn,
                'widget-float-header0': floatHeaderOn,
                'widget-viz-tab': vizTab,   // IE 2026 09 15 (замечание Игоря, вечер): список на вкладке визуализации — без кнопок шапки, островок легенды наверху
                'widget-float-pad': floatPad,   // IE 2026 09 14 / ODOO-… (замечание Игоря: Float — кнопки содержимого ниже островков)
                'widget-border-active': isActiveWidget && !isOnlyWidgetOnPage,
                'widget-mobile-max': !!WIDGET.styleWidget?._mobileMax, // IE 2026 08 20 / ODOO-336291 (mobile UX)
                // IE 2026 08 20 / ODOO-336291 (mobile UX) (заказ Игоря): кнопки шапки общие на экран — видимы только у активного
                'widget-mob-active': store.mobileUi?.on && isActiveWidget,
                'mob-title-inset': mobTitleInset, // IE 2026 08 23: отступ заголовка от левых кнопок
                'mob-only-widget': mobOnlyCardFull, // IE 2026 08 23: один виджет страницы — на весь экран
                'widget-mobile-full': store.mobileUi?.on && !!WIDGET.styleWidget?._mobileFull, // IE 2026 08 20 / ODOO-336291 (mobile UX)
            },
        ]"
        :style="WIDGET.style"

        @dragover="dragOver($event)"
        @dragleave="dragLeave($event)"
        @drop="dragDrop($event)"
        @dragend="dragEnd($event)"

        @focusin="onFocusIn($event)"
        @pointerdown.capture="topLeftArm_guard($event); markFocusIntent($event); popoutHeaderTouchDown($event)   /* IE 2026 10 25 / ODOO-345044 (hotfix: ✕ под курсором после ховера угла): взвод формы угла ⋯ */"
        @mousedown.capture="topLeftArm_guard($event)   /* IE 2026 10 25 / ODOO-345044 (hotfix: ✕ под курсором после ховера угла) */"
        @mouseup.capture="topLeftArm_guard($event)   /* IE 2026 10 25 / ODOO-345044 (hotfix: ✕ под курсором после ховера угла) */"
        @keydown.capture="markFocusIntent"
        @click.capture="topLeftArm_guard($event); popoutSuppressedClick($event)   /* IE 2026 10 25 / ODOO-345044 (hotfix: ✕ под курсором после ховера угла) */"
        @click="clickWidget($event)"
        @mouseenter="stopClear_measure()   /* IE 2026 09 28 / ODOO-341407 (находка ie-demo7 §16.1): наведение — перемер места Stop до того, как проявится панель кнопок */"
  
    >
        <div
            class="popout-grab-top"
            v-uiHelp="{ key: 'widget.header.strip', state: () => (WIDGET.styleWidget?.dock === 'popout' ? 'free' : 'docked'), after: tooltip_tail }"
            @dblclick.stop.prevent="dblclick_popout"
            @contextmenu="store.setting('fe.ux.widgetHeaderContextMenu', true) !== false && hdrContextMenu($event)   /* IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета): полоса над шапкой — правая кнопка тоже форма угла */"
            @touchend="mobileHeaderTouchTap"
            @mousemove="titleTail_move($event)   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок — «…» и продолжение по наведению, как в ячейках): полоса лежит поверх шапки — наведение на заголовок приходит сюда */"
            @mouseleave="titleTail_leave($event)"
            @mousedown="titleTail_hide()"
            @click="kindIcon_clickAt($event)   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета): клик по месту иконки вида под полосой-захватом — панель Settings | Variants */"
            @mouseenter="kindIcon_place()   /* IE 2026 11 02 / ODOO-350449 (заказ Игоря: p216 бейдж виду віджета — тиха іконка, плашка при наведенні): полоса-захват лежит поверх шапки — наведение на шапку приходит сюда */"

            draggable="true"
            @dragstart="dragStart($event)"
            
            @pointerdown.stop="popoutPointerDown($event, 'move')"
        ></div>

        <div v-if="WIDGET.styleWidget?.dock === 'popout'" class="popout-grab-zone">
            <div class="resize-handle h-n" v-uiHelp="'widget.resize.free'"  @pointerdown.stop="popoutDragStart($event, 'top')"></div>
            <div class="resize-handle h-s" v-uiHelp="'widget.resize.free'"  @pointerdown.stop="popoutDragStart($event, 'bottom')"></div>
            <div class="resize-handle h-e" v-uiHelp="'widget.resize.free'"  @pointerdown.stop="popoutDragStart($event, 'right')"></div>
            <div class="resize-handle h-w" v-uiHelp="'widget.resize.free'"  @pointerdown.stop="popoutDragStart($event, 'left')"></div>
            <div class="resize-handle h-ne" v-uiHelp="'widget.resize.free'" @pointerdown.stop="popoutDragStart($event, 'top-right')"></div>
            <div class="resize-handle h-nw" v-uiHelp="'widget.resize.free'" @pointerdown.stop="popoutDragStart($event, 'top-left')"></div>
            <div class="resize-handle h-se" v-uiHelp="'widget.resize.free'" @pointerdown.stop="popoutDragStart($event, 'bottom-right')"></div>
            <div class="resize-handle h-sw" v-uiHelp="'widget.resize.free'" @pointerdown.stop="popoutDragStart($event, 'bottom-left')"></div>
        </div>

        <!-- ресайз docked-виджета за край, результат в текущий layout (ит.3 п.3.4) -->
        <div v-if="WIDGET.styleWidget?.dock === 'dock'" class="dock-resize-zone">
            <div class="resize-handle h-s" v-uiHelp="'widget.resize.dock'"  @pointerdown.stop="dockResizeStart($event, 'bottom')"></div>
            <div class="resize-handle h-e" v-uiHelp="'widget.resize.dock'"  @pointerdown.stop="dockResizeStart($event, 'right')"></div>
            <div class="resize-handle h-se" v-uiHelp="'widget.resize.dock'" @pointerdown.stop="dockResizeStart($event, 'bottom-right')"></div>
        </div>

        <!-- IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2): карточка ожидания данных вида ячеек (mainStore.cellView_requestNow) / «частково» (ответ partial); клики и прокрутка проходят сквозь -->
        <div v-if="WIDGET._cellViewWait || WIDGET._cellViewNote" class="cellview-wait-card" :class="{ 'cellview-note': !WIDGET._cellViewWait }">
            <i v-if="WIDGET._cellViewWait" class="pi pi-spin pi-spinner"></i>{{ cellViewWait_text }}</div>

        <!-- @mouseleave="forceCloseTopLeft"
        @blur.capture="forceCloseTopLeft"
        tabindex="-1" -->
        <!-- IE 2026 09 07 / ODOO-337259: подсказка виджета «ленивая» — контент при показе (Alt / Show tooltips) -->
        <div
            :class="{
                'widget-container': true,
                'widget-loading-OLD': delayedLoading,
                'widget-active': isActiveWidget && !isOnlyWidgetOnPage,
                'widget-container-inactive': !isActiveWidget && isMainArea,
                'widget-stop-clear': stopClearMax != null,   // IE 2026 09 28 / ODOO-341407 (находка ie-demo7 §16.1): Stop — левее панели кнопок, показанной по наведению (stopClear_measure)
                'hdr-spacing': hdrSpacing_on(),   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p220/p221/p222 шапка віджета: p220 — равные отступы край → иконка вида → текст заголовка)
            }"
            v-wjContextMenu="'ContextWidgetMenuId'"
            v-wjTooltipFn="tooltip"
            @contextmenu="hdrContextMenu"
            @mouseenter="kindIcon_place"
        ><!-- IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка мыши — форма ячейки / строки / меню виджета): правая кнопка по шапке виджета — панель ≡ (hdrContextMenu) -->
            <!-- IE 2026 08 20 / ODOO-336291 (mobile UX) (замечание Игоря): на телефоне подменю виджета
                 открывает ЯВНАЯ кнопка в левом верхнем углу, а не пунктирная «змейка»
                 (.resizer-top-left) — её на телефоне не видно -->
            <!-- IE 2026 08 20 / ODOO-336291 (mobile UX) (#4189): угловые кнопки — телепорт в body: fixed внутри
                 stacking context виджета перекрывался свободными (popout) виджетами -->
            <!-- IE 2026 09 23 / ODOO-341407: i18n — corner buttons, tabs sheet -->
            <teleport to="body" v-if="store.mobileUi?.on && isActiveWidget">
                <!-- IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: закрытие виджета — первой кнопкой -->
                <div class="widget-corner-btn widget-close-btn" :title="t('Close widget')"
                    v-uiHelp="'widget.mobile.close'"
                    @click.stop.prevent="mobileCloseWidget"><i class="pi pi-times"></i></div>
                <div class="widget-corner-btn widget-bar-btn"
                    v-if="!store.mobileUi?.railOpen && !store.mobileUi?.widgetsOpen"
                    :class="{ 'widget-corner-btn-open': mobileTabsOpen }" :title="t('Widget tabs')"
                    v-uiHelp="'widget.mobile.tabs'"
                    @click.stop.prevent="toggleMobileTabs"><i class="pi" :class="mobileTabsOpen ? 'pi-times' : 'pi-bookmark'"></i></div>
                <!-- IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: одна кнопка «доп. элементы
                     визуализации»: у грида — номера строк/колонок (через wijmo, место
                     освобождается), у графика — оси и легенда -->
                <div class="widget-corner-btn viz-extras-btn" v-if="mobileVizMode"
                    :class="{ 'widget-corner-btn-open': mobileVizMode === 'chart' ? chartAxesOn : gridHeadsOn }"
                    :title="mobileVizMode === 'chart' ? t('Chart axes and legend') : t('Row and column numbers')"
                    v-uiHelp="{ key: 'widget.mobile.vizExtras', state: () => ((mobileVizMode === 'chart' ? chartAxesOn : gridHeadsOn) ? 'on' : 'off') }"
                    @click.stop.prevent="mobileVizToggle"><i class="pi" :class="mobileVizMode === 'chart' ? 'pi-chart-line' : 'pi-hashtag'"></i></div>
                <!-- IE 2026 09 04 / ODOO-336291 (mobile UX): B-41 — лист серий графика (мобильная легенда со строками 44 px
                     вместо SVG-текста 13-102x14 px). Выкл: window.mobileUi.set('chartLegendSheet', false) -->
                <div class="widget-corner-btn chart-series-btn"
                    v-if="mobileVizMode === 'chart' && store.mobileUi?.chartLegendSheet !== false"
                    :title="t('Chart series')" v-uiHelp="'widget.mobile.chartSeries'" @click.stop.prevent="mobileChartSeries"><i class="pi pi-list"></i></div>
                <!-- IE 2026 09 04 / ODOO-336291 (mobile UX): B-04 — тоггл методом (замер P-31 + закрытие тапом снаружи) -->
                <!-- IE 2026 09 04 / ODOO-336291 (mobile UX): B-33 — кнопка только при непустой панели команд грида (mobileBarRefresh) -->
                <div class="widget-corner-btn widget-panelbar-btn" v-if="mobileBarAvail"
                    :class="{ 'widget-corner-btn-open': mobileBarOpen }" :title="t('Grid command panel')"
                    v-uiHelp="{ key: 'widget.mobile.gridPanel', state: () => (mobileBarOpen ? 'on' : 'off') }"
                    @click.stop.prevent="toggleMobileBar"><i class="pi pi-sliders-h"></i></div>
                <div class="widget-corner-btn widget-max-btn" v-if="!isOnlyWidgetOnPage"
                    :class="{ 'widget-corner-btn-open': WIDGET.styleWidget?._mobileMax }"
                    :title="WIDGET.styleWidget?._mobileMax ? t('Restore size') : t('Maximize')"
                    v-uiHelp="{ key: 'widget.mobile.max', state: () => (WIDGET.styleWidget?._mobileMax ? 'on' : 'off') }"
                    @click.stop.prevent="mobileToggleMax"><i class="pi"
                        :class="WIDGET.styleWidget?._mobileMax ? 'pi-window-minimize' : 'pi-window-maximize'"></i></div>
                <div class="widget-corner-btn widget-nav-prev" v-if="!isOnlyWidgetOnPage"
                    :title="t('Previous widget')" v-uiHelp="'widget.mobile.prev'" @click.stop.prevent="mobileNavWidget(-1)"><i class="pi pi-chevron-left"></i></div>
                <div class="widget-corner-btn widget-nav-next" v-if="!isOnlyWidgetOnPage"
                    :title="t('Next widget')" v-uiHelp="'widget.mobile.next'" @click.stop.prevent="mobileNavWidget(1)"><i class="pi pi-chevron-right"></i></div>
                <!-- IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: Cell menu — только при активной
                     ячейке с dropdown; ниже — открытие ссылки/документа из ячейки (Alt+клик) -->
                <div class="widget-corner-btn cell-dropdown-btn" :title="t('Cell menu')"
                    v-if="store.mobileCell?.wid === WIDGET.id && store.mobileCell?.isRef"
                    v-uiHelp="'widget.mobile.cellMenu'"
                    :class="{ 'widget-corner-btn-open': store.dropdown?.visible }"
                    @click.stop.prevent="store.dropdown?.visible ? store.dropdown.hide() : store.mobileCellDropdownTick++"><i class="pi pi-caret-right"></i></div>
                <div class="widget-corner-btn cell-open-btn" :title="t('Open from cell')"
                    v-if="store.mobileCell?.wid === WIDGET.id && store.mobileCell?.canOpen"
                    v-uiHelp="'widget.mobile.cellOpen'"
                    @click.stop.prevent="store.mobileCellOpenTick++"><i class="pi pi-arrow-up-right"></i></div>
                <div class="widget-corner-btn widget-dots-btn" :title="t('Widget commands')"
                    :class="{ 'widget-corner-btn-open': show_commandPanel_topLeft }"
                    v-uiHelp="'widget.mobile.commands'"
                    @click.stop.prevent="onTopLeftCornerTap"><i class="pi pi-ellipsis-h"></i></div>
            </teleport>
            <!-- IE 2026 08 20 / ODOO-336291 (mobile UX) (#4188): табы — рейл-меню в стиле списков страниц/виджетов -->
            <teleport to="body" v-if="store.mobileUi?.on && mobileTabsOpen">
                <div class="mobile-tabs-backdrop" @click.stop="mobileTabsOpen = false"></div>
                <div class="mobile-tabs-list" @click.stop v-uiHelp="'widget.mobile.tabsSheet'">
                    <!-- IE 2026 08 22 (заказ Игоря): заголовок списка -->
                    <div class="mobile-list-title">{{ t('Widget tabs') }}</div>
                    <!-- IE 2026 09 23 / ODOO-341407: i18n (loop variable t → mt: t is the dictionary function) -->
                    <div v-for="(mt, i) in mobileTabsList" :key="i" class="mobile-tabs-row mm-row"
                        :class="{ 'mt-active': mt.active, 'mt-sub': mt.sub }" @click.stop="mobileTabTap(i)">
                        <a class="mt-icon"><i :class="mt.icon || 'pi pi-folder'"></i></a>
                        <span class="mt-label">{{ mt.title || t('Tab {n}', { n: i + 1 }) }}</span>
                        <!-- IE 2026 08 23 (скрин Игоря 10:43): таб с подтабами — как папка меню -->
                        <i v-if="mt.hasSub" class="pi mm-chev" :class="mt.active ? 'pi-angle-down' : 'pi-angle-right'"></i>
                    </div>
                </div>
            </teleport>
            <div ref="commandPanel" @click.capture="onTopLeftTapCapture">
                <component
                    v-for="attrM in commandPanelLeft"
                    :key="attrM"
                    :widget_id="widget_id" 
                    :is="attrM.component"
                    :attr_id="attrM.id"
                    :initialAttr="attrM" 
                    @mouseenter="onShow_commandPanel_topLeft"
                    @mouseleave="onClose_commandPanel_topLeft"
                />
            </div>

            <Button
                v-if="navRecord.show && !WIDGET.styleWidget.minMode"
                :style="{ visibility: navRecord.canPrev ? 'visible' : 'hidden' }"
                class="commandPanel-buttons p-button-sm p-button-no-border p-2 pl-4 mr-1 pi p-button-white pi-chevron-left"
                :title="t('Previous (Alt ←)')"
                v-uiHelp="{ key: 'widget.header.nav.prev', state: () => (navRecord.canPrev ? 'available' : 'end') }"
                @click.stop="store.executeStoreMethod(WIDGET.vueObj, { command: 'navigate_record', direction: 'prev' })"
            />
            <Button
                v-if="navRecord.show && !WIDGET.styleWidget.minMode"
                :style="{ visibility: navRecord.canNext ? 'visible' : 'hidden' }"
                class="commandPanel-buttons p-button-sm p-button-no-border p-2 mr-1 pi p-button-white pi-chevron-right"
                :title="t('Next (Alt →)')"
                v-uiHelp="{ key: 'widget.header.nav.next', state: () => (navRecord.canNext ? 'available' : 'end') }"
                @click.stop="store.executeStoreMethod(WIDGET.vueObj, { command: 'navigate_record', direction: 'next' })"
            />

            <!-- IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита) -->
            <!-- форма «Audit restore»: бейдж числа изменений против следующей (по умолчанию) / предыдущей версии, поповер, меню режимов -->
            <span v-if="adf_badge" class="cow-badge adf-badge" :class="'adf-badge-' + adf_badge.kind"
                v-uiHelp="{ key: 'widget.header.auditDiff', state: () => adf_badge?.kind }"
                @mouseenter="adfHover_show" @mouseleave="adfHover_hide" @click.stop="adfHover = !adfHover">
                <i class="pi pi-arrow-right-arrow-left"></i>{{ adf_badge.label }}
                <div class="cow-pop adf-pop" v-if="adfHover || adfPinned" @mouseenter="adfHover_show" @mouseleave="adfHover_hide" @click.stop>
                    <div class="cow-pop-title">{{ adf_badge.text }}<i v-if="adfPinned" class="pi pi-times adf-pop-close" :title="t('Close')" @click.stop="adfPinned = false; adfHover = false"></i></div>
                    <div class="cow-pop-row" v-if="adf_otherInfo">{{ adf_otherInfo }}</div>
                    <div class="cow-pop-row" v-if="adf_block && adf_block.text">{{ adf_block.text }}</div>
                    <div class="cow-pop-row adf-mode" v-if="adf_beMenu">{{ t('Show') }}: {{ (adf_viewItems.find(m => m.id === adf_view) || {}).title }} · {{ t('Compare with') }}: {{ (adf_againstItems.find(m => m.id === adf_against) || {}).title }}</div>
                    <div class="cow-pop-row cow-delta cow-delta-negative" v-if="adf_badge.note">{{ adf_badge.note }}</div>
                    <div class="cow-pop-row cow-delta cow-delta-negative" v-if="adf_block && adf_block._adfFailed && adf_block.reason">{{ adf_block.reason }}</div>
                    <div class="cow-pop-actions" v-if="adf_badge.calc">
                        <button class="cow-btn cow-btn-white" v-uiHelp="'widget.header.auditDiff.calc'" @click.stop="auditDiff_calc(adf_against)"><i class="pi pi-refresh"></i><span>{{ t('Calculate') }}</span></button>
                    </div>
                    <div class="cow-pop-row cow-delta adf-not-shown" v-if="adf_nav.hidden">{{ adf_notShown(adf_nav.hidden, adf_nav.total) }}</div>   <!-- IE 2026 10 31 / ODOO-349799: цели вне формы (viewParams, order…) -->
                    <div class="cow-pop-actions" v-if="adf_targets.length">
                        <template v-if="adf_nav.targets.length">   <!-- IE 2026 10 31 / ODOO-349799: счётчик — по достижимым целям -->
                        <button class="cow-btn cow-btn-white" :title="t('Previous change')" v-uiHelp="'widget.header.auditDiff.nav'" @click.stop="auditDiff_nav(-1)"><i class="pi pi-chevron-left"></i></button>
                        <span class="adf-nav-pos">{{ adfNavPos >= 0 ? adfNavPos + 1 : '–' }} / {{ adf_nav.targets.length }}</span>
                        <button class="cow-btn cow-btn-white" :title="t('Next change')" v-uiHelp="'widget.header.auditDiff.nav'" @click.stop="auditDiff_nav(1)"><i class="pi pi-chevron-right"></i></button>
                        </template>
                        <button v-if="adf_block && adf_block.open_action" class="cow-btn cow-btn-white" v-uiHelp="'widget.header.auditDiff.open'" @click.stop="auditDiff_openOther">
                            <i class="pi pi-external-link"></i><span>{{ adf_against === 'next' ? t('Open next version') : t('Open previous version') }}</span></button>
                    </div>
                    <table class="adf-list" v-if="adf_view === 'full' && adf_entries.length">
                        <tr><th>{{ t('Field') }}</th><th>{{ adf_against === 'next' ? t('This version') : t('Previous version') }}</th><th>{{ adf_against === 'next' ? t('Next version') : t('This version') }}</th></tr>
                        <tr v-for="(e, i) in adf_entries" :key="i" :class="{ 'adf-list-go': !!e.target }" @click.stop="e.target && auditDiff_goto(e.target)">
                            <td>{{ e.label }}</td>
                            <td>{{ adf_against === 'next' ? e.cur : e.other }}</td>
                            <td>{{ adf_against === 'next' ? e.other : e.cur }}</td>
                        </tr>
                    </table>
                </div>
            </span>
            <span v-if="adf_badge && !adf_beMenu" class="cow-badge adf-menu-btn"
                v-uiHelp="{ key: 'widget.header.auditDiff.menu', state: () => adf_view }"
                @mouseenter="adfMenu_show" @mouseleave="adfMenu_hide" @click.stop="adfMenu = !adfMenu">
                <i class="pi pi-arrow-right-arrow-left"></i><i class="pi pi-angle-down"></i>
                <div class="cow-pop adf-menu" v-if="adfMenu" @mouseenter="adfMenu_show" @mouseleave="adfMenu_hide" @click.stop>
                    <div class="adf-menu-cap">{{ t('Show') }}</div>
                    <div v-for="m in adf_viewItems" :key="m.id" class="adf-menu-item" :class="{ 'adf-on': adf_view === m.id }" @click.stop="auditDiff_setView(m.id)">
                        <i class="pi" :class="adf_view === m.id ? 'pi-check' : m.icon"></i>{{ m.title }}</div>
                    <div class="adf-menu-cap">{{ t('Compare with') }}</div>
                    <div v-for="m in adf_againstItems" :key="m.id" class="adf-menu-item" :class="{ 'adf-on': adf_against === m.id }" @click.stop="auditDiff_setAgainst(m.id)">
                        <i class="pi" :class="adf_against === m.id ? 'pi-check' : 'pi-circle'"></i>{{ m.title }}</div>
                </div>
            </span>
            <!-- IE 2026 08 23 / ODOO-5884 (заказ Игоря): бейдж COW-копии / рабочей версии записи под веткой -->
            <!-- IE 2026 09 23 / ODOO-341407: i18n — COW badge, Reference view badge, DS | MV switch -->
            <span v-if="WIDGET.cow && (WIDGET.cow.mode === 'copy' || WIDGET.cow.mode === 'working')"
                class="cow-badge" :class="'cow-badge-' + WIDGET.cow.mode"
                v-uiHelp="{ key: 'widget.header.cow', state: () => WIDGET.cow?.mode }"
                @mouseenter="cowHover_show" @mouseleave="cowHover_hide" @click.stop="cowHover = !cowHover">
                <i class="pi" :class="WIDGET.cow.mode === 'copy' ? 'pi-clone' : 'pi-lock'"></i>
                {{ WIDGET.cow.mode === 'copy' ? t('Branch copy') : t('Working version') }}
                <div class="cow-pop" v-if="cowHover" @mouseenter="cowHover_keep" @mouseleave="cowHover_hide" @click.stop>
                    <div class="cow-pop-title" v-if="WIDGET.cow.mode === 'copy'">{{ t('Branch copy') }} — <b>{{ WIDGET.cow.branch_title || WIDGET.cow.branch }}</b></div>
                    <div class="cow-pop-title" v-else v-html="t('Working version (read-only) — branch {branch} has its own branch copy', { branch: '<b>' + store.escapeHtml(WIDGET.cow.branch_title || WIDGET.cow.branch || '') + '</b>' })"></div><!-- IE 2026 09 23 / ODOO-341407: ревью i18n — теги вне ключа -->
                    <div class="cow-pop-row">{{ t('This record') }}: <b>{{ WIDGET.cow.updated_at }}</b> {{ WIDGET.cow.updated_by }}</div>
                    <div class="cow-pop-row" v-if="WIDGET.cow.other_missing">{{ WIDGET.cow.mode === 'copy' ? t('Working version not found') : t('Branch copy not found') }}</div>
                    <div class="cow-pop-row" v-else>{{ WIDGET.cow.mode === 'copy' ? t('Working version') : t('Branch copy') }}: <b>{{ WIDGET.cow.other_updated_at }}</b> {{ WIDGET.cow.other_updated_by }}</div>
                    <div class="cow-pop-row cow-delta" v-if="WIDGET.cow.delta_text" :class="'cow-delta-' + WIDGET.cow.delta_sign">
                        <i class="pi" :class="WIDGET.cow.delta_sign === 'negative' ? 'pi-exclamation-triangle' : 'pi-check-circle'"></i>
                        {{ WIDGET.cow.delta_sign === 'negative' ? t('Working version changed {delta} AFTER the branch copy', { delta: WIDGET.cow.delta_text }) : t('Branch copy is {delta} newer than the working version', { delta: WIDGET.cow.delta_text }) }}
                    </div>
                    <div class="cow-pop-row" v-if="WIDGET.cow.changed_fields && WIDGET.cow.changed_fields.length">{{ t('Differs in') }}: {{ WIDGET.cow.changed_fields.join(', ') }}</div>
                    <div class="cow-pop-row" v-else-if="WIDGET.cow.changed_fields">{{ t('No differences in doc') }}</div>
                    <!-- IE 2026 08 23 / ODOO-5884 (заказ Игоря): кнопки без p-button (ховер-эффекты темы «мелькали»), отступ иконка/текст;
                         «Record versions» — список всех слоёв записи (рабочая версия, копии веток) -->
                    <div class="cow-pop-actions">
                        <button v-if="WIDGET.cow.mode === 'copy'" class="cow-btn cow-btn-white" @click.stop="cow_action('cow_open_working')" :title="t('Open the working version in a separate widget (read-only)')" v-uiHelp="'widget.header.cow.openWorking'"><i class="pi pi-external-link"></i><span>{{ t('Open working version') }}</span></button>
                        <button class="cow-btn cow-btn-white" @click.stop="cow_open_versions" :title="t('All versions of this record: working version, What-if branch copies — open a row to view the record under that version')" v-uiHelp="'widget.header.cow.versions'"><i class="pi pi-clone"></i><span>{{ t('Record versions') }}</span></button>
                        <!-- IE 2026 08 25 / ODOO-5884 (заказ Игоря): применить правки копии в рабочую (родительскую) версию —
                             после этого копия снимается и бейдж пропадает: запись равна рабочей версии -->
                        <button v-if="WIDGET.cow.mode === 'copy'" class="cow-btn cow-btn-apply" @click.stop="cow_action('cow_apply', t('Write these changes into the working version and remove the branch copy? They will be visible outside the branch.'))" :title="t('Write these changes into the working (parent) version and remove the branch copy')" v-uiHelp="'widget.header.cow.apply'"><i class="pi pi-verified"></i><span>{{ t('Apply to working version') }}</span></button>
                        <button v-if="WIDGET.cow.mode === 'copy'" class="cow-btn cow-btn-danger" @click.stop="cow_action('cow_delete', true)" :title="t('Remove this branch copy and show the working version')" v-uiHelp="'widget.header.cow.remove'"><i class="pi pi-undo"></i><span>{{ t('Remove branch copy') }}</span></button>
                    </div>
                </div>
            </span>
            <!-- IE 2026 08 28 / ODOO-5800 (заказ Игоря): бейдж копии, открытой из теста данных (params.compare_reference) -->
            <span v-if="refBadge_test" class="cow-badge cow-badge-refview"
                v-uiHelp="'widget.header.reference'"
                @mouseenter="refHover_show" @mouseleave="refHover_hide" @click.stop="refHover = !refHover">
                <i class="pi pi-check-square"></i>
                {{ t('Reference view') }}
                <div class="cow-pop" v-if="refHover" @mouseenter="refHover_keep" @mouseleave="refHover_hide" @click.stop>
                    <div class="cow-pop-title">{{ t('Reference result as saved — data test') }}</div>
                    <div class="cow-pop-row"><a class="ref-badge-link" :title="t('Open the data test record')" v-uiHelp="'widget.header.reference.open'" @click.stop="refBadge_openTest">{{ refBadge_info.test_title || refBadge_test }}</a></div>
                    <div class="cow-pop-row" v-if="refBadge_info.saved_at">{{ t('Reference saved') }}: <b>{{ refBadge_info.saved_at }}</b></div>
                    <div class="cow-pop-row" v-if="refBadge_info.count != null">{{ t('Reference result') }}: <b>{{ refBadge_info.count }}</b> {{ tn(refBadge_info.count, 'row', 'rows') }}<template v-if="refBadge_info.duration != null">, {{ refBadge_info.duration }} {{ t('s', null, 'seconds') }}</template><template v-if="refBadge_info.size_text">, {{ refBadge_info.size_text }}</template></div>
                    <div class="cow-pop-row" v-if="refBadge_info.chips_text">{{ t('Chips') }}: {{ refBadge_info.chips_text }}</div>
                    <div class="cow-pop-row" v-if="refBadge_info.workspace">{{ t('Workspace') }}: {{ refBadge_info.workspace }}<template v-if="refBadge_info.process_model"> · {{ t('Process model') }}: {{ refBadge_info.process_model }}</template></div>
                    <div class="cow-pop-actions">
                        <button class="cow-btn cow-btn-white" @click.stop="refBadge_openTest" :title="t('Open the data test record')" v-uiHelp="'widget.header.reference.open'"><i class="pi pi-external-link"></i>{{ t('Open data test') }}</button>
                    </div>
                </div>
            </span>
            <!-- IE 2026 09 08 / ODOO-335246 (Igor): у записи DATA-SOURCE вместо бейджа сегмента — тумблер DS | MV (режим запроса:
                 doc.params.mv_create); переключение зовёт mv_switch бэка (флаг, префикс заголовка, Selection по умолчанию), в базу не пишет -->
            <!-- IE 2026 09 23 / ODOO-… (замечание Игоря: в форме ⋯ — те же элементы шапки): при скрытой шапке и открытой форме «⋯» бейдж сегмента и поле заголовка переезжают в её первый ряд ТЕЛЕПОРТОМ —
                 те же DOM-узлы, тот же дропдаун Settings | Variants, та же правка заголовка; копии больше нет (identInForm / identTo — см. identWant,
                 цель — слот .widget-topleft-ident в форме; телепорт включается после отрисовки формы, id слота новый на каждое открытие) -->
            <!-- IE 2026 11 02 / ODOO-350449 (заказ Игоря: p216 бейдж виду віджета — тиха іконка, плашка при наведенні) -->
            <!-- в покое — одна контурная иконка вида (якорь в потоке, ширина постоянная); прежняя плашка лежит поверх якоря (absolute) и видна при наведении на шапку -->
            <!-- IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета) (поправка Игоря 03.11 «вместо А1»): при fe.ux.kindBadgeOpaque (вкл.) плашка вида по наведению не показывается — только иконка; имя сегмента / варианта — по Alt
                 над иконкой (vars name / variant, обычное наведение ничего не показывает — без title); клик по иконке — панель Settings | Variants (kindIcon_clickAt; у docked-виджета
                 иконку накрывает полоса-захват — её клик проверяется по координатам иконки) -->
            <span v-if="kindIcon_on()" ref="kindIco" :class="['kind-badge-ico', 'kind-badge-ico-' + kindIcon_tone(), { 'kind-badge-ico-dirty': cascadeInd.on && cascadeInd.dirty, 'kind-badge-ico-click': kindChip_on() && dropdownApplies }]"
                :title="kindChip_on() ? null : WIDGET.shortTitle" v-uiHelp="{ key: 'widget.header.kindIcon', vars: () => ({ name: WIDGET.shortTitle || '', variant: WIDGET.variant_label ? (WIDGET.variant_main?.title || WIDGET.variant_label) : '', quiet: kindChip_on(), click: kindChip_on() && dropdownApplies }) }"
                @click="kindIcon_clickAt($event)"><i :class="headerChip_pi"></i></span>
            <teleport :to="identTo" :disabled="!identInForm">
            <span class="segment-title pi-header pi-1 segment-mode" v-if="WIDGET.shortTitle && isDataSourceRecord"
                :style="[WIDGET.styleWidget.minMode ? 'pointer-events:none;' : '']"
                :title="t('Query mode: DS — plain query, MV — materialized view (Query is the view body, Selection selects from it)')"
                v-uiHelp="{ key: 'widget.header.dsMv', state: () => (mvMode ? 'mv' : 'ds') }"
                @click.stop
            >
                <i :class="WIDGET.pi + ' pi-header-pi'" v-if="WIDGET?.pi"></i>
                <span v-if="cascadeInd.on" :class="['cascade-ind', { 'cascade-ind-dirty': cascadeInd.dirty }]" :title="cascadeInd.title" v-uiHelp="{ key: 'widget.header.cascade', state: () => (cascadeInd.dirty ? 'dirty' : 'on'), after: cascadeInd_noteHtml }" @click.stop="cascadeInd_open"><i class="pi pi-share-alt"></i></span><!-- IE 2026 09 10 / ODOO-… (заказ Игоря): индикатор каскада; IE 2026 10 07 / ODOO-335246 (Igor): по Alt — текст скрытой плашки о грязных узлах (after) -->
                <span class="dropdown-panel-mode segment-mode-switch" @click.stop>
                    <span :class="['dropdown-panel-mode-btn', { 'dropdown-panel-mode-active': !mvMode }]" :title="t('Plain query (DS)')" @click.stop="mvSwitch(false)">DS</span>
                    <span :class="['dropdown-panel-mode-btn', { 'dropdown-panel-mode-active': mvMode }]" :title="t('Materialized view (MV): Query is the view body, MV → Selection selects from the view')" @click.stop="mvSwitch(true)">MV</span>
                </span>
            </span>
            <!-- IE 2026 09 08 / ODOO-335246 (Igor): панель Settings | Variants / Favorites — только у виджетов (WIDGET-*: отчёты, списки …);
                 у прочих записей (задачи, сегменты …) бейдж без стрелки и без дропдауна -->
            <!-- IE 2026 09 28 / ODOO-341407: vizBadgeStyle — на вкладке визуализации бейдж уступает место заголовку (текст «…», полный — по Alt: vars.full) -->
            <!-- IE 2026 09 28 / ODOO-341407 (ревью ie-dm7, замечание 2): урезанный бейдж несёт подсказку title с полным источником (vizBadgeTip; платформа показывает её
                 по Alt / Show tooltips — utils/uiHelp, nativeTitles); у внутреннего текста пустой title тогда снят, иначе он глушил бы подсказку бейджа над «Джере…» -->
            <!-- IE 2026 11 02 / ODOO-350449 (заказ Игоря: p216 бейдж виду віджета — тиха іконка, плашка при наведенні): в режиме иконки плашка — kind-badge-overlay поверх якоря; по Alt — название вида (vars.full) -->
            <span class="segment-title pi-header pi-1" :class="{ 'segment-title-open': showDropdown, 'segment-title-static': !dropdownApplies, 'viz-badge-bare': vizBadgeBare && vizBadgeMax != null && !identInForm, 'kind-badge-overlay': kindIcon_on(), 'kind-badge-opaque': kindIcon_on() && kindChip_on(), 'kind-badge-below': kindIcon_on() && kindChip_on() && kindIconPlace === 'below' }"
                v-else-if="WIDGET.shortTitle"
                :style="[WIDGET.styleWidget.minMode ? 'pointer-events:none;' : '',
                         showDropdown && dropdownAccent ? { '--sd-acc': dropdownAccent } : '',
                         vizBadgeStyle(), kindIcon_on() && kindIconPos ? kindIconPos : '']"
                :title="vizBadgeTip()"
                v-uiHelp="{ key: 'widget.header.badge', state: () => (!dropdownApplies ? 'static' : (showDropdown ? 'open' : 'closed')), vars: () => ({ full: vizBadgeTip() || (kindIcon_on() ? WIDGET.shortTitle : '') }), after: tooltip_tail }"
                @click="dropdownApplies && toggleDropdown($event)"
                @dblclick="kindIcon_on() && kindBadge_dblclick($event)   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p220/p221/p222 шапка віджета: p221 — двойной клик по плашке поверх начала заголовка = правка заголовка) */"
            ><!-- IE 2026 08 27 / ODOO-5800 (заказ Игоря): оверлей табов больше не всплывает по наведению на ярлык — см. .tabs-hover-zone -->
                <i :class="headerChip_pi + ' pi-header-pi'" v-if="headerChip_pi"></i><!-- IE 2026 10 23 / ODOO-348705 (заказ Игоря: иконка чипа карточки элемента виджета списков) -->
                <i :class="WIDGET.pi3 + ' pi-header-pi'" v-if="WIDGET?.pi3" v-uiHelp="'widget.header.auditIcon'"></i>
                <span v-if="cascadeInd.on" :class="['cascade-ind', { 'cascade-ind-dirty': cascadeInd.dirty }]" :title="cascadeInd.title" v-uiHelp="{ key: 'widget.header.cascade', state: () => (cascadeInd.dirty ? 'dirty' : 'on'), after: cascadeInd_noteHtml }" @click.stop="cascadeInd_open"><i class="pi pi-share-alt"></i></span><!-- IE 2026 09 10 / ODOO-… (заказ Игоря): индикатор каскада; IE 2026 10 07 / ODOO-335246 (Igor): по Alt — текст скрытой плашки о грязных узлах (after) -->

                <!-- IE 2026 09 15 / ODOO-… (замечание Игоря): длинный текст бейджа (имя основной настройки варианта, метка расшифровки) — в одну строку с обрезкой «…», шеврон остаётся -->
                <span class="segment-title-text" :title="WIDGET.variant_label ? (WIDGET.variant_main?.title || WIDGET.variant_label) : (vizBadgeTip() ? null : '')">{{ WIDGET.shortTitle }}<span v-if="WIDGET._dd_label" class="dd-cells-label" :title="t('Cells of the source report decoded by this widget')" v-uiHelp="'widget.header.drilldown'">[{{ WIDGET._dd_label }}]</span><!-- IE 2026 09 04 / ODOO-336331 (заказ Игоря): открыт вариант настройки — в чипе имя ОСНОВНОЙ настройки (заголовок виджета = имя варианта, дважды не показываем) --><span v-if="WIDGET.variant_label" class="dd-cells-label variant-label" :title="variantChip_tooltip()" v-uiHelp="'widget.header.variantLabel'"><i class="pi ie-ico-branch variant-label-pi"></i>{{ WIDGET.variant_main?.title || WIDGET.variant_label }}</span><!-- IE 2026 09 13 / ODOO-335246 (Igor): «ветка» вариантов — не та же иконка, что индикатор каскада (share-alt): на проде читалось как каскад --></span>
                <i v-if="dropdownTabs.length && dropdownApplies" :class="['pi', 'dropdown-chevron', showDropdown ? 'pi-chevron-up' : 'pi-chevron-down']"></i>
            </span>
            </teleport>

            <!-- IE 2026 08 20 / ODOO-5512 (заказ Игоря): табы скрыты на виджете
                 (hideTabs) — при наведении на ярлык всплывает оверлей с табами
                 вида; клик переключает таб; ФИКСИРОВАННЫЙ оверлей — раскладка
                 виджета не дёргается -->
            <div class="tabs-hover-pop" v-if="showTabsHover && !showDropdown" :style="tabsHoverStyle"
                @mouseenter="tabsHover_keep" @mouseleave="tabsHover_hide" @click.stop>
                <!-- IE 2026 09 23 / ODOO-341407: i18n (loop variable t → ht: t is the dictionary function) -->
                <span class="tabs-hover-item" v-for="ht in hoverViewTabs" :key="ht.binding"
                    :class="{ 'tabs-hover-active': ht.active }" :title="ht.tooltip || ht.title"
                    v-uiHelp="{ key: 'widget.header.tabsPop', vars: { name: ht.title || '' } }"
                    @click="tabsHover_go(ht)">
                    <i :class="ht.pi"></i><span class="tabs-hover-title">{{ ht.title }}</span>
                    <span class="tabs-hover-badge" v-if="ht.count">{{ ht.count }}</span>
                </span>
            </div>

            <!-- IE 2026 09 23 / ODOO-… (замечание Игоря: в форме ⋯ — те же элементы шапки): пока бейдж в форме «⋯», его панель (fixed) живёт в обёртке .widget-ident-dd у корня виджета — не в скрытой шапке
                 (display:none) и не в форме (правило иконок .widget-commandPanel .pi, островок Float с backdrop-filter сместил бы fixed-координаты) -->
            <teleport :to="identDdTo" :disabled="!identInForm">
            <div :class="['chips-dropdown', 'widget-settings-dropdown', { 'sd-narrow': sdNarrow, 'sd-sizing': sdSizing }]" v-if="showDropdown" :style="dropdownStyle" @click.stop>
                <!-- IE 2026 08 19 (заказ Игоря): шапка дропдауна — видно, что это
                     панель, «вытекшая» из селектора настроек виджета, а не свободный виджет -->
                <!-- IE 2026 09 23 / ODOO-341407: i18n — settings panel: header, Settings | Variants switch, list hints, «Save as new» -->
                <div class="dropdown-panel-header" @click.stop v-uiHelp="{ key: 'widget.settings.panel', state: () => (settingsPanelMode === 'variants' ? 'variants' : 'settings') }">
                    <i class="pi pi-sliders-h"></i>
                    <span class="dropdown-panel-title">{{ t('Widget settings') }}</span>
                    <span class="dropdown-panel-widget" :title="settingsPanel_recordTitle" v-uiHelp="'widget.settings.recordTitle'">{{ settingsPanel_recordTitle }}</span><!-- IE 2026 09 24 / ODOO-341407: локализованный title записи (meta.title_{lang} → база), не английская база -->
                    <i class="pi pi-times dropdown-panel-close" :title="t('Close')" v-uiHelp="'widget.settings.close'" @click="showDropdown = false"></i>
                </div>
                <div class="dropdown-tabs-row">
                <!-- IE 2026 09 04 / ODOO-336331 (заказ Игоря): вкладка со списком (Settings tree / Variants) тянется на всю
                     панель (flex-колонка), грид внутри занимает ровно видимую область — его полосы прокрутки видны -->
                <div :class="['dropdown-tab', { 'dropdown-tab-grid': tab.name === 'parents_tree' || tab.name === 'variants_tree' }]"
                    v-for="(tab, tabIndex) in dropdownTabs" :key="tabIndex + '-' + resolveIndex">
                    <div :class="['dropdown-tab-header', { 'dropdown-tab-header-action': tab.action }]"
                        v-uiHelp="{ key: 'widget.settings.treeHeader', state: () => (settingsPanelMode === 'variants' ? 'variants' : 'settings') }"
                        @click="tab.action && onDropdownTabAction(tab.action)"
                    >
                        <i :class="tab.pi"></i>
                        <span>{{ tab.title }}</span>
                        <!-- IE 2026 09 04 / ODOO-336331 (заказ Игоря): тумблер Settings | Variants — основное дерево
                             настроек виджета либо варианты текущей настройки (тот же табличный вид) -->
                        <span class="dropdown-panel-mode" v-if="(tab.name === 'parents_tree' || tab.name === 'variants_tree') && settingsVariants_on()" @click.stop>
                            <span :class="['dropdown-panel-mode-btn', { 'dropdown-panel-mode-active': settingsPanelMode !== 'variants' }]"
                                :title="t('Settings tree of this widget')" v-uiHelp="{ key: 'widget.settings.mode.settings', state: () => (settingsPanelMode !== 'variants' ? 'active' : 'inactive') }" @click.stop="settingsPanel_setMode('settings')">{{ t('Settings') }}<span class="dropdown-panel-mode-count" v-if="settingsCount()">{{ settingsCount() }}</span></span>
                            <span :class="['dropdown-panel-mode-btn', { 'dropdown-panel-mode-active': settingsPanelMode === 'variants' }]"
                                :title="t('Variants of the current setting — saved under it, not in the main tree; ★ = default variant (opens instead of the main setting)')"
                                v-uiHelp="{ key: 'widget.settings.mode.variants', state: () => (settingsPanelMode === 'variants' ? 'active' : 'inactive') }"
                                @click.stop="settingsPanel_setMode('variants')">{{ t('Variants') }}<span class="dropdown-panel-mode-count" v-if="variantsCount()">{{ variantsCount() }}</span></span>
                        </span>
                    </div>
                    <!-- IE 2026 08 19 / ODOO-5512 (заказ Игоря): список настроек — обычный
                         ТАБЛИЧНЫЙ вид (AttrGrid): стандартный чипс дерева по родителю,
                         владелец, приватность, панель тегов, командная панель -->
                    <div v-if="tab.name === 'parents_tree' && settingsListAttr && settingsListReady"
                        class="dropdown-tab-items dropdown-settings-grid" @click.stop>
                        <AttrGrid :key="'settings-list-' + resolveIndex" :widget_id="widget_id" :initialAttr="settingsListAttr" />
                        <!-- IE 2026 09 15 / ODOO-… (замечание Игоря, вечер): одна команда «Save as new» ПОД деревом (вместо секции Favorites справа):
                             Settings — новая настройка (моя копия в основном дереве, скрыта от других), Variants — новый вариант текущей настройки (мой) -->
                        <div class="dropdown-settings-footer" @click.stop>
                            <span class="dropdown-tab-item dropdown-settings-save" :title="settingsPanelMode === 'variants' ? t('Save the current state as a new variant of this setting (yours, hidden from others)') : t('Save the current state as a new setting (your copy in the settings tree, hidden from others)')" v-uiHelp="{ key: 'widget.settings.saveAsNew', state: () => (settingsPanelMode === 'variants' ? 'variants' : 'settings') }" @click="settingsList_saveAsNew"><i class="pi pi-lock dropdown-tab-item-cmd-pi"></i><span>{{ t('Save as new') }}</span></span>
                        </div>
                    </div>
                    <!-- IE 2026 09 04 / ODOO-336291 (mobile UX): P-16 settingsDeferred — лист виден с первого кадра, грид списка монтируется следом -->
                    <div v-else-if="tab.name === 'parents_tree' && !settingsListReady" class="dropdown-tab-items mob-settings-loading">{{ t('Loading settings…') }}</div>
                    <!-- IE 2026 09 04 / ODOO-336331 (заказ Игоря): варианты текущей настройки — тот же табличный вид -->
                    <div v-else-if="tab.name === 'variants_tree' && variantsListAttr"
                        class="dropdown-tab-items dropdown-settings-grid" @click.stop>
                        <!-- вариантов ещё нет — подсказка над гридом (его командная панель нужна: там кнопки «Save current as new variant») -->
                        <div v-if="!variantsCount()" class="dropdown-tab-item" style="opacity:.55; pointer-events:none;" v-uiHelp="'widget.settings.variantsEmpty'">
                            <span class="dropdown-tab-item-title">{{ t('No variants yet — «Save as new» below creates the first one') }}</span>
                        </div>
                        <AttrGrid :key="'variants-list-' + resolveIndex" :widget_id="widget_id" :initialAttr="variantsListAttr" />
                        <!-- IE 2026 09 15 / ODOO-… (замечание Игоря, вечер): одна команда «Save as new» ПОД деревом (вместо секции Favorites справа):
                             Settings — новая настройка (моя копия в основном дереве, скрыта от других), Variants — новый вариант текущей настройки (мой) -->
                        <div class="dropdown-settings-footer" @click.stop>
                            <span class="dropdown-tab-item dropdown-settings-save" :title="settingsPanelMode === 'variants' ? t('Save the current state as a new variant of this setting (yours, hidden from others)') : t('Save the current state as a new setting (your copy in the settings tree, hidden from others)')" v-uiHelp="{ key: 'widget.settings.saveAsNew', state: () => (settingsPanelMode === 'variants' ? 'variants' : 'settings') }" @click="settingsList_saveAsNew"><i class="pi pi-lock dropdown-tab-item-cmd-pi"></i><span>{{ t('Save as new') }}</span></span>
                        </div>
                    </div>
                    <div class="dropdown-tab-items" v-else>
                        <!-- дерево настроек ещё не приехало (виджет грузится) / его нет -->
                        <div v-if="tab.name === 'parents_tree' && !WIDGET.parents_tree?.length"
                            class="dropdown-tab-item" style="opacity:.55; pointer-events:none;">
                            <span class="dropdown-tab-item-title">{{ dropdownTreeLoading() ? t('Loading…') : t('No saved settings') }}</span>
                        </div>
                        <div v-if="tab.name === 'variants_tree'"
                            class="dropdown-tab-item" style="opacity:.55; pointer-events:none;">
                            <span class="dropdown-tab-item-title">{{ t('No variants yet — «Save as new» below creates the first one') }}</span>
                        </div>
                        <template v-for="(item, itemIndex) in tab.attrs" :key="itemIndex">
                            <!-- nested tab -->
                            <template v-if="item.attr?.attr_type === 'AttrTab'">
                                <div class="dropdown-tab-subtitle">
                                    <span>{{ item.attr.title }}</span>
                                </div>
                                <div class="dropdown-tab-item dropdown-tab-item-nested"
                                    v-for="(sub, subIndex) in item.attr.attrs"
                                    :key="'n' + subIndex"
                                    @click="onDropdownTabItemClick(sub)"
                                >
                                    <span v-if="sub.attr_type === 'CHIP-Where' || sub.attr_type === 'CHIP-Param' || sub.attr_type === 'CHIP-Action'"
                                        class="dropdown-tab-item-title chip-text"
                                        v-html="resolveDropdownItemHTML(sub)"
                                    />
                                    <span v-else>{{ resolveDropdownItemTitle(sub) }}</span>
                                </div>
                            </template>
                            <!-- regular item -->
                            <template v-else>
                                <div :class="['dropdown-tab-item', {
                                        'dropdown-tab-item-current': item.isCurrent,
                                        'tree-dragging': item._node && item._node === treeDrag.srcNode,
                                    }, treeDropClass(item)]"
                                    :style="item.depth ? { paddingLeft: (12 + item.depth * 16) + 'px', '--drop-indent': (12 + item.depth * 16) + 'px' } : {}"
                                    v-uiHelp="'widget.settings.legacy'"
                                    :draggable="canDrag_treeNode(item)"
                                    @dragstart="onTreeNode_dragStart(item, $event)"
                                    @dragover="onTreeNode_dragOver(item, $event)"
                                    @dragleave="onTreeNode_dragLeave(item, $event)"
                                    @drop="onTreeNode_drop(item, $event)"
                                    @dragend="onTreeNode_dragEnd"
                                    @click="onDropdownTabItemClick(item, $event)"
                                >
                                    <i v-if="item.isCurrent" class="pi pi-map-marker dropdown-tab-item-current-icon" style="color: #f59e0b; filter: drop-shadow(0 0 4px #f59e0b88);"></i>
                                    <i v-else-if="item.attr_type === 'CHIP-Where'"
                                        :class="['dropdown-tab-item-check', 'pi', item.use !== false ? 'pi-check-square' : 'pi-stop']"
                                        @click.stop="item.use = item.use === false ? true : false"
                                    />
                                    <span v-if="item.attr_type === 'CHIP-Where' || item.attr_type === 'CHIP-Param' || item.attr_type === 'CHIP-Action'"
                                        class="dropdown-tab-item-title chip-text"
                                        v-html="resolveDropdownItemHTML(item)"
                                    />
                                    <span v-else class="dropdown-tab-item-title">{{ resolveDropdownItemTitle(item) }}</span>
                                    <span v-if="item.updated_by" class="dropdown-tab-item-meta" v-html="_formatAttrValueHTML(item.updated_by)"></span>
                                    <span v-if="item.updated_at" class="dropdown-tab-item-meta" v-html="_formatAttrValueHTML(item.updated_at)"></span>
                                    <i v-if="item.attr_type === 'CHIP-Node' && canArchive_treeNode(item)"
                                        class="pi pi-trash dropdown-tab-item-clone"
                                        :title="t('Archive {name}', { name: item.node?.valueStr || '' })"
                                        @click.stop="onDropdownTabItemArchive(item)"
                                    />
                                    <i v-if="item.attr_type === 'CHIP-Node'"
                                        class="pi pi-clone dropdown-tab-item-clone"
                                        :title="t('Open in new widget')"
                                        @click.stop="onDropdownTabItemOpenNew(item)"
                                    />
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
                </div>
            </div>
            </teleport>

            <!-- IE 2026 09 15 / ODOO-… (заказ Игоря): экземпляр тиража — чекбокс селектора: клик добавляет значение строки-источника в
                 глобальный селектор виджета-списка (повторный — снимает), Alt/Ctrl+клик — устанавливает только его (store.multiply_selector) -->
            <span v-if="multiplySel()" class="multiply-sel" :class="{ 'multiply-sel-on': multiplySel().on }" :title="multiplySel().title"
                v-uiHelp="{ key: 'widget.header.multiplySel', state: () => (multiplySel()?.on ? 'on' : 'off') }"
                @click.stop="multiplySel_click($event)" @mousedown.stop>
                <i class="pi" :class="multiplySel().on ? 'pi-check-square' : 'pi-stop'"></i>
            </span>
            <teleport :to="identTo" :disabled="!identInForm">
            <!-- IE 2026 09 27 / ODOO-341407: :title — полный заголовок, когда на вкладке визуализации его урезал предел до островка кнопок (vizTitleTip);
                 ревью ie-dm7 #47608: по Alt — полный заголовок в шапке объяснения поля (vars.full → widget.header.title), по наведению — плашка ниже поля -->
            <input
                ref="inputHeader"
                type="text"
                class="widget-header single-line-text"
                :class="{ 'title-ellipsis': titleTailOn }"
                v-uiHelp="{ key: 'widget.header.title', state: () => (isEditingHeader ? 'editing' : 'view'), vars: () => ({ full: vizTitleTip() }), after: tooltip_tail }"
                :style="[WIDGET.styleWidget.minMode ? 'pointer-events:none;' : '', titleFitStyle]"
                :title="vizTitleTip()"
                :id="'widget_title'+widget_id"
                v-model="WIDGET.title"
                :placeholder="WIDGET?.record?.doc?.['title-placeholder'] || t('Enter title')"
                autocomplete="off"
                @mousedown="titleTail_hide(); header_mousedown($event)   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок — «…» и продолжение по наведению, как в ячейках) */"
                @mousemove="titleTail_move($event)   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок — «…» и продолжение по наведению, как в ячейках) */"
                @mouseleave="titleTail_leave($event)"
                @click="activateWidget(true)"
                @dblclick="mobileHeaderDblclick"
                @touchstart="mobHeaderTouchStart"
                @touchend="mobileHeaderTouchTap"
                @keydown="handleKeydown"
                @blur="onTextChange"
                :readonly="!isEditingHeader"
            />
            <!-- IE 2026 09 27 / ODOO-341407 (ревью ie-dm7 #47608): плашка полного заголовка — СРАЗУ за полем (CSS «input:hover + .viz-title-full»), под островком
                 заголовка, мышь не ловит; есть только у урезанного заголовка на вкладке визуализации (vizTitlePlate) -->
            <span v-if="vizTitlePlate()" class="widget-header viz-title-full" aria-hidden="true"
                :style="{ left: vizTitleLeft + 'px', maxWidth: 'calc(100% - ' + (vizTitleLeft + 8) + 'px)' }">{{ WIDGET.title }}</span>
            <!-- IE 2026 09 24 / ODOO-341407 (поручение Игоря по скрину page-settings, уточнение): глобус в шапке — ТОЛЬКО в режиме правки заголовка
                 (dblclick по названию → input.widget-header активен); в обычной шапке кнопки нет — карточка «Translations» открывается из тулбара ЯЧЕЙКА
                 формы записи (поле «Название» вкладки Info / translate-колонки) и пунктом меню виджета «Translations…». Клик — карточка title/tooltip
                 этого виджета, текущий текст инпута — черновик строки текущего языка; правка в шапке снимается без сохранения (mousedown.prevent —
                 фокус инпута не уходит по нажатию, blur-сохранения заголовка нет) -->
            <span v-if="isEditingHeader && i18nGlobe_show()" class="i18n-globe i18n-globe-edit" :title="t('Translations')" v-uiHelp="'widget.header.globe'" @mousedown.prevent.stop @click.stop="i18n_titles_open_fromHeader($event)" @dblclick.stop>
                <i class="pi pi-globe"></i>
            </span>
            </teleport>
            <!-- IE 2026 09 23 / ODOO-341407: i18n — header: placeholder, ARCHIVED, Stop loading, widget menu -->
            <span v-if="WIDGET.record?.params?.showArchived" class="widget-archived-badge" v-uiHelp="'widget.header.archived'">, {{ t('ARCHIVED') }}</span>
            <span v-if="WIDGET.activityInfo" class="widget-activity-badge" v-uiHelp="'widget.header.activity'">, {{ WIDGET.activityInfo }}</span>

            <!-- Стоп: виден ТОЛЬКО пока запрос в полёте, в т.ч. на скелет-кадре
                 первого widget_open (commandPanel ещё пуст) — поэтому отдельная
                 кнопка вне блока .buttons. Только для отчёта/списка (долгая
                 выборка) — в документах кнопка лишняя (Игорь 2026-07-28) -->
            <Button
                v-if="showStopLoading()"
                class="commandPanel-buttons p-button-sm p-button-no-border p-2 mr-1 pi p-button-white pi-stop-circle widget-stop-loading"
                :title="t('Stop loading')"
                v-uiHelp="'widget.header.stop'"
                @click.stop="store.widget_stopLoading(WIDGET)"
            />

            <!-- IE 2026 10 07 / ODOO-5800 (поручение Igor 07.10): панель кнопок шапки — в потоке (не поверх заголовка по наведению; у неактивного — прозрачна до наведения), кнопки, не поместившиеся
                 по ширине, скрыты с конца ряда (v-show, hdrOverflow_measure) и остаются в форме-меню ≡ (папка Command panel); заголовку — читаемый минимум.
                 Выключатель fe.ux.widgetHeaderOverflow (по умолчанию вкл.; выкл. — прежнее: панель поверх заголовка) -->
            <div :class="{
                'buttons': true,
                'buttons-inactive': !isActiveWidget && isMainArea,
                'widget-container-buttons-max-inactive': !hdrOverflowOn && !isActiveWidget && isMainArea && WIDGET?.Rect?.width > 500,   // IE 2026 10 07 / ODOO-5800: при включённом выключателе панель не вынимается из потока — заголовок не перекрывается
                'widget-container-buttons-min': !hdrOverflowOn && (isActiveWidget || !isMainArea) && WIDGET?.Rect?.width <= 500,
                'widget-container-buttons-min-inactive': !hdrOverflowOn && !isActiveWidget && isMainArea && WIDGET?.Rect?.width <= 500,
                'widget-buttons-none': hdrOverflowOn && hdrVisible === 0,
                'buttons-under-tail': titleFullOn && titleTailCover,   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок — «…» и продолжение по наведению, как в ячейках): пока показано продолжение заголовка, панель поверх его хвоста спрятана (кнопки не торчат из-под слоя)
                'buttons-over-title': titleFullOn,   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p223 заголовок неактивного виджета — на всю ширину шапки): панель неактивного — поверх хвоста заголовка (вне потока), заголовок — на всю ширину шапки
            }" 
                v-if="commandPanel.length > 0 && !WIDGET.styleWidget.minMode"
            >
                <!-- IE 2026 10 07 / ODOO-5800: кнопка — компонент Attr с несколькими корневыми узлами (v-show на нём не работает), поэтому при включённом выключателе каждая
                     в обёртке .hdr-cmd (display: flex; v-show по hdrVisible); выключен — прежняя разметка без обёрток -->
                <template v-if="hdrOverflowOn">
                    <div v-for="(attrM, attrM_i) in commandPanel" :key="attrM" class="hdr-cmd" v-show="attrM_i < hdrVisible">
                        <component
                            :widget_id="widget_id" 
                            :is="attrM.component"
                            :attr_id="attrM.id"
                            :initialAttr="attrM" 
                        />
                    </div>
                </template>
                <template v-else>
                <component
                    v-for="attrM in commandPanel"
                    :key="attrM"
                    :widget_id="widget_id" 
                    :is="attrM.component"
                    :attr_id="attrM.id"
                    :initialAttr="attrM" 
                />
                </template>

            </div>
            <!-- IE 2026 08 22 (заказ Игоря): разворот на всю страницу перенесён в
                 hover-форму настроек (commandPanel_Scale, 1-й ряд) -->
            <!-- IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: ≡ активного виджета — телепорт в body (как #4189): fixed-кнопка внутри isolation-контекста .WIDGET перекрывалась соседом, поздним в DOM; :disabled (не v-if) переносит DOM-узел без пересоздания wijmo Menu -->
            <teleport to="body" :disabled="!(store.mobileUi?.on && isActiveWidget)">
            <!-- IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt): у панели ≡ — объяснение кнопки (help="widget"); нативный title контейнера всплывал бы вторым окном — в aria-label, а короткое имя
                 «Widget menu» на обычном наведении показывает сама кнопка (btnShort) элементом подсказки платформы -->
            <div class="widget_menu mr-2" :title="(store.menuPanel_on('Widget') && store.setting('fe.ux.uiHelp', true) !== false) ? null : t('Widget menu')" :aria-label="t('Widget menu')" @click.capture="mobileActionMenuTap"
                :class="{ 'buttons-inactive': !isActiveWidget && isMainArea }" 
            >
                <!-- IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2): ≡ виджета — панель функций в стиле 1С (components/MenuPanel.vue: папка Command panel и Audit / JSON — группы,
                     команды между разделителями — группы без заголовка); прежнее wj-menu — мобильный профиль / выключатель fe.ux.menuPanelWidget -->
                <!-- IE 2026 09 22 (заказ Игоря, п.4): поиск, звёзды и «только избранные»; избранные — личные, в привязке к сегменту виджета (уточнение Игоря) -->
                <!-- IE 2026 09 24 / ODOO-… (заказ Игоря: заголовок панелей-меню): ряд «Widget menu · заголовок виджета» (иконка ряда — pi-bars, как у кнопки) -->
                <MenuPanel v-if="WIDGET && store.menuPanel_on('Widget')" ref="widgetMenuPanel" :items="actionMenu" align="right" :caret="false" btnClass="widget-menu-btn" :title="t('Widget menu')" titleIcon="pi pi-bars" :subtitle="String(WIDGET.title || '')"
                    :openDelay="200" :runsTitle="t('Widget')" search :searchPlaceholder="t('Search commands…')" :favKey="menuFavKind()" :favOf="menuFavOf" :epoch="store._favEpoch"
                    :favTitle="t('Favourite command (for widgets of this segment)')" help="widget" :btnShort="t('Widget menu')" @pick="menuPanelPick" @fav="menuFav">
                    <template #trigger><i class="pi pi-bold pi-bars"></i></template>
                </MenuPanel>
                <wj-menu id="actionMenuId" :displayMemberPath="'titleAction'" :subItemsPath="'attrs'" :showDropDownButton="false"
                    v-else-if="WIDGET"
                    :openOnHover="!store.mobileUi?.on" :isAnimated="false" :itemsSource="actionMenu" :initialized="initMenu" :itemClicked="menuNodeClicked" :formatItem="store.formatMenuItem"
                >
                    <i class="pi pi-bold" :class="store.mobileUi?.on ? 'pi-ellipsis-h' : 'pi-bars'"></i>
                </wj-menu>
            </div>
            </teleport>
            <!-- IE 2026 08 27 / ODOO-5800 (заказ Игоря): табы скрыты (hideTabs) — оверлей табов вида
                 всплывает, когда мышь задержалась ~2 с на невидимой полосе-границе между шапкой и
                 телом виджета (раньше — по наведению на ярлык сегмента). Прочее поведение оверлея
                 (скрытие, содержимое, позиция под ярлыком) прежнее -->
            <div class="tabs-hover-zone" v-if="tabsHoverZone_on()" v-uiHelp="'widget.header.tabsZone'"
                @mouseenter="tabsHoverZone_enter" @mouseleave="tabsHoverZone_leave"></div>
        </div>

        <!-- IE 2026 09 23 / ODOO-… (замечание Игоря: в форме ⋯ — те же элементы шапки): цель телепорта панели Settings | Variants, пока бейдж в форме; обёртка z 99 — ниже формы (100): первый ряд с бейджем
             накрывает верхнюю кромку панели (стык «вытекания» как у ярлыка в шапке), прочие ряды формы на время открытой панели невидимы -->
        <div class="widget-ident-dd" :id="identDdId" v-if="identWant"></div>
        <div v-if="WIDGET.loading || WIDGET.firstBackendCheck || WIDGET._staleOpen" class='widget-text-loading' v-uiHelp="'widget.loading'"></div>
        <!-- R15c (dm 2026 08 04): текст прогресса экспорта над полосой (аналог Loading..) -->
        <div v-if="WIDGET.loadingPct != null" class='widget-text-loading widget-text-progress'>{{ WIDGET.loadingText || t('Exporting') }} {{ Math.round(WIDGET.loadingPct) }}%<!-- IE 2026 09 23 / ODOO-341407: i18n --></div>
        <!-- АН 2026 08 15 / ODOO-4997 (Игорь п.12): pending-плашку не дублируем,
             когда у виджета уже горит полоса загрузки — индикация одна и та же -->
        <!-- IE 2026 10 07 / ODOO-335246 (Igor): жёлтая плашка «Calculation cascade: N dirty node(s) …» скрыта — достаточно жёлтого индикатора каскада в шапке (его текст — по Alt на индикаторе);
             вернуть плашку: настройка fe.ux.cascadeStaleBanner = true -->
        <div v-if="WIDGET?.notification?.visible
                && (WIDGET.notification.code !== 'cascade_stale_sources' || cascadeBannerOn)   /* IE 2026 10 07 / ODOO-335246 */
                && !(WIDGET.notification.status === 'pending'
                    && (WIDGET.loading || WIDGET.firstBackendCheck || WIDGET._staleOpen || WIDGET.loadingPct != null))"
            class="notification-widget" :class="{
            'notification-cleared': !String(WIDGET.notification.text ?? '').trim(), /* IE 2026 08 19: text бывает не-строкой (объект из ответа бэка) — рендер падал TypeError .trim */
            'notification-warning': WIDGET.notification.status=='warning',
            'notification-info': WIDGET.notification.status=='info', /* IE 2026 11 02 / ODOO-349799 (toast-info) */
            'notification-error': WIDGET.notification.status=='error',
            'notification-critical': WIDGET.notification.status=='critical',
            'notification-pending': WIDGET.notification.status=='pending',
            'notification-fading': ntfFading,   /* IE 2026 09 11 (Igor): success/warning затухают сами (notificationAutoHide) */
        }" v-uiHelp="{ key: 'widget.notification', state: () => (WIDGET.notification?.status || 'success') }" @mouseenter="notificationHold">
            <span v-if="WIDGET.notification.header" class="notification-header">
                {{ store?.truncateText(WIDGET.notification.header, 100) }}
            </span>
            <br v-if="WIDGET.notification.header">
            {{ store?.truncateText(String(WIDGET.notification.text ?? ''), 150) }}
            <i class="pi pi-times notification-close" @click="WIDGET.notification.visible = false"></i>
        </div>
        
        <!-- content -->
        <div
            :class="{
                'widget-content': true,
                'widget-content-inactive': false && !isActiveWidget && isMainArea,
            }"
            v-wjContextMenu="'cellMenuId'" >
            <slot :palette="palette" />
        </div>

        <transition name="fade-slide" mode="out-in">
            <!-- IE 2026 08 22: на мобиле панель телепортируется в body — поверх
                 блюра открытого меню (внутри .layout-wrapper попала бы под filter) -->
            <teleport to="body" :disabled="!store.mobileUi?.on">
            <div class="widget-commandPanel widget-commandPanel-top-left"
                v-uiHelp="{ key: 'widget.form', vars: () => ({ lite: cornerLite }) }   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря через webscm #127293: uiHelp угла после p226): объяснение по флагу fe.ux.widgetCornerMenuLite */"
                :class="{ 
                    'top-buttons-1': commandPanel_offsetWidth > 0,
                    'ident-dd-open': identInForm && showDropdown,   /* IE 2026 09 23 / ODOO-… (замечание Игоря: в форме ⋯ — те же элементы шапки): панель открыта из формы — её прочие ряды невидимы */
                    'corner-lite': cornerLite,   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета): один монохромный ряд частых команд (+ «Налаштування й варіанти») */
                    'corner-lite-pct': cornerLite && cornerPct,   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета): из ≡ › Розкладка › «Ширина / висота, %…» — ряд полей W / H / X / Y и Free под рядом */
                }"
                :style="topLeftFormStyle"
                v-if="show_commandPanel_topLeft"
                @mouseenter="onShow_commandPanel_topLeft"
                @mouseleave="onClose_commandPanel_topLeft"
            >
                <!-- IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета): ряд при наведении — Закрити · Розгорнути · Закрити інші · Згорнути · Копіювати посилання · У новій вкладці · Клонувати (utils/widgetCornerMenu.cornerRow)
                     · [Налаштування й варіанти] — только у виджета с выбором настроек / вариантов (cornerVariants_on), открывает ту же панель Settings | Variants, что иконка вида;
                     «⋯» и полной формы нет (поправка Игоря 03.11) — прочие команды в ≡ › Розкладка. Слот бейджа и заголовка при скрытой шапке (identSlotId) — в конце ряда.
                     fe.ux.widgetCornerMenuLite = false — прежняя форма (v-else) -->
                <div class="widget-commandPanel-1 corner-lite-head" v-if="cornerLite">
                    <div class="widget-commandPanel-row corner-lite-row">
                        <component v-for="attrM in cornerLiteHead"
                            :key="attrM.html_id"
                            :widget_id="widget_id"
                            :is="attrM.component"
                            :attr_id="attrM.id"
                            :initialAttr="attrM"
                        />
                        <span class="corner-lite-btn corner-lite-variants" role="button" v-if="cornerVariantsOn" :class="{ 'is-on': showDropdown }" :aria-label="t('Settings and variants')" :aria-expanded="showDropdown ? 'true' : 'false'"
                            v-uiHelp="{ key: 'widget.form.variants', state: () => (showDropdown ? 'open' : 'closed'), vars: () => ({ name: WIDGET.shortTitle || '', variant: WIDGET.variant_label ? (WIDGET.variant_main?.title || WIDGET.variant_label) : '' }) }"
                            @click.stop="cornerVariants_click($event)"><i :class="['pi', WIDGET.variant_label ? 'ie-ico-branch' : 'pi-chevron-down']"></i></span>
                        <span class="widget-topleft-ident" :id="identSlotId" v-if="topLeftIdent" v-uiHelp="'widget.form.ident'"></span>
                    </div>
                </div>
                <div class="widget-commandPanel-1" v-else>
                    <div class="widget-commandPanel-row" v-for="(row, rowIndex) in commandPanel_topLeft1"
                        :key="'row-' + rowIndex"
                    >
                        <component v-for="attrM in row"
                            :key="attrM.html_id"
                            :widget_id="widget_id"
                            :is="attrM.component"
                            :attr_id="attrM.id"
                            :initialAttr="attrM"
                        />
                        <!-- IE 2026 09 22 / ODOO-5800 (поправка Игоря к островку a89be4c4): при скрытой шапке бейдж сегмента + тайтл виджета —
                             в первом ряду формы «⋯» после кнопок закрытия и разворота (а не островком в правом верхнем углу) -->
                        <!-- IE 2026 09 23 / ODOO-… (замечание Игоря: в форме ⋯ — те же элементы шапки): не копия, а СЛОТ телепорта — сюда переезжают сами бейдж сегмента (с дропдауном Settings | Variants)
                             и поле заголовка шапки (Widget.identInForm); id слота новый на каждое открытие формы (identEpoch): телепорт Vue помнит прошлую
                             цель, а прежний слот снят вместе с формой -->
                        <span class="widget-topleft-ident" :id="identSlotId" v-if="rowIndex === 0 && topLeftIdent" v-uiHelp="'widget.form.ident'"></span>
                    </div>
                </div>
                <!-- IE 2026 08 23 (заказ Игоря): мобайл — настройки виджета (дропдаун
                     сегмента, стрелка вниз) и строка команд виджета (прав. верх десктопа) -->
                <template v-if="store.mobileUi?.on">
                    <!-- IE 2026 09 04 / ODOO-336291 (mobile UX): B-03 — тоггл ТОЛЬКО по click; pointerdown.prevent лишь гасит
                         совместимые mouse-события (wijmo закрывал меню и панель по mousedown раньше click) -->
                    <div class="mob-settings-btn" :title="t('Widget settings')"
                        v-uiHelp="'widget.form.mobSettings'"
                        @pointerdown.stop.prevent="mobSettingsPress" @touchstart.stop @click.stop.prevent="mobToggleSettings">
                        <i class="pi pi-angle-down"></i>
                    </div>
                    <div class="widget-commandPanel-row mob-panel-commands" v-if="commandPanel?.length" v-uiHelp="'widget.form.mobCommands'">
                        <component v-for="attrM in commandPanel"
                            :key="attrM.html_id"
                            :widget_id="widget_id"
                            :is="attrM.component"
                            :attr_id="attrM.id"
                            :initialAttr="attrM"
                        />
                    </div>
                </template>
                <div class="widget-commandPanel-2" v-if="!cornerLite || cornerPct">
                    <!-- IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета): облегчённая форма — только ряд полей W / H / X / Y и Free (открыт пунктом ≡ › Розкладка › «Ширина / висота, %…»), кнопок масштаба нет -->
                    <template v-if="!cornerLite">
                    <div class="widget-commandPanel-row" v-for="(row, rowIndex) in commandPanel_Scale"
                        :key="'row-' + rowIndex"
                    >
                        <component v-for="attrM in row"
                            :key="attrM.html_id"
                            :widget_id="widget_id"
                            :is="attrM.component"
                            :attr_id="attrM.id"
                            :initialAttr="attrM"
                            @mouseenter="mouseenter_btnScale(attrM)"
                            @mouseleave="mouseleave_btnScale(attrM)"
                        />
                    </div>
                    </template>
                    <!-- точная настройка размеров в % рабочей области (ит.3 п.3.3) -->
                    <!-- IE 2026 09 23 / ODOO-341407: i18n — W/H/X/Y labels and tooltips, Free toggle -->
                    <div class="widget-commandPanel-row layout-pct-row" @pointerdown.stop @click.stop>
                        <label v-wjTooltip="t('Width, % of page')">{{ t('W') }}
                            <input type="number" min="1" max="100" step="any" v-model.number="layoutInputs.width" @change="applyLayoutInputs('width')" v-uiHelp="'widget.form.width'">
                        </label>
                        <label v-wjTooltip="t('Height, % of page')">{{ t('H') }}
                            <input type="number" min="1" max="100" step="any" v-model.number="layoutInputs.height" @change="applyLayoutInputs('height')" v-uiHelp="'widget.form.height'">
                        </label>
                        <template v-if="layoutInputs.free">
                            <label v-wjTooltip="t('Left, % of page')">{{ t('X') }}
                                <input type="number" min="0" max="100" step="any" v-model.number="layoutInputs.left" @change="applyLayoutInputs('left')" v-uiHelp="'widget.form.left'">
                            </label>
                            <label v-wjTooltip="t('Top, % of page')">{{ t('Y') }}
                                <input type="number" min="0" max="100" step="any" v-model.number="layoutInputs.top" @change="applyLayoutInputs('top')" v-uiHelp="'widget.form.top'">
                            </label>
                        </template>
                        <!-- IE 2026 09 15 / ODOO-… (замечание Игоря): Free — кнопка-тумблер как Float (зелёная = виджет свободный, белая = в сетке страницы), не чекбокс -->
                        <Button class="commandPanel-buttons p-button-sm p-button-no-border p-2 btn-free-widget p-button-white mr-0 p-button-text0 ml-1"
                            :class="{ 'btn-free-widget-on': layoutInputs.free }"
                            v-wjTooltip="layoutInputs.free ? t('Free position (pop-out): the widget floats over the page — click to dock it back into the page grid') : t('Docked in the page grid — click to pop the widget out (free position; X / Y = left / top in % of the page)')"
                            @click.stop="freeToggle"><span v-uiHelp="{ key: 'widget.form.free', state: () => (layoutInputs.free ? 'on' : 'off') }">{{ t('Free') }}</span></Button>
                    </div>
                </div>
            </div>
            </teleport>
        </transition>
        <div class="resizer-top-left" @mouseenter="onShow_commandPanel_topLeft"
            @click.stop.prevent="onTopLeftCornerTap" v-if="!show_commandPanel_topLeft" v-uiHelp="{ key: 'widget.corner.topLeft', vars: () => ({ lite: cornerLite }) }   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря через webscm #127293: uiHelp угла после p226): объяснение по флагу fe.ux.widgetCornerMenuLite */"
            @click.capture="cornerIconTap($event)   /* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета): угол лежит поверх иконки вида — клик в её прямоугольнике открывает панель настроек, а не форму угла */" />
        <div class="resizer-top-right" @mouseenter="onShow_hidden" v-if="(WIDGET.styleWidget?.hideHeader || WIDGET.styleWidget?.hideTabs || WIDGET.styleWidget?.hideGridPanel) && !WIDGET.styleWidget.show_hidden" v-uiHelp="'widget.corner.topRight'" />
        <!-- IE 2026 09 22 / ODOO-5800 (Igor: «когда нет header — показывай при наведении на верхний правый угол виджета элемент-блок сегмента и тайтл виджета, за кнопкой —
             раскрытие виджета на весь экран; в свободном виде, как в режиме Float»): островок вместо показа всей шапки; уход мыши прячет его -->
        <div class="widget-corner-island corner-island corner-island-tr" v-if="cornerIsland && WIDGET.styleWidget?.hideHeader && !WIDGET.styleWidget.show_hidden && !WIDGET.styleWidget.minMode"
            v-uiHelp="'widget.corner.island'"
            @mouseenter="cornerIsland_keep" @mouseleave="cornerIsland_leave" @click.stop @mousedown.stop>
            <span class="segment-title pi-header pi-1 segment-title-static widget-corner-seg" v-if="WIDGET.shortTitle" :title="WIDGET.shortTitle"><i :class="headerChip_pi + ' pi-header-pi'" v-if="headerChip_pi"></i><!-- IE 2026 11 01 / ODOO-350449 (заказ Игоря: папка з шестернею для віджета сегмента, відкрита папка для списку): та же иконка, что в плашке шапки --><span class="segment-title-text">{{ WIDGET.shortTitle }}</span></span>
            <span class="widget-corner-title" :title="WIDGET.title">{{ WIDGET.title }}</span>
            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
            <span class="widget-corner-btn" :title="WIDGET.styleWidget?._mobileMax ? t('Restore the widget size (Alt F)') : t('Expand the widget to the full page (Alt F)')" @click.stop="cornerIsland_max"><i :class="['pi', WIDGET.styleWidget?._mobileMax ? 'pi-arrow-down-left-and-arrow-up-right-to-center' : 'pi-arrow-up-right-and-arrow-down-left-from-center']"></i></span>
            <span class="widget-corner-btn" :title="t('Show the header')" @click.stop="cornerIsland_header"><i class="pi pi-chevron-down"></i></span>
        </div>
        <!-- IE 2026 09 03 / ODOO-11316 (заказ Игоря): несохранённые правки vs обновление — диалог на самом виджете -->
        <div class="widget-unsaved-ask" v-if="WIDGET._unsavedAsk" @mousedown.stop @click.stop @dblclick.stop>
            <div class="widget-unsaved-ask-box" v-uiHelp="'widget.unsavedAsk'">
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <div class="wua-title"><i class="pi pi-pencil" /> {{ t('Unsaved changes') }}</div>
                <div class="wua-text">{{ WIDGET._unsavedAsk.text }}</div>
                <div class="wua-buttons">
                    <!-- IE 2026 10 13 / ODOO-5800: подписи кнопок задаёт вопрос (закрытие виджета с несохранёнными строками ленивых гридов: Save & close / Close without saving) -->
                    <button v-if="WIDGET._unsavedAsk.canSave" type="button" class="wua-btn wua-save" @click="store.unsavedAsk_answer(WIDGET, 'save')"><i class="pi pi-save" /> {{ WIDGET._unsavedAsk.saveLabel || t('Save & refresh') }}</button>
                    <button type="button" class="wua-btn wua-discard" @click="store.unsavedAsk_answer(WIDGET, 'discard')">{{ WIDGET._unsavedAsk.discardLabel || t('Refresh without saving') }}</button>
                    <button type="button" class="wua-btn wua-keep" @click="store.unsavedAsk_answer(WIDGET, 'keep')">{{ t('Keep editing') }}</button>
                </div>
            </div>
        </div>
        <!-- R15c (dm 2026 08 04): loadingPct != null — полоса становится процентной (прогресс экспорта) -->
        <div class="widget-loading-border" v-if="WIDGET.loading || WIDGET.firstBackendCheck || WIDGET.loadingPct != null"
             :style="WIDGET.loadingPct != null ? { width: (5 + 0.9 * WIDGET.loadingPct) + '%' } : null" />
    </div>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import AttrButton from './components_core/AttrButton.vue';
// import RemoveIcon from '../icons/RemoveIcon.vue';
import * as wjcCore from '@mescius/wijmo';
import { t, retranslate, retranslateDeep } from '@/i18n'   // IE 2026 09 23 / ODOO-341407: i18n — data() — стрелочная функция, this там нет; в методах — this.t / this.tn; IE 2026 09 24: retranslate* — переподпись кэша data() при смене языка без reload
// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: объяснение записи виджета (подсказка контейнера — она же у заголовка и бейджа сегмента шапки)
import { uiHelp_recordRowsHtml, uiHelp_enabled, uiHelp_rows } from '@/utils/uiHelp'   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3: uiHelp_rows — строки объяснения widget.header в подсказке контейнера шапки (реестр области — index.js)
import { freeWindow_startRect, freeWindow_dragState, freeWindow_nextRect, freeWindow_apply, freeWindow_listen } from '@/utils/freeWindow'   // demo-webscm 2026 11 02 / ODOO-350612: геометрия свободного окна — общий код с доком навигатора
import { defaultMark, meMarkExplicitOnly } from '@/utils/settingsDefaultMarks'   // IE 2026 10 08 / ODOO-5800: «Я» — только явный выбор (utils/settingsDefaultMarks, fe.ux.meMarkExplicitOnly)
import { chipWidget_open } from '@/utils/chipWidgetOpen'   // IE 2026 10 08 / ODOO-5800: виджет чипса — явно по привязанной записи, без подмены «Я»/«Всі» (utils/chipWidgetOpen)
import recordHelp from '@/utils/recordHelp'
import { cellView_get } from '@/utils/cellViews'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2)
import { adf_on, adf_block, adf_againstOf, adf_viewOf, adf_index, adf_status, adf_valueText, adf_isDeferred, adf_calcParams, adf_sideFromAnswer, adf_targetInfo, adf_navTargets, adf_notShownText, adf_tabSteps, adf_hiddenText, ADF_LANGS, ADF_CALC_METHOD, ADF_VIEW_KEY, ADF_VIEWS, cm_on, cm_rowTarget, adf_targetKey, adf_targetIndex, CM_ROWS_BINDING, CM_TAB_NAME } from '@/utils/auditDiff'   // IE 2026 10 31 / ODOO-349799 (PR3): связь строк «Changes» и формы   // IE 2026 10 31 / ODOO-349799: переход ‹ › через вкладки   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита)
import { widgetPreviews_captureOne, widgetPreviews_menuTipRows, widgetPreviews_menuVisible } from '@/utils/widgetPreviews'   // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов)
import { cornerHoverArm_on, cornerHoverOpenDelay, cornerArmDecide } from '@/utils/cornerHoverArm'   // IE 2026 10 25 / ODOO-345044 (hotfix: ✕ под курсором после ховера угла)
import cornerFormGuard from '@/utils/cornerFormGuard'   // IE 2026 09 28 / ODOO-… (замечание Игоря: зависает меню угла виджета): страж ⋯-формы угла — живёт, пока курсор в зоне «угол + форма» (pointermove + elementFromPoint), а не до mouseleave
import { labelClick_cancelActivation } from '@/utils/settingsListClick'   // IE 2026 10 08 / ODOO-5800: один клик по Я / Всі панели настроек — один запрос
import { stopClear_on, stopClear_fromHead, stopClear_readMin } from '@/utils/stopClear'   // IE 2026 09 28 / ODOO-341407 (находка ie-demo7 §16.1): Stop левее панели кнопок, показанной по наведению
import { vizTitleRoom, badgeWidths, badgeKeepLabel, badgeFullText } from '@/utils/vizHeaderFit'   // IE 2026 09 28 / ODOO-341407: строка шапки на вкладке визуализации — бейдж уступает место заголовку; короткая метка и полный источник (ревью ie-dm7, замечание 2)
import { i18nFieldsMenuItem, i18nFieldsToggleValue, TOGGLE_METHOD as I18N_FIELDS_TOGGLE } from '@/utils/i18nFieldsMenu'   // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2): пункт ≡ «Show translation fields»
import { kindBadge_on, kindBadge_tone, kindBadge_pos, KIND_BADGE_FLAG, KIND_BADGE_OPAQUE_FLAG, HEADER_SPACING_FLAG, kindBadge_posChip, kindBadge_roomAbove } from '@/utils/widgetKindBadge'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p220/p221/p222 шапка віджета: p220 / p222)   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p216 бейдж виду віджета — тиха іконка, плашка при наведенні)
import { formChip_pi, segMeta_headerPi, segMeta_cmdClass } from '@/utils/formChipIcon'   // IE 2026 10 23 / ODOO-348705 (заказ Игоря: иконка чипа карточки элемента виджета списков) · IE 2026 11 01 / ODOO-350449 (заказ Игоря: папка з шестернею для віджета сегмента, відкрита папка для списку): + segMeta_*
import { yearTotalsButton_on, yearTotals_button, yearTotals_insertAt } from '@/utils/yearTotals'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p217 кнопка Σ — річні підсумки за опцією, типово вимкнено)
import { TITLE_FULL_FLAG, TITLE_TAIL_FLAG, titleFlag_on, titleFull_on, titleTail_want, titleTail_clipX, stats as titleTailStats } from '@/utils/widgetTitleFit'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p223 заголовок на всю ширину неактивного виджета / p224 «…» и продолжение по наведению)
import { clipOverlay_show } from '@/utils/clipOverlay'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок — «…» и продолжение по наведению, как в ячейках)
import altTooltip from '@/utils/altTooltip'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок — «…» и продолжение по наведению, как в ячейках): при зажатом Alt (режим объяснений) продолжения нет
import { widgetHeaderOverflow_on, widgetHeaderOverflow_titleRoom, widgetHeaderOverflow_count, stats as hdrOverflowStats } from '@/utils/widgetHeaderOverflow'   // IE 2026 10 07 / ODOO-5800: кнопки шапки, не поместившиеся по ширине, — скрыты (остаются в ≡)
import { cornerMenuLite_on, cornerRow, cornerVariants_on, cornerLayoutMenu, cornerLayout_has, stats as cornerMenuStats } from '@/utils/widgetCornerMenu'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета)
import { sizeGrid_on, sizeGrid_current, sizePct_current, sizePct_parse, stats as menuSizeStats } from '@/utils/widgetMenuSize'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: визуальный выбор размера в меню виджета)
import { helpCard_on, helpCard_button, helpCard_isDocsButton, helpCard_show } from '@/utils/helpCard'   // IE 2026 11 03 / ODOO-350881 (инвентаризация помощи, этап 1): «?» карточки помощи у всех окон, флаг fe.ux.helpCard
let vizMeasureCanvas = null   // IE 2026 09 28 / ODOO-341407 (ревью ie-dm7, замечание 2): один canvas на все виджеты — замер ширины короткой метки бейджа (vizBadge_textWidth)

export default {
    props: [
        'widget_id',
    ],
    data: () => ({ 
        ntfFading: false,   // IE 2026 09 11 (Igor): затухание зелёного/жёлтого сообщения виджета
        cascadeStaleLast: '',   // IE 2026 10 07 / ODOO-335246 (Igor): последний текст плашки cascade_stale_sources — для подсказки индикатора каскада по Alt
        WIDGET: {},
        commandPanel: [],
        actionMenu: [],
        commandPanel_offsetWidth: 0,

        delayedLoading: false,
        loadingTimer: null,

        commandPanelLeft: [],
        show_commandPanel_topLeft: false,
        cornerPct: false,   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета): под рядом угла — поля W / H / X / Y и Free (пункт ≡ › Розкладка › «Ширина / висота, %…»)
        cornerIsland: false,   // IE 2026 09 22 / ODOO-5800 (Igor): при скрытой шапке — островок «сегмент · тайтл · развернуть» по наведению на правый верхний угол
        identInForm: false,   // IE 2026 09 23 / ODOO-… (замечание Игоря: в форме ⋯ — те же элементы шапки): бейдж + заголовок шапки телепортированы в форму «⋯» (включается после отрисовки формы — см. watch identWant)
        identEpoch: 0,        // номер открытия формы — id слота / цели панели (телепорт Vue помнит прошлую цель, снятую вместе с формой)
        is_hovered: false,
        commandPanel_topLeft1: [   // IE 2026 09 23 / ODOO-341407: i18n (tooltips)
            [
            //     { 'tooltip': 'Save', hotkey: 'Alt S', 'command': 'onSaveRecord__Click', 'v-if-meta000':'modified', 'params':{'closeWindow':false}, 'cssClass-row':'p-button-yellow', 'cssClass':'pi mb-1 p-button-yellow pi-save' }
            // ],[
                { 'tooltip': t('Reload'), 'cssClass-row':'p-button-yellow', 'cssClass':'pi mr-0 p-button-yellow p-button-text0 pi-sync', 'command': 'executeWidgetMethod', 'method': 'reload', 'record_sendToBackend_exclude': ['_doc'], 'v-if':"WIDGET?.record?._meta?.modified && WIDGET?.record?.id", uiHelp: 'widget.form.reload' },   // IE 2026 09 24 / ODOO-… (U3)
                { 'tooltip': t('Close Widget'), hotkey: 'Alt W', 'cssClass':'pi btn-widget-close p-button-white mr-0 p-button-text0 pi-times', 'command': 'onCloseWindow__Click', uiHelp: 'widget.form.close' },   // IE 2026 09 24 / ODOO-… (U3)
                // IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2), по скрину: разворот виджета на страницу — второй кнопкой после крестика (был в ряду масштаба), глиф — как у полного экрана стола
                { 'tooltip': t('Expand widget to full page / restore'), hotkey: 'Alt F', 'cssClass':'pi btn-widget-maximaze p-button-white mr-0 p-button-text0 pi-arrow-up-right-and-arrow-down-left-from-center', 'command': 'onWidgetMaxToggle__Click', uiHelp: 'widget.form.expand', uiHelpState: (W) => (W?.styleWidget?._mobileMax ? 'on' : 'off') },   // IE 2026 09 24 / ODOO-… (U3)
                // IE 2026 08 20 / ODOO-336291 (mobile UX) (заказ Игоря): «выбор настроек» скрыт и на десктопе (бейдж сегмента открывает то же)
                { hide: true, 'tooltip': t('Settings tree / Favorites'), 'cssClass':'pi btn-widget-dropdown p-button-white mr-0 p-button-text0 pi-angle-down', 'command': 'executeWidgetObjMethod', method:'toggleDropdown',  },
                { hotkey: 'Esc', 'command': 'onCloseWindow__Click', hide: true },
            ]
        ],
        // IE 2026 09 25 / ODOO-341407: "Scale widh N, height M" → "Scale width N, height M" (typo fixed in the tooltip keys below)
        commandPanel_Scale: [   // IE 2026 09 23 / ODOO-341407: i18n (titles, tooltips)
            [
                // IE 2026 08 20 / ODOO-336291 (mobile UX) (заказ Игоря): Minimize скрыт и на десктопе (hotkey Alt M живёт)
                { hide: true, 'tooltip': t('Minimize'), hotkey: 'Alt M', 'cssClass':'pi p-button-white mr-0 p-button-text0  pi-window-minimize', 'command': 'onMinimizeWidget__Click', uiHelp: 'widget.form.minimize' },   // IE 2026 09 24 / ODOO-… (U3)
            //     // { 'tooltip': 'Normal', 'command': 'onScale__Click', 'params':{'cssClassW':'none', 'cssClassH':'none'} },
            //     // { 'tooltip': 'Zoom', 'command': 'onScale__Click', 'params':{'widthMin_rem':4, 'heightMin_rem':4} },
            //     { 'tooltip': 'Full screen', 'cssClass':'pi p-button-white mr-0 p-button-text0  pi-window-maximize', 'command': 'onFullscreen__Click' },
            // ],[
                // { 'tooltip': 'Minimize', hotkey: 'Alt M', 'cssClass':'pi btn-widget-minimize p-button-white mr-0 p-button-text0  pi-minus', 'command': 'onMinimizeWidget__Click' },
                { tooltip: t('Pop-out / Dock back'), hotkey: 'Alt P', cssClass: 'pi btn-widget-popout p-button-white mr-0 p-button-text0 pi-th-large', command: 'onPopOut_DockBack__Click', uiHelp: 'widget.form.popout', uiHelpState: (W) => (W?.styleWidget?.dock === 'popout' ? 'free' : 'docked') },   // IE 2026 09 24 / ODOO-… (U3)
                { 'tooltip': t('Close others'), 'cssClass':'pi btn-widget-close p-button-white mr-0 p-button-text0  pi-bullseye', 'command': 'onCloseOthersWindow__Click', uiHelp: 'widget.form.closeOthers' },   // IE 2026 09 24 / ODOO-… (U3)
                // IE 2026 08 22 (заказ Игоря): разворот виджета на всю страницу
                // (тумблер _mobileMax) — перенесён сюда из правого верхнего угла
                // IE 2026 09 14 / ODOO-… (замечание Игоря: кнопки Full screen / Expand to page): кнопки и их иконки поменяны местами (визуально как было): стрелки из центра — разворот
                // виджета на страницу, окно с рамкой — полный экран браузера; глифы свои (ie-ico-fit-page / ie-ico-fullscreen)
                // IE 2026 09 15 / ODOO-… (заказ Игоря): Alt F — разворот виджета на страницу, полный экран браузера — Shift Alt F
                // IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2): разворот виджета (Alt F) переехал в первый ряд формы, за крестик
                { 'tooltip': t('Full screen'), hotkey: 'Shift Alt F', 'cssClass':'pi btn-widget-maximaze p-button-white mr-0 p-button-text0  ie-ico-fullscreen', 'command': 'onFullscreen__Click', uiHelp: 'widget.form.fullscreen', uiHelpState: () => (document.fullscreenElement ? 'on' : 'off') },   // IE 2026 09 24 / ODOO-… (U3)
                //TODO { tooltip: 'Pin / Unpin widget', hotkey: 'Alt P', cssClass: 'pi btn-widget-pin p-button-white mr-0 p-button-text0 pi-thumbtack', command: 'onTogglePinned__Click', },
            ],[
                { 'tooltip': t('Copy to clipboard'), 'cssClass':'pi btn-widget-minimize p-button-white mr-0 p-button-text0  pi-copy', 'command': 'externalLink', method: 'copyToClipboard', uiHelp: 'widget.form.copyLink' },   // IE 2026 09 24 / ODOO-… (U3)
                { 'tooltip': t('Open record in new tab'), 'cssClass':'pi btn-widget-minimize p-button-white mr-0 p-button-text0  pi-external-link', 'command': 'externalLink', method: 'openInNewTab', uiHelp: 'widget.form.newTab' },   // IE 2026 09 24 / ODOO-… (U3)
                { 'tooltip': t('Clone'), hotkey: 'Alt L', 'command':'onCloneRecord__Click', 'params':{'clone':true}, 'cssClass':'pi btn-widget-minimize p-button-white mr-0 p-button-text0 pi-clone', uiHelp: 'widget.form.clone'},   // IE 2026 09 24 / ODOO-… (U3)
            ],[

                // { 'tooltip': 'Zen mode', 'cssClass':'pi btn-zen-mode p-button-white mr-0 p-button-text0  pi-window-maximize', 'command': 'onZenMode__Click' },
                { title: t('Header'), tooltip: t('Toggle widget header'),      showCommandTitle: true, cssClass: 'btn-hide-header    p-button-white mr-0 p-button-text0 ml-1 mt-1 mb-1', command: 'onToggleView__Click', param: 'hideHeader', uiHelp: 'widget.form.header', uiHelpState: (W) => (W?.styleWidget?.hideHeader ? 'off' : 'on') },   // IE 2026 09 24 / ODOO-… (U3)
                { title: t('Tabs'),   tooltip: t('Toggle tab headers'),        showCommandTitle: true, cssClass: 'btn-hide-tabs      p-button-white mr-0 p-button-text0 ml-1 mt-1 mb-1', command: 'onToggleView__Click', param: 'hideTabs', uiHelp: 'widget.form.tabs', uiHelpState: (W) => (W?.styleWidget?.hideTabs ? 'off' : 'on') },   // IE 2026 09 24 / ODOO-… (U3)
                { title: t('Panel'),  tooltip: t('Toggle grid command panel'), showCommandTitle: true, cssClass: 'btn-hide-gridpanel p-button-white mr-0 p-button-text0 ml-1 mt-1 mb-1', command: 'onToggleView__Click', param: 'hideGridPanel', uiHelp: 'widget.form.panel', uiHelpState: (W) => (W?.styleWidget?.hideGridPanel ? 'off' : 'on') },   // IE 2026 09 24 / ODOO-… (U3)
                // IE 2026 09 14 / ODOO-… (замечание Игоря: парящий заголовок): заголовок и панель команд островками поверх содержимого (при скрытых табах — содержимое под всей рамкой)
                // IE 2026 09 24 / ODOO-341407 (замечание Игоря): контекстный ключ «Float|layout» — «Плаваючий», не «Дробове число» (числовой тип)
                { title: t('Float', null, 'layout'),  tooltip: t('Floating header: the title and the command panel as islands over the content'), showCommandTitle: true, cssClass: 'btn-float-header p-button-white mr-0 p-button-text0 ml-1 mt-1 mb-1', command: 'onToggleView__Click', param: 'floatHeader', uiHelp: 'widget.form.float', uiHelpState: (W) => (W?.vueObj?.floatHeaderOn ? 'on' : 'off') },   // IE 2026 09 24 / ODOO-… (U3)
            ],[
                { 'tooltip': t('Scale width 1, height 1'), hotkey: 'Alt 1', 'cssClass':'pi btn-widget-size p-button-white mr-0 p-button-text0 pi-expand btnScale', 'command': 'onScale__Click', 'params':{'widthMin_rem':1, 'heightMin_rem':1}, uiHelp: 'widget.form.scale' },   // IE 2026 09 24 / ODOO-… (U3)
                { 'tooltip': t('Scale width 2, height 1'), hotkey: 'Alt 2', 'cssClass':'pi btn-widget-size p-button-white mr-0 p-button-text0 pi-expand btnScale', 'command': 'onScale__Click', 'params':{'widthMin_rem':2, 'heightMin_rem':1}, uiHelp: 'widget.form.scale' },   // IE 2026 09 24 / ODOO-… (U3)
                { 'tooltip': t('Scale width 3, height 1'), hotkey: 'Alt 3', 'cssClass':'pi btn-widget-size p-button-white mr-0 p-button-text0 pi-expand btnScale', 'command': 'onScale__Click', 'params':{'widthMin_rem':3, 'heightMin_rem':1}, uiHelp: 'widget.form.scale' },   // IE 2026 09 24 / ODOO-… (U3)
                { 'tooltip': t('Scale width 4, height 1'), hotkey: 'Alt 4', 'cssClass':'pi btn-widget-size p-button-white mr-0 p-button-text0 pi-expand btnScale', 'command': 'onScale__Click', 'params':{'widthMin_rem':4, 'heightMin_rem':1}, uiHelp: 'widget.form.scale' },   // IE 2026 09 24 / ODOO-… (U3)
                // { 'tooltip': 'Full screen', 'cssClass':'pi p-button-white mr-0 p-button-text0', 'command': 'onFullscreen__Click' },
            ],[
                // { 'tooltip': 'Minimize', 'cssClass':'pi p-button-white mr-0 p-button-text0', 'command': 'onMinimizeWidget__Click' },
                { 'tooltip': t('Scale width 1, height 2'), hotkey: 'Alt 5', 'cssClass':'pi btn-widget-size p-button-white mr-0 p-button-text0 pi-expand btnScale', 'command': 'onScale__Click', 'params':{'widthMin_rem':1, 'heightMin_rem':2}, uiHelp: 'widget.form.scale' },   // IE 2026 09 24 / ODOO-… (U3)
                { 'tooltip': t('Scale width 2, height 2'), hotkey: 'Alt 6', 'cssClass':'pi btn-widget-size p-button-white mr-0 p-button-text0 pi-expand btnScale', 'command': 'onScale__Click', 'params':{'widthMin_rem':2, 'heightMin_rem':2}, uiHelp: 'widget.form.scale' },   // IE 2026 09 24 / ODOO-… (U3)
                { 'tooltip': t('Scale width 3, height 2'), hotkey: 'Alt 7', 'cssClass':'pi btn-widget-size p-button-white mr-0 p-button-text0 pi-expand btnScale', 'command': 'onScale__Click', 'params':{'widthMin_rem':3, 'heightMin_rem':2}, uiHelp: 'widget.form.scale' },   // IE 2026 09 24 / ODOO-… (U3)
                { 'tooltip': t('Scale width 4, height 2'), hotkey: 'Alt 8', 'cssClass':'pi btn-widget-size p-button-white mr-0 p-button-text0 pi-expand btnScale', 'command': 'onScale__Click', 'params':{'widthMin_rem':4, 'heightMin_rem':2}, uiHelp: 'widget.form.scale' },   // IE 2026 09 24 / ODOO-… (U3)
            ]
        ],

        // текущие значения полей W/H/X/Y % и флага Free (ит.3 п.3.3)
        layoutInputs: { width: null, height: null, left: null, top: null, free: false },
        topLeftLeft: null,   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета): ряд угла правее иконки вида (тихая шапка) — его left в px; null — как раньше (3 px)
        topLeftTop: null,   // IE 2026 09 15 / ODOO-… (замечание Игоря): в Float ⋯-форма открывается под островком заголовка — её top в px
        vizTab: false,   // IE 2026 09 15 (замечание Игоря, вечер): виджет-список на вкладке визуализации (пузырьки / график / карта / граф) в Float

        show_commandPanel_bottomRight: false,
        // IE 2026 09 25 / ODOO-341407: "Scale widh N, height M" → "Scale width N, height M" (typo fixed in the tooltip keys below)
        commandPanel_bottomRight: [   // IE 2026 09 23 / ODOO-341407: i18n (tooltips)
            [
                { 'title': '1', 'tooltip': t('Scale width 1, height 1'), 'cssClass':'pi p-button-white mr-0 p-button-text0 ', 'command': 'onScale__Click', 'params':{'widthMin_rem':1, 'heightMin_rem':1} },
                { 'title': '2', 'tooltip': t('Scale width 2, height 1'), 'cssClass':'pi p-button-white mr-0 p-button-text0 ', 'command': 'onScale__Click', 'params':{'widthMin_rem':2, 'heightMin_rem':1} },
                { 'title': '3', 'tooltip': t('Scale width 3, height 1'), 'cssClass':'pi p-button-white mr-0 p-button-text0 ', 'command': 'onScale__Click', 'params':{'widthMin_rem':3, 'heightMin_rem':1} },
                { 'title': '4', 'tooltip': t('Scale width 4, height 1'), 'cssClass':'pi p-button-white mr-0 p-button-text0 ', 'command': 'onScale__Click', 'params':{'widthMin_rem':4, 'heightMin_rem':1} },
            ],[
                { 'title': '5', 'tooltip': t('Scale width 1, height 2'), 'cssClass':'pi p-button-white mr-0 p-button-text0 ', 'command': 'onScale__Click', 'params':{'widthMin_rem':1, 'heightMin_rem':2} },
                { 'title': '6', 'tooltip': t('Scale width 2, height 2'), 'cssClass':'pi p-button-white mr-0 p-button-text0 ', 'command': 'onScale__Click', 'params':{'widthMin_rem':2, 'heightMin_rem':2} },
                { 'title': '7', 'tooltip': t('Scale width 3, height 2'), 'cssClass':'pi p-button-white mr-0 p-button-text0 ', 'command': 'onScale__Click', 'params':{'widthMin_rem':3, 'heightMin_rem':2} },
                { 'title': '8', 'tooltip': t('Scale width 4, height 2'), 'cssClass':'pi p-button-white mr-0 p-button-text0 ', 'command': 'onScale__Click', 'params':{'widthMin_rem':4, 'heightMin_rem':2} },
            ],[
                // { 'tooltip': 'Minimize', 'cssClass':'pi p-button-white mr-0 p-button-text0  pi-window-minimize', 'command': 'onMinimizeWidget__Click' },
                // { 'tooltip': 'Normal', 'command': 'onScale__Click', 'params':{'cssClassW':'none', 'cssClassH':'none'} },
                // { 'tooltip': 'Zoom', 'command': 'onScale__Click', 'params':{'widthMin_rem':4, 'heightMin_rem':4} },
                { 'tooltip': t('Full screen'), 'cssClass':'pi p-button-white mr-0 p-button-text0  pi-window-maximize', 'command': 'onFullscreen__Click' },
            ],
        ],

        isEditingHeader:false,
        isMainArea: true,
        openInPlace: true,
        showDropdown: false,
        dropdownAccent: '',
        // IE 2026 08 20 (заказ Игоря): ховер-оверлей табов при скрытой строке табов
        showTabsHover: false,
        titleFitWidth: null,   // IE 2026 09 14 / ODOO-… (замечание Игоря: парящий заголовок): ширина островка заголовка по тексту
        vizTitleMax: null,     // IE 2026 09 27 / ODOO-341407: вкладка визуализации — предел ширины заголовка до островка кнопок холста (замер vizTitle_measure)
        vizTitleLeft: null,    // IE 2026 09 27 / ODOO-341407 (ревью ie-dm7 #47608): левый край поля заголовка в шапке — место плашки полного заголовка
        titleTailCover: false,   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок — «…» и продолжение по наведению, как в ячейках): продолжение заголовка показано поверх панели кнопок
        hdrVisible: Infinity,   // IE 2026 10 07 / ODOO-5800 (поручение Igor 07.10): сколько кнопок панели шапки видно (с начала ряда); Infinity — все; 0 — панель скрыта целиком (hdrOverflow_measure)
        stopClearMax: null,    // IE 2026 09 28 / ODOO-341407 (находка ie-demo7 §16.1): предел заголовка, при котором Stop стоит левее панели кнопок по наведению (замер stopClear_measure)
        vizBadgeMax: null,     // IE 2026 09 28 / ODOO-341407: вкладка визуализации — предел ширины бейджа сегмента, уступившего место заголовку (vizTitle_measure → vizTitleRoom)
        kindIconPos: null,   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p216 бейдж виду віджета — тиха іконка, плашка при наведенні): положение плашки поверх тихой иконки (kindIcon_place)
        kindIconPlace: 'above',   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p220/p221/p222 шапка віджета: p222 — чипс над шапкой; 'below' — под строкой шапки, когда сверху места нет (kindIcon_checkRoom)
        vizBadgeBare: false,   // IE 2026 09 28 / ODOO-341407: бейдж уступил весь текст (остались иконки и шеврон) — текст прячется целиком, без обрезка глифа
        floatPad: false,       // IE 2026 09 14 / ODOO-… (замечание Игоря: Float — кнопки содержимого ниже островков): содержимое без «холста» (грид/форма) — с отступом под островки
        cowHover: false,            // IE 2026 08 23 / ODOO-5884: панель бейджа COW
        cowHoverTimer: null,
        refHover: false,            // IE 2026 08 28 / ODOO-5800: панель бейджа «Reference view» (копия из теста данных)
        refHoverTimer: null,
        adfHover: false, adfHoverTimer: null, adfPinned: false, adfMenu: false, adfMenuTimer: null, adfNavPos: -1, adfTick: 0,   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита)
        tabsHoverStyle: {},
        // IE 2026 08 20 (заказ Игоря): доп. колонки списка настроек (Tags/Owner/
        // Updated/Private) по умолчанию скрыты — показ тумблером sl-details
        settingsListDetails: false,
        settingsListAttr: null,      // IE 2026 08 19 / ODOO-5512: табличный список настроек
        settingsListReady: true,     // IE 2026 09 04 / ODOO-336291 (mobile UX): P-16 — false на время отложенной сборки списка (мобайл)
        settingsListHeight: 320,     // высота встроенной таблицы под содержимое
        settingsListMy: false,       // фильтр «только мои»
        settingsListHidden: false,   // показать скрытые (private) чужие
        settingsPanelMode: 'settings',   // IE 2026 09 04 / ODOO-336331: тумблер Settings | Variants
        variantsListAttr: null,          // IE 2026 09 04 / ODOO-336331: табличный список вариантов текущей настройки
        variantsListHeight: 220,
        dropdownStyle: {},
        sdNarrow: false, // IE 2026 09 04 / ODOO-336331: узкая панель — Favorites под списком
        sdSizing: false, // IE 2026 09 04 / ODOO-336331: панель невидима до первого подбора размера (нет прошлого размера)
        mobSelectMode: false,   // IE 2026 08 21 (заказ Игоря): false = режим просмотра грида (пан/зум)
        mobileBarOpen: false,   // IE 2026 08 20 / ODOO-336291 (mobile UX): лист панели команд грида
        mobileBarAvail: true,   // IE 2026 09 04 / ODOO-336291 (mobile UX): B-33 — у активного виджета есть непустая панель команд грида
        mobileTabsOpen: false,
        mobileVizMode: 'grid', // IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: что тумблерит viz-кнопка
        chartAxesOn: false,
        gridHeadsOn: false,
        mobTitleInset: false, // IE 2026 08 23: заголовок с отступом 56px влезает целиком
        mobileTabsList: [],     // IE 2026 08 20 / ODOO-336291 (mobile UX) (#4188): пункты рейл-меню табов     // IE 2026 08 20 / ODOO-336291 (mobile UX) (#4184): показать числовые заголовки грида     // IE 2026 08 20 / ODOO-336291 (mobile UX) (#4182): показать оси/легенду графика  // IE 2026 08 20 / ODOO-336291 (mobile UX) (#4174): лист табов — отдельно, нижней левой кнопкой
        resolveIndex: 0,
        treeDrag: { srcNode: null, overId: null, position: null },

        // for dropdown example
        dropdown_data: [
            // IE 2026 09 23 / ODOO-341407: i18n (tab titles)
            { attr_type: 'AttrTab', title: t('Settings tree'), name:'parents_tree', pi: 'pi pi-folder-open', 
                action: { 'command': 'onShowInList__Click', 'viewAccess':'access-extraView' },
                default_segment: 'CHIP-Node',
                'attrs':[
                    // { node: {
                    //     pi: "pi pi-pen-to-square",
                    //     value: "task-process_mesures",
                    //     valueStr: "Select & calculate",
                    //     attr_type: "AttrLink",
                    //     relation_segment: "TASKS-process_mesures",
                    // }},
            ]},
            // IE 2026 09 04 / ODOO-336331 (заказ Игоря): варианты текущей настройки — своя вкладка,
            // видна в режиме Variants тумблера (dropdownTabs)
            // IE 2026 09 04 / ODOO-336331: глиф pi-share-alt — pi-code-branch в primeicons 7.0.0 нет (кнопка/иконка рисовались пустыми)
            { attr_type: 'AttrTab', title: t('Variants of the current setting'), name:'variants_tree', pi: 'pi pi-share-alt', 'attrs':[] },
            // IE 2026 09 15 / ODOO-… (замечание Игоря, вечер): секция Favorites (Save current as copy / as my copy) снята — одна команда
            // «Save as new» под деревом (dropdown-settings-footer → settingsList_saveAsNew)
        ],
    }),
    // setup: () => ({ palette }),
    setup() {
        const store = useMainStore();
        const palette = store.palette;
        return {
            store,
            palette
        }
    },
    created() {
        // this.title = this.store.findWidget(this.widget_id).WIDGET.title
        // if (!this.store.hide_console) console.log('created Widget')
        const WIDGET = this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        // if (!('vueObj' in WIDGET)) {
        //     WIDGET.vueObj = this
        // }
            
        // this.store.widget_attr_set(this)
        WIDGET.attrs_vueObj.WIDGET = this
     
        this.set_commandPanel()

        this.PAGE = this.store.WORKSPACES[WIDGET.workspace].PAGES[WIDGET.page]
    
        // const scrollPosition = window.scrollY
        // this.$nextTick(() => {
        //     window.scrollTo(0, scrollPosition)
        // })

        this.commandPanel_topLeft1.forEach((panel, index) => {
            this.store.prepare_attrs(panel, `commandPanel1_${WIDGET.id}_${index}`)
        })
        // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета): кнопка Minimize в форме «⋯» снова видна на десктопе (скрыта с 20.08, коммит 23715e08d); выключатель fe.ux.widgetMinimize (дефолт ВКЛ), телефон — скрыта
        try { const mn = this.commandPanel_Scale.flat().find(a => a && a.command === 'onMinimizeWidget__Click'); if (mn && !this.store.mobileUi?.on && this.store.setting('fe.ux.widgetMinimize', true) !== false) mn.hide = false } catch (e) { /* без кнопки — как с 20.08 */ }   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета)
        this.commandPanel_Scale.forEach((panel, index) => {
            this.store.prepare_attrs(panel, `commandPanel2_${WIDGET.id}_${index}`)
        })
        this.commandPanel_bottomRight.forEach((panel, index) => {
            this.store.prepare_attrs(panel, `commandPanel3_${WIDGET.id}_${index}`)
        })
        this.mouseenter_btnScale()
        this._resolveDropdownAttrLinks()
    },
    mounted() {
        cornerFormGuard.install(this.store)   // IE 2026 09 28 / ODOO-… (замечание Игоря: зависает меню угла виджета): глобальные слушатели стража — один раз на приложение (install идемпотентен)
        // IE 2026 09 24 / ODOO-341407 (поручение Игоря: смена языка без перезагрузки): описания кнопок шапки / масштаба / нижней панели и
        // вкладок панели настроек собраны в data() строками t() прежнего языка — переподписываем на месте (retranslate: обратная карта
        // словаря), командная панель / меню виджета пересобираются штатным set_commandPanel после перелокализации подписей бэка (phase 'attrs')
        this._i18nHandler = (ev) => {
            // IE 2026 09 24 / ODOO-341407 (второй обход dev02): phase 'data' — подписи дерева настроек (parents_tree) переведены по id, строки списка панели пересобрать
            if (ev?.detail?.phase === 'data') { try { if (this.settingsListAttr) this.settingsList_rebuild() } catch (e) { console.warn('[i18n] settings list', e) } return }
            if (ev?.detail?.phase !== 'attrs') return
            try {
                retranslateDeep(this.commandPanel_topLeft1)
                retranslateDeep(this.commandPanel_Scale)
                retranslateDeep(this.commandPanel_bottomRight)
                for (const tab of this.dropdown_data || []) if (typeof tab?.title === 'string') tab.title = retranslate(tab.title)   // без attrs: узлы дерева — данные
                this.set_commandPanel()
                if (this.vizTab) { this.$nextTick(() => this.vizTitle_measure()); clearTimeout(this._vizTitleT); this._vizTitleT = setTimeout(() => this.vizTitle_measure(), 400) }   // IE 2026 09 27 / ODOO-341407: бейдж сменил ширину («DS» ↔ «Джерело»)
                clearTimeout(this._stopClearT); this._stopClearT = setTimeout(() => this.stopClear_measure(), 400)   // IE 2026 09 28 / ODOO-341407: подписи панели кнопок сменили ширину (en «Sales» ↔ uk)
            } catch (e) { console.warn('[i18n] widget relabel', e) }
        }
        window.addEventListener('i18n:changed', this._i18nHandler)
        this.mobGridBrowseInit() // IE 2026 08 21 (заказ Игоря): режим просмотра грида
        // IE 2026 08 23: отступ заголовка от кнопок; на mounted размеры/заголовок
        // ещё не готовы — ретраи после раскладки и ответа бэка
        this.$nextTick(() => this.mobTitleInsetCheck())
        // v2: $cg.setTimeout перетирал таймеры соседних виджетов (общий ключ)
        setTimeout(() => this.mobTitleInsetCheck(), 1200)
        this.$nextTick(() => this.titleFit_measure()); setTimeout(() => this.titleFit_measure(), 1200)   // IE 2026 09 14 / ODOO-… (замечание Игоря: парящий заголовок)
        // IE 2026 09 14 / ODOO-… (замечание Игоря: Float — кнопки содержимого ниже островков)
        this.$nextTick(() => this.floatPad_check()); setTimeout(() => this.floatPad_check(), 1500)
        this.$el?.addEventListener?.('mouseenter', () => this.floatPad_check(), { passive: true })
        // IE 2026 09 16 (вопрос Игоря: островок шестерёнки в строке заголовка только у первого виджета): холст (пузырьки / график) появляется
        // позже таймеров загрузки — режим viz-вкладки пересчитывается по изменению содержимого виджета, а не только по наведению
        try {
            // наблюдаем корень виджета: .widget-content у части виджетов появляется позже монтирования (v-if) — наблюдатель на нём не вставал
            const root = this.$el
            if (root && root.nodeType === 1 && typeof MutationObserver !== 'undefined') {
                this._floatPadMO = new MutationObserver(() => { clearTimeout(this._floatPadT); this._floatPadT = setTimeout(() => this.floatPad_check(), 200) })
                this._floatPadMO.observe(root, { childList: true, subtree: true })
            }
        } catch (e) { /* без наблюдателя — прежние таймеры и наведение */ }
        setTimeout(() => this.mobTitleInsetCheck(), 3500)
        let vueObj = this; const store = this.store; let WIDGET = this.WIDGET
        this.store.widgetResize_afterTimer(vueObj)
        this.setObserver_widgetResize()
        store.Scale(vueObj, WIDGET)

        if ('actionMenu' in vueObj) vueObj.actionMenu.command = vueObj.menuCommand();

        if (WIDGET._popoutRestoreStyle) {
            const style = WIDGET._popoutRestoreStyle
            delete WIDGET._popoutRestoreStyle
            store.setWIDGET_style(WIDGET, style, false)
        }

        // popout с ещё не применённым ректом (widget_open): применить до первой
        // отрисовки кадра — иначе окно мигает в левом-верхнем углу до checkPopout;
        // позиция уже правильная — dim-фаза widget-hidden (opacity .2) не нужна
        if (WIDGET.styleWidget?.dock === 'popout' && WIDGET.styleWidget.setWidgetRect) {
            store.checkPopout()
            WIDGET.hidden = false
        }

        vueObj.activateWidget()
        vueObj.attr_loadPyodide()
        // IE 2026 08 18 / ODOO-5512: открыт расшифровкой ячеек — связь со строкой-
        // источником (линия + область ячеек в чипе), div виджета уже в DOM
        if (WIDGET._drilldown_source != null) {
            this.$nextTick(() => store.drilldown_link(WIDGET, WIDGET._drilldown_source))
        }

        document.addEventListener('click', this._onDocumentClick)
        this.PAGE?.mainArea?.vueObj.checkWorkspaceScroll()
        // R10 (widget-unplaced): страховка — если раскладка не выдала px за 1.5с
        // (нештатный случай), показать виджет как есть, а не держать невидимым
        if (!WIDGET._placed) {
            this._placedFailsafe = setTimeout(() => { if (!this.WIDGET._placed) this.WIDGET._placed = true }, this.store.setting('fe.ux.widgetPlacedFailsafeMs', 1500))   // IE 2026 09 05 / ODOO-336330
        }
        const el = this.$refs.commandPanel
        if (el) {
            const observer = new ResizeObserver(entries => {
                this.commandPanel_offsetWidth = this.$refs.commandPanel.offsetWidth
            })
            observer.observe(el)
            this._resizeObserver = observer
        }
    },
    updated() {
        // IE 2026 09 27 / ODOO-341407 (ревью ie-dm7 #47608: Stop loading накрывал легенду): шапка перерисовалась (появилась / ушла кнопка Stop loading, бейдж) —
        // предел заголовка пересчитать в тот же кадр, не ждать наблюдателя floatPad_check (200 мс); не чаще раза в кадр
        if (this.vizTab && !this._vizTitleRaf && typeof requestAnimationFrame === 'function') this._vizTitleRaf = requestAnimationFrame(() => { this._vizTitleRaf = null; this.vizTitle_measure() })
        // IE 2026 09 28 / ODOO-341407 (находка ie-demo7 §16.1): появилась / ушла кнопка Stop, виджет стал (не)активным — место Stop относительно панели кнопок перемерить
        // в следующем кадре; без Stop и без предела — ничего не делаем
        if (!this._stopClearRaf && typeof requestAnimationFrame === 'function' && (this.stopClearMax != null || this.$el?.querySelector?.(':scope > .widget-container > .widget-stop-loading'))) {
            this._stopClearRaf = requestAnimationFrame(() => { this._stopClearRaf = null; this.stopClear_measure() })
        }
        this.hdrOverflow_schedule()   // IE 2026 10 07 / ODOO-5800: шапка перерисовалась (Stop, бейдж, состав панели) — перемерить, какие кнопки помещаются
        if (this.WIDGET?.startTime) {
            const endTime = performance.now()
            if (this.timerId) { clearTimeout(this.timerId) }
            this.timerId = setTimeout(() => {
                if (!this.store.hide_console) console.log()
                this.WIDGET.TERMINAL += `\n${( (endTime - this.WIDGET.startTime) / 1000).toFixed(3) }s rendering [[[[[[[[[[[]]]]]]]]]]]`
                this.WIDGET.startTime = null
                if (this.WIDGET.vueObj?.content_Changed_attr_vueObj) {
                    this.WIDGET.vueObj.content_Changed_attr_vueObj('TERMINAL', {fold:true})
                }
            }, 2000)

        }
    },
    // IE 2026 09 28 / ODOO-… (замечание Игоря: зависает меню угла виджета): уход со страницы (KeepAlive) — открытая форма закрывается: DOM страницы отсоединён, mouseleave не придёт, а после возврата
    // форма стояла бы открытой без курсора
    deactivated() { cornerFormGuard.deactivated(this) },
    beforeUnmount() {
        cornerFormGuard.sync(this, false)   // IE 2026 09 28 / ODOO-… (замечание Игоря: зависает меню угла виджета)
        if (this._i18nHandler) { window.removeEventListener('i18n:changed', this._i18nHandler); this._i18nHandler = null }   // IE 2026 09 24 / ODOO-341407
        if (this._floatPadMO) { try { this._floatPadMO.disconnect() } catch (e) { this._floatPadMO = null } this._floatPadMO = null }   // IE 2026 09 16
        clearTimeout(this._floatPadT)
        clearTimeout(this._vizTitleT)   // IE 2026 09 27 / ODOO-341407
        if (this._vizTitleRaf) { cancelAnimationFrame(this._vizTitleRaf); this._vizTitleRaf = null }   // IE 2026 09 27 / ODOO-341407 (ревью ie-dm7 #47608)
        clearTimeout(this._stopClearT); if (this._stopClearRaf) { cancelAnimationFrame(this._stopClearRaf); this._stopClearRaf = null }   // IE 2026 09 28 / ODOO-341407
        if (this._hdrRaf) { cancelAnimationFrame(this._hdrRaf); this._hdrRaf = null }   // IE 2026 10 07 / ODOO-5800
        this.titleTail_hide()   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок — «…» и продолжение по наведению, как в ячейках)
        // IE 2026 09 04 / ODOO-336331: слушатель ресайза окна панели настроек
        if (this._sdWinResize) { window.removeEventListener('resize', this._sdWinResize); this._sdWinResize = null }
        clearTimeout(this._tabsHoverZoneT); clearTimeout(this._tabsHoverT) // IE 2026 08 27 / ODOO-5800: таймеры оверлея табов
        document.removeEventListener('click', this._onDocumentClick)
        this.mobileBarOutside_sync(false); this.removeTopLeftOutside() // IE 2026 09 04 / ODOO-336291 (mobile UX): снять document-слушатели листов
        this._mobPanelRO?.disconnect(); this._mobPanelRO = null // IE 2026 09 04 / ODOO-336291 (mobile UX): B-15
        this._resizeObserver?.disconnect()
        clearTimeout(this.loadingTimer);
        clearTimeout(this._placedFailsafe);
        clearTimeout(this._ntfTimer); clearTimeout(this._ntfFadeTimer)   // IE 2026 09 11 (Igor): таймеры затухания сообщения
    },
    unmounted() {
        this.PAGE?.mainArea?.vueObj.checkWorkspaceScroll()
    },
    methods: {
        // IE 2026 09 11 (Igor): затухание сообщения виджета — success/warning: 8 с показа, 1.5 с затухания, потом visible=false;
        // наведение мыши останавливает таймер (сообщение остаётся до крестика или следующего сообщения)
        notificationAutoHide(n) {
            clearTimeout(this._ntfTimer); clearTimeout(this._ntfFadeTimer); this.ntfFading = false
            if (!n || !n.visible) return
            const st = String(n.status || 'success')
            if (!['success', 'warning', 'info', 'ok'].includes(st)) return
            const ms = st === 'warning' ? 12000 : 8000
            this._ntfFadeTimer = setTimeout(() => { this.ntfFading = true }, ms - 1500)
            this._ntfTimer = setTimeout(() => { this.ntfFading = false; n.visible = false }, ms)
        },
        notificationHold() {
            clearTimeout(this._ntfTimer); clearTimeout(this._ntfFadeTimer); this.ntfFading = false
        },
        showStopLoading() {
            // Stop уместен там, где идёт долгая ВЫБОРКА (отчёт/список) или
            // первичная ОТРИСОВКА тела: большой отчёт строит кадр десятки секунд.
            // В документе (Record) и прочих виджетах кнопка мешала.
            // МЕТОД, а не computed: WIDGET первого открытия ещё сырой
            // (нереактивный) — computed кэшировался навсегда и кнопка
            // «зависала» при погашенных флагах ($forceUpdate компонент
            // перерисовывает, но кэш computed не сбрасывает)
            const W = this.WIDGET
            // идёт формирование отчёта (полоса прогресса от бэка) — кнопка нужна
            // всегда, чем бы виджет ни оказался
            if (W.loadingPct != null) return true
            const busy = W.loading || W.firstBackendCheck || W._firstLoading || W._gridTitlesPending > 0
            if (!busy) return false
            const wc = W.widget_class || W.record?.segment || ''
            if (!wc) {
                // скелет-кадр первого открытия: класс придёт только с view, а
                // ждать тут дольше всего (формирование отчёта) — кнопку показываем
                return !!W.firstBackendCheck || !!W._firstLoading
            }
            // класс/сегмент проверяем подстрокой — как остальной код (REPORT2
            // бывает не только 'widget_REPORT2': варианты класса и сегмента
            return /REPORT2|LIST|TREE/.test(wc)
        },
        activateWidget(is_header=false, run_scrollInWorkspace=true) {
            this.store.widget_activate(this.WIDGET, 'WIDGET::activateWidget', run_scrollInWorkspace)
        },
        // ⚠ КОНФЛИКТ ДВУХ ЗАДАЧ — не «упрощать» этот guard (activity-theft-guard):
        // Задача А (клавиатура грида): после обновления данных wijmo/AttrGrid
        //   возвращают DOM-фокус активной ячейке ПРОГРАММНО — и наш
        //   flex.hostElement.focus() (AttrGrid, парный маркер), и ВНУТРЕННИЙ
        //   рефокус wijmo при refresh (его перехватить нельзя). Это нужно для
        //   стрелок/hotkeys.
        // Задача Б (активность открытого окна): виджет, явно открытый
        //   пользователем (Alt+клик по ячейке, кнопка open), активируется в
        //   widget_open.success и ДОЛЖЕН удержать активность.
        // Без guard'а программный рефокус источника приходит ПОЗЖЕ активации
        // нового окна (~500-600мс, после refresh грида) → focusin → активность
        // крадётся назад. Поэтому focusin переносит активность ТОЛЬКО если ему
        // предшествовал ПОЛЬЗОВАТЕЛЬСКИЙ ввод в этом же виджете
        // (pointerdown/keydown < 500мс, см. markFocusIntent) — программный
        // рефокус таким вводом не сопровождается и активность не трогает.
        // IE 2026 09 12 / ODOO-… (замечание Игоря): клик по крестику (закрыть / закрыть остальные) НЕактивного виджета не должен менять активный
        // виджет. Раньше нажатие сначала активировало закрываемый виджет (фокус кнопки → onFocusIn, всплытие клика → clickWidget),
        // и widget_close, видя его активным, отдавал активность родителю или первому виджету страницы
        isCloseButtonEvent(e) {
            const t = e?.target
            return !!(t && typeof t.closest === 'function' && t.closest('.btn-widget-close, .widget-close-btn'))
        },
        markFocusIntent(e) {
            if (this.isCloseButtonEvent(e)) { this.store._focusIntent = null; return }   // IE 2026 09 12 / ODOO-…
            this.store._focusIntent = { id: this.WIDGET.id, t: performance.now() }
        },
        onFocusIn() {
            if (this.store._suppressFocusActivate) return
            const intent = this.store._focusIntent
            if (!(intent && intent.id === this.WIDGET.id && performance.now() - intent.t < 500)) return
            this.activateWidget(false, false)
        },
        _focus_activeChips(force = false) {
            setTimeout(() => {
                const ae = document.activeElement
                if (!force && ae && ae !== document.body
                    && ae.closest('.wj-cell,.wj-row,[role="grid"],.chips-input,.chip-input,button,a,select,textarea,input')
                ) return
                const chipsVueObj = this._find_visibleChips()
                if (!chipsVueObj) return
                chipsVueObj.editable = true
                this.$nextTick(() => chipsVueObj.$refs.input?.focus())
            }, 50)
        },
        _flash_border() {
            const el = this.$el
            if (!el) return
            el.classList.remove('widget-border-flash')
            void el.offsetWidth  // force reflow to restart animation
            el.classList.add('widget-border-flash')
            el.addEventListener('animationend', () => el.classList.remove('widget-border-flash'), { once: true })
        },
        _find_visibleChips() {
            for (const vueObj of Object.values(this.WIDGET.attrs_vueObj)) {
                if (!vueObj?.$el || vueObj.$el.offsetParent === null) continue
                if (vueObj.attr?.attr_type === 'AttrChips' && vueObj.mode !== 'Page') return vueObj
                if (vueObj.attr?.attr_type === 'AttrGrid' && vueObj.$refs?.chips) return vueObj.$refs.chips
            }
            return null
        },
        clickWidget(e) {
            // IE 2026 09 12 / ODOO-… (замечание Игоря): крестик — не активация; закрытый (мягко) виджет тоже не активируем
            if (this.isCloseButtonEvent(e) || this.WIDGET?._softClosed || this.WIDGET?.close) return
            // IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: на телефоне тап по любому виджету
            // (и свободному тоже — inDock у него false) делает его активным
            if (this.store.mobileUi?.on) {
                if (!this.isActiveWidget) this.store.widget_activate(this.WIDGET, 'WIDGET::clickWidget')
                return
            }
            // IE 2026 09 08 / ODOO-… (заказ Игоря, скрин dev02): клик по ЛЮБОЙ части ЛЮБОГО виджета делает его
            // активным. Снята защита be333e0f «родитель не активируется, пока активен его дочерний виджет»
            // (при открытой из виджета форме клик по его шапке/телу не делал ничего — шапку накрывает
            // .popout-grab-top, и клик шёл сюда, а не в title-input). Дочерняя форма остаётся открытой и
            // по-прежнему следует за строкой родителя; фокус-защита от программного рефокуса (onFocusIn) не тронута.
            if (this.WIDGET.styleWidget?.inDock) {
                this.store.widget_activate(this.WIDGET, 'WIDGET::clickWidget')
            } else if (this.WIDGET.styleWidget?.dock === 'popout') {
                // клик по области СВОБОДНОГО виджета тоже активирует (раньше — только шапка или фокус поля);
                // режимы свободных виджетов (utils/freeWidgets) идут от активации
                if (this.store.activeWIDGET !== this.WIDGET) this.store.widget_activate(this.WIDGET, 'WIDGET::clickWidget:popout')
            }
        },
        initMenu(menu) {
            this[menu.hostElement.id] = menu;
            // IE 2026 08 21 (скрин Игоря 19:31): мобайл — тап по папке раскрывает
            // её содержимое на месте (capture-страховка, если itemClicked не дошёл)
            const drill = (e) => {
                if (!this.store.mobileUi?.on) return
                const el = e.target.closest?.('.wj-listbox-item')
                if (!el || !menu.dropDown?.contains(el)) return
                const items = [...menu.dropDown.querySelectorAll('.wj-listbox-item')]
                const item = menu.itemsSource?.[items.indexOf(el)]
                if (item && item.attrs?.length) {
                    e.stopPropagation(); e.preventDefault()
                    this.menuDrill(menu, item)
                }
            }
            // dropDown создаётся лениво — вешаем слушатель при первом открытии
            menu.isDroppedDownChanged.addHandler(() => {
                if (menu.isDroppedDown && menu.dropDown && !menu.dropDown._drillHooked) {
                    menu.dropDown._drillHooked = true
                    // click до панели не доходит (wijmo гасит/пересобирает) —
                    // ловим mousedown и touchstart
                    menu.dropDown.addEventListener('mousedown', drill, true)
                    menu.dropDown.addEventListener('touchstart', drill, true)
                }
            })
        },
        menuDrill(menu, item) {
            // IE 2026 08 22 (заказ Игоря): INLINE — дети вставляются/убираются
            // ПОД пунктом в том же списке, глубина рисуется отступом
            // IE 2026 08 23 (скрин Игоря 12:36): мутация НА МЕСТЕ — переприсваивание
            // itemsSource закрывало панель (морг при реопене)
            const src = menu.itemsSource.slice()
            const idx = src.indexOf(item)
            if (idx < 0) return
            const d0 = item._menuDepth || 0
            if (item._menuOpen) {
                let end = idx + 1
                while (end < src.length && (src[end]._menuDepth || 0) > d0) end++
                for (let j = idx + 1; j < end; j++) src[j]._menuOpen = false
                src.splice(idx + 1, end - idx - 1)
                item._menuOpen = false
            } else {
                const children = item.attrs
                    .filter(a => a.use !== false && a.hidden !== true && this.store.checkAccess(a, this.WIDGET))   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + WIDGET — архив прячет запись только у данных модели (ревью #110599)
                children.forEach(a => { a._menuDepth = d0 + 1 })
                src.splice(idx + 1, 0, ...children)
                item._menuOpen = true
            }
            menu.itemsSource = src
            menu.selectedIndex = -1
            setTimeout(() => { menu.isDroppedDown = true }, 50)
            // IE 2026 08 23 (скрин Игоря 11:27): раскрытая папка у нижнего
            // края — прокрутить панель: заголовок папки виден сверху, дети в кадре
            if (item._menuOpen) setTimeout(() => {
                const p = menu.dropDown
                const el = p?.querySelectorAll?.('.wj-listbox-item')?.[idx]
                if (el && p.scrollHeight > p.clientHeight + 4) {
                    const top = el.getBoundingClientRect().top - p.getBoundingClientRect().top + p.scrollTop
                    p.scrollTop = Math.max(0, Math.min(top - 8, p.scrollHeight - p.clientHeight))
                }
            }, 170)
        },
        menuCommand(param) {
            let this_ = this
            return {
                executeStoreMethod: function(param){
                    let vueObj = this_.WIDGET.vueObj
                    vueObj.store.executeStoreMethod(vueObj, param)
                },
                canExecuteCommand: function(param){
                    return true;
                }
            }
        },
        // IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2): пункт панели функций ≡ — то же действие, что у пункта wj-menu (menuNodeClicked)
        menuPanelPick(item) {
            if (!item || item.disabled) return
            this.store.executeStoreMethod(this.WIDGET.vueObj, item)
        },
        // IE 2026 09 22 / ODOO-… (заказ Игоря, п.4): избранные команды ≡ виджета — личные, ключ 'widget:<сегмент записи виджета>'
        menuFavKind() { return 'widget:' + String(this.WIDGET?.record?.segment || this.WIDGET?.widget_class || '') },
        menuFavOf(raw) { return (raw && !raw.attrs?.length) ? this.store.menuFav_has(this.menuFavKind(), raw) : null },
        menuFav(raw, on) { this.store.menuFav_toggle(this.menuFavKind(), raw, on) },
        menuNodeClicked(menu) {
            let actionMenu = menu.itemsSource[menu.selectedIndex]
            // IE 2026 08 21: мобайл — папка/«‹ Back» раскрываются на месте
            if (this.store.mobileUi?.on && actionMenu && actionMenu.attrs?.length) {
                this.menuDrill(menu, actionMenu)
                return
            }
            let vueObj = this.WIDGET.vueObj
            this.store.executeStoreMethod(vueObj, actionMenu)
        },
        onClick(actionMenu) {
            let vueObj = this.WIDGET.vueObj
            vueObj.store.executeStoreMethod(vueObj, actionMenu)
        },
        onZoomClick() {
            if (!this.WIDGET.title_editable) {
                let vueObj = this.WIDGET.vueObj
                if (this.WIDGET.record.doc.widthMin_rem === 1) {
                    vueObj.store.executeStoreMethod(vueObj, {'command': 'onScale__Click', 'params':{'widthMin_rem':4, 'heightMin_rem':4}})
                } else {
                    vueObj.store.executeStoreMethod(vueObj, {'command': 'onScale__Click', 'params':{'widthMin_rem':1, 'heightMin_rem':1}})
                }
                this.mouseenter_btnScale()
            }
        },
        handleKeydown(e) {
            if (e.key === 'Enter') {
                e.preventDefault()

                // e.target.blur()
                this.onTextChange(e)
            } else if (e.key === 'Escape') {
                // IE 2026 09 12 / ODOO-… (замечание Игоря): Esc в поле заголовка — отмена правки (прежний заголовок) и выход из
                // редактирования со снятием фокуса; следующий Esc, как всюду, закрывает виджет. Раньше глобальный обработчик
                // пропускал Esc как «ввод в input», а поле на него не реагировало — ни первый, ни второй Esc ничего не делали
                e.preventDefault(); e.stopPropagation()
                // IE 2026 09 24 / ODOO-341407: отмена — к заголовку, что был ДО правки (под uk/ru это перевод, а не английская база)
                if (this.isEditingHeader && this.WIDGET.record && this.WIDGET.record.title !== undefined) this.WIDGET.title = this._titleBeforeEdit !== undefined ? this._titleBeforeEdit : this.WIDGET.record.title
                this._titleBeforeEdit = undefined
                this.isEditingHeader = false
                this.titleSelection_clear(e.target)   // IE 2026 09 12 / ODOO-… (уточнение Игоря): выделение текста в заголовке снять
                e.target.blur()
            }
        },
        // IE 2026 09 12 / ODOO-… (уточнение Игоря): после выхода из редактирования заголовка (Esc / Enter) выделение текста
        // (enableEditing делает select()) снимается — курсор в конец, подсветки нет
        titleSelection_clear(inputEl) {
            const el = inputEl || this.$refs.inputHeader
            if (!el) return
            try { const n = (el.value || '').length; el.setSelectionRange(n, n) } catch (e) { /* input без selection API */ }
            try { const sel = window.getSelection(); if (sel && sel.rangeCount && el.contains?.(sel.anchorNode)) sel.removeAllRanges() } catch (e) { /* нет выделения */ }
        },
        enableEditing() { // onZoomClick
            this._titleBeforeEdit = this.WIDGET.title   // IE 2026 09 24 / ODOO-341407: заголовок до правки — сравнение в onTextChange (blur без правки = no-op)
            this.isEditingHeader = true
            this.$nextTick(() => {
                const inputEl = this.$refs.inputHeader
                inputEl.focus()
                inputEl.select()
            })
        },
        onTextChange(e) {
            const WIDGET = this.WIDGET
            const store = this.store
            // IE 2026 09 24 / ODOO-341407 (F1, дизайн-док B1): под uk/ru правка заголовка в шапке пишет ПЕРЕВОД (meta.title_{lang}), английская
            // база не затирается никогда; сравнение — с заголовком до правки (проба 4: blur без единого нажатия делал виджет «жёлтым», у
            // предопределённого виджета словарный текст уезжал в базу). Blur без входа в правку — no-op
            const _lang = store.get_lang()
            const _before = this._titleBeforeEdit !== undefined ? this._titleBeforeEdit
                : (_lang ? (store.get_value(WIDGET.record, 'meta.title_' + _lang) || WIDGET.record.title) : WIDGET.record.title)
            this._titleBeforeEdit = undefined
            const _changed = this.isEditingHeader && WIDGET.title !== _before && WIDGET.record
            if (_changed) {
                const _meta = WIDGET.record?._meta

                if (WIDGET.widget === 'widget-search') {
                    WIDGET.record.title = WIDGET.title
                } else if (_meta?.type === 'widget-row-chip') {
                    store.set_value(WIDGET.record, 'title', WIDGET.title)
                    store.set_value(WIDGET.record._record, 'title', WIDGET.title)

                    const parentWIDGET = store.findWidget(WIDGET.parentWIDGET?.id)?.WIDGET
                    store.set_chip(parentWIDGET, _meta, WIDGET.record._record)

                    parentWIDGET?.attrs_vueObj?.[`${_meta.binding}-CHIPS`]?.emitChips()

                } else if (_lang && WIDGET.record.segment) {
                    store.set_value(WIDGET.record, 'meta.title_' + _lang, WIDGET.title)   // перевод текущего языка; база — только из строки English карточки
                } else if (!_lang && WIDGET.record.segment && typeof WIDGET.record.meta?.title_en === 'string' && WIDGET.record.meta.title_en !== '') {
                    // IE 2026 09 25 / ODOO-341407 (этап 2 переводов данных 1С): под en запись, показанная английским вариантом meta.title_en (справочник с не
                    // английской базой, данные 1С), — правка идёт в этот вариант; база из загрузки не меняется (без варианта — бэк saveRecord2
                    // сам уводит правку названия такой записи в meta.title_en)
                    store.set_value(WIDGET.record, 'meta.title_en', WIDGET.title)
                } else {
                    store.set_value(WIDGET.record, 'title', WIDGET.title)
                }

                // IE 2026 08 23 / ODOO-5884 (заказ Игоря): реактивность «заголовок → поле Title инфо-вкладки».
                // Поле Title в AttrTabGrid рендерит СНАПШОТ значения на узле вью (attr.value/valueStr, кладёт бэк при
                // widget_open) — правка record.title сама по себе в грид не попадает. Прямое направление (поле → заголовок)
                // работает потому, что редактор пишет в сам узел. Здесь — обратное: синхронизируем узлы вью с binding
                // 'title' и перерисовываем ВСЕГДА (без условия на активную страницу — как пишется WIDGET.title в attr_set)
                const _syncTitleNodes = (attrs) => { for (const a of attrs || []) {
                    if (a && a.binding === 'title' && ('value' in a || 'valueStr' in a || a.attr_type)) { a.value = WIDGET.title; a.valueStr = WIDGET.title }
                    if (a?.attrs) _syncTitleNodes(a.attrs)
                } }
                _syncTitleNodes(WIDGET.view)
                WIDGET.vueObj?.content_Changed?.() // for update value in other places (в т.ч. поле Title инфо-вкладки)
                // гриды инфо-вкладки: их isVisible может остаться false (вкладка ⓘ активируется вне lazyTabs) —
                // content_Changed откладывает перерисовку «до показа» навсегда; добиваем те, чей флекс РЕАЛЬНО видим в DOM
                setTimeout(() => { try {
                    for (const id in (WIDGET.attrs_vueObj || {})) {
                        const vo = WIDGET.attrs_vueObj[id]
                        // IE 2026 08 24 / ODOO-5884 (заказ Игоря): грид рисует СВОИ строки-снапшоты — обновляем
                        // значение поля Title прямо в строках грида и перерисовываем flex (узлы вью синканы выше,
                        // но wijmo без invalidate ячейку не перечитывает)
                        try {
                            const rows = vo?.flex?.collectionView?.sourceCollection || vo?.data || []
                            let touched = false
                            const walkRows = (rs) => { for (const r of rs || []) {
                                if (r?.attr?.binding === 'title') { r.attr.value = WIDGET.title; r.attr.valueStr = WIDGET.title; touched = true }
                                if (r && r.binding === 'title' && ('value' in r || 'valueStr' in r)) { r.value = WIDGET.title; r.valueStr = WIDGET.title; touched = true }
                                if (Array.isArray(r?.attrs)) walkRows(r.attrs)
                            } }
                            walkRows(Array.isArray(rows) ? rows : [])
                            if (touched && vo.flex) vo.flex.invalidate()
                        } catch (e2) { /* грид без flex/данных — пропускаем */ }
                        if (vo?.need_content_Changed_afterTimeout && vo.flex?.hostElement?.offsetParent) vo.content_Changed_afterTimeout?.()
                    }
                } catch (e) { console.warn('title repaint sweep', e) } }, 60)
                if (WIDGET.action_afterChange_title && WIDGET.page === store.activeWORKSPACE?.activePAGE?.page) {
                    store.executeStoreMethod(WIDGET.vueObj, WIDGET.action_afterChange_title)
                }
            }
            this.isEditingHeader = false
            this.$nextTick(() => this.titleSelection_clear())   // IE 2026 09 12 / ODOO-…: и после Enter/blur — без выделения
        },
        setObserver_widgetResize() {
            const vueObj = this,
            elementToObserve = document.querySelector(`#WIDGET${vueObj.widget_id}`)
            if (elementToObserve) {
                const resizeObserver = new ResizeObserver(entries => {
                    // IE 2026 09 04 / ODOO-336291 (mobile UX): B-35 rotateSync — смена ШИРИНЫ карточки (поворот экрана)
                    // пересчитывается сразу, без 120 мс дебаунса: высота host грида отставала на 1-2 с и
                    // таблица оставалась обрезанной. Смена только высоты (клавиатура, адресная строка) — как раньше.
                    // Выкл: window.mobileUi.set('rotateSync', false)
                    const _w = Math.round(entries?.[0]?.contentRect?.width || 0)
                    const _fast = !!(vueObj.store.mobileUi?.on && vueObj.store.mobileUi.rotateSync !== false
                        && _w && vueObj._mobObsW && _w !== vueObj._mobObsW)
                    if (_w) vueObj._mobObsW = _w
                    vueObj.store.widgetResize(vueObj, _fast ? 0 : 120)
                    // IE 2026 08 23: размер сменился (загрузка/раскладка/поворот) —
                    // перемерить отступ заголовка от левых кнопок
                    clearTimeout(vueObj._mobTitleT)
                    vueObj._mobTitleT = setTimeout(() => vueObj.mobTitleInsetCheck(), 250)
                    if (vueObj.vizTab) { clearTimeout(vueObj._vizTitleT); vueObj._vizTitleT = setTimeout(() => vueObj.vizTitle_measure(), 160) }   // IE 2026 09 27 / ODOO-341407: островок кнопок сдвинулся с шириной виджета
                    clearTimeout(vueObj._stopClearT); vueObj._stopClearT = setTimeout(() => vueObj.stopClear_measure(), 160)   // IE 2026 09 28 / ODOO-341407: панель кнопок сдвинулась с шириной виджета
                    vueObj.hdrOverflow_schedule()   // IE 2026 10 07 / ODOO-5800: ширина виджета сменилась — какие кнопки шапки помещаются
                })
                resizeObserver.observe(elementToObserve)
            }
        },
        segMetaIcon_on() { return this.store?.setting?.('fe.ux.segmentMetaIcon', true) !== false },   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: папка з шестернею для віджета сегмента, відкрита папка для списку)
        // // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p217 кнопка Σ — річні підсумки за опцією, типово вимкнено): клик по Σ — итоги лет показать / спрятать во всех гридах виджета, без запроса; в запись не пишется. → мс переключения (window.__yearTotals.lastMs)
        yearTotals_toggle() {
            const t0 = performance.now()
            this.WIDGET._yearTotalsOn = !this.WIDGET._yearTotalsOn
            let n = 0
            for (const g of Object.values(this.WIDGET.attrs_vueObj || {})) {
                if (g && g.flex && typeof g.yearTotals_sync === 'function') { try { n += g.yearTotals_sync() || 0 } catch (e) { /* грид пересоздаётся */ } }
            }
            this.set_commandPanel()
            const ms = Math.round(performance.now() - t0)
            const S = window.__yearTotals || (window.__yearTotals = { syncs: 0, cols: 0 })
            S.lastMs = ms; S.toggles = (S.toggles || 0) + 1
            if (!this.store.hide_console) console.log(`year totals ${this.WIDGET._yearTotalsOn ? 'shown' : 'hidden'}: ${n} columns, ${ms} ms`)
            return ms
        },
        set_commandPanel(eval_params={}) {
            // IE 2026 09 23 / ODOO-341407: i18n (titles of the default menu items)
            this.store.set_widgetRecord_nav_shortTitle(this.WIDGET)
            if ('groupMenu' in this.WIDGET && 'commandPanel' in this.WIDGET.groupMenu) {
                // if (!this.store.hide_console) console.log('set_commandPanel')
                const newLeft = []
                const newRight = []

                try { this.store.cellView_syncButtons?.(this.WIDGET) } catch (e) { /* без вида ячеек */ }   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: кругові діаграми за статусами у клітинках REPORT2, опції зрізу і їх розміщення): кнопки вида ячеек (view + front_only) — по состоянию виджета, не по active ответа
                const nav = this.WIDGET._nav
                let cvDupes = []   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p191 кола — за натиснутим видом у смузі, без опції «Кругові за статусами»): кнопка вида в шапке, дублирующая вид полосы над таблицей («Кругові за статусами»), не показывается
                try { cvDupes = this.store.cellView_headerDupes?.(this.WIDGET) || [] } catch (e) { cvDupes = [] }
                const helpOn = helpCard_on(this.store)   // IE 2026 11 03 / ODOO-350881 (инвентаризация помощи, этап 1): флаг выключен — панель как была
                if (helpOn) this.helpCard_docLink = ''
                for (let command of this.WIDGET.groupMenu.commandPanel) {
                    if (cvDupes.length && cvDupes.includes(command)) continue   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p191 кола — за натиснутим видом у смузі, без опції «Кругові за статусами»)
                    if (helpOn && helpCard_isDocsButton(command)) { this.helpCard_docLink = command.params?.doc_link || ''; continue }   // IE 2026 11 03 / ODOO-350881: «?» бэка (widget-docs) — его ссылка уходит в карточку, место — «?» карточки
                    if (command.cssClass2 !== ' mr-1 ') command.cssClass2 = ' mr-1 '
                    if (command.method === 'openSourceSegment') { const c = segMeta_cmdClass(command, this.segMetaIcon_on()); if (c !== command.cssClass) command.cssClass = c }   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: папка з шестернею для віджета сегмента, відкрита папка для списку)
                    if (command.command === 'navigate_record' && nav) {
                        if (command.direction === 'prev') {
                            command.disabled = nav.currentIndex <= 0
                        } else if (command.direction === 'next') {
                            command.disabled = nav.currentIndex >= nav.siblings.length - 1
                        }
                    }
                    if (command.isWidgetLeftPanelCommand) {
                        newLeft.push(command)
                    } else {
                        newRight.push(command)
                    }
                }

                // // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p217 кнопка Σ — річні підсумки за опцією, типово вимкнено): кнопка Σ — в конце полосы опций (после последней кнопки группы опций), только у виджета с колонками годового итога
                // (WIDGET._yearTotalsHas ставит грид, AttrGrid.yearTotals_sync); объект кнопки — один на виджет (стабильный id — панель обновляется на месте)
                if (this.WIDGET._yearTotalsHas && yearTotalsButton_on((k, d) => this.store.setting(k, d))) {
                    const had = !!this.WIDGET._yearTotalsBtn
                    const yb = this.WIDGET._yearTotalsBtn = yearTotals_button(this.WIDGET._yearTotalsBtn, !!this.WIDGET._yearTotalsOn, (k) => this.t(k))
                    if (!had) this.store.prepare_attrs([yb], `yearTotals_${this.WIDGET.id}`)
                    this.store.prepare_actionMenu(yb)
                    newRight.splice(yearTotals_insertAt(newRight), 0, yb)
                }
                // IE 2026 11 03 / ODOO-350881 (инвентаризация помощи, этап 1): «?» карточки помощи — первой кнопкой панели (узкая шапка прячет кнопки с конца, в ≡ она есть всегда);
                // объект кнопки — один на виджет (стабильный id — панель обновляется на месте), как кнопка Σ
                if (helpOn) {
                    const had = !!this.WIDGET._helpCardBtn
                    const hb = this.WIDGET._helpCardBtn = helpCard_button(this.WIDGET._helpCardBtn, (k) => this.t(k))
                    if (!had) this.store.prepare_attrs([hb], `helpCard_${this.WIDGET.id}`)
                    this.store.prepare_actionMenu(hb)
                    newRight.unshift(hb)
                }
                // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): кнопка «Plan approval» — в ряду шапки отчёта
                // справа, как в прототипе (раздел 1); объект ставит грид Баланса (AttrGrid.planApproval_headerSync → WIDGET._paHeaderBtn), выключатель fe.ux.planApprovalHeaderRow — в гриде
                const paHb = this.WIDGET._paHeaderBtn
                if (paHb) { this.store.prepare_attrs([paHb], `planApproval_${this.WIDGET.id}`); this.store.prepare_actionMenu(paHb); newRight.push(paHb) }
                this.store.updateCommandPanelInPlace(this.commandPanelLeft, newLeft)
                this.store.updateCommandPanelInPlace(this.commandPanel, newRight)

                this.actionMenu = this.store.actionMenu_from_commandPanel(this.commandPanel, this.WIDGET)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + WIDGET — архив прячет запись только у данных модели (ревью #110599)
                this.hdrOverflow_schedule()   // IE 2026 10 07 / ODOO-5800: состав / подписи панели могли смениться — перемер
                for (let command_ of this.WIDGET.groupMenu?.actionMenu||[]) {
                    const command = command_, v_if = command_['v-if'] // { 'v-if': v_if, ...command } = command_
                    command.visible = this.store.eval_value(this.WIDGET, v_if, eval_params)
                    const lastAddedAttr = this.actionMenu.length > 0 ? this.actionMenu[this.actionMenu.length - 1] : null
                    if (command.visible && (!lastAddedAttr || lastAddedAttr.title !== command.title) && this.store.checkAccess(command, this.WIDGET)) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + WIDGET — архив прячет запись только у данных модели (ревью #110599)
                        this.actionMenu.push(this.store.prepare_actionMenu(command))
                    }
                }
                // IE 2026 09 24 / ODOO-341407: пункт «Translations…» (pi-globe, Alt T) даёт бэк (set_menu); пока его нет в ответе —
                // фронтовый пункт с тем же методом (без горячей клавиши)
                if (this.i18nGlobe_show() && !this.actionMenu.some(a => a?.method === 'i18n_titles_open')) {
                    this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type': 'AttrButton', 'cssClass': 'pi p-button-white pi-globe', 'title': this.t('Translations…'), 'command': 'executeVueObjMethod', method: 'i18n_titles_open', _key: 'Translations…' }))
                }
                // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2 / п.3): «Show translation fields» — личная опция вида (по сегменту данных, память стора +
                // localStorage, запись виджета не метится), флажок формы-меню; и у роли «только чтение» (смотреть переводы можно) — до её фильтра
                if (!this.actionMenu.some(a => a?.method === I18N_FIELDS_TOGGLE)) {
                    const i18nFieldsItem = i18nFieldsMenuItem(this.store, this.WIDGET)
                    if (i18nFieldsItem) this.actionMenu.push(this.store.prepare_actionMenu(i18nFieldsItem))
                }
                // IE 2026 09 29 / ODOO-342781: роль «только чтение» — вложенные пункты меню (папка JSON: Deep copy / Paste record / Import record, «Translations…»)
                // тоже без записи: checkAccess выше видит только верхний уровень списка. Без роли — тот же массив, как было
                if (this.store.readonly_on()) this.actionMenu = this.store.readonly_menu(this.actionMenu)
                // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета): раздел «Layout» — команды, которых нет в ряду угла (Reload, Pop-out, Full screen, Header / Tabs / Panel / Float, Size 1–8, W / H %, Free); флажки — живое состояние
                if (this.cornerLite && !cornerLayout_has(this.actionMenu)) {
                    const sw = () => this.WIDGET?.styleWidget || {}
                    const lay = cornerLayoutMenu(this.commandPanel_topLeft1, this.commandPanel_Scale, (k) => this.t(k), {
                        header: () => !sw().hideHeader, tabs: () => !sw().hideTabs, panel: () => !sw().hideGridPanel,
                        float: () => !!this.floatHeaderOn, free: () => sw().dock === 'popout',
                        sizeGrid: sizeGrid_on(this.store) ? this.menuSize_grid() : null,   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: визуальный выбор размера в меню виджета)
                    })
                    if (lay) { for (const it of lay.attrs) { this.store.prepare_actionMenu(it); for (const c of it.attrs || []) this.store.prepare_actionMenu(c) } this.actionMenu.push(lay) }
                }
                // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): пункт «Update preview» — снимок содержимого виджета для панели страниц и меню страницы
                this.preview_menuAdd()
            } else if (this.WIDGET.firstBackendCheck) {
                // скелет-кадр (ответа widget_open ещё нет): дефолтное меню —
                // Reopen повторяет исходный запрос как он был отправлен
                // (command 'widget_open_repeat', а не бэковский reload)
                const actionMenu = [
                    { 'cssClass':'pi p-button-white pi-sync', 'title': this.t('Reopen Widget'), 'command':'widget_open_repeat', 'action_name':'action-front-widgetOpenRepeat-2026-07-10' },
                ]
                const showWidget = { 'cssClass':'pi p-button-white pi-external-link', 'title': this.t('Record source (JSON)'), _key: 'Show widget', 'viewAccess':'access-extraInfo', 'command':'onViewRecord__Click' }   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: названия меню виджета по смыслу)
                if (this.store.checkAccess(showWidget)) {
                    actionMenu.push({'title': '-'})
                    actionMenu.push({ 'cssClass':'pi p-button-white pi-database', 'title': this.t('Copy & transfer'), _key: 'JSON', 'attrs': [this.store.prepare_actionMenu(showWidget)] })   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: названия меню виджета по смыслу)
                }
                this.actionMenu = actionMenu.map(a => this.store.prepare_actionMenu(a))
            } else if (this.store.mobileUi?.on) {
                // IE 2026 08 22 (скрин Игоря 18:48): ответ без groupMenu (напр.
                // график) — «…» показывал панель управления без меню (wijmo с
                // пустым списком не открывается, панель нечем закрыть); в
                // мобильном профиле даём дефолтные пункты как у скелет-кадра
                if (!this.actionMenu._noGroupDefault) {
                    const actionMenu = [
                        { 'cssClass':'pi p-button-white pi-sync', 'title': this.t('Reopen Widget'), 'command':'widget_open_repeat', 'action_name':'action-front-widgetOpenRepeat-2026-07-10' },
                    ]
                    const showWidget = { 'cssClass':'pi p-button-white pi-external-link', 'title': this.t('Record source (JSON)'), _key: 'Show widget', 'viewAccess':'access-extraInfo', 'command':'onViewRecord__Click' }   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: названия меню виджета по смыслу)
                    if (this.store.checkAccess(showWidget)) {
                        actionMenu.push({'title': '-'})
                        actionMenu.push({ 'cssClass':'pi p-button-white pi-database', 'title': this.t('Copy & transfer'), _key: 'JSON', 'attrs': [this.store.prepare_actionMenu(showWidget)] })   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: названия меню виджета по смыслу)
                    }
                    this.actionMenu = actionMenu.map(a => this.store.prepare_actionMenu(a))
                    this.actionMenu._noGroupDefault = true
                }
            } else {
                // ответ пришёл без groupMenu — убрать меню скелет-кадра; IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): остаётся пункт «Update preview»
                const pv = this.preview_menuItem()
                if (pv) { if (!(this.actionMenu.length === 1 && this.actionMenu[0]?.method === 'preview_update')) this.actionMenu = [pv] }
                else if (this.actionMenu.length) this.actionMenu = []
            }
        },
        tooltip() {
            // IE 2026 09 07 / ODOO-337259: «ленивая» подсказка (v-wjTooltipFn) — считается при показе: Show tooltips или зажатый Alt
            if (!this.store.tooltips_on()) return ''

            let params = {},
            WIDGET = this.WIDGET
            // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3: строки объяснения СВЕРХУ техсводки (порядок вставки в params управляет порядком строк в store.tooltip_html) — техсводка остаётся ниже;
            // элементы шапки без своего объяснения по Аlt показывают именно это (widget.header)
            if (uiHelp_enabled()) Object.assign(params, uiHelp_rows('widget.header', { state: this.isActiveWidget ? 'active' : 'inactive' }))
            Object.assign(params, this.tooltip_tech())   // накат 26.09: техсводка — общая с хвостом объяснений бейджа / поля названия / полосы (tooltip_tail)

            return this.store.tooltip_html(params, WIDGET.tooltip||'') + this.recHelp_html()   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2
        },
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3 (накат 26.09): техсводка записи виджета — строки id / segment / isReadOnly / Predefined / Non Updatable
        tooltip_tech() {
            const WIDGET = this.WIDGET, params = {}
            // IE 2026 09 23 / ODOO-341407: i18n (labels of the tooltip rows)
            params[this.t('id')] = WIDGET.record?.id || WIDGET.record?.id
            params[this.t('segment')] = WIDGET.record?.segment || WIDGET.record?.segment
            
            if (this.isReadOnly) { 
                params[this.t('isReadOnly')] = 'true'
            }
            if (WIDGET.record?.meta?.predefined) {
                params[this.t('Addon record')] = `<input type="checkbox" checked disabled>` // IE 2026 10 31 / ODOO-349799

                params[this.t('Modified')] = this.store.attr_html(this.WIDGET, 'Widget', 'noupdate', WIDGET.record.meta.noupdate) // IE 2026 10 31 / ODOO-349799
            }
            return params
        },
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3 (накат 26.09): хвост объяснения бейджа типа / поля названия / полосы перетаскивания (v-uiHelp … after):
        // техсводка и объяснение ЗАПИСИ виджета (About / Purpose / How to use + «Edit description», R2) — как у подсказки контейнера, которую эти элементы накрывают своим объяснением
        tooltip_tail() {
            const tech = this.store.tooltip_html(this.tooltip_tech())
            return (tech ? '<br>' + tech : '') + this.recHelp_html()
        },
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: объяснение записи виджета (отчёт, список, DS, задача…) — что это / зачем / как использовать (строки About / Purpose /
        // How to use из record_help приходят пачкой — подсказка перерисуется сама); вариант без своего объяснения — объяснение основной настройки; «Edit description»
        // админу (вариант без своего объяснения — правится основная). Подсказка контейнера — она же у заголовка и бейджа сегмента шапки
        recHelp_html() {
            const W = this.WIDGET, rec = W?.record
            if (!rec || !rec.id || !uiHelp_enabled()) return ''
            const own = { id: String(rec.id), segment: String(rec.segment || ''), title: String(W.title || rec.title || '') }
            let rows = uiHelp_recordRowsHtml(own.id, own.segment, { kind: 'widget', widget: W.id })
            let tgt = own
            const mainId = W.variant_main?.id || rec.doc?.variant_of || ''
            if (!rows && mainId && String(mainId) !== own.id) {
                tgt = { id: String(mainId), segment: own.segment, title: String(W.variant_main?.title || '') }
                rows = uiHelp_recordRowsHtml(tgt.id, tgt.segment, { kind: 'widget', widget: W.id, variantOf: own.id })
            }
            return rows + recordHelp.editHtml(tgt)
        },
        // IE 2026 11 03 / ODOO-350881 (инвентаризация помощи, этап 1): «?» карточки помощи (кнопка helpCard_button, флаг fe.ux.helpCard) — карточка этого окна
        // (components/HelpCard.vue): описание записи (вариант без своего — основной настройки, как recHelp_html), блок типа, статья «?» бэка, навигатор.
        // Кнопка спрятана узкой шапкой (пункт ≡) — карточка встаёт у шапки виджета
        helpCard_open(action) {
            const W = this.WIDGET, rec = W?.record || {}
            const btn = action?.html_id ? document.getElementById(action.html_id) : null
            const anchor = (btn && btn.getClientRects().length) ? btn : (this.$el?.querySelector?.('.widget-container') || this.$el)
            helpCard_show({ anchor, vueObj: W?.vueObj || this, title: String(W?.title || rec.title || ''), id: String(rec.id ?? ''), segment: String(rec.segment || ''),
                mainId: String(W?.variant_main?.id || rec.doc?.variant_of || ''), docLink: this.helpCard_docLink || '' })
        },
        initPopupTab(popup) {
            this.popupTab = popup
        },
        
        // ------------- resize ----------------------------------------
        onShow_commandPanel_topLeft(event, vueEvent) {
            // IE 2026 08 20 / ODOO-336291 (mobile UX): на таче mouseenter прилетает ВМЕСТЕ с тапом —
            // панель раскрывалась под пальцем и клик доставался её кнопке (виджет «сам закрывался»).
            // На мобильном панель открывает только явный тап по углу ⋮⋮ (onTopLeftCornerTap)
            if (this.store.mobileUi?.on) return
            // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3 (накат 26.09): при зажатом Alt наведение на угол не открывает форму «⋯» — иначе форма ложилась бы на объяснение угла (widget.corner.topLeft), а сам угол пропадал (v-if); открывает клик / наведение без Alt.
            // Только пока форма ещё закрыта: внутри открытой формы наведение с Alt на её кнопки закрытие не запускает (таймеры не сбрасываются)
            if (event?.altKey && !this.show_commandPanel_topLeft) return
            // IE 2026 10 25 / ODOO-345044 (заказ Игоря: ховер углов виджета всегда): наведение на угол ⋯ открывает форму ВСЕГДА, опция «Open menus on hover» угол не касается (она — для меню шапки); клик по углу — topLeftCornerClick. Гейт p001 (217b3103b) снят
            this.clearTopLeftTimers();

            if (!this.store.hide_console) console.log('show ' + !!vueEvent)
            this.timerId_onShow_commandPanel_topLeft = setTimeout(() => {
                // IE 2026 09 28 / ODOO-… (замечание Игоря: зависает меню угла виджета): показ — только если курсор реально на углу (последнее движение мыши над ним, курсор в окне, угол не накрыт
                // панелью-меню / подсказкой / другим виджетом); раньше — store.mouse_isInside по последним координатам всплывающего mousemove: форма
                // открывалась после выхода курсора за окно и «сама» после закрытия панели над углом. fe.ux.widgetCornerFormGuard = false — прежняя проверка
                if (cornerFormGuard.canShow(this, event.target)) {
                    if (!this.show_commandPanel_topLeft) {
                        this.mouseenter_btnScale()
                        this.fillLayoutInputs()
                        this.topLeftForm_place()   // IE 2026 09 15 / ODOO-… (замечание Игоря): в Float — под островком заголовка
                        this._tlCtxPt = null   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета): открыта наведением на угол — точки правого клика нет
                        this.show_commandPanel_topLeft = true
                        // this.timerId_onClose_commandPanel_topLeft = setTimeout(() => {
                        //     this.show_commandPanel_topLeft = false
                        // }, 50)
                    }
            //     } else {
            //         this.show_commandPanel_topLeft = false
                }
            }, cornerHoverOpenDelay(cornerHoverArm_on(this.store)))   // IE 2026 10 25 / ODOO-345044 (hotfix: ✕ под курсором после ховера угла): пауза намерения наведения 350 мс (было 50 мс — форма с ✕ под курсором открывалась раньше, чем успевал клик по углу); клик по углу — сразу (topLeftCornerClick)
        },
        onClose_commandPanel_topLeft(event) {
            // IE 2026 09 04 / ODOO-336291 (mobile UX): B-03 — на таче совместимый mouseleave прилетает после тапа
            // (открытие листа настроек меняет разметку под пальцем) и закрывал панель вместе с единственной
            // кнопкой закрытия листа (шеврон); на мобиле панель закрывают только явные тапы (как onShow_ выше)
            if (this.store.mobileUi?.on) return
            this.clearTopLeftTimers();
            // IE 2026 09 28 / ODOO-… (замечание Игоря: зависает меню угла виджета): закрытие решает страж (зона «угол + форма (+ панель Settings | Variants из бейджа)», курсор по pointermove) — mouseleave
            // формы лишь один из поводов проверить; ниже — прежняя логика (выключатель fe.ux.widgetCornerFormGuard = false)
            if (cornerFormGuard.on(this)) { cornerFormGuard.leave(this, event); return }

            if (!this.store.hide_console) console.log('X')
            // IE 2026 09 15 (замечание Игоря): в Float шапка прозрачна и мышь не ловит — по пути от угла ⋯ к форме mouseleave прилетал
            // сразу, и форма закрывалась раньше, чем до неё доходил курсор. Пока курсор в зоне «угол + форма» (с полем), форму не закрывать
            if (this.identInForm && this.showDropdown) { this.topLeftZone_watch(); return }   // IE 2026 09 23 / ODOO-… (замечание Игоря: в форме ⋯ — те же элементы шапки): панель Settings | Variants открыта из формы — форма держится, пока панель открыта
            if (event && this.topLeftZone_inside(event.clientX, event.clientY)) { this.topLeftZone_watch(); return }
            this.timerId_onClose_commandPanel_topLeft = setTimeout(() => {
                this.show_commandPanel_topLeft = false
            }, 50)
        },
        // IE 2026 09 15 / ODOO-… (замечание Игоря: в Float кнопка закрытия ⋯-формы ложилась на бейдж сегмента): в режиме островков форма
        // вида открывается ПОД островком заголовка (низ парящей шапки + 4px), а не поверх него; без Float / без заголовка — как прежде (top 3px).
        // Замер — при каждом открытии (высота островка зависит от бейджей и панели слева)
        topLeftForm_place() {
            let top = null
            try {
                const sw = this.WIDGET?.styleWidget || {}
                if (this.floatHeaderOn && !sw.minMode && !sw.hideHeader && !this.store.mobileUi?.on && this.$el?.querySelector) {
                    const c = this.$el.querySelector(':scope > .widget-container')
                    const w = this.$el.getBoundingClientRect()
                    // IE 2026 09 16 (замечание Игоря: форма «уехала на полосу вниз»): опора — островок ЗАГОЛОВКА, а не вся шапка: в шапке
                    // могут стоять более высокие островки (панель, чекбокс тиража) или второй ряд — форма всё равно открывается под заголовком
                    const h = c && c.querySelector(':scope > .widget-header')
                    const hr = h && h.getBoundingClientRect()
                    if (hr && hr.height > 0) top = Math.max(3, Math.round(hr.bottom - w.top) + 4)
                    else if (c) { const r = c.getBoundingClientRect(); if (r.height > 0) top = Math.max(3, Math.round(r.bottom - w.top) + 4) }
                }
            } catch (e) { top = null }
            this.topLeftTop = top
            // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета): тихая шапка (иконка вида, плашки по наведению нет) — ряд угла открывается ПРАВЕЕ иконки: иконка остаётся видна и кликабельна (панель настроек),
            // «Закрити» не ложится под курсор, наведённый на иконку (замер пробы dev02 03.11: ряд от left 3 px накрывал иконку кнопкой «Закрити»)
            this.cornerLite_place()
        },
        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета): left ряда угла — правее иконки вида; зовут topLeftForm_place и наблюдатель открытия формы (любой путь открытия). Счётчик причин — cornerMenuStats.place
        cornerLite_place() {
            let left = null, why = 'off'
            try {
                const sw = this.WIDGET?.styleWidget || {}
                const ico = this.$refs.kindIco
                if (!this.cornerLite) why = 'flag'
                else if (!ico) why = 'no-icon'
                else if (!this.kindIcon_on() || !this.kindChip_on()) why = 'not-quiet'
                else if (sw.hideHeader || sw.minMode) why = 'header-hidden'
                else {
                    const ir = ico.getBoundingClientRect(), wr = this.$el.getBoundingClientRect()
                    if (ir.width > 0) { left = Math.max(3, Math.round(ir.right - wr.left) + 4); why = 'icon' } else why = 'icon-0'
                }
            } catch (e) { left = null; why = 'err' }
            const st = cornerMenuStats.place || (cornerMenuStats.place = {})
            st[why] = (st[why] || 0) + 1
            this.topLeftLeft = left
        },
        // IE 2026 09 15 / ODOO-… (замечание Игоря): кнопка Free в ⋯-форме — тумблер свободного положения (вместо чекбокса)
        freeToggle() {
            this.layoutInputs.free = !this.layoutInputs.free
            this.applyLayoutInputs('free')
        },
        // зона удержания формы вида: объединение прямоугольников угла ⋯ (левый верх виджета, 64×52) и самой формы, с полем 12 px
        topLeftZone_rect() {
            const el = this.$el
            if (!el || !el.getBoundingClientRect) return null
            const w = el.getBoundingClientRect()
            let l = w.left, t = w.top, r = w.left + 64, b = w.top + 52
            const form = el.querySelector('.widget-commandPanel-top-left')
            if (form) { const f = form.getBoundingClientRect(); l = Math.min(l, f.left); t = Math.min(t, f.top); r = Math.max(r, f.right); b = Math.max(b, f.bottom) }
            // IE 2026 09 23 / ODOO-… (замечание Игоря: в форме ⋯ — те же элементы шапки): панель Settings | Variants, открытая из формы, — часть зоны удержания
            const dd = this.identInForm && this.showDropdown ? el.querySelector('.chips-dropdown.widget-settings-dropdown') : null
            if (dd) { const d = dd.getBoundingClientRect(); if (d.width > 0) { l = Math.min(l, d.left); t = Math.min(t, d.top); r = Math.max(r, d.right); b = Math.max(b, d.bottom) } }
            const cp = this.show_commandPanel_topLeft ? this._tlCtxPt : null   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета): форма открыта правой кнопкой на шапке — точка клика в зоне удержания
            if (cp) { l = Math.min(l, cp.x - 16); t = Math.min(t, cp.y - 16); r = Math.max(r, cp.x + 16); b = Math.max(b, cp.y + 16) }   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета)
            return { left: l - 12, top: t - 12, right: r + 12, bottom: b + 12 }
        },
        topLeftZone_inside(x, y) {
            const z = this.topLeftZone_rect()
            return !!z && x >= z.left && x <= z.right && y >= z.top && y <= z.bottom
        },
        // следить за курсором по документу, пока форма открыта: вышел из зоны — закрыть (150 мс), вернулся — оставить
        topLeftZone_watch() {
            if (this._tlZoneMove) return
            this._tlZoneMove = (e) => {
                if (!this.show_commandPanel_topLeft) { this.topLeftZone_unwatch(); return }
                if (this.identInForm && this.showDropdown) { if (this._tlZoneT) { clearTimeout(this._tlZoneT); this._tlZoneT = null } return }   // IE 2026 09 23 / ODOO-… (замечание Игоря: в форме ⋯ — те же элементы шапки): панель из формы открыта — не закрывать, следить дальше
                if (this.topLeftZone_inside(e.clientX, e.clientY)) { if (this._tlZoneT) { clearTimeout(this._tlZoneT); this._tlZoneT = null } return }
                if (!this._tlZoneT) this._tlZoneT = setTimeout(() => { this._tlZoneT = null; if (this.show_commandPanel_topLeft && !this.store.mouse_isInside?.(this.$el.querySelector('.widget-commandPanel-top-left'))) this.show_commandPanel_topLeft = false; this.topLeftZone_unwatch() }, 150)
            }
            document.addEventListener('mousemove', this._tlZoneMove, { passive: true })
        },
        topLeftZone_unwatch() {
            if (this._tlZoneMove) { document.removeEventListener('mousemove', this._tlZoneMove); this._tlZoneMove = null }
            if (this._tlZoneT) { clearTimeout(this._tlZoneT); this._tlZoneT = null }
        },
        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета): кнопка «Налаштування й варіанти» ряда — та же панель Settings | Variants, что иконка вида / бейдж (toggleDropdown; панель «вытекает» из места бейджа у угла)
        cornerVariants_click(ev) {
            if (!this.dropdownApplies) return
            cornerMenuStats.variants++
            this.toggleDropdown(ev)
        },
        // пункты раздела «Layout» меню ≡ (utils/widgetCornerMenu.cornerLayoutMenu, команда executeWidgetObjMethod): переключатель вида — та же кнопка формы (onToggleView__Click)
        cornerMenu_toggleView(ev, action) {
            const v = action?.view
            const a = this.commandPanel_Scale.flat().find(x => x && x.command === 'onToggleView__Click' && x.param === v)
            if (a) this.store.executeStoreMethod(this.WIDGET.vueObj, a)
        },
        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: визуальный выбор размера в меню виджета): данные строки «Size» меню ≡ (MenuPanel): текущий масштаб (выделенная миниатюра),
        // значения полей W / H (% страницы) и применение поля — тем же путём, что поля W / H формы угла (fillLayoutInputs → applyLayoutInputs); пустое / нечисловое не применяется
        menuSize_grid() {
            const sp = () => this.PAGE?.stylePage || this.store.def_stylePage
            return {
                cur: () => sizeGrid_current(this.WIDGET?.styleWidget, sp(), this.WIDGET?.record?.doc),
                pct: () => sizePct_current(this.WIDGET?.styleWidget, sp(), () => this.store.getWIDGET_size(this.WIDGET)),
                apply: (field, v) => {
                    const n = sizePct_parse(v)
                    if (n === null || (field !== 'width' && field !== 'height')) { menuSizeStats.pctRejected++; return false }
                    this.fillLayoutInputs()
                    this.layoutInputs[field] = n
                    this.applyLayoutInputs(field)
                    menuSizeStats.pctApplied++
                    return true
                },
                click: () => { menuSizeStats.cellClicks++ },
            }
        },
        // Free — тот же тумблер, что кнопка Free формы (поля W / H / X / Y — из живого положения)
        cornerMenu_free() { this.fillLayoutInputs(); this.freeToggle() },
        // «Width / height, % of page…» — форма угла с полями W / H / X / Y и Free. Курсор в этот миг над меню ≡ (далеко от угла): точка удержания — последнее движение мыши
        // (как у формы по правой кнопке на шапке), но только до первого захода курсора в форму; до захода форму закрывают нажатие мимо неё, Esc, уход за прямоугольник «угол … точка»
        cornerMenu_openPct() {
            const pt = (cornerFormGuard.x != null && cornerFormGuard.y != null) ? { x: cornerFormGuard.x, y: cornerFormGuard.y } : null
            this.$nextTick(() => {
                this.topLeftForm_openAt(pt); this.cornerPct = true; cornerMenuStats.pctOpened++
                if (pt) this.cornerCtx_watch()
            })
        },
        cornerCtx_watch() {
            this.cornerCtx_drop()
            const form = () => this.$el?.querySelector?.('.widget-commandPanel-top-left')
            this._cornerCtxMove = (e) => {
                const r = form()?.getBoundingClientRect()
                if (r && e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) { this._tlCtxPt = null; this.cornerCtx_drop() }
            }
            this._cornerCtxDown = (e) => { const f = form(); if (f && !f.contains(e.target)) { this.cornerCtx_drop(); this.forceCloseTopLeft() } }
            document.addEventListener('mousemove', this._cornerCtxMove, { passive: true })
            setTimeout(() => { if (this._cornerCtxMove) document.addEventListener('pointerdown', this._cornerCtxDown, true) }, 0)
        },
        cornerCtx_drop() {
            if (this._cornerCtxMove) { document.removeEventListener('mousemove', this._cornerCtxMove); this._cornerCtxMove = null }
            if (this._cornerCtxDown) { document.removeEventListener('pointerdown', this._cornerCtxDown, true); this._cornerCtxDown = null }
        },
        forceCloseTopLeft() {
            this._tlCtxPt = null   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета)
            this.clearTopLeftTimers();
            this.topLeftZone_unwatch()   // IE 2026 09 15
            this.show_commandPanel_topLeft = false;
            if (this.store.mobileUi?.on) this.showDropdown = false // #4174: лист настроек закрывается вместе
            this.removeTopLeftOutside();
        },
        // IE 2026 08 20 / ODOO-336291 (mobile UX) (замечание Игоря): на таче hover нет — тап по
        // бейджу виджета сначала РАСКРЫВАЕТ панель команд (не исполняя её действие),
        // повторный тап по кнопке уже исполняет; тап вне панели — сворачивает
        onTopLeftTapCapture(e) {
            if (!this.store.mobileUi?.on) return
            if (this.show_commandPanel_topLeft) return
            e.stopPropagation(); e.preventDefault()
            this.openTopLeftPanelMobile()
        },
        // явный тап по углу ⋮⋮ (замечание Игоря: «более явные элементы меню для пальца»)
        // IE 2026 08 20 / ODOO-336291 (mobile UX) (#4188): собрать табы активного виджета в рейл-меню;
        // переключение — штатный click по заголовку wijmo (работает и на скрытом элементе)
        toggleMobileTabs() {
            this.mobileTabsOpen = !this.mobileTabsOpen
            if (this.mobileTabsOpen) { this.buildMobileTabs(); window.mobTapDone?.('tabs') } // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-04 — лист панели команд грида: тоггл кнопкой + закрытие тапом снаружи
        // (document pointerdown capture, как _topLeftOutside); попапы контролов панели — не «снаружи».
        // Слушатель ставит/снимает вотчер mobileBarOpen (лист закрывает и вотчер isActiveWidget)
        toggleMobileBar() {
            this.mobileBarOpen = !this.mobileBarOpen
            if (this.mobileBarOpen) window.mobTapDone?.('gridPanel') // P-31
        },
        mobileBarOutside_sync(open) {
            if (this._mobileBarOutside) { document.removeEventListener('pointerdown', this._mobileBarOutside, true); this._mobileBarOutside = null }
            if (!open) return
            this._mobileBarOutside = (ev) => {
                const t = ev.target
                if (!t?.closest) return
                if (t.closest('.grid-top-line, .widget-panelbar-btn, .wj-dropdown-panel, .wj-popup, .p-dialog, .p-overlaypanel, .p-datepicker, .dropdown, .chips-dropdown')) return
                this.mobileBarOpen = false
            }
            document.addEventListener('pointerdown', this._mobileBarOutside, true)
        },
        // IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08 (скрин Игоря 10:40): список табов —
        // иерархия: верхний уровень целиком, вложенные — только у АКТИВНОГО таба
        // (раньше все .wj-tabheader сваливались в одну кучу, тап по вложенному табу
        // неактивной панели открывал «пустую вкладку»)
        buildMobileTabs() {
            const root = this.$el
            this._mobTabEls = []
            const items = []
            const info = (h, fallback) => {
                // #4201: чистый заголовок — бейджи-счётчики и иконки не попадают в текст
                const c = h.cloneNode(true)
                c.querySelectorAll('.badge, .p-badge, [class*="badge"], i').forEach(el => el.remove())
                const iconEl = h.querySelector('i[class*="pi-"]')
                // #4203/21.08: без тайтла — тултип вьюхи (data-mob-title, v-wjTooltip атрибут не пишет)
                const tt = h.querySelector('[data-mob-title]')?.getAttribute('data-mob-title')
                    || h.getAttribute('title') || h.getAttribute('aria-label')
                    || h.querySelector('[title]')?.getAttribute('title') || ''
                return {
                    title: (c.textContent || '').replace(/\s+/g, ' ').trim() || tt.trim() || fallback,
                    icon: iconEl ? iconEl.className : '',
                    active: h.classList.contains('wj-state-active'),
                }
            }
            const allPanels = [...(root?.querySelectorAll?.('.wj-tabpanel') || [])]
            const topPanels = allPanels.filter(p => !allPanels.some(q => q !== p && q.contains(p)))
            for (const p of topPanels) {
                const headersBox = [...p.querySelectorAll('.wj-tabheaders')].find(x => x.closest('.wj-tabpanel') === p)
                const panesBox = [...p.querySelectorAll('.wj-tabpanes')].find(x => x.closest('.wj-tabpanel') === p)
                if (!headersBox) continue
                // заголовки/панели — ПОТОМКИ своих боксов (wijmo оборачивает), не прямые дети
                const hs = [...headersBox.querySelectorAll('.wj-tabheader')].filter(h => h.closest('.wj-tabheaders') === headersBox)
                const ps = panesBox ? [...panesBox.querySelectorAll('.wj-tabpane')].filter(x => x.closest('.wj-tabpanes') === panesBox) : []
                hs.forEach((h, i) => {
                    const it = info(h, this.t('Tab {n}', { n: i + 1 }))   // IE 2026 09 23 / ODOO-341407: i18n
                    // IE 2026 08 23: у вкладки есть подтабы (вложенный tabpanel в её
                    // панели) — рисуем шеврон; у неактивных best-effort (DOM может
                    // быть ещё не смонтирован — тогда стрелка появится после тапа)
                    it.hasSub = !!(ps[i] && ps[i].querySelector('.wj-tabpanel'))
                    it.k = this._mobTabEls.push(h) - 1
                    items.push(it)
                    if (it.active && ps[i]) {
                        const sub = ps[i].querySelector('.wj-tabpanel')
                        const subHeaders = sub && sub.querySelector('.wj-tabheaders')
                        const subHs = subHeaders ? [...subHeaders.querySelectorAll('.wj-tabheader')].filter(h => h.closest('.wj-tabheaders') === subHeaders) : []
                        subHs.forEach((sh, j) => {
                            const si = info(sh, this.t('Tab {n}', { n: j + 1 }))
                            si.sub = true
                            si.k = this._mobTabEls.push(sh) - 1
                            items.push(si)
                        })
                    }
                })
            }
            this.mobileTabsList = items
        },
        // IE 2026 08 20 / ODOO-336291 (mobile UX) (#4197): развернуть виджет на весь экран поверх других / вернуть
        // IE 2026 08 20 / ODOO-336291 (mobile UX) (#4197): на телефоне dblclick по заголовку максимизирует
        // (переименование остаётся десктопу)
        // IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: на iOS dblclick по input заголовка
        // не генерится — свой детектор двойного тапа (окно 350мс)
        // IE 2026 08 23 (заказ Игоря): свайп по заголовку РАЗВЁРНУТОГО виджета —
        // след./пред. виджет страницы (влево = следующий, как листание)
        mobHeaderTouchStart(e) {
            const t = e.touches?.[0]
            this._hdrSw = t ? { x: t.clientX, y: t.clientY } : null
        },
        mobileHeaderTouchTap(e) {
            if (!this.store.mobileUi?.on) return
            const t = e.changedTouches?.[0], sw = this._hdrSw
            this._hdrSw = null
            if (t && sw && this.WIDGET.styleWidget?._mobileMax) {
                const dx = t.clientX - sw.x, dy = t.clientY - sw.y
                if (Math.abs(dx) > this.store.setting('fe.mobile.headerSwipePx', 45) && Math.abs(dx) > 2 * Math.abs(dy)) {   // IE 2026 09 05 / ODOO-336330
                    e.preventDefault()
                    this._hdrTapTs = 0
                    this.mobileNavWidget(dx < 0 ? 1 : -1)
                    return
                }
            }
            const now = Date.now()
            if (now - (this._hdrTapTs || 0) < this.store.setting('fe.mobile.headerDblTapMs', 350)) {   // IE 2026 09 05 / ODOO-336330
                e.preventDefault()
                this._hdrTapTs = 0
                this.mobileToggleMax()
                return
            }
            this._hdrTapTs = now
        },
        mobileHeaderDblclick(e) {
            if (this.store.mobileUi?.on) { this.mobileToggleMax(); return }
            this.enableEditing(e)
        },
        // IE 2026 08 20 / ODOO-336291 (mobile UX) (#4200): пред/след виджет страницы; максимизация переезжает вместе с фокусом
        mobileNavWidget(dir) {
            const list = (this.store.WORKSPACES[this.WIDGET.workspace]?.ALL_WIDGETS || [])
                .filter(w => w.page === this.WIDGET.page && !w.close && !w._softClosed)
            const i = list.indexOf(this.WIDGET)
            if (i < 0 || list.length < 2) return
            const next = list[(i + dir + list.length) % list.length]
            const wasMax = !!this.WIDGET.styleWidget?._mobileMax
            if (wasMax) {
                this.WIDGET.styleWidget._mobileMax = false
                ;(next.styleWidget = next.styleWidget || {})._mobileMax = true
            }
            this.store.widget_activate(next, 'mobileNavWidget', true, true)
            if (!wasMax) window.$cg.setTimeout(this, 'mobileNavWidget', () => {
                document.getElementById('WIDGET' + next.id)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }, 150)
        },
        // IE 2026 08 20 / ODOO-336291 (mobile UX) (баг от ie-webscm7-2): у actionMenu задан
        // command — клик по шапке ВЫПОЛНЯЕТ команду, открытие списка только hover,
        // которого на таче нет. Capture-перехват до wijmo + программное открытие.
        // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка мыши — форма ячейки / строки / меню виджета)
        // правая кнопка по шапке виджета (заголовок, бейдж, кнопки первого ряда) — та же панель ≡, что открывает кнопка в правом верхнем углу, у точки клика
        // (MenuPanel.show({ at })); прежнее wj-menu (fe.ux.menuPanelWidget = false) — раскрывается как обычно. Поле заголовка в правке, панели шапки — меню браузера.
        // Выключатель fe.ux.contextMenuActions (дефолт ВКЛ); телефон — нет
        hdrContextMenu(e) {
            try {
                if (e.defaultPrevented || this.store.setting('fe.ux.contextMenuActions', true) === false || this.store.mobileUi?.on) return
                if (!this.WIDGET || this.WIDGET.styleWidget?.minMode) return
                const tg = e.target
                if (tg?.closest?.('textarea, select, [contenteditable="true"], .menu-panel, .chips-dropdown, .widget-settings-dropdown, .cow-pop, .tabs-hover-pop, .wj-dropdown-panel')) return
                const inp = tg?.closest?.('input')
                if (inp && !inp.readOnly) return   // поле в правке (заголовок по dblclick, поиск) — меню браузера
                if (this.store.setting('fe.ux.widgetHeaderContextMenu', true) !== false) {   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета): правая кнопка по шапке — форма угла «⋯» (выкл — прежняя панель ≡)
                    e.preventDefault()   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета)
                    const cf = (window.ctxMenuActions = window.ctxMenuActions || {}); cf.headerForm = (cf.headerForm || 0) + 1   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета)
                    if (!this.show_commandPanel_topLeft) this.topLeftForm_openAt({ x: e.clientX, y: e.clientY })   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета)
                    return   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета)
                }   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета)
                const c = (window.ctxMenuActions = window.ctxMenuActions || { cell: 0, cellKept: 0, row: 0, rowForm: 0, header: 0, skip: 0 })
                const mp = this.$refs.widgetMenuPanel
                if (mp && typeof mp.show === 'function') {
                    e.preventDefault()
                    if (!mp.open) mp.show({ by: 'click', at: { x: e.clientX, y: e.clientY } })
                    c.header = (c.header || 0) + 1
                    return
                }
                const wm = this.actionMenuId
                if (wm && wm.hostElement && !wm.isDroppedDown) { e.preventDefault(); wm.isDroppedDown = true; c.header = (c.header || 0) + 1 }
            } catch (err) { /* меню ещё не готово — меню браузера */ }
        },
        mobileActionMenuTap(e) {
            if (!this.store.mobileUi?.on) return
            const host = e.currentTarget.querySelector('.wj-menu')
            const ctrl = host && wjcCore.Control.getControl(host)
            if (!ctrl) return
            e.stopPropagation()
            if (!ctrl._mobTapWired) {
                ctrl._mobTapWired = true
                ctrl.isDroppedDownChanged.addHandler(() => {
                    if (!ctrl.isDroppedDown) ctrl._mobClosedTs = Date.now()
                    else window.mobTapDone?.('widgetMenu') // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31
                    // маркер открытого меню для CSS (блюр, скрытие кнопок)
                    if (this.store.mobileUi?.on) document.body.classList.toggle('wj-menu-open', ctrl.isDroppedDown)
                    // IE 2026 08 23: панель управления выросла (строка команд) и
                    // перекрывала верх меню (z 1501) — тапы уходили в неё и wijmo
                    // закрывал «тап мимо»; меню опускается под панель по факту
                    // IE 2026 09 04 / ODOO-336291 (mobile UX): B-16 — владелец меню становится видимым X (иконка pi-times; CSS поднимает его над панелью)
                    if (this.store.mobileUi?.on) {
                        const ic = host.querySelector('.pi')
                        if (ic) { ic.classList.toggle('pi-times', ctrl.isDroppedDown); ic.classList.toggle('pi-ellipsis-h', !ctrl.isDroppedDown) }
                        if (!ctrl.isDroppedDown) { window.mobTapDone?.('widgetMenuClose'); ctrl.dropDown?.style.removeProperty('max-height') }
                    }
                    if (this.store.mobileUi?.on && ctrl.isDroppedDown) requestAnimationFrame(() => {
                        const dd = ctrl.dropDown
                        if (!dd) return
                        const cp = document.querySelector('body > .widget-commandPanel-top-left')
                        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-13 / B-14 — панель wijmo лежит ВНУТРИ fixed-владельца ≡ (wijmo берёт ближайшего
                        // fixed-предка и ставит её transform'ом); геометрию задаём сами: fixed от края до края экрана (8 px),
                        // верх — под панелью команд (иначе под кнопкой), потолок высоты — до низа экрана (список прокручивается;
                        // раньше сдвиг marginTop не учитывался и последние пункты уходили за экран, подменю раздувало панель до 699 px)
                        const top = Math.round(cp ? cp.getBoundingClientRect().bottom + 8 : host.getBoundingClientRect().bottom + 6)
                        const S = (k, v) => dd.style.setProperty(k, v, 'important')
                        S('position', 'fixed'); S('transform', 'none'); S('left', '8px'); S('right', '8px'); S('width', 'auto'); S('top', top + 'px')
                        dd.style.marginTop = ''
                        S('max-height', Math.max(120, window.innerHeight - top - 8) + 'px')
                        this.mobPanelSync()
                    })
                })
            }
            // wijmo мог закрыть панель по mousedown ЭТОГО же тапа — это «было открыто»
            const wasOpen = ctrl.isDroppedDown || (Date.now() - (ctrl._mobClosedTs || 0) < 400)
            const want = !wasOpen
            setTimeout(() => { ctrl.isDroppedDown = want }, 30)
            // IE 2026 08 22: вместе с меню — панель управления виджетом сверху
            this.show_commandPanel_topLeft = want
            if (!ctrl._mobPanelWired) {
                ctrl._mobPanelWired = true
                ctrl.isDroppedDownChanged.addHandler(() => {
                    // IE 2026 08 23: при открытом листе настроек панель остаётся
                    if (this.store.mobileUi?.on && !ctrl.isDroppedDown && !this.showDropdown) this.show_commandPanel_topLeft = false
                })
            }
        },
        // IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: контекст viz-кнопки — видимый чарт
        // или грид активной вьюхи
        // IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: закрытие виджета верхней левой кнопкой
        mobileCloseWidget() {
            const vueObj = this.WIDGET.vueObj || this
            this.store.executeStoreMethod(vueObj, { command: 'onCloseWindow__Click' })
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-33 — кнопка панели команд грида только при непустой панели (на Launchpad лист был 0×0)
        mobileBarRefresh() {
            const gls = [...(this.$el?.querySelectorAll?.('.grid-top-line') || [])]
            this.mobileBarAvail = gls.some(gl => gl.querySelectorAll('.commandPanel-buttons, .p-button, button, .wj-control').length > 0)
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-15 — фактический низ панели команд → CSS-переменная --mob-panel-b: лист настроек встаёт под панель
        // по её реальной высоте (панель со строкой команд 183 px закрывала заголовок и первые строки листа при константе 64 px)
        mobPanelSync() {
            const cp = document.querySelector('body > .widget-commandPanel-top-left')
            const de = document.documentElement
            if (!cp) { de.style.removeProperty('--mob-panel-b'); this._mobPanelRO?.disconnect(); this._mobPanelRO = null; return }
            const apply = () => { if (cp.isConnected) de.style.setProperty('--mob-panel-b', Math.round(cp.getBoundingClientRect().bottom) + 'px') }
            apply()
            if (!this._mobPanelRO && window.ResizeObserver) {
                this._mobPanelRO = new ResizeObserver(apply)
                this._mobPanelRO.observe(cp)
            }
        },
        mobileVizRefresh() {
            const el = this.$el
            if (!el?.querySelectorAll) { this.mobileVizMode = ''; return }
            const vis = (n) => n && n.getBoundingClientRect().width > 0
            this.mobileVizMode = [...el.querySelectorAll('.wj-flexchart')].some(vis) ? 'chart'
                : (el.querySelector('.wj-flexgrid') ? 'grid' : '')
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-41 — сигнал активному чарту открыть/закрыть лист серий
        mobileChartSeries() {
            const prev = this.store.mobileChartLegend
            this.store.mobileChartLegend = { wid: this.WIDGET.id, tick: (prev?.tick || 0) + 1 }
            window.mobTapDone?.('chartSeriesSheet') // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31
        },
        mobileVizToggle() {
            this.mobileVizRefresh()
            if (this.mobileVizMode === 'chart') {
                this.chartAxesOn = !this.chartAxesOn
                this.store.mobileChartAxes = { wid: this.WIDGET.id, on: this.chartAxesOn }
                return
            }
            this.gridHeadsOn = !this.gridHeadsOn
            this.applyMobileGridHeads()
        },
        // номера строк (row headers) и числовая строка колонок — через wijmo, чтобы
        // место освобождалось (display:none у панелей wijmo его не возвращал)
        applyMobileGridHeads() {
            if (!this.store.mobileUi?.on) return
            const on = this.gridHeadsOn
            this.$el?.querySelectorAll?.('.wj-flexgrid').forEach(host => {
                const g = wjcCore.Control.getControl(host)
                if (!g || !g.columnHeaders) return
                // IE 2026 08 21 (скрин Игоря 22:15): пересборка грида восстанавливала
                // строку нумерации колонок — состояние живёт на гриде и доприменяется
                // на каждом updatedView
                g._mobHeadsOff = !on
                const applyOff = () => {
                    if (g.headersVisibility !== 1) {
                        if (g._mobHV == null) g._mobHV = g.headersVisibility
                        g.headersVisibility = 1
                    }
                    const rows = g.columnHeaders.rows
                    if (rows.length > 1 && rows[rows.length - 1].visible) rows[rows.length - 1].visible = false
                }
                try {
                    if (on) {
                        if (g._mobHV != null) { g.headersVisibility = g._mobHV; g._mobHV = null }
                        const rows = g.columnHeaders.rows
                        if (rows.length > 1 && !rows[rows.length - 1].visible) rows[rows.length - 1].visible = true
                        g._mobNumRow = null
                    } else {
                        applyOff()
                    }
                } catch (e) { /* грид в перестройке — доприменит updatedView */ }
                if (!g._mobHeadsHooked) {
                    g._mobHeadsHooked = true
                    g.updatedView.addHandler(() => {
                        if (!g._mobHeadsOff) return
                        try { applyOff() } catch (e) { /* перестройка */ }
                    })
                }
            })
        },
        // IE 2026 08 21 (заказ Игоря 22:28): режим ПРОСМОТРА грида (дефолт на мобиле):
        // перехват до wijmo (capture на корне виджета) — тап не выделяет ячейки,
        // палец прокручивает грид по обеим осям, пинч зумит; кнопка-карандаш
        // переключает в режим выделения (прежнее поведение)
        mobGridBrowseInit() {
            if (!this.store.mobileUi?.on || this._mobBrowseWired || !this.$el?.addEventListener) return
            this._mobBrowseWired = true
            const root = this.$el
            // IE 2026 08 22: режим ГЛОБАЛЬНЫЙ (кнопка нижнего ряда), на все виджеты
            const browsing = () => this.store.mobileUi?.on && !this.store.mobileUi?.selectMode
            // IE 2026 09 04 / ODOO-336291 (mobile UX): B-24 settingsEditable — грид полей настроек (data-mob-editable ставит AttrGrid) режим просмотра
            // не перехватывает: тап выделяет, двойной тап редактирует (как на десктопе)
            const gridOf = (e) => { const gh = e.target?.closest?.('.wj-flexgrid'); return gh && gh.dataset.mobEditable ? null : gh }
            const zoomOf = (gh) => gh._mobZoom || (gh._mobZoom = { scale: 1, tx: 0, ty: 0 })
            const applyZoom = (gh) => {
                const z = zoomOf(gh)
                const w = gh.clientWidth || 1, h = gh.clientHeight || 1
                z.tx = Math.min(0, Math.max(-(w * (z.scale - 1)), z.tx))
                z.ty = Math.min(0, Math.max(-(h * (z.scale - 1)), z.ty))
                const on = z.scale > 1.01
                // IE 2026 08 23 (заказ Игоря): осевые превью-трансформы по панелям —
                // шапки в превью НЕ растут (высота ch / ширина rh), геометрия
                // совпадает с реальным зумом => отпускание без прыжка
                const q = (p) => gh.querySelector(`[wj-part="${p}"]`)
                const cells = q('cells'), ch = q('ch'), rh = q('rh')
                if (cells && ch && rh) {
                    const tfs = [
                        [cells, `translate(${z.tx}px, ${z.ty}px) scale(${z.scale})`],
                        [ch, `translate(${z.tx}px, 0px) scale(${z.scale}, 1)`],
                        [rh, `translate(0px, ${z.ty}px) scale(1, ${z.scale})`],
                    ]
                    for (const [el, tf] of tfs) {
                        el.style.transformOrigin = '0 0'
                        el.style.transform = on ? tf : ''
                        el.style.willChange = on ? 'transform' : ''
                    }
                    gh.style.transform = ''
                } else {
                    gh.style.transformOrigin = '0 0'
                    gh.style.transform = on ? `translate(${z.tx}px, ${z.ty}px) scale(${z.scale})` : ''
                    gh.style.willChange = on ? 'transform' : ''
                }
            }
            let pan0 = null, pinch0 = null
            const dist = (t) => Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY)
            // IE 2026 09 04 / ODOO-336291 (mobile UX): P-10 — есть ли гриду куда прокрутиться по вертикали в сторону жеста
            // (scrollPosition.y ≤ 0: палец вверх → y убывает к -(scrollH-clientH), палец вниз → y растёт к 0)
            const gridCanScrollY = (g, dy) => {
                if (!g?.scrollSize) return false
                const sh = g.scrollSize.height || 0, ch = g.clientSize?.height || 0
                if (sh <= ch + 1) return false
                const y = g.scrollPosition?.y || 0, minY = -(sh - ch)
                return dy < 0 ? y > minY + 1 : y < -1
            }
            // IE 2026 08 23: коалесценция пана по кадрам (см. комментарий метода);
            // замер: window._mobPanStats = {moves, applies}
            let rafId = 0, rafFn = null
            const stats = (window._mobPanStats = window._mobPanStats || { moves: 0, applies: 0 })
            const schedule = (fn) => {
                if (this.store.mobileUi?.panRaf === false) { stats.applies++; fn(); return }
                rafFn = fn
                if (!rafId) rafId = requestAnimationFrame(() => {
                    rafId = 0
                    const f = rafFn; rafFn = null
                    if (f) { stats.applies++; f() }
                })
            }
            // wijmo слушает pointer/mouse на хосте — глушим их раньше (capture на корне)
            for (const type of ['pointerdown', 'mousedown', 'click', 'dblclick']) {
                root.addEventListener(type, (e) => {
                    if (!browsing() || !gridOf(e)) return
                    e.stopPropagation()
                }, true)
            }
            root.addEventListener('touchstart', (e) => {
                if (!browsing()) return
                const gh = gridOf(e)
                if (!gh) return
                e.stopPropagation()
                if (e.touches.length === 2) {
                    const r = gh.getBoundingClientRect(), z = zoomOf(gh)
                    pinch0 = { gh, d: dist(e.touches), scale: z.scale, tx: z.tx, ty: z.ty,
                        cx: (e.touches[0].clientX + e.touches[1].clientX) / 2 - r.left,
                        cy: (e.touches[0].clientY + e.touches[1].clientY) / 2 - r.top }
                    pan0 = null
                } else if (e.touches.length === 1) {
                    const g = wjcCore.Control.getControl(gh)
                    const sp = g?.scrollPosition
                    pan0 = { gh, g, x: e.touches[0].clientX, y: e.touches[0].clientY,
                        spx: sp ? sp.x : 0, spy: sp ? sp.y : 0, moved: false,
                        tx: zoomOf(gh).tx, ty: zoomOf(gh).ty }
                    window._mobPanActive = true // IE 2026 09 04 / ODOO-336291 (mobile UX): R-2 frozenCloneHold — палец ведёт грид (AttrGrid.initialized держит клон frozen-ячеек)
                }
                // IE 2026 09 04 / ODOO-336291 (mobile UX): R-2/R-3 (зонд 04.09) — touch-события идут ЦЕЛИ touchstart; wijmo при прокрутке
                // рециклит ячейки, и цель (ячейка / её дочерний div) выпадает из DOM — остаток жеста до корня не доходит,
                // пан обрывался после 30–100 px. Те же обработчики вешаются на саму цель (событие продолжает приходить
                // отсоединённому узлу); дубль с корнем гасит метка __mobPanSeen
                const tgt = e.target
                if (tgt && tgt !== root && typeof tgt.addEventListener === 'function') {
                    const mv = (ev) => onMove(ev)
                    const off = () => { tgt.removeEventListener('touchmove', mv); tgt.removeEventListener('touchend', end); tgt.removeEventListener('touchcancel', cancel) }
                    const end = (ev) => { onEnd(ev); if (ev.touches.length === 0) off() }
                    const cancel = (ev) => { onCancel(ev); off() }
                    tgt.addEventListener('touchmove', mv, { passive: false })
                    tgt.addEventListener('touchend', end, { passive: true })
                    tgt.addEventListener('touchcancel', cancel, { passive: true })
                }
            }, { capture: true, passive: true })
            // IE 2026 09 04 / ODOO-336291 (mobile UX): R-3 — жест отменён системой (звонок, свайп по краю): сбросить пан/пинч
            const onCancel = (e) => { if (e?.__mobPanSeen) return; if (e) e.__mobPanSeen = true; pan0 = null; pinch0 = null; window._mobPanActive = false }
            root.addEventListener('touchcancel', onCancel, { capture: true, passive: true })
            const onMove = (e) => {
                if (e.__mobPanSeen) return
                e.__mobPanSeen = true
                if (!browsing()) { pan0 = pinch0 = null; return }
                if (pinch0 && e.touches.length === 2) {
                    e.preventDefault(); e.stopPropagation()
                    const z = zoomOf(pinch0.gh)
                    // пределы превью от накопленного реального зума: вниз до полного
                    // сброса (1/k), вверх до суммарных 4x (4/k)
                    const kReal = pinch0.gh._mobRealK || 1
                    const ns = Math.min(4 / kReal, Math.max(1 / kReal, pinch0.scale * (dist(e.touches) / (pinch0.d || 1))))
                    z.tx = pinch0.cx - (pinch0.cx - pinch0.tx) * (ns / pinch0.scale)
                    z.ty = pinch0.cy - (pinch0.cy - pinch0.ty) * (ns / pinch0.scale)
                    z.scale = ns
                    applyZoom(pinch0.gh)
                } else if (pan0 && e.touches.length === 1) {
                    const dx = e.touches[0].clientX - pan0.x, dy = e.touches[0].clientY - pan0.y
                    // IE 2026 09 04 / ODOO-336291 (mobile UX): B-19 / P-10 gridPanChain — ось жеста по ПЕРВОМУ touchmove; вертикальный
                    // свайп, которому гриду некуда прокручиваться (нет диапазона / уже у края), не глушим —
                    // нативный скролл ленты (.page-container) забирает жест. Решать нужно на первом
                    // touchmove: после preventDefault браузер не отдаёт остаток жеста скроллу.
                    // Выкл (прежнее: preventDefault всегда): window.mobileUi.set('gridPanChain', false)
                    if (!pan0.axis && this.store.mobileUi?.gridPanChain !== false && zoomOf(pan0.gh).scale <= 1.01) {
                        pan0.axis = Math.abs(dy) > Math.abs(dx) ? 'y' : 'x'
                        if (pan0.axis === 'y' && !gridCanScrollY(pan0.g, dy)) { pan0 = null; window._mobPanActive = false; return }
                    }
                    // IE 2026 09 04 / ODOO-336291 (mobile UX): R-3 (верификация 04.09) — горизонтальный жест глушим всегда, пока событие отменяемо;
                    // если браузер уже увёл ВЕРТИКАЛЬНЫЙ жест в нативный скролл (событие не отменяемо — поток был занят),
                    // оставляем его ленте и грид по вертикали не двигаем (два скролла одного жеста); горизонталь
                    // нативно не стартует вовсе — touch-action: pan-y на гриде в режиме просмотра (mobile-ui.css)
                    if (!e.cancelable) { if (pan0.axis === 'y') { pan0 = null; window._mobPanActive = false; return } }
                    else e.preventDefault()
                    e.stopPropagation()
                    stats.moves++
                    if (Math.abs(dx) + Math.abs(dy) > this.store.setting('fe.mobile.panMovedPx', 8)) pan0.moved = true   // IE 2026 09 05 / ODOO-336330
                    const z = zoomOf(pan0.gh)
                    if (z.scale > 1.01) {
                        z.tx = pan0.tx + dx; z.ty = pan0.ty + dy
                        const gh = pan0.gh
                        schedule(() => applyZoom(gh))
                    } else if (pan0.g) {
                        // прокрутка самим гридом — виртуализация живая; применение
                        // не чаще кадра (значения замкнуты — pan0 мог обнулиться)
                        const g = pan0.g, sx = pan0.spx + dx, sy = pan0.spy + dy
                        schedule(() => { g.scrollPosition = new wjcCore.Point(sx, sy) })
                    }
                }
            }
            root.addEventListener('touchmove', onMove, { capture: true, passive: false })
            const onEnd = (e) => {
                if (e.__mobPanSeen) return
                e.__mobPanSeen = true
                if (pinch0 && e.touches.length < 2) {
                    // IE 2026 08 22 (замечание Игоря): по отпусканию transform-превью
                    // превращается в НАСТОЯЩИЙ зум метрик грида — заголовки остаются
                    // прилипшими и растут пропорционально
                    const gh = pinch0.gh, z = zoomOf(gh)
                    const factor = z.scale
                    // IE 2026 08 23: якорь превью — реальный зум совмещает картинку
                    const anchor = { tx: z.tx, ty: z.ty, s: z.scale }
                    // IE 2026 08 23 v3 (замечание Игоря 14:25): превью держим до
                    // конца реального зума — снятие в done() тем же кадром, без морга
                    const done = () => { z.scale = 1; z.tx = 0; z.ty = 0; applyZoom(gh) }
                    if (Math.abs(factor - 1) > 0.03) this.mobGridRealZoom(gh, factor, anchor, done)
                    else done()
                    pinch0 = null
                }
                if (pan0 && e.touches.length === 0) {
                    // короткий тап: ячейку не выделяем, но виджет активируем
                    if (!pan0.moved && browsing()) {
                        if (this.store.activeWIDGET !== this.WIDGET) this.store.widget_activate(this.WIDGET, 'mobGridBrowseTap')
                        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-36 activateAndAct — ТОТ ЖЕ тап делает и однозначное
                        // действие (раскрыть узел дерева, открыть меню ячейки-ссылки), а не только активирует виджет:
                        // режим просмотра гасит pointer/mouse до wijmo, поэтому действие выполняем сами
                        this.mobGridTapAct(pan0.gh, pan0.x, pan0.y)
                    }
                    pan0 = null
                }
                if (e.touches.length === 0) window._mobPanActive = false // IE 2026 09 04 / ODOO-336291 (mobile UX): R-2 frozenCloneHold
            }
            root.addEventListener('touchend', onEnd, { capture: true, passive: true })
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-36 activateAndAct — что делает тап по гриду помимо активации.
        // Только ОДНОЗНАЧНЫЕ цели: глиф свёртки узла/группы и тумблер ссылки в ячейке. Выделение ячейки
        // остаётся за режимом выделения (карандаш) — в режиме просмотра палец возит таблицу.
        // Выкл: window.mobileUi.set('activateAndAct', false)
        mobGridTapAct(gh, x, y) {
            if (!gh || this.store.mobileUi?.activateAndAct === false) return false
            let el = null
            try { el = document.elementFromPoint(x, y) } catch (e) { return false }
            if (!el || !gh.contains(el)) return false
            // 1) тумблер ссылки в ячейке (.cell-dropdown-toggle 16x16 — тап по нему не проходил вовсе)
            const tgl = el.closest?.('.cell-dropdown-toggle')
            if (tgl) { tgl.click(); window.mobTapDone?.('gridCellToggle'); return true } // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31
            // 2) глиф свёртки: под пальцем сам глиф ИЛИ его увеличенная зона (кнопка wj-elem-collapse ячейки)
            const cell = el.closest?.('.wj-cell')
            if (!cell) return false
            let btn = el.closest?.('.wj-elem-collapse')
            if (!btn) {
                const cand = cell.querySelector('.wj-elem-collapse')
                if (cand) {
                    const r = cand.getBoundingClientRect()
                    // зона глифа расширена на 14 px во все стороны — 7x7 пальцем не берётся
                    if (x >= r.left - 14 && x <= r.right + 14 && y >= r.top - 14 && y <= r.bottom + 14) btn = cand
                }
            }
            if (!btn) return false
            const g = wjcCore.Control.getControl(gh)
            if (!g || !g.rows) return false
            let ht = null
            try { ht = g.hitTest(x, y) } catch (e) { return false }
            const row = ht && ht.row >= 0 ? g.rows[ht.row] : null
            if (!row) return false
            try { row.isCollapsed = !row.isCollapsed } catch (e) { return false }
            window.mobTapDone?.('gridGroupToggle') // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31
            return true
        },
        // IE 2026 08 22: настоящий зум грида — масштаб метрик от базового снимка
        mobGridRealZoom(gh, factor, anchor = null, done = null) {
            const g = wjcCore.Control.getControl(gh)
            if (!g || !g.columns) { if (done) done(); return }
            const base = gh._mobZoomBase || (gh._mobZoomBase = {
                font: parseFloat(getComputedStyle(gh).fontSize) || 13,
                rowH: g.rows.defaultSize,
                colH: g.columnHeaders?.rows?.defaultSize || 24,
                widths: g.columns.map(c => c.renderWidth || c.width || 80),
                headW: (g.rowHeaders?.columns || []).map(c => c.renderWidth || c.width || 40),
            })
            const kPrev = gh._mobRealK || 1
            let k = kPrev * factor
            k = Math.min(4, Math.max(1, k))
            if (k <= 1.05) k = 1
            gh._mobRealK = k
            const fEff = k / kPrev
            const sp0 = g.scrollPosition
            try {
                g.deferUpdate(() => {
                    gh.style.fontSize = k === 1 ? '' : (base.font * k).toFixed(1) + 'px'
                    // шапки без изменений: их шрифт остаётся базовым (CSS по
                    // data-mob-zoomed), высота шапки колонок и ширина шапки строк
                    // не масштабируются — меняются только общие ширины колонок
                    // и высоты строк
                    gh.style.setProperty('--mob-grid-base-font', base.font + 'px')
                    // IE 2026 09 04 / ODOO-336291 (mobile UX): B-39 — размер текста ЯЧЕЕК на телефоне задаётся
                    // переменной (наследование от хоста прерывают панели wijmo), поэтому пинч-зум масштабирует её
                    if (k === 1) gh.style.removeProperty('--mob-grid-cell-font')
                    else gh.style.setProperty('--mob-grid-cell-font', (base.font * k).toFixed(1) + 'px')
                    if (k === 1) delete gh.dataset.mobZoomed; else gh.dataset.mobZoomed = '1'
                    g.rows.defaultSize = Math.round(base.rowH * k)
                    g.columns.forEach((c, i) => { c.width = Math.round((base.widths[i] || 80) * k) })
                })
            } catch (e) { /* грид в перестройке */ }
            // IE 2026 08 23 v3: скролл СИНХРОННО с пересчитанными метриками
            // (отложенный давал морг и промежуточное смещение), затем тем же
            // кадром снимается превью — repaint один; клампанутый скролл
            // поправляется тихо после пересчёта wijmo
            if (anchor && anchor.s) {
                const r = fEff / anchor.s
                const target = new wjcCore.Point(anchor.tx * r + fEff * sp0.x, anchor.ty * r + fEff * sp0.y)
                try { g.scrollPosition = target } catch (e) { /* пересборка */ }
                setTimeout(() => {
                    try {
                        const p = g.scrollPosition
                        if (Math.abs(p.x - target.x) > 2 || Math.abs(p.y - target.y) > 2) g.scrollPosition = target
                    } catch (e) { /* пересборка */ }
                }, 120)
            }
            if (done) done()
        },
        // IE 2026 08 23 (скрин Игоря 10:47): заголовок не прячется под левыми
        // fixed-кнопками — постоянный класс mob-title-inset, если текст с
        // отступом 56px влезает целиком (мерка canvas по computed-шрифту)
        mobTitleInsetCheck() {
            if (!this.store.mobileUi?.on) return
            const el = this.$refs.inputHeader
            const host = this.$el
            if (!el || !host?.classList) return
            let fits = false
            try {
                const cs = getComputedStyle(el)
                const canvas = this._mobTitleCanvas || (this._mobTitleCanvas = document.createElement('canvas'))
                const ctx = canvas.getContext('2d')
                ctx.font = `${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`
                const text = el.value || this.WIDGET?.title || ''
                const w = ctx.measureText(text).width
                // clientWidth мерим БЕЗ отступа: при уже включённом классе паддинг
                // 56px сам съедает ширину — вычитаем его влияние
                const padL = parseFloat(cs.paddingLeft || '0')
                fits = w + parseFloat(cs.paddingRight || '0') + 58 <= el.clientWidth + padL - (this.mobTitleInset ? 0 : padL)
            } catch (e) { fits = false }
            // v4: класс через data+биндинг — ручной classList стирался перерендером
            this.mobTitleInset = fits
        },
        // IE 2026 08 23 (заказ Игоря): лист настроек виджета — вместо блока
        // меню на том же экране; wijmo-меню закрывается, панель остаётся
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-03 — pointerdown только гасит совместимые mouse-события (.stop.prevent в шаблоне),
        // работы в нём нет: тяжёлый toggleDropdown из pointerdown блокировал ~380 мс, touchstart приходил
        // после окна дедупа 350 мс и переворачивал состояние обратно (лист «мигал», панель закрывалась,
        // а click уезжал в кнопку максимизации под пальцем). Тоггл — один путь события: click
        mobSettingsPress() { /* см. шаблон: .stop.prevent */ },
        mobToggleSettings() {
            // boolean-дедуп на кадр вместо таймстампа: повторный click в том же кадре игнорируется
            if (this._settingsToggling) return
            this._settingsToggling = true
            requestAnimationFrame(() => { this._settingsToggling = false })
            const opening = !this.showDropdown
            this.toggleDropdown()
            if (opening) this.show_commandPanel_topLeft = true
            if (opening) {
                this.$nextTick(() => this.mobPanelSync()) // IE 2026 09 04 / ODOO-336291 (mobile UX): B-15 — лист под фактический низ панели
                try {
                    const el = document.querySelector('body > .widget_menu .wj-menu') || this.$el.querySelector('.widget_menu .wj-menu')
                    const c = el && wjcCore.Control.getControl(el)
                    if (c && c.isDroppedDown) c.isDroppedDown = false
                } catch (e) { /* меню и так закрыто */ }
                this.addTopLeftOutside() // тап снаружи листа/панели закрывает обе (как лист табов и меню ≡)
                window.mobTapDone?.('settings') // P-31
            } else {
                this.show_commandPanel_topLeft = false
                this.removeTopLeftOutside()
            }
        },
        mobileToggleMax() {
            const sw = this.WIDGET.styleWidget = this.WIDGET.styleWidget || {}
            sw._mobileMax = !sw._mobileMax
            window.mobTapDone?.('max') // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31
            if (sw._mobileMax) this.store.widget_activate(this.WIDGET, 'mobileMax')
            // IE 2026 08 20 / ODOO-336291 (mobile UX) (Safari/iPhone): максимизирован — держать экран
            window.mobileWakeLock?.(sw._mobileMax)
            window.mobileHaptic?.()
        },
        mobileTabTap(i) {
            const it = this.mobileTabsList[i]
            const h = it != null ? this._mobTabEls?.[it.k] : null
            if (!h) { this.mobileTabsOpen = false; return }
            h.click()
            if (it.sub) {
                // вложенный таб выбран — работа сделана
                this.mobileTabsOpen = false
            } else {
                // верхнеуровневый: если у выбранного есть вложенные — показать их (лист остаётся)
                window.$cg.setTimeout(this, 'mobileTabsRebuild', () => {
                    if (!this.mobileTabsOpen) return
                    this.buildMobileTabs()
                    if (!this.mobileTabsList.some(x => x.sub)) this.mobileTabsOpen = false
                }, 300)
            }
            // IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: вьюха сменилась — viz-кнопка и номера
            window.$cg.setTimeout(this, 'mobileVizTab', () => { this.mobileVizRefresh(); this.applyMobileGridHeads(); this.mobileBarRefresh() }, 450) // IE 2026 09 04 / ODOO-336291 (mobile UX): B-33
        },
        // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл): клик мышью по углу ⋯ (десктоп) — открыть форму теми же шагами, что наведение (без паузы); пока форма открыта, угла нет — закрывает её уход курсора
        // из зоны «угол + форма» (topLeftZone_watch; дальше — прежнее закрытие по уходу с формы). С опцией «Open menus on hover» клик тоже открывает
        // IE 2026 10 25 / ODOO-345044 (hotfix: ✕ под курсором после ховера угла): первые 300 мс после открытия формы угла ⋯ (любым путём) её кнопки клик не принимают — «✕ Close» лежит в точке угла, клик, начатый
        // как «клик по ⋯» сразу после наведения, закрывал виджет. Капчур на корне виджета: pointerdown / mousedown / mouseup / click в форме. Мобильный профиль — не трогается.
        // Выключатель fe.ux.widgetCornerHoverArm = false — без взвода
        topLeftArm_guard(ev) {   // IE 2026 10 25 / ODOO-345044 (hotfix: ✕ под курсором после ховера угла)
            if (this.store.mobileUi?.on || !this.show_commandPanel_topLeft || !ev?.target?.closest?.('.widget-commandPanel-top-left')) return   // IE 2026 10 25 / ODOO-345044 (hotfix: ✕ под курсором после ховера угла)
            const d = cornerArmDecide(ev.type, this._tlOpenedAt, Date.now(), cornerHoverArm_on(this.store), this._tlArmDown)   // IE 2026 10 25 / ODOO-345044 (hotfix: ✕ под курсором после ховера угла)
            this._tlArmDown = d.downBlocked   // IE 2026 10 25 / ODOO-345044 (hotfix: ✕ под курсором после ховера угла)
            if (!d.block) return   // IE 2026 10 25 / ODOO-345044 (hotfix: ✕ под курсором после ховера угла)
            ev.stopPropagation(); ev.preventDefault()   // IE 2026 10 25 / ODOO-345044 (hotfix: ✕ под курсором после ховера угла)
            if (!this.store.hide_console) console.log('corner form armed: ' + ev.type + ' ignored')   // IE 2026 10 25 / ODOO-345044 (hotfix: ✕ под курсором после ховера угла)
        },   // IE 2026 10 25 / ODOO-345044 (hotfix: ✕ под курсором после ховера угла)
        topLeftCornerClick() {   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл)
            if (this.show_commandPanel_topLeft) { this.forceCloseTopLeft(); return }   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл)
            this.clearTopLeftTimers()   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл)
            this.mouseenter_btnScale()   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл)
            this.fillLayoutInputs()   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл)
            this.topLeftForm_place()   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл)
            this._tlCtxPt = null   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета): открыта с угла — точки правого клика нет
            this.show_commandPanel_topLeft = true   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл)
            this.topLeftZone_watch()   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл): курсор ушёл, не заходя на форму, — форма закрывается (иначе mouseleave не придёт: угол исчез)
        },   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл)
        // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета): форма угла «⋯» по правой кнопке на шапке — теми же шагами, что клик по углу; точка клика входит в зону удержания (topLeftZone_rect), иначе страж
        // закрыл бы форму через 150 мс: курсор в шапке далеко от угла. Закрытие — уход из зоны «угол + форма + точка», Esc, клик мимо
        topLeftForm_openAt(pt) {   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета)
            this.clearTopLeftTimers()   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета)
            this.mouseenter_btnScale()   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета)
            this.fillLayoutInputs()   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета)
            this.topLeftForm_place()   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета)
            this._tlCtxPt = pt && typeof pt.x === 'number' ? { x: pt.x, y: pt.y } : null   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета)
            this.show_commandPanel_topLeft = true   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета)
            this.topLeftZone_watch()   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета)
        },   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню виджета)
        onTopLeftCornerTap() {
            if (!this.store.mobileUi?.on) { this.topLeftCornerClick(); return }   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл): на десктопе клик по углу ⋯ открывает / закрывает форму
            // IE 2026 08 20 / ODOO-336291 (mobile UX) (замечание Игоря): кнопка закреплена в углу,
            // повторный тап по ней сворачивает панель
            if (this.show_commandPanel_topLeft) { this.forceCloseTopLeft(); return }
            this.openTopLeftPanelMobile()
        },
        openTopLeftPanelMobile() {
            this.clearTopLeftTimers()
            this.mouseenter_btnScale()
            this.fillLayoutInputs()
            this.show_commandPanel_topLeft = true
            // #4174: под строкой команд — выбор настроек (только если у виджета есть таблица настроек,
            // иначе пустой белый лист перекрывал строку команд — скрин Игоря)
            if (this.dropdownTabs?.length) this.showDropdown = true
            this.addTopLeftOutside()
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): закрытие панели/листа настроек тапом снаружи — общий регистратор (зовут
        // openTopLeftPanelMobile и mobToggleSettings). На мобиле панель телепортирована в body — искать её
        // в this.$el было нельзя; попапы wijmo/Prime и dropdown ячейки живут в body — тап в них не закрытие
        addTopLeftOutside() {
            this.removeTopLeftOutside()
            this._topLeftOutside = (ev) => {
                const t = ev.target
                if (!t?.closest) return
                const panel = document.querySelector('body > .widget-commandPanel-top-left') || this.$el?.querySelector?.('.widget-commandPanel-top-left')
                if (panel?.contains(t) || this.$refs.commandPanel?.contains(t)) return
                if (t.closest('.widget-corner-btn, .widget_menu')) return
                if (t.closest('.widget-settings-dropdown')) return // #4174: тапы в листе настроек — не закрытие
                if (t.closest('.wj-dropdown-panel, .wj-popup, .p-dialog, .p-overlaypanel, .p-datepicker, .dropdown')) return
                this.forceCloseTopLeft()
            }
            document.addEventListener('pointerdown', this._topLeftOutside, true)
        },
        removeTopLeftOutside() {
            if (this._topLeftOutside) {
                document.removeEventListener('pointerdown', this._topLeftOutside, true)
                this._topLeftOutside = null
            }
        },
        clearTopLeftTimers() {
            if (this.timerId_onShow_commandPanel_topLeft) { clearTimeout(this.timerId_onShow_commandPanel_topLeft) }
            if (this.timerId_onClose_commandPanel_topLeft) { clearTimeout(this.timerId_onClose_commandPanel_topLeft) }
        },


        onShow_hidden(event, vueEvent) {
            // IE 2026 10 25 / ODOO-345044 (заказ Игоря: ховер углов виджета всегда): правый верхний угол «показать скрытое» открывается наведением ВСЕГДА — опция «Open menus on hover» его не касается
            if (event?.altKey) return   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3 (накат 26.09): при зажатом Alt наведение на угол не открывает скрытые части шапки — объяснение угла (widget.corner.topRight) остаётся на месте
            if (this.timerId_onShow_container) { clearTimeout(this.timerId_onShow_container) }
            this.timerId_onShow_container = setTimeout(() => {
                if (this.store.mouse_isInside(event.target)) {
                    // IE 2026 09 22 / ODOO-5800 (Igor): при скрытой шапке — островок «сегмент · тайтл · развернуть» вместо всей шапки (её открывает шеврон островка);
                    // скрытые только табы / панель — как раньше. Выключатель fe.ux.cornerIsland
                    // IE 2026 09 22 (поправка Игоря): бейдж + тайтл переехали в форму «⋯» левого угла — островок по умолчанию выключен (fe.ux.cornerIsland = true вернёт)
                    if (this.WIDGET.styleWidget?.hideHeader && !this.store.mobileUi?.on && this.store.setting('fe.ux.cornerIsland', false) === true) { this.cornerIsland_keep(); this.cornerIsland = true; return }
                    this.WIDGET.styleWidget.show_hidden = true;
                    if (this.WIDGET.styleWidget?.hideTabs) this.store.settingsForm_prefetchIfVisible?.(this.WIDGET, 'tabs-shown', true)   // IE 2026 09 28 / ODOO-5800: полоса вкладок показана наведением на угол — форма настроек
                }
            }, 50)
        },
        cornerIsland_keep() { if (this._cornerIslandT) { clearTimeout(this._cornerIslandT); this._cornerIslandT = null } },
        cornerIsland_leave() { this.cornerIsland_keep(); this._cornerIslandT = setTimeout(() => { this.cornerIsland = false }, 350) },
        cornerIsland_max() { this.cornerIsland = false; this.store.executeStoreMethod(this, { command: 'onWidgetMaxToggle__Click' }) },
        cornerIsland_header() { this.cornerIsland = false; this.WIDGET.styleWidget.show_hidden = true },
        // IE 2026 09 23 / ODOO-… (замечание Игоря: в форме ⋯ — те же элементы шапки): identBadge_click (22.09) снят — в форме стоит сам бейдж шапки, его клик открывает панель на месте (toggleDropdown)

        onShow_commandPanel_bottomRight(event) {
            this.show_commandPanel_bottomRight = true
            // this.isManuallyResizing = true

            // this.startX = event.clientX;
            // this.startY = event.clientY;
            // this.scaling = true;

            // window.addEventListener("mouseenter", this.onResize);
            // window.addEventListener("mouseup", this.stopResize);
        },
        onResize(event) {
            // const dx = event.clientX - this.startX;
            // const dy = event.clientY - this.startY;

            // this.scaleX = (this.initialWidth + dx) / this.initialWidth;
            // this.scaleY = (this.initialHeight + dy) / this.initialHeight;
        },
        onClose_commandPanel_bottomRight(event) {
            this.show_commandPanel_bottomRight = false
            // if (this.isManuallyResizing) {
            //     this.isManuallyResizing = false
            // }

            // const dx = event.clientX - this.startX;
            // const dy = event.clientY - this.startY;

            // this.finalWidth = this.initialWidth + dx;
            // this.finalHeight = this.initialHeight + dy;
            // this.initialWidth = this.finalWidth;
            // this.initialHeight = this.finalHeight;

            // this.scaleX = 1;
            // this.scaleY = 1;
            // this.scaling = false;

            // window.removeEventListener("mouseenter", this.onResize);
            // window.removeEventListener("mouseup", this.stopResize);
        },

        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок — «…» и продолжение по наведению, как в ячейках): наведение на обрезанный заголовок — через fe.ux.clipOverlayDelayMs его продолжение поверх (utils/clipOverlay.js, как у ячеек и строк панелей).
        // У docked-виджета шапку накрывает полоса-захват .popout-grab-top, а поле заголовка мышь не ловит (.widget-header { all: unset } → pointer-events от шапки) —
        // поэтому наведение считается по координатам: движение мыши над полосой или над полем (Float), точка — в видимой части поля (левее панели поверх хвоста).
        // Слой временный (5 с; снова — после ухода мыши с поля), снимается уходом мыши, нажатием, колесом / прокруткой / клавишей
        titleTail_move(e) {
            const el = this.$refs.inputHeader
            if (!el || !e) return
            const r = el.getBoundingClientRect()
            const head = el.parentElement
            const panel = head && head.querySelector(':scope > .buttons.buttons-over-title')
            const clipX = panel ? titleTail_clipX(r, panel.getBoundingClientRect()) : null
            const inside = r.width > 0 && e.clientX >= r.left && e.clientX < (clipX != null ? clipX : r.right) && e.clientY >= r.top && e.clientY < r.bottom
            if (!inside) { this._ttDone = false; if (this._ttT || this._ttOv) this.titleTail_hide(); return }
            if (this._ttT || this._ttOv || this._ttDone) return
            titleTailStats.over++
            const want = () => titleTail_want({ flag: this.titleTailOn, editing: this.isEditingHeader, plate: !!this.vizTitlePlate(), mobile: !!this.store?.mobileUi?.on,
                alt: !!altTooltip.held, scrollWidth: el.scrollWidth, clientWidth: el.clientWidth })
            if (!want()) { this._ttDone = true; return }
            let delay = 300
            try { const v = +this.store.setting('fe.ux.clipOverlayDelayMs', 300); if (v >= 0) delay = v } catch (err) { delay = 300 }
            this._ttT = setTimeout(() => {
                this._ttT = null
                if (!el.isConnected || !want()) return
                const p2 = el.parentElement && el.parentElement.querySelector(':scope > .buttons.buttons-over-title')
                const cx = p2 ? titleTail_clipX(el.getBoundingClientRect(), p2.getBoundingClientRect()) : null
                let ov = null
                try { ov = clipOverlay_show(el, { className: 'clip-overlay widget-title-clip-overlay', clipX: cx }) } catch (err) { ov = null }
                if (!ov) { this._ttDone = true; return }
                this._ttOv = ov
                if (cx != null) this.titleTailCover = true
                titleTailStats.shown++; titleTailStats.last = { wid: this.widget_id, clipX: cx, mode: ov.dataset.clipMode }
                this._ttOff = () => this.titleTail_hide()
                for (const ev of ['wheel', 'scroll', 'keydown', 'resize']) window.addEventListener(ev, this._ttOff, true)
                this._ttT3 = setTimeout(() => { this.titleTail_hide(); this._ttDone = true }, 5000)
            }, delay)
        },
        // уход мыши с полосы / поля: переход между ними (полоса ↔ поле) слой не снимает
        titleTail_leave(e) {
            const to = e && e.relatedTarget
            const el = this.$refs.inputHeader
            if (to && el && (to === el || (to.closest && to.closest('.popout-grab-top') === this.$el?.querySelector?.(':scope > .popout-grab-top')))) return
            this._ttDone = false
            this.titleTail_hide()
        },
        titleTail_hide() {
            clearTimeout(this._ttT); clearTimeout(this._ttT3); this._ttT = this._ttT3 = null
            if (this._ttOff) { for (const ev of ['wheel', 'scroll', 'keydown', 'resize']) window.removeEventListener(ev, this._ttOff, true); this._ttOff = null }
            if (this._ttOv) { try { this._ttOv.remove() } catch (e) { /* слой уже снят */ } this._ttOv = null; titleTailStats.hidden++ }
            if (this.titleTailCover) this.titleTailCover = false
        },
        // ------------- drag&drop ----------------------------------------
        header_mousedown(e) {
            this.is_header_mousedown = e.currentTarget.closest('.WIDGET')
            if (this.WIDGET.styleWidget.dock === 'popout') {
                this.popoutDragStart(e);
            }
        },
        dragStart(e) {
            // ✅ popout -> запрещаем HTML5 DnD, будем двигать по координатам
            if (this.is_header_mousedown && this.WIDGET.styleWidget.dock === 'popout') {
                e.preventDefault();
                this.popoutDragStart(e);
                return;
            }

            // ✅ обычный режим -> HTML5 DnD
            if (this.is_header_mousedown && this.WIDGET.styleWidget.dock !== 'popout') {
                let pSource = this.store.params_dragSource = {
                    WIDGET: this.WIDGET,
                    vueObj: this,
                    type: 'widget',
                }

                pSource.text = pSource.WIDGET.title
                e.dataTransfer.setData('text/plain', pSource.text)
                e.dataTransfer.setDragImage(this.get_dragImage(pSource), 10, 100)
    
                pSource.WIDGET.isDragging = true
                e.dataTransfer.effectAllowed = 'move'

                this._armDragWatchdog(1500)

            } else {
                e.preventDefault()
            }
        },
        get_dragImage(pSource) {
            const dragImage = pSource.dragImage = document.createElement('div')
            dragImage.className = 'drag-box'
            
            dragImage.innerHTML = `<b class='drag-header'>${pSource.text}</b>`

            if (pSource.WIDGET.pi) {
                dragImage.innerHTML = `<i class="${pSource.WIDGET.pi} pi-header drag-header"></i>` + dragImage.innerHTML
            }

            document.body.appendChild(dragImage)

            return dragImage
        },
        dragOver(e) {
            let pSource = this.store.params_dragSource
            if (!(pSource?.type === 'widget' && pSource.WIDGET.styleWidget.dock !== 'popout')) {
                return
            }

            let pTarget = this.store.params_dragTarget || {},
            pOver = {
                WIDGET: this.WIDGET,
                vueObj: this,
                type: 'widget',
            }

            if (pTarget?.WIDGET && pTarget.WIDGET !== pOver.WIDGET) {
                pTarget.WIDGET.isDragOver = false
                pTarget = this.store.params_dragTarget = {}
                if (!this.store.hide_console) console.log(`remoute drag-over-widget`)
            }

            e.preventDefault()
            if (pSource.WIDGET !== pOver.WIDGET && pTarget.WIDGET !== pOver.WIDGET) {
                e.dataTransfer.dropEffect = 'move'

                pTarget = this.store.params_dragTarget = pOver
                pTarget.WIDGET.isDragOver = true
                if (!this.store.hide_console) console.log(`add drag-over-widget`)
            
                pSource.vueObj._armDragWatchdog(2500)
                pOver.vueObj._armDragWatchdog(2500)
            }
            
            this._armDragWatchdog(1500)
        },
        dragDrop(e) {
            let pSource = this.store.params_dragSource
            if (!(pSource?.type === 'widget' && pSource.WIDGET.styleWidget.dock !== 'popout')) {
                return
            }

            let pTarget = this.store.params_dragTarget || {}

            if (pSource.WIDGET && pTarget.WIDGET) {
                const store = this.store,
                source = store.findWidget(pSource.WIDGET.id),
                target = store.findWidget(pTarget.WIDGET.id)
    
                if (store.swapOnDragAndDrop) {
                    store.WORKSPACES[source.workspace].ALL_WIDGETS.splice(source.ind, 1, target.WIDGET)
                    store.WORKSPACES[target.workspace].ALL_WIDGETS.splice(target.ind, 1, source.WIDGET)
                } else {
                    store.WORKSPACES[source.workspace].ALL_WIDGETS.splice(source.ind, 1)
                    store.WORKSPACES[target.workspace].ALL_WIDGETS.splice(target.ind, 0, source.WIDGET)
                }

                e.preventDefault()

                // // isMapped
                // if (this.PAGE.WIDGET_transfer) {
                //     this.store.set_isMappedWidgets(pSource.WIDGET, 1000)
                // }
            }

            this.safeDragCleanup()
        },
        dragLeave(e) {
            // Ignore if cursor moved to a child element — browsers fire dragleave on parent when entering a child
            if (this.$el.contains(e.relatedTarget)) return

            let pTarget = this.store.params_dragTarget || {}
            if (!(pTarget?.type === 'widget' && pTarget.WIDGET.styleWidget.dock !== 'popout')) {
                return
            }

            if (pTarget.WIDGET) {
                pTarget.WIDGET.isDragOver = false
            }
            this.store.params_dragTarget = {}
        },
        dragEnd(e) {
            let pSource = this.store.params_dragSource
            if (!(pSource?.type === 'widget' && pSource.WIDGET.styleWidget.dock !== 'popout')) {
                return
            }

            this.safeDragCleanup()
            // let pTarget = this.store.params_dragTarget || {}
            
            // // source
            // pSource.WIDGET.isDragging = false
            // pSource.vueObj.is_header_mousedown = false
            
            // if (pTarget.WIDGET) {
            //     pTarget.WIDGET.isDragOver = false
            // }
            
            // document.body.removeChild(pSource.dragImage)
            // this.store.params_dragSource = {}
            // this.store.params_dragTarget = {}
        },

        safeDragCleanup() {
            clearTimeout(this._dragWatchdog)

            const pSource = this.store.params_dragSource || {}
            const pTarget = this.store.params_dragTarget || {}

            try {
                pSource.WIDGET && (pSource.WIDGET.isDragging = false)
                pTarget.WIDGET && (pTarget.WIDGET.isDragOver = false)

                if (pSource.dragImage && pSource.dragImage.parentNode) {
                    pSource.dragImage.parentNode.removeChild(pSource.dragImage)
                }
            } catch(_) { /* ignore */ }

            this.is_header_mousedown = false
            this.store.params_dragSource = {}
            this.store.params_dragTarget = {}

            // this.PAGE is the original page (set in created(), not reactive) — recalculate source page layout after widget may have moved to another page
            this.PAGE?.mainArea?.vueObj.checkWorkspaceScroll()
        },
        _armDragWatchdog(timeout = 1500) {
            // clearTimeout(this._dragWatchdog)
            // this._dragWatchdog = setTimeout(() => {
            //     const idleFor = Date.now() - (this._lastDragOverAt || 0)
            //     // если недавно был dragover — подождём ещё
            //     if (idleFor < timeout) return this._armDragWatchdog(timeout)

            //     // если зажаты модификаторы (Ctrl/Shift/Alt/Meta) — не чистим,
            //     // а откладываем проверку (пользователь, возможно, целится в target)
            //     // if (this._isAnyModHeld()) return this._armDragWatchdog(timeout)

            //     // если источник всё ещё помечен как перетаскиваемый — чистим
            //     const pSource = this.store.params_dragSource
            //     if (pSource?.WIDGET?.isDragging) this.safeDragCleanup()
            // }, timeout)
        },

        // ------------- popout ----------------------------------------
        // IE 2026 08 20 / ODOO-336291 (mobile UX) (замечание Игоря): на таче popout можно тянуть
        // за всю шапку — grab-зона перекрыта бейджем/заголовком, а mouse-hover нет.
        // Порог 8px: тап без сдвига остаётся обычным кликом (бейдж, кнопки работают)
        popoutSuppressedClick(e) {
            if (this._popoutSuppressClick) { e.stopPropagation(); e.preventDefault() }
        },
        popoutHeaderTouchDown(e) {
            if (!this.store.mobileUi?.on || e.pointerType !== 'touch') return
            if (this.WIDGET.styleWidget?.dock !== 'popout') return
            const host = e.currentTarget
            const r = host.getBoundingClientRect()
            if (e.clientY - r.top > 44) return
            if (e.target.closest('input,textarea,select,.resize-handle')) return
            const sx = e.clientX, sy = e.clientY
            let engaged = false
            const cancelScroll = (te) => te.preventDefault()
            // IE 2026 09 04 / ODOO-336291 (mobile UX): B-02 / P-10 gridPanChain — глушить скролл страницы только ПОСЛЕ порога 8 px
            // и только для горизонтального жеста; вертикальный свайп по шапке остаётся браузеру (лента
            // карточек скроллится). Выкл (прежнее: preventDefault с pointerdown): mobileUi.set('gridPanChain', false)
            const chain = this.store.mobileUi?.gridPanChain !== false
            let vertical = false
            if (!chain) window.addEventListener('touchmove', cancelScroll, { passive: false })
            const move = (pe) => {
                if (engaged || vertical) return
                const dx = pe.clientX - sx, dy = pe.clientY - sy
                if (Math.hypot(dx, dy) > 8) {
                    if (chain && Math.abs(dy) > Math.abs(dx)) { vertical = true; return }
                    engaged = true
                    if (chain) window.addEventListener('touchmove', cancelScroll, { passive: false })
                    this._popoutSuppressClick = true
                    this.popoutDragStart(e, 'move')
                }
            }
            const up = () => {
                window.removeEventListener('touchmove', cancelScroll)
                window.removeEventListener('pointermove', move, true)
                window.removeEventListener('pointerup', up, true)
                window.removeEventListener('pointercancel', up, true)
                setTimeout(() => { this._popoutSuppressClick = false }, 80)
            }
            window.addEventListener('pointermove', move, true)
            window.addEventListener('pointerup', up, true)
            window.addEventListener('pointercancel', up, true)
        },
        popoutPointerDown(e, mode = "move") {
            // двойной клик — НЕ запускаем drag
            if (e.detail >= 2) {
                // dblclick сам отработает
                return;
            }

            this.popoutDragStart(e, mode);
        },
        
        popoutDragStart(e, mode = "move") {
            // включаем только для popout
            if (this.WIDGET.styleWidget?.dock !== 'popout') {
                this.is_header_mousedown = e.currentTarget.closest('.WIDGET')
                // this.dragStart(e);
                return;
            }

            const WidgetContainer = document.getElementById(`WIDGET${this.WIDGET.id}`);
            if (!WidgetContainer) return;

            this.store.widget_activate(this.WIDGET, 'WIDGET::popoutDragStart')

            this.store.params_dragSource = { WIDGET: this.WIDGET, vueObj: this, type: 'widget' }
            this.store.popoutDragging = true

            // если клик по интерактивным элементам внутри (кнопки/инпуты/ссылки) — не начинаем drag
            const t = e.target;
            if (t && (t.closest?.("button,a,input,textarea,select,[data-no-popout-drag]"))) return;

            const rect = WidgetContainer.getBoundingClientRect();

            // demo-webscm 2026 11 02 / ODOO-350612: стартовый рект (style, иначе rect — и проставить в style) и состояние жеста — utils/freeWindow.js
            // (общий код с доком навигатора); формулы и минимумы прежние
            const start = freeWindow_startRect(WidgetContainer, rect)

            // запоминаем позицию до начала перемещения
            this._popoutInitialRect = { ...start }

            // можно менять курсор сразу
            WidgetContainer.style.transition = "none";

            this._popoutDrag = { ...freeWindow_dragState(start, e.clientX, e.clientY, mode), rect, lastEvent: e };   // mode: move | top | bottom | left | right | top-right | top-left | bottom-right | bottom-left

            // IE 2026 08 20 / ODOO-336291 (mobile UX): pointer-события — drag работает и пальцем
            // (тач не генерит mousemove; touch-action:none на ручках — см. стили); у тача скролл страницы глушится, иначе браузер отберёт жест (pointercancel)
            this._popoutDragOff = freeWindow_listen(window, e, { move: this.popoutDragMove, end: this.popoutDragEnd })   // ODOO-350612: слушатели — там же

            document.body.style.userSelect = "none";
        },

        popoutDragMove(e) {
            if (!this._popoutDrag) return;
            e.preventDefault();

            this._popoutDrag.lastEvent = e;
            if (this._popoutDrag.raf) return;

            this._popoutDrag.raf = requestAnimationFrame(() => {
                const d = this._popoutDrag;
                const ev = d.lastEvent;
                if (!ev) return;

                const dx = ev.clientX - d.sx;
                const dy = ev.clientY - d.sy;

                const WidgetContainer = document.getElementById(`WIDGET${this.WIDGET.id}`);
                if (!WidgetContainer) return;

                // demo-webscm 2026 11 02 / ODOO-350612: move — сдвиг left/top; resize — по сторонам режима, минимум 320×180 с компенсацией для
                // север/запад (utils/freeWindow.js, те же формулы, что были здесь)
                freeWindow_apply(WidgetContainer, freeWindow_nextRect(d, dx, dy))

                this.PAGE.vueObj.refreshe_svg(0)

                const tabEl = document.elementsFromPoint(ev.clientX, ev.clientY)
                    .find(el => el.classList.contains('left-area-button-tab')
                        || el.closest?.('.left-area-button-tab'))
                    ?.closest('.left-area-button-tab')
                    ?? document.elementsFromPoint(ev.clientX, ev.clientY)
                        .find(el => el.classList.contains('left-area-button-tab'))
                this.store.popoutOverPageInd = tabEl?.dataset?.pageIndex ?? false

                d.raf = null;
            });
        },

        popoutDragEnd(e) {
            if (!this._popoutDrag) return;
            e.preventDefault();

            if (this._popoutDragOff) { this._popoutDragOff(); this._popoutDragOff = null }   // ODOO-350612: снять слушатели (pointer* и touchmove тача) — utils/freeWindow.js
            document.body.style.userSelect = "";

            const WidgetContainer = document.getElementById(`WIDGET${this.WIDGET.id}`);
            if (WidgetContainer) {
                WidgetContainer.style.transition = ""; // вернуть анимацию
            }

            if (this.WIDGET.widget === 'widget-row' && WidgetContainer) {
                // позиция/размер по ключу «виджет+источник» — применяется при
                // следующих открытиях row из того же источника (приоритетнее layout с бэка)
                this.store._widgetRowRects[this.store.widgetRowRect_key(this.WIDGET)] = {
                    top: WidgetContainer.style.top,
                    left: WidgetContainer.style.left,
                    width: WidgetContainer.style.width,
                    height: WidgetContainer.style.height,
                }
            }
            // IE 2026 08 19 / ODOO-5512: виджет расшифровки — рект по цели, переживает переоткрытие
            if (this.WIDGET._ddRectKey && WidgetContainer) {
                this.store._ddRects[this.WIDGET._ddRectKey] = {
                    top: WidgetContainer.style.top,
                    left: WidgetContainer.style.left,
                    width: WidgetContainer.style.width,
                    height: WidgetContainer.style.height,
                }
            }

            // чистим raf
            if (this._popoutDrag?.raf) cancelAnimationFrame(this._popoutDrag.raf);
            this._popoutDrag = null;

            const overInd = this.store.popoutOverPageInd
            if (overInd !== false) {
                const source = this.store.findWidget(this.WIDGET.id)
                const pageVue = this.PAGE.vueObj
                const targetPage = pageVue.checkNewPage(overInd)
                if (source.page !== targetPage) {
                    const r = this._popoutInitialRect
                    if (r) {
                        this.WIDGET._popoutRestoreStyle = {
                            left: r.left + 'px', top: r.top + 'px',
                            width: r.width + 'px', height: r.height + 'px',
                        }
                    }
                    this.WIDGET.attrsResize = []
                    this.WIDGET.page = targetPage
                    this.WIDGET.isMove = false
                }
            }
            this._popoutInitialRect = null
            this.store.popoutDragging = false
            this.store.popoutOverPageInd = false

            if (!this.WIDGET._popoutRestoreStyle) {
                this.store.checkPopout()
            }
        },

        // ------------- dock resize (ит.3 п.3.4) ----------------------------------------
        dockResizeStart(e, mode) {
            if (this.WIDGET.styleWidget?.dock !== 'dock') return;
            if (e.detail >= 2) return;

            const WidgetContainer = document.getElementById(`WIDGET${this.WIDGET.id}`);
            if (!WidgetContainer) return;

            this.store.widget_activate(this.WIDGET, 'WIDGET::dockResizeStart')

            const rect = WidgetContainer.getBoundingClientRect();
            WidgetContainer.style.transition = "none";

            this._dockResize = {
                sx: e.clientX,
                sy: e.clientY,
                mode,                  // right | bottom | bottom-right
                startW: Number.parseInt(WidgetContainer.style.width, 10) || rect.width,
                startH: Number.parseInt(WidgetContainer.style.height, 10) || rect.height,
                lastEvent: e,
                raf: null,
            };

            // IE 2026 08 20 / ODOO-336291 (mobile UX): pointer-события — ресайз работает и пальцем
            window.addEventListener("pointermove", this.dockResizeMove, { passive: false });
            window.addEventListener("pointerup", this.dockResizeEnd, { passive: false });
            window.addEventListener("pointercancel", this.dockResizeEnd, { passive: false });
            if (e.pointerType === 'touch') {
                this._blockTouchScroll2 = (te) => te.preventDefault()
                window.addEventListener('touchmove', this._blockTouchScroll2, { passive: false })
            }

            document.body.style.userSelect = "none";
        },

        dockResizeMove(e) {
            if (!this._dockResize) return;
            e.preventDefault();

            this._dockResize.lastEvent = e;
            if (this._dockResize.raf) return;

            this._dockResize.raf = requestAnimationFrame(() => {
                const d = this._dockResize;
                if (!d?.lastEvent) return;

                const WidgetContainer = document.getElementById(`WIDGET${this.WIDGET.id}`);
                if (!WidgetContainer) return;

                const MIN_PX = 80;
                if (d.mode.includes("right")) {
                    WidgetContainer.style.width = Math.round(Math.max(d.startW + d.lastEvent.clientX - d.sx, MIN_PX)) + "px";
                }
                if (d.mode.includes("bottom")) {
                    WidgetContainer.style.height = Math.round(Math.max(d.startH + d.lastEvent.clientY - d.sy, MIN_PX)) + "px";
                }

                d.raf = null;
            });
        },

        dockResizeEnd(e) {
            if (!this._dockResize) return;
            e.preventDefault();

            window.removeEventListener("pointermove", this.dockResizeMove);
            window.removeEventListener("pointerup", this.dockResizeEnd);
            window.removeEventListener("pointercancel", this.dockResizeEnd);
            if (this._blockTouchScroll2) {
                window.removeEventListener('touchmove', this._blockTouchScroll2)
                this._blockTouchScroll2 = null
            }
            document.body.style.userSelect = "";

            const d = this._dockResize;
            if (d.raf) cancelAnimationFrame(d.raf);
            this._dockResize = null;

            const WidgetContainer = document.getElementById(`WIDGET${this.WIDGET.id}`);
            if (!WidgetContainer) return;
            WidgetContainer.style.transition = "";

            // px -> % рабочей области (инверсия calculateWidget_px) в текущий layout виджета
            const styleWidget = this.WIDGET.styleWidget;
            const stylePage = this.PAGE?.stylePage || this.store.def_stylePage;
            const pageW = stylePage.widthWidget * stylePage.width_rem;
            const pageH = stylePage.heightWidget * stylePage.height_rem;
            const vals = {};
            if (d.mode.includes("right") && pageW > 0) {
                vals.width = (Number.parseInt(WidgetContainer.style.width, 10) + styleWidget.marginRight * 2) / pageW * 100;
            }
            if (d.mode.includes("bottom") && pageH > 0) {
                vals.height = (Number.parseInt(WidgetContainer.style.height, 10) + styleWidget.marginBottom * 2) / pageH * 100;
            }
            if (Object.keys(vals).length) {
                this.store.set_widgetLayout_pct(this.WIDGET, { free: false, ...vals });
            }
        },

        dblclick_popout(e) {
            e.preventDefault();
            e.stopPropagation();
            // IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: на телефоне двойной клик/тап по
            // верхней зоне виджета = максимизация (как кнопка), а не dock/undock
            if (this.store.mobileUi?.on) { this.mobileToggleMax(); return }

            // 1) если dblclick по заголовочному input — редактируем, а не докаем/минимайзим
            if (this.WIDGET.styleWidget.minMode) {
                this.store.executeStoreMethod(this, {'command': 'onMinimizeWidget__Click'})
            
            } else if (this._tryEditTitleOnDblClick(e)) {
                this.$nextTick(() => {
                    this.enableEditing()
                });

            } else {
                this.store.executeStoreMethod(this, {'command': 'onPopOut_DockBack__Click'})
            }
        },
        _tryEditTitleOnDblClick(e) {
            // найди конкретный input (подстрой селектор под свой реальный)
            const inputEl = this.$refs.inputHeader
            if (!inputEl) return false;

            // хотим “в начале input”: определим позицию клика относительно input
            const r = inputEl.getBoundingClientRect();
            const x = e.clientX - r.left;

            // “начало” — первые N пикселей (подбери). Можно 40–80px.
            const START_ZONE_PX = 70;
            if (x > START_ZONE_PX) return false;

            return true;
        },
        // ------------- layout % (ит.3 п.3.3) ----------------------------------------
        fillLayoutInputs() {
            const styleWidget = this.WIDGET.styleWidget || {}
            const r2 = (v) => Math.round(v * 100) / 100
            const li = this.layoutInputs
            li.free = styleWidget.dock === 'popout'
            if (li.free) {
                const size = this.store.getWIDGET_size(this.WIDGET)
                li.width = r2(size.width_pct * 100)
                li.height = r2(size.height_pct * 100)
                li.left = r2(size.left_pct * 100)
                li.top = r2(size.top_pct * 100)
            } else {
                const stylePage = this.PAGE?.stylePage || this.store.def_stylePage
                const layout_pct = styleWidget.layout_pct || {}
                li.width = r2(layout_pct.width ?? (styleWidget.width_rem || 1) / stylePage.width_rem * 100)
                li.height = r2(layout_pct.height ?? (styleWidget.height_rem || 1) / stylePage.height_rem * 100)
                li.left = null
                li.top = null
            }
        },
        applyLayoutInputs(field) {
            const li = this.layoutInputs
            if (field === 'free') {
                // переключение docked <-> free с текущими значениями полей
                this.store.set_widgetLayout_pct(this.WIDGET, { free: li.free, width: li.width, height: li.height, left: li.left, top: li.top })
            } else {
                this.store.set_widgetLayout_pct(this.WIDGET, { free: li.free, [field]: li[field] })
            }
            this.$nextTick(() => this.fillLayoutInputs())
        },

        // -------------  ----------------------------------------

        mouseenter_btnScale(attrM0) {
            if (this.timerId_mouseenter_btnScale) {
                clearTimeout(this.timerId_mouseenter_btnScale)
            }
            this.timerId_mouseenter_btnScale = setTimeout(() => {
                // IE 2026 08 28 / ODOO-5828 (баг Игоря: «ставлю один кубик — при повторном открытии подсвечены два»):
                // жёлтая подсветка читала запасной пресет doc.widthMin_rem/heightMin_rem, который меняется только
                // кликом по кубику и НЕ сохраняется на сервер — после переоткрытия/перезагрузки он старый, хотя
                // реальный размер (layout_pct, W/H в %) давно другой. Текущие кубики считаем из живого layout,
                // doc остаётся фолбэком (виджет без layout_pct)
                const stylePage = this.PAGE?.stylePage || this.store.def_stylePage || {}
                const lp = this.WIDGET.styleWidget?.layout_pct || {}
                const curW = lp.width != null ? Math.max(1, Math.round(lp.width / 100 * (stylePage.width_rem || 4)))
                    : (this.WIDGET.record?.doc?.widthMin_rem || 1)
                const curH = lp.height != null ? Math.max(1, Math.round(lp.height / 100 * (stylePage.height_rem || 2)))
                    : (this.WIDGET.record?.doc?.heightMin_rem || 1)
                this.commandPanel_Scale.forEach((panel, index) => {
                    panel.forEach((attrM, index) => {
                        if ((attrM.params?.widthMin_rem && attrM0?.params?.widthMin_rem && attrM.params.widthMin_rem <= attrM0.params.widthMin_rem)
                        && (attrM.params?.heightMin_rem && attrM0?.params?.heightMin_rem && attrM.params.heightMin_rem <= attrM0.params.heightMin_rem)) {
                            if (!attrM.cssClass.includes('btnHover')) attrM.cssClass += ' btnHover'
                        } else {
                            if (attrM.cssClass.includes('btnHover')) attrM.cssClass = attrM.cssClass.replace(' btnHover','')
                        }

                        if ((attrM.params?.widthMin_rem && attrM.params.widthMin_rem <= curW)
                        && (attrM.params?.heightMin_rem && attrM.params.heightMin_rem <= curH)) {
                            if (!attrM.cssClass.includes('btnYellow')) attrM.cssClass += ' btnYellow'
                        } else {
                            if (attrM.cssClass.includes('btnYellow')) attrM.cssClass = attrM.cssClass.replace(' btnYellow','')
                        }
                    })
                })
            }, 100)
        },
        mouseleave_btnScale(attrM) {
            if (!this.store.hide_console) console.log(2)
        },

        openSegmentList() {
            const action = { 'command': 'onShowInList__Click', 'viewAccess':'access-extraView' }
            if (this.store.checkAccess(action)) {
                this.store.executeStoreMethod(this.WIDGET.vueObj, action)
            }
        },
        // IE 2026 08 20 / ODOO-5512 (заказ Игоря): при скрытых табах (hideTabs)
        // наведение на ярлык показывает оверлей табов вида; клик переключает
        // таб; оверлей fixed — раскладка виджета не дёргается
        tabsHover_show(event) {
            if (!this.WIDGET?.styleWidget?.hideTabs || this.WIDGET.styleWidget.minMode) return
            if (this.WIDGET.styleWidget.show_hidden) return // табы уже показаны
            if (!this.hoverViewTabs.length) return
            clearTimeout(this._tabsHoverT)
            const el = (event?.currentTarget instanceof Element && event.currentTarget)
                || this.$el.querySelector('.segment-title')
            if (!el) return
            const r = el.getBoundingClientRect()
            this.tabsHoverStyle = { top: (r.bottom + 2) + 'px', left: r.left + 'px' }
            this.showTabsHover = true
            // IE 2026 09 28 / ODOO-5800: оверлей вкладок показывает бейджи — форма настроек (каркас) догружается сразу
            this.store.settingsForm_prefetchNow?.(this.WIDGET, 'hover')
        },
        // ---- IE 2026 08 23 / ODOO-5884 (заказ Игоря): бейдж COW-копии ----
        // IE 2026 08 28 / ODOO-5800 (заказ Игоря): бейдж «Reference view» — как COW-бейдж
        refHover_show() { clearTimeout(this.refHoverTimer); this.refHover = true },
        refHover_keep() { clearTimeout(this.refHoverTimer); this.refHover = true },
        refHover_hide() { clearTimeout(this.refHoverTimer); this.refHoverTimer = setTimeout(() => { this.refHover = false }, this.store.setting('fe.ux.hoverHideMs', 250)) },   // IE 2026 09 05 / ODOO-336330
        refBadge_openTest() {
            this.refHover = false
            this.store.executeStoreMethod(this.WIDGET.vueObj, { command: 'widget_open', widget: 'widget-record', new: true,
                item: { id: this.refBadge_test, segment: 'TEST-DATA', title: this.refBadge_info.test_title || this.refBadge_test } })
        },
        // ---- IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита) ----
        adfHover_show() { clearTimeout(this.adfHoverTimer); this.adfHover = true },
        adfHover_hide() { clearTimeout(this.adfHoverTimer); this.adfHoverTimer = setTimeout(() => { this.adfHover = false }, this.store.setting('fe.ux.hoverHideMs', 250)) },
        adfMenu_show() { clearTimeout(this.adfMenuTimer); this.adfMenu = true },
        adfMenu_hide() { clearTimeout(this.adfMenuTimer); this.adfMenuTimer = setTimeout(() => { this.adfMenu = false }, this.store.setting('fe.ux.hoverHideMs', 250)) },
        // режим badges | diff | full (меню шапки или пункт AttrMenu бэка: executeVueObjMethod 'auditDiff_setView', params.view); выбор помнит браузер
        auditDiff_setView(a) {
            const v = typeof a === 'string' ? a : (a?.params?.view || a?.view)
            const diff = this.WIDGET?.audit_diff
            if (!diff || !ADF_VIEWS.includes(v)) return
            diff.view_user = v
            try { window.localStorage?.setItem(ADF_VIEW_KEY, v) } catch (e) { /* хранилище недоступно — выбор только на эту форму */ }
            this.adfTick++
            this.adfMenu = false
            this.adfPinned = v === 'full'
            if (v === 'full') this.adfHover = true
            this.auditDiff_refreshGrids()
        },
        // сторона: next (по умолчанию — то, что изменило событие этой строки аудита) | prev; executeVueObjMethod 'auditDiff_setAgainst', params.against
        auditDiff_setAgainst(a) {
            const v = typeof a === 'string' ? a : (a?.params?.against || a?.against)
            const diff = this.WIDGET?.audit_diff
            if (!diff || (v !== 'prev' && v !== 'next')) return
            diff.against_user = v
            this.adfTick++
            this.adfMenu = false
            this.adfNavPos = -1
            this.auditDiff_refreshGrids()
            if (adf_isDeferred(adf_block(diff, v))) this.auditDiff_calc(v)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита): сторона не посчитана при открытии — досчитать
        },
        // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита): досчёт стороны (BE считает при открытии только next в бюджете 2,5 с; prev — 'deferred')
        auditDiff_calc(direction) {
            const diff = this.WIDGET?.audit_diff
            const dir = direction === 'prev' ? 'prev' : 'next'
            if (!diff || typeof diff !== 'object' || diff[dir]?.status === 'calculating') return
            const before = diff[dir] && typeof diff[dir] === 'object' ? diff[dir] : { direction: dir }
            const put = (side) => {
                if (this.WIDGET?.audit_diff !== diff) return   // форма уже показывает другую версию
                diff[dir] = side
                diff._adfGen = (diff._adfGen || 0) + 1
                this.adfTick++
                this.adfNavPos = -1
                this.auditDiff_refreshGrids()
            }
            // роль «только чтение»: метод не в белом списке политики — отказ сразу (тост даёт сам readonly_deny), а не ожидание таймаута
            if (this.store.readonly_deny?.('executeBackendMethod', ADF_CALC_METHOD)) { put({ ...before, status: 'deferred', reason: this.t('Not allowed for your role'), _adfFailed: true }); return }
            put({ ...before, status: 'calculating', reason: null })
            let done = false
            const fin = (side) => { if (done) return; done = true; clearTimeout(tm); put(side) }
            const fail = (reason) => fin({ ...before, status: 'deferred', reason, _adfFailed: true })
            const tm = setTimeout(() => fail(this.t('No answer from the server')), this.store.setting('fe.ux.auditRecordDiff.calcTimeoutMs', 60000))
            try {
                this.store.executeBackendMethod({}, { method: ADF_CALC_METHOD, params: adf_calcParams(diff, dir) }, (answer) => {
                    if (answer?.audit_id != null && String(answer.audit_id) !== String(diff.audit_id)) return   // ответ на другую версию — не применять (таймаут вернёт сторону)
                    const side = adf_sideFromAnswer(answer, dir, diff.audit_id)
                    if (side) fin(side)
                    else fail(String(answer?.message || answer?.text || '') || this.t('No answer from the server'))
                })
            } catch (e) { fail(String(e?.message || e)) }
        },
        // пункт AttrMenu бэка «Against the next / previous version»: executeVueObjMethod 'auditDiff_setDirection', params.direction
        auditDiff_setDirection(a) { this.auditDiff_setAgainst(typeof a === 'string' ? a : (a?.params?.direction || a?.direction)) },
        // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита): ответ widget_open / updateWidget пришёл в СЫРОЙ WIDGET (mainStore → adf_kick) — computed adf_* в кэше;
        // сменился audit_diff (новая форма / другая версия / ушёл) — пересчитать бейдж, поповер и разметку гридов
        auditDiff_sync() {
            const d = this.WIDGET?.audit_diff || null
            if (d === this._adfSeen) return
            this._adfSeen = d
            this.adfTick++
            this.adfNavPos = -1
            this._adfGotoSeq = (this._adfGotoSeq || 0) + 1   // IE 2026 10 31 / ODOO-349799: незавершённый переход к цели прежней разницы — отменить
            this._cmSel = null   // IE 2026 10 31 / ODOO-349799 (PR3): цель прежней разницы (строка «Changes» ↔ ячейка) забыта
            if (d) this.$nextTick(() => this.auditDiff_refreshGrids())
        },
        auditDiff_grids() {
            // IE 2026 10 31 / ODOO-349799 (проба dev02: цели title_uk / title_ru не выделялись): полосы AttrTabGridLanes (вкладка «Master data» при ширине от двух колонок) —
            // AttrGrid без attr_id, в attrs_vueObj их нет, там лежит координатор с laneRefs; прежде такие гриды переходу и обновлению разницы были невидимы
            const out = []
            for (const v of Object.values(this.WIDGET?.attrs_vueObj || {})) {
                if (!v || v === this) continue
                if (typeof v.auditDiff_refresh === 'function') { if (!out.includes(v)) out.push(v) }
                else if (Array.isArray(v.laneRefs)) for (const l of v.laneRefs) { if (l && l !== this && typeof l.auditDiff_refresh === 'function' && !out.includes(l)) out.push(l) }
            }
            return out
        },
        auditDiff_refreshGrids() {
            for (const v of this.auditDiff_grids()) { try { v.auditDiff_refresh() } catch (e) { console.warn('auditDiff_refresh', e) } }
        },
        // IE 2026 10 31 / ODOO-349799 (заказ Игоря: при первом открытии «›» не переключал вкладку с изменением; скрытое поле): вкладки-контейнеры по пути к цели
        // (все панели, включая вложенные) — активировать; true — все открыты; false — панель по пути ещё не смонтирована (вложенная панель внутри
        // только что открытой вкладки) или вкладка не принимает выбор (use: false) — вызывающий повторит после отрисовки
        auditDiff_openTabs(steps) {
            for (const s of (Array.isArray(steps) ? steps : [])) {
                const vo = s.panel?.id != null ? this.WIDGET?.attrs_vueObj?.[s.panel.id] : null
                if (!vo?.tabPanel || !Array.isArray(vo.tabAttrs)) return false
                let i = vo.tabAttrs.findIndex(x => x === s.tab || (x?.id != null && x.id === s.tab?.id) || (x?.html_id && x.html_id === s.tab?.html_id))
                if (i < 0) i = s.index
                if (i < 0 || i >= vo.tabAttrs.length) return false
                if (vo.tabPanel.selectedIndex !== i) {
                    // как выбор бэка (selectTab_set, 30.10): вкладка помнится панелью (tabKeep_record), selection_restore / activeTab_apply её не перебивают
                    try { if (typeof vo.selectTab_set === 'function') vo.selectTab_set(i); else vo.tabPanel.selectedIndex = i } catch (e) { return false }
                    if (vo.tabPanel.selectedIndex !== i) return false
                }
            }
            return true
        },
        auditDiff_gotoGrids(target) {
            for (const v of this.auditDiff_grids()) { try { if (v.auditDiff_goto(target)) return true } catch (e) { /* грид в перестройке */ } }
            return false
        },
        // переход к цели ‹ › / записи списка «Full comparison». Promise<boolean>: true — цель показана (или сообщено, что поле скрыто); false сразу — цели
        // нет ни в смонтированных гридах, ни в описании формы (WIDGET.view). Раньше: только смонтированные гриды и только ближайшая панель вкладок —
        // при первом открытии гриды неоткрытых вкладок ещё не смонтированы (AttrTabPanel lazyTabs: порциями через 1,2 с), и «›» молча проходил весь круг.
        // Теперь: путь к attr цели по дереву view → открыть вкладки по пути (auditDiff_openTabs) → дождаться монтирования грида и его строк
        // (повтор через fe.ux.auditRecordDiff.gotoStepMs, не больше gotoTries) → грид выделяет и подсвечивает ячейку. Не дождались — «Field X is hidden in this view»
        // Проба dev02 31.10 (запись task-sync_sftp, 13 целей): цель — перевод поля (title_uk) → к основному translate-полю, строки «(uk)» нет — подсказка опции;
        // цели вне формы (viewParams, order, heightMin_rem…) — не в списке перехода (adf_nav), поповер называет их число; поле-компонент вне грида — открыть вкладку
        auditDiff_goto(target) {
            const seq = (this._adfGotoSeq = (this._adfGotoSeq || 0) + 1)
            if (!target || typeof target !== 'object') return Promise.resolve(false)
            const view = this.WIDGET?.view
            const info = adf_targetInfo(view, target, this.adf_langs())
            if (!info) return Promise.resolve(Array.isArray(view) && view.length ? false : this.auditDiff_gotoGrids(target))
            // IE 2026 10 31 / ODOO-349799: strict — «Show translation fields» включена, строка «(uk)» ЕСТЬ в какой-то полосе формы: грид без неё не берёт основное поле (оно может лежать в соседней полосе)
            let strict = false
            if (info.i18n) { try { strict = !!this.store.i18nFields_on(this.WIDGET) } catch (e) { strict = false } }
            const tgtOf = (loose) => info.i18n ? { ...target, binding: info.i18n.base, i18n: { ...info.i18n, rowBinding: this.adf_rowBinding(info.i18n), strict: strict && !loose } } : target
            let tgt = tgtOf(false)
            const path = info.path, steps = adf_tabSteps(path)
            const hit = () => info.kind === 'standalone' || this.auditDiff_gotoGrids(tgt)
            const stepMs = this.store.setting('fe.ux.auditRecordDiff.gotoStepMs', 50), tries = this.store.setting('fe.ux.auditRecordDiff.gotoTries', 40)
            // IE 2026 10 31 / ODOO-349799 (проба dev02: «Master data» выделение пропадало): первое выделение попало в одиночный грид, который тут же пересобрала AttrTabGridLanes
            // (ширина вкладки стала известна → полосы), и новый грид выделения не имел. После попадания звать переход тихо (без уведомлений), пока грид не устоится
            const settle = async () => {
                const n = this.store.setting('fe.ux.auditRecordDiff.gotoSettleTries', 12), ms = this.store.setting('fe.ux.auditRecordDiff.gotoSettleCheckMs', 150), need = this.store.setting('fe.ux.auditRecordDiff.gotoSettleStable', 4)   // проба: грид пересобирался через ~270 мс после выделения — устойчивым считаем ~600 мс без изменений
                if (info.kind === 'standalone' || !(n > 0)) return
                let stable = 0
                for (let k = 0; k < n && stable < need; k++) {
                    await new Promise(r => setTimeout(r, ms))
                    if (seq !== this._adfGotoSeq || !this.WIDGET || this.WIDGET.close) return
                    this.auditDiff_openTabs(steps)
                    const quiet = { ...tgt, silent: true, changed: false }
                    if (this.auditDiff_gotoGrids(quiet) && !quiet.changed) stable++; else stable = 0
                }
            }
            return new Promise((resolve) => {
                let n = 0
                const step = () => {
                    if (seq !== this._adfGotoSeq || !this.WIDGET || this.WIDGET.close) return resolve(false)
                    const ready = this.auditDiff_openTabs(steps)
                    if (ready && hit()) { resolve(true); settle(); return }   // IE 2026 10 31 / ODOO-349799
                    if (ready && n + 1 >= tries && strict && tgt.i18n.strict) { tgt = tgtOf(true); if (hit()) { resolve(true); settle(); return } }   // IE 2026 10 31 / ODOO-349799: строки «(uk)» так и нет — основное поле с подсказкой
                    if (++n >= tries) {
                        const a = path[path.length - 1]
                        this.store.show_notification({ text: adf_hiddenText(a.title || a.binding), status: 'info' })
                        return resolve(true)
                    }
                    setTimeout(step, stepMs)
                }
                if (this.auditDiff_openTabs(steps) && hit()) { resolve(true); settle(); return }   // всё уже смонтировано — без ожидания   // IE 2026 10 31 / ODOO-349799
                this.$nextTick(step)
            })
        },
        adf_langs() { try { const l = this.store.i18n_fieldLangs(); return Array.isArray(l) && l.length ? l : ADF_LANGS } catch (e) { return ADF_LANGS } },   // IE 2026 10 31 / ODOO-349799
        adf_rowBinding(of) { try { return this.store.localize_binding(of.base, of.lang, of.base) } catch (e) { return of.base + '_' + of.lang } },   // IE 2026 10 31 / ODOO-349799: binding строки «<поле> (uk)» формы (title → meta.title_uk)
        adf_notShown(hidden, total) { return adf_notShownText(hidden, total) },   // IE 2026 10 31 / ODOO-349799
        async auditDiff_nav(dir) {
            const tg = this.adf_nav.targets   // IE 2026 10 31 / ODOO-349799: только цели, которые есть на форме
            if (!tg.length) return
            const seq = (this._adfNavSeq = (this._adfNavSeq || 0) + 1)
            // цели, которых нет ни в гридах, ни в описании формы, пропускаем — не больше одного круга
            for (let k = 0; k < tg.length; k++) {
                this.adfNavPos = ((this.adfNavPos < 0 ? (dir > 0 ? -1 : 0) : this.adfNavPos) + dir + tg.length) % tg.length
                const ok = await this.auditDiff_goto(tg[this.adfNavPos])
                if (ok && seq === this._adfNavSeq) this.compareMerge_mark?.(tg[this.adfNavPos])   // IE 2026 10 31 / ODOO-349799 (PR3): строка «Changes» — на цель ‹ ›
                if (ok || seq !== this._adfNavSeq) return
            }
        },
        auditDiff_openOther() {
            const action = this.adf_block?.open_action
            if (!action || typeof action !== 'object') return
            this.adfHover = false; this.adfPinned = false
            this.store.executeStoreMethod(this.WIDGET.vueObj, JSON.parse(JSON.stringify(action)))
        },
        // IE 2026 10 31 / ODOO-349799 (PR3, заказ Игоря «как в 1С»): связь вкладки «Changes» (грид _doc.compare_changes бэка compare_merge.tab; строка несёт target
        // того же вида, что цели ‹ ›) с формой. Строка → форма: клик (смена выделения указателем, кроме колонки Use) или двойной клик по строке — вкладка поля,
        // выделение и подсветка ячейки, как ‹ › (auditDiff_goto); позиция ‹ › встаёт на цель строки. Форма → строка: клик по ячейке с бейджем запоминает цель
        // (_cmSel: ключ adf_targetKey), ‹ › показывает её номер, строка «Changes» выделяется сразу (грид смонтирован) и при показе вкладки (AttrTabPanel →
        // compareMerge_tabShown). Выключатель fe.ux.compareMerge.linkRows (дефолт ВКЛ; false — прежнее поведение); fe.ux.compareMerge.gotoOnSelect false —
        // только двойной клик; fe.ux.compareMerge.gotoDelayMs — пауза после клика (двойной клик её отменяет)
        compareMerge_on() { return cm_on((k, d) => this.store.setting(k, d)) },
        compareMerge_grid() {
            for (const v of Object.values(this.WIDGET?.attrs_vueObj || {})) if (v && v !== this && v.attr?.binding === CM_ROWS_BINDING && typeof v.compareMerge_selectByKey === 'function') return v
            return null
        },
        // строка «Changes» выбрана пользователем (AttrGrid.compareMerge_selHook / compareMerge_dblclick) → форма. Promise<boolean> auditDiff_goto; строка без цели
        // (изменение только в сравниваемой версии: строки ТЧ в этой записи нет) — подсказка
        compareMerge_gotoRow(row) {
            if (!this.compareMerge_on() || !this.adf_diff) return Promise.resolve(false)
            const target = cm_rowTarget(row)
            if (!target) { this.store.show_notification({ text: this.t('This change has no cell in this record'), status: 'info' }); return Promise.resolve(false) }
            this.compareMerge_mark(target, false)
            return this.auditDiff_goto(target)
        },
        // запомнить цель (ячейка формы с бейджем — AttrGrid.compareMerge_selHook; строка «Changes»; шаг ‹ ›): позиция ‹ › и, если selectRow, строка «Changes»
        compareMerge_mark(target, selectRow = true) {
            const key = adf_targetKey(target)
            if (!key || !this.compareMerge_on()) return false
            this._cmSel = { key, target }
            const i = adf_targetIndex(this.adf_nav.targets, target)
            if (i >= 0) this.adfNavPos = i
            if (selectRow) this.compareMerge_selectRow(false)
            return true
        },
        // строка «Changes» по запомненной цели: одиночное выделение без подсветки; false — грид ещё не смонтирован или без строк (вызывающий повторит)
        compareMerge_selectRow(scroll = false) {
            const sel = this._cmSel, g = this.compareMerge_grid()
            if (!sel || !g) return false
            try { return g.compareMerge_selectByKey(sel.key, scroll) } catch (e) { return false }
        },
        // AttrTabPanel.selectedIndexChanged: показана вкладка «Changes» — выделить строку запомненной цели (строки ленивой вкладки могут ещё монтироваться — повторы)
        compareMerge_tabShown(attrTab) {
            if (!attrTab || attrTab.name !== CM_TAB_NAME || !this._cmSel || !this.compareMerge_on()) return
            const seq = (this._cmTabSeq = (this._cmTabSeq || 0) + 1)
            const stepMs = this.store.setting('fe.ux.compareMerge.tabStepMs', 100), tries = this.store.setting('fe.ux.compareMerge.tabTries', 30)
            let n = 0
            const step = () => {
                if (seq !== this._cmTabSeq || !this.WIDGET || this.WIDGET.close) return
                if (this.compareMerge_selectRow(true) || ++n >= tries) return
                setTimeout(step, stepMs)
            }
            this.$nextTick(step)
        },
        cowHover_show() { clearTimeout(this.cowHoverTimer); this.cowHover = true },
        cowHover_keep() { clearTimeout(this.cowHoverTimer); this.cowHover = true },
        cowHover_hide() { clearTimeout(this.cowHoverTimer); this.cowHoverTimer = setTimeout(() => { this.cowHover = false }, this.store.setting('fe.ux.hoverHideMs', 250)) },   // IE 2026 09 05 / ODOO-336330
        // IE 2026 09 08 / ODOO-335246 (Igor): тумблер DS | MV в шапке записи DATA-SOURCE — флаг ставится в записи формы сразу
        // (жёлтая Save), бэк mv_switch дописывает префикс заголовка / Selection по умолчанию и шлёт тост; сохраняет пользователь
        // IE 2026 09 10 / ODOO-…: вкладка каскада в дереве вида (badgeBinding = '_doc.cascade_badge') — тексты подсказки индикатора
        cascadeInd_tab() {
            // сначала смонтированные панели вкладок (tabAttrs) — по ним же открывается вкладка кликом
            try {
                for (const v of Object.values(this.WIDGET?.attrs_vueObj || {})) {
                    const t = (v && ('tabAttrs' in v) && Array.isArray(v.tabAttrs)) ? v.tabAttrs.find(t => t?.badgeBinding === '_doc.cascade_badge' || t?.badgeBinding === '_doc.cascade_tab_badge') : null   // IE 2026 09 10 (Igor): бейдж вкладки — по флагу
                    if (t) return t
                }
            } catch (e) { /* панели ещё нет */ }
            const seen = new Set(); let found = null
            const walk = (a, depth) => {
                if (!a || typeof a !== 'object' || found || depth > 14 || seen.has(a)) return
                seen.add(a)
                if (a.badgeBinding === '_doc.cascade_badge' || a.badgeBinding === '_doc.cascade_tab_badge') { found = a; return }
                for (const ch of (Array.isArray(a.attrs) ? a.attrs : [])) walk(ch, depth + 1)
            }
            try { walk(this.WIDGET?.view, 0) } catch (e) { /* вид не собран */ }
            return found
        },
        // IE 2026 09 10 / ODOO-…: клик по индикатору — открыть вкладку каскада (если она есть в форме), дропдаун не трогать
        // IE 2026 10 07 / ODOO-335246 (Igor: «по Alt на индикаторе — показывать скрытое сообщение»): хвост Alt-подсказки индикатора каскада (v-uiHelp … after) — полный
        // (не усечённый) текст плашки о грязных узлах; есть только пока индикатор жёлтый (на источниках есть грязные узлы), иначе ничего не добавляется
        cascadeInd_noteHtml() {
            if (!this.cascadeInd.dirty) return ''   // IE 2026 10 07 / ODOO-335246
            // IE 2026 10 07 / ODOO-335246: уведомление читается в момент показа — бэк кладёт WIDGET.notification мимо реактивности, computed cascadeStaleNtfText
            // на бою оставался пустым (замер DM 07.10 22:58: notification с кодом есть, computed '' — строки «Message:» не было)
            const n = this.WIDGET?.notification   // IE 2026 10 07 / ODOO-335246
            const now = n && n.code === 'cascade_stale_sources' ? String(n.text ?? '') : ''   // IE 2026 10 07 / ODOO-335246
            if (now) this.cascadeStaleLast = now   // IE 2026 10 07 / ODOO-335246: запомнить — плашка может погаснуть / смениться другим уведомлением
            const text = now || this.cascadeStaleNtfText || this.cascadeStaleLast   // IE 2026 10 07 / ODOO-335246
            if (!text) return ''   // IE 2026 10 07 / ODOO-335246
            return `<br><b class='tooltip-header'>${this.t('Message')}:</b> <b class='tooltip-text'> ${this.store.escapeHtml(text)}</b>`   // IE 2026 10 07 / ODOO-335246
        },
        cascadeInd_open() {
            const tab = this.cascadeInd_tab()
            if (!tab?.name) return
            for (const v of Object.values(this.WIDGET?.attrs_vueObj || {})) {
                const i = (v?.tabPanel && ('tabAttrs' in v) && Array.isArray(v.tabAttrs)) ? v.tabAttrs.indexOf(tab) : -1   // IE 2026 09 12 / ODOO-335246 (Igor)
                if (i >= 0) { v.tabPanel.selectedIndex = i; return }
            }
        },
        mvSwitch(on) {
            if (this.store.readonly_on()) { this.store.readonly_toast('', 'edit'); return }   // IE 2026 09 29 / ODOO-342781: роль «только чтение» — тумблер DS | MV правит запись и зовёт mv_switch: не даём
            const rec = this.WIDGET?.record
            if (!rec || !!rec.doc?.params?.mv_create === !!on) return
            if (!rec.doc) rec.doc = {}
            if (!rec.doc.params) rec.doc.params = {}
            rec.doc.params.mv_create = !!on
            rec._meta = rec._meta || {}
            rec._meta.modified = true
            // префикс заголовка по режиму — сразу и в записи, и в шапке (то же правило, что у mv_switch бэка):
            // MV: «DS::» → «MV::», без префикса — добавить «MV::»; DS: «MV::» → «DS::»
            const t = String(rec.title || '')
            const nt = on ? (t.startsWith('DS::') ? 'MV::' + t.slice(4) : (t.startsWith('MV::') ? t : 'MV::' + t))
                          : (t.startsWith('MV::') ? 'DS::' + t.slice(4) : t)
            const syncTitle = () => {
                if (rec.title && this.WIDGET.title !== rec.title) this.WIDGET.title = rec.title
                try { this.store.set_widgetRecord_nav_shortTitle(this.WIDGET) } catch (e) { /* нет навигации */ }
            }
            if (nt !== t) { rec.title = nt; syncTitle() }
            try {
                const r = this.store.executeStoreMethod(this.WIDGET.vueObj, { command: 'executeWidgetMethod', method: 'mv_switch', params: { on: !!on }, record_sendToBackend_exclude: ['_doc'] })
                // ответ бэка (updateDoc record.title / Selection) — заголовок шапки за записью
                if (r && typeof r.then === 'function') r.then(syncTitle).catch(() => {})
                else setTimeout(syncTitle, 1500)
            } catch (e) { console.warn('mv_switch skipped', e) }
        },
        cow_action(method, confirmText) {
            // IE 2026 08 25 / ODOO-5884: confirmText — свой текст подтверждения (true = прежний текст «Remove branch copy»)
            if (confirmText && !window.confirm(confirmText === true
                ? this.t('Remove the branch copy of this record? The working version will be shown again.') : confirmText)) return   // IE 2026 09 23 / ODOO-341407: i18n
            this.cowHover = false
            this.store.executeStoreMethod(this.WIDGET.vueObj, { command: 'executeWidgetMethod', method, record_sendToBackend_exclude: ['_doc'] })
        },
        // IE 2026 08 23 / ODOO-5884 (заказ Игоря): список всех версий записи (как пункт «Record versions» меню записи)
        cow_open_versions() {
            this.cowHover = false
            // готовое действие с бэка (set_menu: fieldsMapping segment/version '*'/WHERE id) — как пункт меню «Record versions»
            const action = this.WIDGET.cow?.versions_action || { command: 'widget_open', widget: 'widget-list-record-versions', title: this.t('Record versions') }   // IE 2026 09 23 / ODOO-341407: i18n
            this.store.executeStoreMethod(this.WIDGET.vueObj, JSON.parse(JSON.stringify(action)))
        },
        // IE 2026 09 14 / ODOO-… (замечание Игоря: парящий заголовок): ширина островка заголовка = ширина текста заголовка (canvas.measureText шрифтом инпута)
        // + внутренние отступы; пересчёт при смене текста и режима
        // IE 2026 09 14 / ODOO-… (замечание Игоря: Float — кнопки содержимого ниже островков): в режиме поверх содержимого графики (график, карта, TreeMap, пузырьки, граф) остаются под островками —
        // у них опускаются только кнопки (CSS); всё остальное (грид, лист, форма) отодвигается отступом. Пересчёт при
        // смене режима / табов, после монтирования и при наведении (смена активной вкладки виджета)
        floatPad_check() {
            const on = this.floatHeaderOn && !!this.WIDGET?.styleWidget?.hideTabs && !this.WIDGET?.styleWidget?.minMode
            if (!on) { this.floatPad = false; this.vizTab = false; return }
            const c = this.$el?.querySelector?.(':scope > .widget-content')
            if (!c) return
            const canvas = [...c.querySelectorAll('.attr-chart, .attr-geo-map, .attr-tree-map, .attr-bubble-chart, .attr-graph0')].some(el => el.offsetHeight > 0)
            // IE 2026 09 15 / ODOO-… (замечание Игоря, вечер): виджет-список на вкладке визуализации — кнопки панели команд шапки (открыть список,
            // перечитать, передать, селекторы) лишние и скрыты, островок легенды / шестерёнки поднимается в правый верхний угол, заголовок
            // режется «…» (полный — по наведению). Класс widget-viz-tab, правила в CSS
            this.vizTab = canvas && String(this.WIDGET?.record?.segment || this.WIDGET?.segment || '') === 'WIDGET-LIST'
            // IE 2026 09 15 / ODOO-… (замечание Игоря: Flow-tree — панель графа под островком заголовка): видимая командная панель
            // (Panel) — содержимое тоже опускается под островки, холст один не спасает
            // IE 2026 09 16 (вопрос Игоря «Panel в пузырьках не вижу»): панель считается только ВИДИМАЯ — панель списка на неактивной вкладке
            // (грид) не должна опускать островки виджета с пузырьками / графиком на строку ниже
            const panelShown = !this.WIDGET?.styleWidget?.hideGridPanel && [...c.querySelectorAll('.widget-commandPanel, .chips-container, .widget-command-panel')].some(el => el.offsetHeight > 0 && el.getClientRects().length > 0)
            this.floatPad = !canvas || panelShown
            this.$nextTick(() => this.vizTitle_measure())   // IE 2026 09 27 / ODOO-341407: класс widget-viz-tab уже в DOM — островок кнопок на своём месте
        },
        // IE 2026 09 15 / ODOO-… (заказ Игоря): МЕТОД, не computed — запись фиксированного виджета (selector_header) приходит после
        // открытия мимо реактивности объекта WIDGET, и computed оставался null; метод пересчитывается при каждой перерисовке шапки
        // ---- IE 2026 09 24 / ODOO-341407 (заказ Игоря): карточка «Translations» у виджета — глобус в шапке и пункт меню «Translations…» ----
        i18nGlobe_show() {
            const W = this.WIDGET
            if (!W?.record?.segment || W.isReadOnly || this.store.mobileUi?.on || this.store.readonly_on()) return false   // IE 2026 09 29 / ODOO-342781: роль «только чтение» — карточки переводов нет (запись переводов бэк отказал бы)
            if (W.styleWidget?.minMode || W.widget === 'widget-search' || W.widget === 'widget-row' || W.record?._meta?.type === 'widget-row-chip') return false
            return true
        },
        // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2): пункт ≡ «Show translation fields» (executeVueObjMethod, action — пункт; у чекбокса формы-меню
        // с полем value: boolean). Только память стора и localStorage: запись виджета, _meta.modified и doc.viewParams не трогаются; гриды и поля
        // пересобираются сами по реактивному store.i18nFields_on. Метод — только у Widget.vue (DESIGN Р15: одноимённый метод грида перехватил бы резолв)
        i18nFields_toggle(action) {
            const W = this.WIDGET
            this.store.i18nFields_set(W, i18nFieldsToggleValue(this.store, W, action))
            // wj-menu (мобильный профиль / без формы-меню) рисует иконку пункта один раз — пересобрать меню; форма-меню читает геттеры пункта живьём,
            // пересборка заново раскладывала бы открытую панель
            if (!this.store.menuPanel_on('Widget')) this.set_commandPanel()
        },
        // IE 2026 09 24 / ODOO-341407 (уточнение Игоря): глобус режима правки заголовка — текущий текст инпута уходит черновиком строки ТЕКУЩЕГО
        // языка карточки (en — строка базы); правка в шапке отменяется как по Esc (заголовок до правки, режим снят) — blur инпута после этого
        // no-op (isEditingHeader уже false), в запись пишет только Apply карточки (F1 остаётся no-op)
        i18n_titles_open_fromHeader(ev) {
            const W = this.WIDGET, store = this.store
            const el = this.$refs.inputHeader
            const draft = String((el && el.value != null ? el.value : W.title) ?? '')
            const before = this._titleBeforeEdit
            if (W.record && W.record.title !== undefined && before !== undefined) W.title = before
            this._titleBeforeEdit = undefined
            this.isEditingHeader = false
            try { el?.blur() } catch (e) { /* инпут уже без фокуса */ }
            this.$nextTick(() => this.titleSelection_clear())
            const lang = store.get_lang() || 'en'
            const drafts = draft.trim() && draft !== (before ?? '') ? { title: { [lang]: draft } } : null
            this.i18n_titles_open(ev, { drafts, anchorEl: el || this.$el })
        },
        // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): пункт ≡ «Update preview» — только панель функций (не мобильный профиль, не wj-menu), без скелет-кадра, при fe.ux.widgetPreviews;
        // виден (getter visible — реактивно), когда бэк подтвердил методы картинок и у виджета есть строка на странице (utils/widgetPreviews.widgetPreviews_menuVisible);
        // строки Alt-подсказки — объяснение пункта и текущая картинка: когда и кем снята, чипсы, вкладка, «Outdated» (_tipRows-функция, MenuPanel._itemTip)
        preview_menuItem() {
            if (!this.WIDGET || this.WIDGET.firstBackendCheck || this.store.mobileUi?.on || !this.store.menuPanel_on('Widget')) return null
            if (this.store.setting('fe.ux.widgetPreviews', true) === false) return null
            if (this.store.readonly_on()) return null   // IE 2026 09 29 / ODOO-342781: роль «только чтение» — снимок пишет в общую таблицу
            const store = this.store, W = this.WIDGET
            const item = this.store.prepare_actionMenu({ 'attr_type': 'AttrButton', 'cssClass': 'pi p-button-white pi-camera', 'title': this.t('Update preview'), 'command': 'executeVueObjMethod',
                method: 'preview_update', _key: 'Update preview', _tipRows: () => widgetPreviews_menuTipRows(store, W) })
            Object.defineProperty(item, 'visible', { get: () => widgetPreviews_menuVisible(store, W), enumerable: true, configurable: true })
            return item
        },
        preview_menuAdd() {
            if (this.actionMenu.some(a => a?.method === 'preview_update')) return
            const pv = this.preview_menuItem()
            if (pv) this.actionMenu.push(pv)
        },
        // команда пункта: снимок и сохранение (тосты хода / итога — utils/widgetPreviews.widgetPreviews_captureOne; ждёт закрытия панели ≡)
        preview_update() { return widgetPreviews_captureOne(this.store, this.WIDGET, { mode: 'manual' }) },
        // из шапки (ev — MouseEvent) или из меню виджета (executeVueObjMethod: ev — action бэка); opts.drafts — черновики строк карточки {title: {uk: '…'}}
        i18n_titles_open(ev, opts = null) {
            const W = this.WIDGET, store = this.store
            const record = W?.record
            if (!record?.segment) { store.show_notification({ text: this.t('Translations: the widget has no record'), status: 'warning' }); return }
            const anchorEl = opts?.anchorEl || (ev?.currentTarget || ev?.target)?.closest?.('.i18n-globe') || this.$refs.inputHeader || this.$el
            store.i18n_card_open({
                label: (String(record.segment || '').startsWith('WIDGET') ? this.t('Widget') : this.t('Record')) + ': ' + (W.title || record.title || record.id),   // IE 2026 09 25 / ODOO-341407: форма записи справочника — «Record»
                record,
                fields: store.i18n_recordFields(),
                anchorEl,
                drafts: opts?.drafts || null,   // IE 2026 09 24 / ODOO-341407: черновик из инпута шапки
                readOnly: !!W.isReadOnly,
                afterApply: (res) => {
                    // шапка: перевод текущего языка → словарь (карточка его знает) → английская база; узлы вью с binding 'title'
                    // (поле Title инфо-вкладки рендерит снапшот) и перерисовка — как после правки заголовка в шапке
                    const dict = res.fields?.find(f => f.key === 'title')?.dict || null
                    // бэк (i18n_values_set) отдаёт title_localized под языком запроса — у предопределённой записи это словарный заголовок
                    W.title = (typeof res.answer?.title_localized === 'string' && res.answer.title_localized) || store.i18n_record_title(record, dict) || W.title
                    const sync = (attrs) => { for (const a of attrs || []) {
                        if (a && a.binding === 'title' && ('value' in a || 'valueStr' in a || a.attr_type)) { a.value = W.title; a.valueStr = W.title }
                        if (a?.attrs) sync(a.attrs)
                    } }
                    sync(W.view)
                    W.vueObj?.content_Changed?.()
                },
            })
        },
        multiplySel() {
            const m = this.store.headerSel_of?.(this.WIDGET)   // IE 2026 09 15 / ODOO-… (заказ Игоря): тираж ИЛИ настройка виджета selector_header
            if (!m?.values?.length) return null
            const params = this.store.WORKSPACES?.[this.WIDGET.workspace]?.record?.doc?.params
            if (!params) return null
            const fields = (m.selectorFields && m.selectorFields.length) ? m.selectorFields : [m.values[0].source || m.values[0].binding]
            const vals = m.values.filter(v => fields.includes(v.source || v.binding) && v.value !== undefined && v.value !== null && v.value !== '')
            if (!vals.length) return null
            const rows = params.WHERE || []
            const on = vals.every(v => { const r = rows.find(x => x?.leftValue?.value === (v.source || v.binding)); return !!(r && r.use !== false && (r.attrs || []).some(a => a?.rightValue?.value === v.value)) })
            const names = vals.map(v => v.title || v.value).join(' · ')
            return { on, vals, title: (on ? this.t('In the selector') : this.t('Add to the selector')) + ': ' + names + ' — ' + this.t('click: add / remove, Alt+click: set only this value') }   // IE 2026 09 23 / ODOO-341407: i18n
        },
        multiplySel_click(ev) {   // IE 2026 09 15 / ODOO-… (заказ Игоря)
            this.store.multiply_selector(this.WIDGET, { set: !!(ev?.altKey || ev?.ctrlKey || ev?.metaKey) })
        },
        titleFit_measure() {
            if (!this.floatHeaderOn && !this.identInForm) { this.titleFitWidth = null; return }   // IE 2026 09 23 / ODOO-… (замечание Игоря: в форме ⋯ — те же элементы шапки): и поле заголовка в слоте формы «⋯» — по ширине текста
            const el = this.$refs.inputHeader
            if (!el) return
            const cs = getComputedStyle(el)
            const cv = this._titleFitCanvas || (this._titleFitCanvas = document.createElement('canvas'))
            const ctx = cv.getContext('2d')
            ctx.font = `${cs.fontStyle} ${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`
            const text = String(this.WIDGET?.title || el.placeholder || '')
            const pad = ['paddingLeft', 'paddingRight', 'borderLeftWidth', 'borderRightWidth'].reduce((a, k) => a + (parseFloat(cs[k]) || 0), 0)
            this.titleFitWidth = Math.ceil(ctx.measureText(text).width + pad + 2)
        },
        // IE 2026 09 27 / ODOO-341407 (замечание ie-dm7 #47471 по живой проверке FADO: в uk заголовок накрывал кнопку легенды 🏷 — её не нажать):
        // на вкладке визуализации островок кнопок холста (легенда / шестерёнка, .corner-island вверху справа) стоит в строке заголовка, а запас под
        // него был фиксированный — 200px от ширины шапки; бейдж «Джерело» в uk шире «DS» в en и сдвигал заголовок на кнопки. Теперь предел заголовка —
        // до левого края островка по замеру; левый край поля от его ширины не зависит — пересчёт без качелей. Пересчёт: floatPad_check,
        // ресайз виджета, смена языка, перерисовка шапки (updated). Выкл: window.feSettings.set('fe.ux.vizTitleFit', false) — прежний запас 200px
        // IE 2026 09 27 / ODOO-341407 (ревью ie-dm7 #47608): зазор до островка 2px, а не 8px — заголовок, помещавшийся до -19 (запас 200px, зазор 1,9px у
        // 585_001-dos-by-object на 1920 uk), снова не режется (в titleFitWidth и так 2px запаса); правее поля в потоке шапки стоят Stop loading (пока идёт
        // загрузка), ARCHIVED, activity — их ширина тоже вычитается, иначе Stop накрывал легенду; абсолютные элементы (плашка полного заголовка) — не в счёт
        // IE 2026 09 28 / ODOO-341407 (замечание ie-fado7 по проду FADO на 1366, bubble_layout_check_0928 п. 1: у ieXYZB_001/002 шириной 322px заголовок «АВ…»):
        // предел поля до островка кнопок (-19, 860555151) верен — 🏷 не накрывается, но бейдж сегмента («Джерело», 40 % шапки = 118px) держал своё место, и полю
        // оставалось 71px (на -18 было 96px поверх 🏷 — кнопку не нажать). Теперь бейдж УСТУПАЕТ заголовку: текст бейджа режется «…» на столько, сколько не хватает
        // заголовку, в самом узком случае — весь (иконки и шеврон остаются; на 322px заголовок «ABC × XYZ…» вместо «АВ…») — vizTitleRoom; правый предел поля — прежний.
        // Ширины бейджа считаются от его полного текста (scrollWidth), а не от текущей ширины — пересчёт без качелей.
        // Выкл: window.feSettings.set('fe.ux.vizTitleBadgeShrink', false) — бейдж по CSS, как на -25
        vizTitle_measure() {
            let max = null, left = null, bmax = null, bare = false   // IE 2026 09 28 / ODOO-341407: bmax — предел бейджа, bare — без текста
            try {
                if (this.vizTab && this.floatHeaderOn && this.store.setting('fe.ux.vizTitleFit', true) !== false) {
                    const el = this.$refs.inputHeader
                    const c = this.$el?.querySelector?.(':scope > .widget-content')
                    const isl = c && [...c.querySelectorAll('.corner-island')].find(x => !x.matches('.corner-island-bl, .corner-island-br, .ant-flow-player') && x.offsetWidth > 0)
                    if (el && isl && el.offsetWidth > 0 && !this.identInForm) {
                        const tl = el.getBoundingClientRect().left, il = isl.getBoundingClientRect().left
                        let tail = 0   // IE 2026 09 27 / ODOO-341407: элементы шапки в потоке между полем и меню (Stop loading, ARCHIVED, activity)
                        for (let s = el.nextElementSibling; s; s = s.nextElementSibling) {
                            if (s.matches('.buttons, .widget_menu')) break
                            if (!s.offsetWidth) continue
                            const cs = getComputedStyle(s)
                            if (cs.position === 'absolute' || cs.position === 'fixed') continue
                            tail += s.getBoundingClientRect().width + (parseFloat(cs.marginLeft) || 0) + (parseFloat(cs.marginRight) || 0)
                        }
                        const room = { left: tl, right: il - 2 - tail, titleNat: this.titleFitWidth || 0, titleSlack: 2, shrink: this.store.setting('fe.ux.vizTitleBadgeShrink', true) !== false }   // IE 2026 09 28 / ODOO-341407: зазор 2px + хвост шапки, как было; titleSlack — 2px запаса titleFitWidth бейдж не отдаёт (прогон FADO 1920 uk: «Джере…» при целом заголовке)
                        const b = this.vizBadge_measure(el)   // IE 2026 09 28 / ODOO-341407: бейдж сегмента левее поля — его полная / самая узкая / CSS-ширина
                        if (b) Object.assign(room, { left: b.left, gap: Math.max(0, tl - b.right), badgeNat: b.nat, badgeCap: b.cap, badgeMin: b.min })   // IE 2026 09 28 / ODOO-341407
                        const fit = vizTitleRoom(room)   // IE 2026 09 28 / ODOO-341407: без бейджа / флаг выкл — прежний предел Math.max(40, il − tl − 2 − хвост)
                        max = fit.titleMax; bmax = fit.badgeMax   // IE 2026 09 28 / ODOO-341407
                        bare = !!(b && bmax != null && !b.keep && bmax <= b.min + 1)   // IE 2026 09 28 / ODOO-341407: от текста остались доли пикселя; у бейджа без иконки (b.keep) текст не прячется — видна короткая метка «Д…» (ревью ie-dm7, замечание 2)
                        left = el.offsetLeft   // IE 2026 09 27 / ODOO-341407: плашка полного заголовка — под полем
                    }
                }
            } catch (e) { max = null; left = null; bmax = null; bare = false }   // IE 2026 09 28 / ODOO-341407: и бейдж — по CSS
            const changed = max !== this.vizTitleMax || bmax !== this.vizBadgeMax   // IE 2026 09 28 / ODOO-341407
            if (max !== this.vizTitleMax) this.vizTitleMax = max
            if (left !== this.vizTitleLeft) this.vizTitleLeft = left   // IE 2026 09 27 / ODOO-341407
            if (bmax !== this.vizBadgeMax) this.vizBadgeMax = bmax   // IE 2026 09 28 / ODOO-341407
            if (bare !== this.vizBadgeBare) this.vizBadgeBare = bare   // IE 2026 09 28 / ODOO-341407
            // IE 2026 09 28 / ODOO-341407: островки шапки сменили ширину — содержимое (пузырьковый график: верх области под островками, headerReserveFit) перемеряет себя
            if (changed) this.$nextTick(() => { try { this.$el?.dispatchEvent?.(new CustomEvent('viz-header-fit')) } catch (e) { /* без CustomEvent — перемер по следующей отрисовке */ } })
        },
        // IE 2026 09 28 / ODOO-341407: бейдж сегмента в строке шапки левее поля заголовка (не DS | MV — тот не режется): левый / правый край, ширина с полным текстом
        // (nat: видимый текст .segment-title-text заменён полным — scrollWidth, поэтому от уже наложенного предела не зависит), самая узкая (min: иконки и шеврон,
        // без текста), по CSS (cap: не шире 40 % шапки)
        // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p216 бейдж виду віджета — тиха іконка, плашка при наведенні): методы, не computed — WIDGET в сторе не реактивен по полям (pi / shortTitle приходят позже первой отрисовки); computed,
        // посчитанный до прихода shortTitle, залипал (замер dev02: headerChip_pi = '' при WIDGET.pi = 'pi pi-list'). headerChip_pi читается только
        // при shortTitle — как раньше в v-else-if плашки, тогда pi уже пришёл (mainStore: shortTitle и pi ставятся вместе)
        kindIcon_on() {
            if (!this.WIDGET?.shortTitle || this.isDataSourceRecord) return false
            void this.store?._settingsEpoch
            if (this.store?.setting?.(KIND_BADGE_FLAG, true) === false) return false   // выкл — headerChip_pi не трогаем вовсе (прежний порядок вычислений)
            return kindBadge_on({ flag: true, pi: this.headerChip_pi, title: this.WIDGET.shortTitle,
                isDataSource: false, inForm: this.identInForm, mobile: !!this.store?.mobileUi?.on })
        },
        kindIcon_tone() { return kindBadge_tone(this.WIDGET) },
        // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p216 бейдж виду віджета — тиха іконка, плашка при наведенні): плашка встаёт ровно на якорь-иконку — координаты якоря в шапке (offsetParent .widget-container) при наведении на шапку
        kindIcon_place() {
            if (!this.kindIcon_on()) return
            if (this.kindChip_on()) { this.kindChip_place(); return }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p220/p221/p222 шапка віджета: p222 — непрозрачный чипс над шапкой)
            const pos = kindBadge_pos(this.$refs.kindIco)
            if (pos && (!this.kindIconPos || pos.left !== this.kindIconPos.left || pos.top !== this.kindIconPos.top)) this.kindIconPos = pos
        },
        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p220/p221/p222 шапка віджета): p222 — плашка вида при наведении: непрозрачный чипс над шапкой (не на тексте заголовка); выкл — прежняя плашка поверх якоря
        kindChip_on() {
            void this.store?._settingsEpoch
            return this.store?.setting?.(KIND_BADGE_OPAQUE_FLAG, true) !== false
        },
        // p220 — равные отступы край виджета → иконка вида → текст заголовка (CSS .hdr-spacing; только в режиме иконки)
        hdrSpacing_on() {
            void this.store?._settingsEpoch
            return this.store?.setting?.(HEADER_SPACING_FLAG, true) !== false
        },
        kindChip_el() { return this.$el?.querySelector?.(':scope > .widget-container > .segment-title.kind-badge-overlay') || null },
        // положение чипса: над шапкой, пока шапка на том же месте и сверху было место; сдвиг виджета — снова пробуем «над»
        kindChip_place() {
            const anchor = this.$refs.kindIco
            if (!anchor) return
            const W = this.$el?.getBoundingClientRect?.()
            const key = W ? Math.round(W.left) + ':' + Math.round(W.top) + ':' + Math.round(W.width) : ''
            if (key !== this._kindChipKey) { this._kindChipKey = key; this.kindIconPlace = 'above' }
            this.kindChip_apply(kindBadge_posChip(anchor, this.kindIconPlace))
            if (this.kindIconPlace === 'above') this.$nextTick(() => requestAnimationFrame(() => this.kindIcon_checkRoom()))
        },
        // координаты — и в данные (отрисовка), и сразу в стиль узла: панель настроек, открытая в том же такте, меряет уже новое место
        kindChip_apply(pos) {
            if (!pos) return
            const cur = this.kindIconPos
            if (!cur || cur.left !== pos.left || cur.top !== pos.top || cur.bottom !== pos.bottom) this.kindIconPos = pos
            const el = this.kindChip_el()
            if (el) { el.style.left = pos.left; el.style.top = pos.top; el.style.bottom = pos.bottom }
        },
        // сверху нет места (край окна, полоса приложения или соседний слой накрывает чипс) — чипс под строкой шапки; текст заголовка не перекрывается и там
        kindIcon_checkRoom() {
            const el = this.kindChip_el()
            if (!el || this.kindIconPlace !== 'above' || getComputedStyle(el).visibility !== 'visible') return
            const r = el.getBoundingClientRect()
            let hit = null
            try { if (r.width > 0) { const h = document.elementFromPoint(r.left + Math.min(r.width / 2, 24), r.top + r.height / 2); hit = !!(h && el.contains(h)) } } catch (e) { hit = null }
            if (kindBadge_roomAbove(r, hit)) return
            this.kindIconPlace = 'below'
            this.kindChip_apply(kindBadge_posChip(this.$refs.kindIco, 'below'))
        },
        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета) (поправка Игоря 03.11 «вместо А1»): клик по иконке вида (или по полосе-захвату над ней) — панель Settings | Variants, как клик по плашке;
        // только при fe.ux.kindBadgeOpaque (плашки по наведению нет) и у виджетов с панелью (dropdownApplies); точка — в прямоугольнике иконки (±2 px)
        kindIcon_clickAt(e) {
            if (!e || !this.kindIcon_on() || !this.kindChip_on() || !this.dropdownApplies) return false
            if (this.WIDGET?.styleWidget?.minMode || this.store.mobileUi?.on) return false
            const r = this.$refs.kindIco?.getBoundingClientRect?.()
            if (!r || !(r.width > 0) || e.clientX < r.left - 2 || e.clientX > r.right + 2 || e.clientY < r.top - 2 || e.clientY > r.bottom + 2) return false
            this.clearTopLeftTimers()   // наведение на угол успело взвести показ формы — снять
            cornerMenuStats.kindIconClicks++
            this.toggleDropdown(e)
            return true
        },
        // клик по углу (он лежит поверх иконки вида) в прямоугольнике иконки — панель настроек; обработчик угла (onTopLeftCornerTap) этот клик уже не получает
        cornerIconTap(e) {
            if (this.cornerLite && this.kindIcon_clickAt(e)) { e.stopImmediatePropagation(); e.preventDefault() }
        },
        // p221 — двойной клик по прежней плашке поверх начала заголовка (выключатель чипса выкл) — правка заголовка, как по самому полю; чипс над / под шапкой
        // текст не накрывает — двойной клик по нему остаётся кликами по плашке
        kindBadge_dblclick(e) {
            if (this.kindChip_on() || this.WIDGET?.styleWidget?.minMode || this.store.mobileUi?.on) return
            e?.stopPropagation?.()
            if (this.showDropdown) this.showDropdown = false
            this.enableEditing()
        },
        vizBadge_measure(el) {
            if (this.kindIcon_on()) return null   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p216 бейдж виду віджета — тиха іконка, плашка при наведенні): плашка поверх иконки (absolute) места в строке не занимает — пределов ей нет
            const head = el?.parentElement
            const badge = head && [...head.children].find(x => x.matches('.segment-title:not(.segment-mode)') && x.offsetWidth > 0)
            if (!badge) return null
            const br = badge.getBoundingClientRect()
            if (br.right > el.getBoundingClientRect().left + 1) return null   // бейдж не левее поля — не наш случай
            const txt = badge.querySelector('.segment-title-text')
            // IE 2026 09 28 / ODOO-341407 (ревью ie-dm7, замечание 2): уступив заголовку, бейдж не пропадает бесследно — минимум несёт значок (иконка сегмента);
            // у бейджа без иконки в минимуме остаётся короткая метка (первая буква и «…», badgeKeepLabel) — её ширина шрифтом бейджа (keepW)
            const icon = [...badge.children].some(c => c.tagName === 'I' && c.classList.contains('pi-header-pi') && c.offsetWidth > 0)
            const keepW = (!icon && txt) ? this.vizBadge_textWidth(txt, badgeKeepLabel(txt.textContent)) : 0
            const w = badgeWidths({ badgeW: br.width, textClientW: txt ? txt.clientWidth : 0, textScrollW: txt ? txt.scrollWidth : 0, keepW })
            const hcs = getComputedStyle(head)
            const headW = head.clientWidth - (parseFloat(hcs.paddingLeft) || 0) - (parseFloat(hcs.paddingRight) || 0)
            return { left: br.left, right: br.right, nat: w.nat, min: w.min, cap: Math.min(w.nat, 0.4 * headW), keep: keepW > 0 }   // cap — CSS .widget-container > .segment-title { max-width: 40% }; keep — IE 2026 09 28 / ODOO-341407: минимум с короткой меткой
        },
        // IE 2026 09 28 / ODOO-341407 (ревью ie-dm7, замечание 2): ширина строки шрифтом элемента (canvas, без перерисовки DOM) + 1px запаса на округление; ошибка — 0 (без метки, как было)
        vizBadge_textWidth(node, text) {
            try {
                if (!text) return 0
                const c = vizMeasureCanvas || (vizMeasureCanvas = document.createElement('canvas'))
                const ctx = c.getContext('2d')
                const cs = getComputedStyle(node)
                ctx.font = cs.font || `${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`
                const ls = parseFloat(cs.letterSpacing) || 0
                return Math.ceil(ctx.measureText(text).width + ls * Array.from(text).length) + 1
            } catch (e) { return 0 }
        },
        // IE 2026 09 28 / ODOO-341407: бейдж уступил место заголовку — предел его ширины (текст «…»); в форме «⋯» (телепорт) — без предела
        vizBadgeStyle() {
            return (this.vizBadgeMax != null && !this.identInForm && !this.kindIcon_on()) ? { maxWidth: this.vizBadgeMax + 'px' } : ''   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p216 бейдж виду віджета — тиха іконка, плашка при наведенні)
        },
        // IE 2026 09 28 / ODOO-341407: текст бейджа урезан пределом — полный в шапке объяснения по Alt (vars.full → widget.header.badge)
        vizBadgeTip() {
            // IE 2026 09 28 / ODOO-341407 (ревью ie-dm7, nit 4): полный источник — с меткой расшифровки [ячейки] и именем основной настройки варианта, как в бейдже целиком
            if (this.vizBadgeMax == null || this.identInForm) return null
            const W = this.WIDGET || {}
            return badgeFullText({ title: W.shortTitle, dd: W._dd_label, variant: W.variant_label ? (W.variant_main?.title || W.variant_label) : '' })
        },
        // IE 2026 09 27 / ODOO-341407: заголовок урезан пределом vizTitle_measure — полный текст в подсказке поля (в titleFitWidth 2px запаса сверх текста —
        // ревью ie-dm7 #47608: без них заголовок, который помещается целиком, считался урезанным)
        vizTitleTip() {
            return (this.vizTab && this.vizTitleMax != null && this.titleFitWidth && this.titleFitWidth - 2 > this.vizTitleMax && !this.isEditingHeader) ? String(this.WIDGET?.title || '') : null
        },
        // IE 2026 09 27 / ODOO-341407 (ревью ie-dm7 #47608: «обрезанный заголовок не раскрыть ни наведением, ни по Alt»): по наведению на урезанный заголовок —
        // плашка с полным текстом ПОД островком заголовка (как прежнее раскрытие, но кнопки островка не накрывает; показ — CSS :hover поля, мышь плашка не ловит);
        // при fe.ux.hoverTooltips полный текст и так в подсказке по наведению — плашки нет. По Alt — полный текст в шапке объяснения поля (vars.full)
        vizTitlePlate() {
            try { if (this.store.setting('fe.ux.hoverTooltips', false) === true) return null } catch (e) { /* без настроек — плашка есть */ }
            return this.vizTitleLeft != null ? this.vizTitleTip() : null
        },
        // IE 2026 09 28 / ODOO-341407 (замечание 2 ревью ie-dm7): ширина текста заголовка, px — тем же холстом и шрифтом, что titleFit_measure
        titleText_width() {
            const el = this.$refs.inputHeader
            if (!el) return 0
            const cs = getComputedStyle(el)
            const cv = this._titleFitCanvas || (this._titleFitCanvas = document.createElement('canvas'))
            const ctx = cv.getContext('2d')
            if (!ctx) return 0
            ctx.font = `${cs.fontStyle} ${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`
            return ctx.measureText(String(this.WIDGET?.title || el.placeholder || '')).width
        },
        // IE 2026 09 28 / ODOO-341407 (находка ie-demo7 §16.1: у НЕактивного виджета Stop мышью не нажать — на него ложится «Hide empty» панели кнопок,
        // показанной по наведению): пока Stop виден, а панель вне потока, заголовок уступает место — Stop встаёт левее панели туда же, где он у
        // активного виджета, и по нажатию не прыгает. Правило и замер — utils/stopClear.js; выкл: window.feSettings.set('fe.ux.stopClearOfPanel', false)
        stopClear_measure() {
            let max = null
            try {
                // IE 2026 09 28 / ODOO-341407 (замечание 2 ревью ie-dm7): узкому виджету — читаемый минимум заголовка (не шире его текста), Stop не заходит на «Hide empty»
                if (stopClear_on(this.store) && !this.identInForm) max = stopClear_fromHead(this.$el?.querySelector?.(':scope > .widget-container'), this.$refs.inputHeader, undefined,
                    { read: stopClear_readMin(this.store), textWidth: () => this.titleText_width() })
            } catch (e) { max = null }
            if (max !== this.stopClearMax) this.stopClearMax = max
        },
        // IE 2026 10 07 / ODOO-5800 (поручение Igor 07.10): кнопки команд шапки, не поместившиеся по ширине, скрыты (с конца ряда), заголовку остаётся читаемое место
        // (TITLE_READ, utils/stopClear.js); скрытые остаются в форме-меню ≡ (actionMenu — все команды панели). Правило и выключатель — utils/widgetHeaderOverflow.js
        hdrOverflow_schedule() {
            if (this._hdrRaf || typeof requestAnimationFrame !== 'function') return
            this._hdrRaf = requestAnimationFrame(() => { this._hdrRaf = null; this.hdrOverflow_measure() })
        },
        hdrOverflow_measure(again = false) {
            let vis = Infinity
            try { vis = this.hdrOverflow_calc(again) } catch (e) { vis = Infinity; if (!this.store.hide_console) console.warn('hdrOverflow', e) }
            if (vis !== this.hdrVisible) { this.hdrVisible = vis; hdrOverflowStats.changes++ }
        },
        // возвращает, сколько кнопок с начала ряда видно (Infinity — все); undefined-замер (шапка скрыта) оставляет текущее
        hdrOverflow_calc(again) {
            hdrOverflowStats.measures++
            if (!this.hdrOverflowOn || this.identInForm || this.WIDGET?.styleWidget?.minMode) return Infinity
            const head = this.$el?.querySelector?.(':scope > .widget-container')
            const panel = head?.querySelector?.(':scope > .buttons')
            const input = this.$refs.inputHeader
            if (!head || !panel || !input || input.parentElement !== head) return Infinity
            const list = this.commandPanel || []
            // состав / подписи панели сменились — ширины кэша не годятся: все кнопки в ряд, перемер до отрисовки (в том же микротаске)
            const sig = list.map(a => (a.id || a.html_id || a.command || '') + ':' + (a.title || a.tooltip || '') + (a.disabled ? '!' : '')).join('|')
            if (sig !== this._hdrSig) {
                this._hdrSig = sig; this._hdrW = null; this._hdrOverhead = null
                if (this.hdrVisible !== Infinity) { this.hdrVisible = Infinity; if (!again) this.$nextTick(() => this.hdrOverflow_measure(true)); return Infinity }
            }
            if (!(head.clientWidth > 0)) return this.hdrVisible   // шапка скрыта (Header off / вкладка) — как было
            const nodes = [...panel.children].filter(n => n.classList.contains('hdr-cmd'))   // обёртки кнопок, по одной на команду (шаблон)
            if (nodes.length !== list.length) return Infinity       // панель ещё не перерисована под список — не гадаем
            const cs = (el) => getComputedStyle(el)
            const full = (el) => { const c = cs(el); return el.offsetWidth + (parseFloat(c.marginLeft) || 0) + (parseFloat(c.marginRight) || 0) }
            const W = this._hdrW || (this._hdrW = new Array(list.length).fill(null))
            let seen = 0
            for (let i = 0; i < list.length; i++) {
                if (i >= this.hdrVisible) continue                  // скрыта нами — ширина из кэша
                const n = nodes[i]
                W[i] = full(n)                                      // невидимая сама по себе (isVisible) — 0
                seen += W[i]
            }
            if (W.some(w => w == null)) { if (!again) { this.hdrVisible = Infinity; this.$nextTick(() => this.hdrOverflow_measure(true)) } return Infinity }   // нет замера скрытой — показать все и перемерить
            const shown = this.hdrVisible === 0 ? 0 : Math.min(list.length, this.hdrVisible)
            if (shown > 0) {
                const pw = panel.getBoundingClientRect().width
                if (!(pw > 0)) return this.hdrVisible               // панель скрыта не нами (вкладка визуализации) — как было
                this._hdrOverhead = Math.max(0, pw - seen)
            }
            const overhead = this._hdrOverhead != null ? this._hdrOverhead : 0
            const hc = cs(head)
            let inner = head.clientWidth - (parseFloat(hc.paddingLeft) || 0) - (parseFloat(hc.paddingRight) || 0)
            for (const k of head.children) {                        // элементы шапки в потоке, кроме поля заголовка и панели: бейдж сегмента, Stop, меню ≡ …
                if (k === panel || k === input) continue
                const c = cs(k)
                if (c.position === 'absolute' || c.position === 'fixed' || c.display === 'none') continue
                inner -= k.getBoundingClientRect().width + (parseFloat(c.marginLeft) || 0) + (parseFloat(c.marginRight) || 0)
            }
            const ic = cs(input)
            const pad = ['paddingLeft', 'paddingRight', 'borderLeftWidth', 'borderRightWidth'].reduce((a, key) => a + (parseFloat(ic[key]) || 0), 0)
            inner -= (parseFloat(ic.marginLeft) || 0) + (parseFloat(ic.marginRight) || 0)
            const room = widgetHeaderOverflow_titleRoom(this.store, this.titleText_width(), ic.boxSizing === 'border-box' ? 0 : pad) + (ic.boxSizing === 'border-box' ? pad : 0)
            const avail = inner - room - overhead - 2
            const seps = list.map((a, i) => (a.attr_type === 'AttrSeparator' ? i : -1)).filter(i => i >= 0)
            const n = widgetHeaderOverflow_count(W, avail, seps)
            hdrOverflowStats.hidden = n === Infinity ? 0 : list.length - n
            hdrOverflowStats.last = { wid: this.widget_id, head: head.clientWidth, inner: Math.round(inner), room, overhead: Math.round(overhead), avail: Math.round(avail), total: Math.round(W.reduce((a, b) => a + b, 0)), n: String(n) }   // IE 2026 10 07 / ODOO-5800: последний замер — для живой проверки
            return n
        },
        tabsHover_hide() {
            clearTimeout(this._tabsHoverT)
            this._tabsHoverT = setTimeout(() => { this.showTabsHover = false }, this.store.setting('fe.ux.hoverHideMs', 300))   // IE 2026 09 05 / ODOO-336330
        },
        // IE 2026 08 27 / ODOO-5800 (заказ Игоря): полоса-граница шапка/тело — оверлей табов
        // после удержания мыши 1.8 с; уход с полосы до срока — таймер снимается
        // IE 2026 08 27 / ODOO-5800: метод, а не computed — WIDGET.styleWidget заполняется
        // после первого рендера и не реактивен, computed «застывал» в false и зона не появлялась
        tabsHoverZone_on() {
            const sw = this.WIDGET?.styleWidget
            return !!sw?.hideTabs && !sw.minMode && !sw.show_hidden && !this.store.mobileUi?.on && this.hoverViewTabs.length > 0
        },
        tabsHoverZone_enter() {
            clearTimeout(this._tabsHoverZoneT)
            clearTimeout(this._tabsHoverT) // оверлей уже показан и гаснет — оставить
            this._tabsHoverZoneT = setTimeout(() => { this.tabsHover_show() }, this.store.setting('fe.ux.tabsHoverZoneMs', 1800))   // IE 2026 09 05 / ODOO-336330
        },
        tabsHoverZone_leave() {
            clearTimeout(this._tabsHoverZoneT)
            if (this.showTabsHover) this.tabsHover_hide()
        },
        tabsHover_keep() { clearTimeout(this._tabsHoverT) },
        tabsHover_go(t) {
            this.showTabsHover = false
            this.store.set_activeAttr(this.WIDGET.view, { binding: t.binding }, this.WIDGET)
        },

        // --- dropdown ---
        toggleDropdown(event, action) {
            if (!this.showDropdown) {
                // WIDGET — сырой объект: parents_tree, пришедший ПОСЛЕ первого
                // вычисления dropdownTabs, кэш computed не инвалидирует — дропдаун,
                // открытый до загрузки виджета, оставался пустым навсегда.
                // На каждое открытие сбрасываем кэш и дорезолвиваем ссылки
                this.resolveIndex++
                this._resolveDropdownAttrLinks()
                this.settingsPanel_restoreMode() // IE 2026 09 04 / ODOO-336331: режим панели из localStorage
                // IE 2026 08 19 / ODOO-5512: табличный список настроек
                // IE 2026 08 26 / ODOO-5800 (замечание Игоря): после выбора другой настройки запись виджета
                // новая — дефолтный чипс дерева по родителю ставится на КАЖДОЕ открытие, а не только при init
                // IE 2026 09 04 / ODOO-336291 (mobile UX): P-16 settingsDeferred — на мобиле лист показывается сразу (showDropdown ниже),
                // сборка списка + монтирование AttrGrid — после первого кадра (rAF → setTimeout 0): первая
                // отрисовка листа десятки мс вместо ~500. Выкл: window.mobileUi.set('settingsDeferred', false)
                const _slInit = () => { try { this.settingsList_init(); this.settingsList_ensureDefaultChips(); this.settingsList_rebuild() } catch (e) { console.warn('settings list init', e) } }
                if (this.store.mobileUi?.on && this.store.mobileUi.settingsDeferred !== false) {
                    this.settingsListReady = false
                    requestAnimationFrame(() => setTimeout(() => { if (!this.showDropdown) { this.settingsListReady = true; return } _slInit(); this.settingsListReady = true }, 0))
                } else _slInit()
                // якорь: ВСЕГДА заголовок segment-title (панель «вытекает» из
                // ярлыка и при открытии из меню виджета — заказ Игоря 20.08),
                // фолбэки — кликнутый элемент → кнопка панели → сам виджет
                // (заголовок скрыт при !WIDGET.shortTitle — ODOO-3759)
                if (this.kindIcon_on() && this.kindChip_on()) this.kindChip_apply(kindBadge_posChip(this.$refs.kindIco, this.kindIconPlace))   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p220/p221/p222 шапка віджета: p222 — панель «вытекает» из чипса на его месте)
                const el = this.$el.querySelector('.segment-title')
                    || (event?.currentTarget instanceof Element && event.currentTarget)
                    || this.$el.querySelector('.btn-widget-dropdown')
                    || this.$el
                if (el) {
                    const rect = el.getBoundingClientRect()
                    const style = {
                        // −2px: верхняя граница панели заходит ПОД таб — белое
                        // тело таба (z выше) накрывает её и линию шапки виджета,
                        // стык без шва и без бордюра под табом (заказ Игоря 20.08)
                        top: (rect.bottom - 2) + 'px',
                        left: rect.left + 'px',
                    }
                    // IE 2026 08 20 / ODOO-5512 (заказ Игоря): рамка панели —
                    // цвета ярлыка (фон segment-title до открытия), внешний
                    // край рамки заподлицо с кольцом ярлыка (−2px)
                    if (el.classList?.contains('segment-title')) {
                        style.left = (rect.left - 2) + 'px'
                        const bg = window.getComputedStyle(el).backgroundColor
                        if (bg && bg !== 'rgba(0, 0, 0, 0)') {
                            style['--sd-border'] = bg
                            this.dropdownAccent = bg
                        }
                    }
                    // IE 2026 09 04 / ODOO-336331 (заказ Игоря): размер панели при открытии подбирается ПОД СОДЕРЖИМОЕ
                    // (settingsPanel_autoSize — после монтирования грида), а не из запомненного мышкой; ручной ресайз
                    // в этой сессии панели уважается до закрытия (_sdUserResized)
                    this._sdUserResized = false
                    this._sdAutoW = null; this._sdAutoH = null
                    // IE 2026 09 04 / ODOO-336331 (заказ Игоря): сразу прошлый подобранный размер этого режима (без «ползания»),
                    // окончательный — один раз по хуку refreshed грида (settingsPanel_requestSize)
                    const _last = this._sdLast?.[this.settingsPanelMode === 'variants' ? 'variants' : 'settings']
                    if (_last) { style.width = _last.w + 'px'; style.height = _last.h + 'px'; this._sdAutoW = _last.w; this._sdAutoH = _last.h }
                    this.dropdownStyle = style
                    // наблюдатель ресайза — отличает ручной ресайз (размер ≠ подобранному) от автоподбора
                    setTimeout(() => this.settingsPanel_ensureObserver(), 300)
                }
            }
            this.showDropdown = !this.showDropdown
            if (this.showDropdown) this.settingsPanel_requestSize('open') // IE 2026 09 04 / ODOO-336331: размер один раз по refreshed (грид ещё монтируется)
            if (!this.identInForm) this.show_commandPanel_topLeft = false   // IE 2026 09 23 / ODOO-… (замечание Игоря: в форме ⋯ — те же элементы шапки): бейдж в форме — форма остаётся (иначе телепорт вернул бы бейдж и панель в скрытую шапку)
            event?.stopPropagation?.()
        },
        onDropdownTabAction(action) {
            if (!this.store.checkAccess(action, this.WIDGET)) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + WIDGET — архив прячет запись только у данных модели (ревью #110599)
                return
            }
            if (action.command === 'widget_open') {
                this.store.widget_open({ widget: action.widget })
            }
            if (action.command === 'set_activeAttr') {
                this.store.set_activeAttr(this.WIDGET.view, { binding: action.binding }, this.WIDGET)
            }
            if (action.command === 'onShowInList__Click') {
                if (this.store.checkAccess(action, this.WIDGET)) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + WIDGET — архив прячет запись только у данных модели (ревью #110599)
                    this.store.executeStoreMethod(this.WIDGET.vueObj, action)
                }
            }
            this.showDropdown = false
        },
        onDropdownTabItemClick(item, event) {
            if (item.attr_type === 'CHIP-Where') {
                chipWidget_open(this.store, item.widget || 'widget-selectors')   // IE 2026 10 08 / ODOO-5800: виджет чипса — явно по привязанной записи, без подмены «Я»/«Всі» (utils/chipWidgetOpen)
                this.showDropdown = false
                return
            }
            if (item.attr_type === 'CHIP-Node' && item.node?.value) {
                if (event?.altKey) {
                    this.onDropdownTabItemOpenNew(item)
                    return
                }
                if (this.openInPlace) {
                    this.WIDGET.record.id = this.WIDGET.widget = item.node.value
                    this.store.executeStoreMethod(this.WIDGET.vueObj, {
                        command: 'executeWidgetMethod',
                        method: 'reload',
                        record_sendToBackend_exclude: ['_doc'],
                    })
                } else {
                    this.store.widget_open({ widget: item.node.value })
                }
                this.showDropdown = false
                return
            }
            if (item.attr_type === 'CHIP-Action' && item.action?.command) {
                this.store.executeStoreMethod(this.WIDGET.vueObj, item.action)
                this.showDropdown = false
                return
            }
            this.showDropdown = false
        },
        onDropdownTabItemOpenNew(item) {
            if (item.attr_type === 'CHIP-Node' && item.node?.value) {
                this.store.widget_open({ widget: item.node.value, parentAction: { new: true } })
                this.showDropdown = false
            }
        },
        // ---- IE 2026 08 19 / ODOO-5512 (заказ Игоря): список настроек — обычная
        // таблица (AttrGrid): дерево по родителю стандартным чипсом CHIP-Tree,
        // колонки Owner/Private/Tags, фильтры «My/All» и «Show hidden», панель
        // тегов (словарь сегмента), командная панель: выбрать / открыть в новом
        // виджете / пометить на удаление / сохранить копию как мою скрытую ----
        settingsList_init() {
            // IE 2026 09 04 / ODOO-336331 (заказ Игоря): два табличных списка одного вида — основное дерево
            // настроек виджета (settings) и дерево вариантов текущей настройки (variants, если бэк прислал
            // WIDGET.variants_tree — механизм включён)
            if (!this.WIDGET?.record?.segment) return
            if (!this.settingsListAttr) this.settingsListAttr = this.settingsList_makeAttr('settings')
            if (!this.variantsListAttr && this.settingsVariants_on()) this.variantsListAttr = this.settingsList_makeAttr('variants')
        },
        settingsVariants_on() {
            // механизм вариантов включён: бэк прислал дерево вариантов (при variants_off его нет)
            return Array.isArray(this.WIDGET?.variants_tree)
        },
        variantsCount() {
            const count = (nodes) => (nodes || []).reduce((n, x) => n + 1 + count(x.attrs), 0)
            return count(this.WIDGET?.variants_tree)
        },
        settingsCount() {
            // IE 2026 09 04 / ODOO-336331 (заказ Игоря): счётчик записей дерева настроек на кнопке Settings (как Variants)
            const count = (nodes) => (nodes || []).reduce((n, x) => n + 1 + count(x.attrs), 0)
            return count(this.WIDGET?.parents_tree)
        },
        settingsPanel_modeKey() { return `settingsPanelMode::${this.WIDGET?.widget || ''}` },
        settingsPanel_restoreMode() {
            let mode = 'settings'
            try { mode = localStorage.getItem(this.settingsPanel_modeKey()) || 'settings' } catch (e) { /* хранилище недоступно */ }
            if (mode === 'variants' && !this.settingsVariants_on()) mode = 'settings'
            this.settingsPanelMode = mode
        },
        settingsPanel_setMode(mode) {
            if (this.settingsPanelMode === mode) return
            this.settingsPanelMode = mode
            try { localStorage.setItem(this.settingsPanel_modeKey(), mode) } catch (e) { /* хранилище недоступно */ }
            this.resolveIndex++
            try { this.settingsList_init(); this.settingsList_ensureDefaultChips(); this.settingsList_rebuild() } catch (e) { console.warn('settings list mode', e) }
            this.settingsPanel_requestSize('mode') // IE 2026 09 04 / ODOO-336331: другой список — один подбор размера по refreshed грида режима
        },
        // IE 2026 09 04 / ODOO-336331 (заказ Игоря): размер панели подбирается ОДИН раз, когда строки грида отрисованы (хук refreshed),
        // а не цепочкой таймеров (панель «ползла» дискретными шагами ~1,5 с); до этого — прошлый подобранный размер
        // режима (если есть) либо панель невидима (sd-sizing); страховочный таймер — если refreshed не пришёл
        settingsPanel_requestSize(reason) {
            if (this._sdUserResized) return
            this._sdNeedSize = reason
            const mode = this.settingsPanelMode === 'variants' ? 'variants' : 'settings'
            const last = this._sdLast?.[mode]
            if (last) {
                const st = this.dropdownStyle || {}
                if (st.width !== last.w + 'px' || st.height !== last.h + 'px') this.dropdownStyle = { ...st, width: last.w + 'px', height: last.h + 'px' }
                this._sdAutoW = last.w; this._sdAutoH = last.h; this._sdAutoAt = performance.now()
                this.sdSizing = false
            } else this.sdSizing = true
            if (this._sdFallbackTimer) clearTimeout(this._sdFallbackTimer)
            this._sdFallbackTimer = setTimeout(() => { this._sdFallbackTimer = null; try { this.settingsPanel_sizeOnce('fallback') } catch (e) { /* панель закрыта */ } }, 900)
        },
        settingsPanel_sizeOnce(reason) {
            if (!this._sdNeedSize) return
            this._sdNeedSize = null
            if (this._sdFallbackTimer) { clearTimeout(this._sdFallbackTimer); this._sdFallbackTimer = null }
            try { if (this.showDropdown) this.settingsPanel_autoSizeNow(reason) } catch (e) { console.warn('settings panel size', e) }
            this.sdSizing = false
        },
        settingsPanel_ensureObserver() {
            // IE 2026 09 04 / ODOO-336331 (заказ Игоря): наблюдатель ресайза панели — отличает ручной ресайз (размер ≠
            // подобранному) от автоподбора; ручной размер закрепляется в dropdownStyle, иначе следующий рендер панели
            // (смена Settings|Variants → resolveIndex) вернул бы подобранный; элемент панели может пересоздаваться — навешивать заново
            const dd = this.$el?.querySelector('.chips-dropdown.widget-settings-dropdown')
            if (!dd || dd.__sdResizeObs || !window.ResizeObserver) return
            dd.__sdResizeObs = true
            const ro = new ResizeObserver(() => {
                if (!dd.isConnected) { try { ro.disconnect() } catch (e) { /* уже отключён */ } return }
                const r = dd.getBoundingClientRect()
                if (r.width < 50 || r.height < 50) return
                const w = Math.round(r.width), h = Math.round(r.height)
                // IE 2026 09 04 / ODOO-336331: размер, применённый автоподбором только что (в т.ч. подрезанный CSS-границами), — не ручной
                if (this._sdAutoAt && performance.now() - this._sdAutoAt < 400) {
                    this._sdAutoW = w; this._sdAutoH = h; this._sdW = w; this._sdH = h
                    this.settingsPanel_updateNarrow(dd, w)
                    return
                }
                if (this._sdAutoW != null && (Math.abs(w - this._sdAutoW) > 3 || Math.abs(h - this._sdAutoH) > 3)) {
                    this._sdUserResized = true
                    const st = this.dropdownStyle || {}
                    if (st.width !== w + 'px' || st.height !== h + 'px') this.dropdownStyle = { ...st, width: w + 'px', height: h + 'px' }
                }
                this._sdW = w; this._sdH = h
                this.settingsPanel_updateNarrow(dd, w) // IE 2026 09 04 / ODOO-336331: перенос Favorites под список
            })
            ro.observe(dd)
            this.settingsPanel_updateNarrow(dd, dd.getBoundingClientRect().width)
        },
        // IE 2026 09 04 / ODOO-336331 (заказ Игоря): при ширине панели меньше «список (680) + Favorites» секция
        // Favorites переносится ПОД список (класс sd-narrow, CSS), список получает всю ширину; ширина Favorites
        // измеряется в широком режиме и кэшируется (в узком она равна ширине панели)
        settingsPanel_favWidth(dd) {
            // IE 2026 09 15 (замечание Игоря, вечер): секции Favorites больше нет — ширина 0 (панель не уходит в узкий режим)
            if (!dd || !dd.querySelector('.dropdown-tab:not(.dropdown-tab-grid)')) return 0
            if (!this.sdNarrow) {
                let fw = 0
                for (const f of dd.querySelectorAll('.dropdown-tab:not(.dropdown-tab-grid)')) fw += (f.offsetWidth || 0)
                if (fw > 40) this._sdFavW = fw
            }
            return this._sdFavW || 385
        },
        settingsPanel_updateNarrow(dd, w) {
            if (!dd || !(w > 0)) return
            const narrow = w < 680 + this.settingsPanel_favWidth(dd) - 2
            if (narrow !== this.sdNarrow) this.sdNarrow = narrow
        },
        settingsList_makeAttr(mode) {
            // IE 2026 09 23 / ODOO-341407: i18n (column titles, tooltips of the list commands)
            const vueObj = this, isVar = mode === 'variants'
            const name = isVar ? 'variants-list' : 'settings-list'
            // ВАЖНО: без autoGeneratedButton — слияние groupMenu в set_commandPanel
            // такие кнопки пропускает (это «свои» кнопки грида)
            const btn = (o) => ({ attr_type: 'AttrButton', source_name: name, ...o })
            // методы кнопок получают (event, action): action.mode — какой из двух списков активен
            // IE 2026 09 19 / ODOO-… (замечание Игоря со скринами панели настроек: «убери выделенные команды из командной панели, оставь в
            // меню таблицы (верхний правый угол)»): команды списков — только пунктами меню ≡ (menuOnly, AttrGrid); в панели остаётся
            // «открыть списком» (sl-open-list). Двойной клик / клик по заголовку строки по-прежнему исполняют команду выбора
            const cmd = (o) => btn({ command: 'executeWidgetObjMethod', mode, menuOnly: true, ...o })
            const attr = {
                name, binding: `_doc.${isVar ? 'variants_list' : 'settings_list'}`, attr_type: 'AttrGrid', component: 'AttrGrid',
                isReadOnly: true, readOnlyRows: true, allowAddNew: false, allowSorting: 'SingleColumn',
                // IE 2026 08 19 (заказ Игоря п.1/2/4/6): headers 'Row' по умолчанию; клик по
                // ячейке заголовка строки = дабл-клик (первая команда выбора); свой стиль
                // без нижних бордюров; оформление элементов из meta.appearance
                noResize: true, headersVisibility: 'All', rowHeaderClick_dblclick: true,   // IE 2026 09 15 (замечание Игоря, вечер): заголовки колонок All · Me видны
                // IE 2026 08 26 / ODOO-5800 (заказ Игоря): клик по тексту настройки (Title) = выбор,
                // как через заголовок строки (иконка-ссылка по-прежнему открывает элемент)
                cellClick_dblclick: ['title'],
                // IE 2026 09 04 / ODOO-336331 (заказ Игоря): клик по ячейке колонки Default списка вариантов — ставит/снимает
                // основной вариант (эксклюзивно, через бэк); свой обработчик клика грида (cellClick_method)
                // IE 2026 09 15 / ODOO-… (замечание Игоря, вечер): колонки All · Me в обоих списках — клик по ячейке ставит / снимает цель по умолчанию
                // (All — для всех, doc.default_variant основной; Me — для меня, запись пользователя — только с бэком, который её знает)
                // IE 2026 10 08 / ODOO-5800 (замер ботом: два POST set_/clear_default_variant на один клик): клик по label ячейки-флага порождал второй click на input — гасим активацию label (utils/settingsListClick)
                cellClick_bindings: ['default_all', 'default_me'], cellClick_method: (binding, item, grid, e) => { labelClick_cancelActivation(e); vueObj.settingsList_toggleDefault(item, binding === 'default_me' ? 'me' : 'all') },   // IE 2026 10 08 / ODOO-5800
                cssClass: 'settings-list-grid', elements_appearance: true, appearance_saveNow: true,
                // IE 2026 08 20 (заказ Игоря): по умолчанию «Collapse rows to level» = max
                // (всё развёрнуто) и свёртка НЕ персистится в настройки
                collapseGroupsToLevel: 99, foldPersist: false,
                // IE 2026 08 20 (заказ Игоря): свойство таблицы Бордюры = None
                borders: 'None',
                // IE 2026 09 04 / ODOO-336331 (заказ Игоря): строки стандартной высоты (rowsHeight 0/пусто = 2) — без компактности −2px
                rowsHeightStandard: true,
                // IE 2026 08 20 (заказ Игоря): вместо пунктирных вертикалей —
                // Г-образная рамка группы подчинённых (вертикаль + угол + низ)
                tree_frame: 'L',
                // IE 2026 08 19 (заказ Игоря): Params в меню чипсов — про виджет,
                // не про этот список — скрыт; Chips предлагает чипс дерева Parent
                chips_hideParams: true,
                tags_panel: [],
                tags_onToggle: () => vueObj.settingsList_rebuild(mode),
                attrs: [
                    // IE 2026 08 19 (заказ Игоря п.5): AttrMulti — значение-словарь
                    // {value,valueStr,pi,relation_segment}: кликабельная иконка сегмента
                    // в начале текста (cell-link), клик открывает элемент в новом виджете
                    { binding: 'title', title: this.t('Title'), attr_type: 'AttrMulti', width: '2*', minWidth: 240, isReadOnly: true, uiHelp: 'widget.settings.list.title' },   // IE 2026 09 24 / ODOO-… (U3)
                    // IE 2026 09 15 / ODOO-… (замечание Игоря, вечер): кроме названия — только колонки All · Me (Tags / Owner / Updated / Private /
                    // Default сняты); ☑ у цели по умолчанию, у строки самой основной настройки ☑ = «открывается сама»
                    // IE 2026 09 17 (замечание Игоря): колонки All · Me видны всегда, независимо от заполненности — фильтр «непустые» (глаз)
                    // и авто-скрытие пустых колонок их не трогают (showEmpty / skip_check_nonEmptyWidget колонки, как у полей с «Show empty»)
                    { binding: 'default_all', title: this.t('All'), attr_type: 'AttrBool', width: 46, isReadOnly: true, checkbox_always: true, showEmpty: true, skip_check_nonEmptyWidget: true,
                        tooltip: this.t('Default for all — opens instead of the main setting for everyone (owner / admin). Click to set (one at a time) or clear'), uiHelp: 'widget.settings.list.all' },   // IE 2026 09 24 / ODOO-… (U3)
                    ...(vueObj.settingsList_meAvail() ? [{ binding: 'default_me', title: this.t('Me'), attr_type: 'AttrBool', width: 46, isReadOnly: true, checkbox_always: true, showEmpty: true, skip_check_nonEmptyWidget: true,
                        tooltip: this.t('Default for me — opens instead of the main setting for me (wins over «for all»). Click to set or clear'), uiHelp: 'widget.settings.list.me' }] : []),   // IE 2026 09 24 / ODOO-… (U3)
                ],
                groupMenu: {
                    commandPanel: [
                        // dblClick+binding: первая команда выбора = действие дабл-клика
                        // (find_dblclick) — её же исполняет клик по заголовку строки (п.2)
                        // IE 2026 09 04 / ODOO-336331 (заказ Игоря): в режиме Variants кнопки сохранения стоят ПЕРВЫМИ (видимая
                        // часть панели узкая — чипсы, остальное уходит в меню ⋮); кнопка ✓ «открыть выбранный» скрыта
                        // ('v-if': 'false' — выбор кликом по строке/заголовку строки остаётся: dblClick-команда в списке);
                        // ★ / Set default / Clear default заменены колонкой-флагом Default
                        ...(isVar ? [
                            cmd({ name: 'sl-save-variant', pinned: true, tooltip: this.t('Save current as new variant (child of the selected variant, else of the main setting)'), method: 'settingsList_saveAsVariant', cssClass: 'pi pi-share-alt p-button-white p-button-text0', uiHelp: 'widget.settings.cmd.saveVariant' }),   // IE 2026 09 24 / ODOO-… (U3)
                            cmd({ name: 'sl-save-setting', pinned: true, tooltip: this.t('Save current as new setting (copy in the main tree, child of the main setting)'), method: 'settingsList_saveAsSetting', cssClass: 'pi pi-save p-button-white p-button-text0', uiHelp: 'widget.settings.cmd.saveSetting' }),   // IE 2026 09 24 / ODOO-… (U3)
                            cmd({ name: 'sl-choose', 'v-if': 'false', tooltip: this.t('Open the selected variant in place'), method: 'settingsList_choose', dblClick: true, binding: '_doc.variants_list', cssClass: 'pi pi-check p-button-white p-button-text0', uiHelp: 'widget.settings.cmd.apply' }),   // IE 2026 09 24 / ODOO-… (U3)
                        ] : [
                            // IE 2026 09 04 / ODOO-336331: ✓ и ⧉ закреплены (pinned) — при десяти тегах уходили в ⋮
                            cmd({ name: 'sl-choose', pinned: true, tooltip: this.t('Apply the selected setting (open in place)'), method: 'settingsList_choose', dblClick: true, binding: '_doc.settings_list', cssClass: 'pi pi-check p-button-white p-button-text0', uiHelp: 'widget.settings.cmd.apply' }),   // IE 2026 09 24 / ODOO-… (U3)
                        ]),
                        cmd({ name: 'sl-open', pinned: true, tooltip: isVar ? this.t('Open the selected variant in a new widget') : this.t('Open the selected setting in a new widget'), method: 'settingsList_openNew', cssClass: 'pi pi-clone p-button-white p-button-text0', uiHelp: 'widget.settings.cmd.openNew' }),   // IE 2026 09 24 / ODOO-… (U3)
                        cmd({ name: 'sl-archive', tooltip: isVar ? this.t('Mark the selected variant for deletion (archive)') : this.t('Mark the selected setting for deletion (archive)'), method: 'settingsList_archive', cssClass: 'pi pi-trash p-button-white p-button-text0', uiHelp: 'widget.settings.cmd.archive' }),   // IE 2026 09 24 / ODOO-… (U3)
                        // IE 2026 09 04 / ODOO-336331 (заказ Игоря): команды сохранения — новая настройка (в основное
                        // дерево) / новый вариант / новый вариант сразу основной / назначить-снять основной вариант
                        ...(isVar ? [] : [
                            cmd({ name: 'sl-save-setting', tooltip: this.t('Save current as new setting (copy in the main tree, child of the current setting)'), method: 'settingsList_saveAsSetting', cssClass: 'pi pi-save p-button-white p-button-text0', uiHelp: 'widget.settings.cmd.saveSetting' }),   // IE 2026 09 24 / ODOO-… (U3)
                            cmd({ name: 'sl-save-variant', tooltip: this.t('Save current as new variant of this setting (Variants tab)'), method: 'settingsList_saveAsVariant', cssClass: 'pi pi-share-alt p-button-white p-button-text0', uiHelp: 'widget.settings.cmd.saveVariant' }),   // IE 2026 09 24 / ODOO-… (U3)
                        ]),
                        cmd({ name: 'sl-my', tooltip: isVar ? this.t('Only my variants / all variants') : this.t('Only my settings / all settings'), method: 'settingsList_toggleMy', cssClass: 'p-button-white p-button-text0', uiHelp: 'widget.settings.cmd.onlyMine' }),   // IE 2026 09 24 / ODOO-… (U3)
                        cmd({ name: 'sl-hidden', tooltip: isVar ? this.t('Show variants hidden by their owners (private)') : this.t('Show settings hidden by their owners (private)'), method: 'settingsList_toggleHidden', cssClass: 'pi pi-eye-slash p-button-white p-button-text0', uiHelp: 'widget.settings.cmd.showHidden' }),   // IE 2026 09 24 / ODOO-… (U3)
                        // IE 2026 08 20 (заказ Игоря): по умолчанию видна только колонка
                        // Title — тумблер показа деталей (Tags/Owner/Updated/Private)
                        cmd({ name: 'sl-details', 'v-if': 'false', tooltip: this.t('Show detail columns (tags, owner, updated, private)'), method: 'settingsList_toggleDetails', cssClass: 'pi pi-table p-button-white p-button-text0' }),
                        cmd({ name: 'sl-reset', tooltip: this.t('Reset view to default (tree by parent, all settings, no tag filters)'), method: 'settingsList_resetView', cssClass: 'pi pi-history p-button-white p-button-text0', uiHelp: 'widget.settings.cmd.resetView' }),   // IE 2026 09 24 / ODOO-… (U3)
                        ...(isVar ? [] : [
                            cmd({ name: 'sl-open-list', menuOnly: false, tooltip: this.t('Open in list widget'), method: 'settingsList_openList', cssClass: 'pi pi-external-link p-button-white p-button-text0', uiHelp: 'widget.settings.cmd.openList' }),   // IE 2026 09 24 / ODOO-… (U3)
                        ]),
                    ],
                },
            }
            this.store.prepare_attrs([attr], `${isVar ? 'variantsList' : 'settingsList'}_${this.WIDGET.id}`)
            return attr
        },
        settingsList_ensureDefaultChips() {
            // чипсы грида — в viewParams записи (их читает AttrChips/дерево грида);
            // дефолт: стандартный чипс дерева по родителю. set_modified=false —
            // раскладка настроек не делает запись изменённой.
            // IE 2026 08 26 / ODOO-5800: вызывается на каждое открытие панели — запись виджета меняется
            // при выборе настройки, и у новой записи чипсов списка нет (список показывался плоским)
            if (!this.WIDGET?.record) return
            // IE 2026 09 04 / ODOO-336331: то же для списка вариантов (variants-list)
            for (const nm of ['settings-list', 'variants-list']) {
                const vpChips = this.store.get_value(this.WIDGET.record, `doc.viewParams.${nm}.CHIPS`)
                // IE 2026 09 10 / ODOO-… (замечание Игоря «после выбора настройки иногда пропадает иерархия»): у записи выбранной настройки
                // CHIPS списка бывает ПУСТЫМ массивом (viewParams инициализируются пустыми CHIPS) — раньше проверялось
                // только «не массив», чипс дерева не ставился, список показывался плоским. Чипс дерева ставим всегда,
                // когда его нет (остальные чипсы списка сохраняются)
                const hasTree = Array.isArray(vpChips) && vpChips.some(c => c && (c.segment === 'CHIP-Tree' || c.attr_type === 'CHIP-Tree'))
                if (!hasTree) {
                    this.store.set_value(this.WIDGET.record, `doc.viewParams.${nm}.CHIPS`, [
                        ...(Array.isArray(vpChips) ? vpChips : []),
                        { segment: 'CHIP-Tree', title: 'Parent', meta: { use: true, pi: 'pi-sitemap' },   // IE 2026 09 24 / ODOO-341407: в запись (viewParams) — английская база; перевод при показе (AttrChips.getChipTitleHTML); groupDescriptions — данные чипса
                            doc: { groupDescriptions: [{ title: 'Parent', binding: 'parent' }] } },
                    ], null, null, null, false)
                }
            }
        },
        settingsList_onRecordReplaced() {
            // IE 2026 09 10 / ODOO-…: запись виджета заменена (reload после выбора настройки) при ОТКРЫТОЙ панели — у новой записи нет чипсов
            // списка, а строки списка (_doc.settings_list) не пересобраны: список показывался пустым/плоским до переоткрытия
            if (!this.showDropdown || !this.settingsListAttr) return
            try { this.settingsList_ensureDefaultChips(); this.settingsList_rebuild() } catch (e) { console.warn('settings list refresh', e) }
        },
        settingsList_rebuild(mode) {
            // IE 2026 09 04 / ODOO-336331: без аргумента — оба списка (настройки и варианты)
            if (!mode) { this.settingsList_rebuild('settings'); if (this.variantsListAttr) this.settingsList_rebuild('variants'); return }
            const W = this.WIDGET, store = this.store, isVar = mode === 'variants'
            const attr = isVar ? this.variantsListAttr : this.settingsListAttr
            if (!attr) return
            const rows = []
            // IE 2026 09 15 / ODOO-… (замечание Игоря, вечер): колонки All · Me — цель по умолчанию основной настройки (All — doc.default_variant
            // основной, Me — запись пользователя); у строки самой основной ☑ = «открывается сама»
            const mainId0 = this.settingsList_mainId(), dvAll = this.settingsList_defaultOf('all'), dvMe = this.settingsList_defaultOf('me')
            const meExpl = meMarkExplicitOnly(store)   // IE 2026 10 08 / ODOO-5800: «Я» — только явный выбор (utils/settingsDefaultMarks, fe.ux.meMarkExplicitOnly)
            // IE 2026 08 19 (заказ Игоря п.5): иконка по типу элемента
            const piBySegment = (seg) => seg === 'WIDGET-REPORT2' ? 'pi pi-table'
                : seg === 'WIDGET-LIST' ? 'pi pi-list' : 'pi pi-file'
            const walk = (nodes) => {
                for (const n of nodes || []) {
                    // IE 2026 09 04 / ODOO-336331 (заказ Игоря): текущая открытая запись — бейдж «Current» в начале строки
                    // (в стиле «Branch copy»; AttrGrid рисует его по title.badge), маркер • убран; ★ в дереве настроек остался
                    const mark = (!isVar && n.is_default ? '★ ' : '')
                    // IE 2026 09 16 (замечание Игоря: «не вижу бейджа текущей настройки»): открыт ВАРИАНТ настройки — в дереве настроек
                    // бейдж «Current» стоит у его ОСНОВНОЙ настройки (сам вариант — строка списка Variants, там свой бейдж)
                    const curVariantOf = (!isVar && W.record?.doc?.variant_of && W.record.doc.variant_of !== W.record.id) ? W.record.doc.variant_of : ''
                    const isCur = n.id === W.record?.id || (!!curVariantOf && n.id === curVariantOf)
                    const badgeTitle = n.id === W.record?.id ? this.t('This setting is open in the widget now') : this.t('A variant of this setting is open in the widget now: {title}', { title: this.settingsPanel_recordTitle || W.record?.title || W.record?.id })   // IE 2026 10 13 / ODOO-341407   // IE 2026 09 23 / ODOO-341407: i18n (badges)
                    rows.push({
                        id: n.id, parent: n.parent || '', segment: n.segment,
                        // словарь AttrMulti: текст valueStr + кликабельная иконка pi (п.5)
                        title: { value: n.id, valueStr: mark + (n.title || n.id), pi: piBySegment(n.segment), relation_segment: n.segment,
                            // valueStr_fix: valueStr финален — prepare_AttrMulti не резолвит по
                            // itemsSource и НЕ перетирает pi иконкой реестра сегментов (pi-expand)
                            attr_type: 'AttrLink', valueStr_fix: true,
                            ...(isCur ? { badge: n.id === W.record?.id ? this.t('Current', null, 'setting') : this.t('Current · variant'), badge_class: 'cell-badge-current', badge_title: badgeTitle } : {}) },   // IE 2026 09 24 / ODOO-341407: контекстный ключ словаря (ревизия омонимов)
                        is_current: isCur,
                        created_by: n.created_by || '', updated_at: String(n.updated_at || '').slice(0, 16).replace('T', ' '),
                        private: !!n.private, tags: n.tags || '', archived: !!n.archived, _node: n,
                        is_default: !!n.is_default, default_flag: isVar ? !!n.is_default : false,   // IE 2026 09 04 / ODOO-336331: булево под AttrBool
                        default_all: defaultMark(n.id, mainId0, dvAll), default_me: defaultMark(n.id, mainId0, dvMe, meExpl),   // IE 2026 09 15 · IE 2026 10 08 / ODOO-5800: «Я» — только явный выбор
                        _appearance: n.appearance || null, // оформление элемента (п.6)
                    })
                    walk(n.attrs)
                }
            }
            walk(isVar ? W.variants_tree : W.parents_tree)
            if (isVar) {
                // IE 2026 09 04 / ODOO-336331 (заказ Игоря): первая строка списка вариантов — сама ОСНОВНАЯ настройка
                // (переход к ней отсюда: клик по строке открывает её явно); варианты — под ней (parent = основная);
                // её флаг Default = «по умолчанию открывается основная» (default_variant пуст)
                const mainId = this.settingsList_mainId()
                const mainOpen = W.record?.id === mainId
                const mainRec = mainOpen ? (W.record || {}) : (W.variant_main || {})
                const mainTitle = (mainOpen ? this.settingsPanel_recordTitle : '') || mainRec.title || mainId   // IE 2026 10 13 / ODOO-341407 (Igor, скрин DM uk: «Signals (основне)»): открыта основная — её title в record сырой (база en), перевод — meta.title_{lang}/словарь, как у заголовка панели; variant_main уже локализован бэком
                const anyDefault = rows.some(r => r.is_default)
                rows.unshift({
                    id: mainId, parent: '', segment: W.record?.segment || '',
                    title: { value: mainId, valueStr: mainTitle + ' ' + this.t('(main)'),   // IE 2026 10 13 / ODOO-341407 pi: 'pi pi-home', relation_segment: W.record?.segment || '',   // IE 2026 09 23 / ODOO-341407: i18n
                        attr_type: 'AttrLink', valueStr_fix: true,
                        // IE 2026 09 04 / ODOO-336331 (заказ Игоря): бейдж «Current», если открыта основная
                        ...(mainOpen ? { badge: this.t('Current', null, 'setting'), badge_class: 'cell-badge-current', badge_title: this.t('This setting is open in the widget now') } : {}) },   // IE 2026 09 24 / ODOO-341407: контекстный ключ словаря (ревизия омонимов)
                    is_current: mainOpen,
                    created_by: mainRec.created_by || '', updated_at: String(mainRec.updated_at || '').slice(0, 16).replace('T', ' '),
                    private: !!(mainOpen ? W.record?.doc?.private : mainRec.private), tags: '', archived: false,
                    _node: { id: mainId, segment: W.record?.segment || '', title: mainTitle, is_main: true },   // IE 2026 10 13 / ODOO-341407
                    is_main: true, is_default: !anyDefault, default_flag: !anyDefault,   /* IE 2026 09 04 / ODOO-336331 */ _appearance: null,
                    default_all: !dvAll, default_me: defaultMark(mainId, mainId, dvMe, meExpl),   // IE 2026 09 15: основная «открывается сама», пока цель не назначена · IE 2026 10 08 / ODOO-5800: «Я» — только явный выбор
                })
            }
            const me = store.user?.id
            const vpChips = store.get_value(W.record, `doc.viewParams.${attr.name}.CHIPS`) || []
            const tagChips = vpChips.filter(c => c && (c.attr_type === 'CHIP-Tag' || c.segment === 'CHIP-Tag') && c.use !== false && c.meta?.use !== false).map(c => c.title)
            const out = rows.filter(r => {
                if (r.is_main) return true // строка основной настройки видна всегда
                if (this.settingsListMy && r.created_by !== me) return false
                if (!this.settingsListHidden && r.private && r.created_by !== me) return false
                if (tagChips.length) {
                    const t = String(r.tags || '').split(',').map(x => x.trim()).filter(Boolean)
                    if (!tagChips.every(tc => t.includes(tc))) return false
                }
                return true
            })
            // панель тегов: словарь сегмента (WIDGET.segment_tags с бэка) + теги строк
            const tagSet = new Set(W.segment_tags || [])
            for (const r of rows) for (const t of String(r.tags || '').split(',')) if (t.trim()) tagSet.add(t.trim())
            attr.tags_panel = this.settingsList_tagsOn() ? [...tagSet] : []   // IE 2026 09 15 (замечание Игоря, вечер): чипсы тегов скрыты (опция в коде)
            store.set_value(W.record, attr.binding, out, null, null, null, false)
            // высота под содержимое (прижатие вверх): шапка+чипсы+панель ≈ 150px,
            // строка — по фактической высоте грида (Borders=None компактнее)
            const hKey = isVar ? 'variantsListHeight' : 'settingsListHeight'
            const gridV = attr.vueObj || W.attrs_vueObj?.[attr.id]
            const _rowH = gridV?.flex?.rows?.defaultSize || 17
            this[hKey] = Math.max(200, Math.min(184 + out.length * _rowH, 480))   // IE 2026 09 15: + строка «Save as new» под деревом
            // на ПЕРВОМ открытии дропдауна грид ещё монтируется — повторить разово,
            // иначе хук пересчёта высоты не навесится до второго открытия
            const retryKey = isVar ? '_vlRebuildRetry' : '_slRebuildRetry'
            if (!gridV?.flex && !this[retryKey]) {
                this[retryKey] = true
                setTimeout(() => { this[retryKey] = false; try { this.settingsList_rebuild(mode) } catch (e) { /* дропдаун мог закрыться */ } }, 400)
            }
            try {
                if (gridV?.flex) {
                    gridV.content_Changed_main({ isVue: true })
                    gridV.content_Changed_afterTimeout({ isVue: true })
                    // IE 2026 08 20 (заказ Игоря): доп. колонки видны только при
                    // включённом тумблере sl-details (по умолчанию — только Title);
                    // ПОСЛЕ content_Changed_* — пересоздание колонок сбрасывает
                    // видимость, поэтому же применяется и в хуке refreshed ниже
                    this.settingsList_applyDetailCols(gridV)
                    if (!this._sdNeedSize) this.settingsPanel_autoSize('rebuild') // IE 2026 09 04 / ODOO-336331; IE 2026 09 04 / ODOO-336331: при ожидании одноразового подбора — по refreshed
                    // IE 2026 08 20 (заказ Игоря): при свёртке/развороте дерева высота
                    // пересчитывается по ВИДИМЫМ строкам — без пустоты снизу
                    if (!gridV.flex.__slHeightHook) {
                        gridV.flex.__slHeightHook = true
                        const self = this
                        gridV.flex.refreshed.addHandler(() => {
                            try {
                                self.settingsList_applyDetailCols(gridV)
                                const n = [...gridV.flex.rows].filter(r => r.isVisible).length
                                const _rh = gridV.flex.rows.defaultSize || 17
                                const h = Math.max(180, Math.min(150 + n * _rh, 460))
                                if (h !== self[hKey]) self[hKey] = h
                                // IE 2026 09 04 / ODOO-336331 (заказ Игоря): размер панели под содержимое списка
                                // IE 2026 09 04 / ODOO-336331: ожидающий одноразовый подбор — по первому refreshed с видимыми строками
                                if (self._sdNeedSize) {
                                    const listLen = (self.store.get_value(self.WIDGET?.record, isVar ? '_doc.variants_list' : '_doc.settings_list') || []).length
                                    if (n > 0 || !listLen) self.settingsPanel_sizeOnce('refreshed')
                                } else self.settingsPanel_autoSize('refreshed')
                            } catch (e) { /* грид мог перестроиться */ }
                        })
                    }
                }
            } catch (e) { console.warn('settings list refresh', e) }
        },
        settingsList_grid(mode) {
            const attr = mode === 'variants' ? this.variantsListAttr : this.settingsListAttr
            return attr?.vueObj || this.WIDGET.attrs_vueObj?.[attr?.id]
        },
        // IE 2026 09 04 / ODOO-336331 (заказ Игоря): «интеллектуальный» размер панели настроек при открытии —
        // высота по числу видимых строк списка (10 строк → все 10 видны, 2 строки → компактно) + шапка вкладки +
        // командная панель грида; ширина — чтобы были видны колонки списка и соседняя вкладка Favorites; но не
        // выходя за границы виджета (или окна, если виджет меньше) — при переполнении скроллит сам грид.
        // Пересчёт при смене режима Settings|Variants, свёртке дерева и ресайзе окна; ручной ресайз мышкой
        // в этой сессии панели не перебивается (до закрытия). Вызывать можно часто — реальный расчёт в rAF.
        settingsPanel_autoSize(reason) {
            if (!this.showDropdown || this._sdUserResized) return
            if (this._sdAutoRaf) cancelAnimationFrame(this._sdAutoRaf)
            this._sdAutoRaf = requestAnimationFrame(() => {
                this._sdAutoRaf = null
                try { this.settingsPanel_autoSizeNow(reason) } catch (e) { console.warn('settings panel autosize', e) }
            })
        },
        settingsPanel_autoSizeNow(reason) {
            if (!this.showDropdown || this._sdUserResized) return
            const dd = this.$el?.querySelector('.chips-dropdown.widget-settings-dropdown')
            if (!dd) return
            const mode = this.settingsPanelMode === 'variants' ? 'variants' : 'settings'
            const gridV = this.settingsList_grid(mode)
            const flex = gridV?.flex
            this.settingsPanel_ensureObserver()
            // IE 2026 09 04 / ODOO-336331: грид ещё пуст (монтируется после смены режима), а список не пуст — не ужимать
            // панель до минимума по нулевым строкам; размер придёт с хука refreshed / повторной попытки (autoSizeRetry)
            const listRows = this.store.get_value(this.WIDGET?.record, mode === 'variants' ? '_doc.variants_list' : '_doc.settings_list') || []
            if (flex?.rows && listRows.length && ![...flex.rows].some(r => r.isVisible)) return
            // IE 2026 09 04 / ODOO-336331 (заказ Игоря): ширина панели ФИКСИРУЕТСЯ после первого подбора режима — refreshed грида,
            // вызванный нашей же сменой размера, ширину не пересчитывает (scrollWidth панели/Favorites зависят от текущей
            // ширины контейнера → цикл «−1 px» каждые ~60 мс); по refreshed меняется только высота, и только один раз
            // после подбора (перенос тегов) либо при смене числа видимых строк (свёртка дерева)
            const nVis = flex?.rows ? [...flex.rows].filter(r => r.isVisible).length : -1
            const lockedW = (reason === 'refreshed' || reason === 'fallback') ? (this._sdLockW?.[mode] || 0) : 0
            if (lockedW && nVis === (this._sdLastRows?.[mode] ?? -2) && this._sdHeightPass?.[mode]) return
            const tab = dd.querySelector('.dropdown-tab-grid')
            const gridBox = tab?.querySelector('.dropdown-settings-grid')
            const ddRect = dd.getBoundingClientRect()
            // --- границы: виджет (или окно, если виджет меньше минимума панели) ---
            const wRect = this.$el.getBoundingClientRect()
            const top = parseFloat(this.dropdownStyle?.top) || ddRect.top
            const left = parseFloat(this.dropdownStyle?.left) || ddRect.left
            const MIN_W = 680, MIN_H = 220, PAD = 6 // IE 2026 09 04 / ODOO-336331: MIN_W = min-width панели (680)
            let maxW = Math.min(wRect.right, window.innerWidth - PAD) - left - PAD
            let maxH = Math.min(wRect.bottom, window.innerHeight - PAD) - top - PAD
            if (maxW < MIN_W) maxW = Math.max(MIN_W, window.innerWidth - left - PAD)
            if (maxH < MIN_H) maxH = Math.max(MIN_H, window.innerHeight - top - PAD)
            // --- желаемая высота: шапка вкладки + командная панель грида + строки + отступы ---
            const hdr = tab?.querySelector('.dropdown-tab-header')
            const topLine = gridBox?.querySelector('.grid-top-line')
            const hint = gridBox?.querySelector('.dropdown-tab-item') // «No variants yet…»
            let rowsH = 0
            if (flex?.rows) {
                const n = [...flex.rows].filter(r => r.isVisible).length
                const rh = flex.rows.defaultSize || 17
                rowsH = n * rh + (flex.columnHeaders?.height || 0)
            } else rowsH = Math.max(60, (this[mode === 'variants' ? 'variantsListHeight' : 'settingsListHeight'] || 180) - 150)
            const chrome = (hdr?.offsetHeight || 41) + (topLine?.offsetHeight || 38) + (hint?.offsetHeight || 0) + 10 /* padding грида */ + 4 /* рамка */ + 16 /* горизонтальная полоса грида, если появится */
            let h = Math.round(chrome + rowsH + 6)
            // --- желаемая ширина: видимые колонки + заголовок строк + вертикальная полоса + Favorites ---
            let w
            if (lockedW) w = Math.max(MIN_W, Math.min(lockedW, maxW)) // IE 2026 09 04 / ODOO-336331: ширина зафиксирована
            else {
                let gridW = 0
                if (flex?.columns) {
                    // звёздные колонки (width '2*') — по minWidth: их renderWidth равен текущей ширине контейнера
                    const cw = (c) => typeof c.width === 'string' && c.width.includes('*') ? (c.minWidth || 240) : (c.renderWidth || c.width || 0)
                    for (const c of flex.columns) if (c.visible) gridW += cw(c)
                    if (flex.rowHeaders?.columns) for (const c of flex.rowHeaders.columns) gridW += (c.renderWidth || c.width || 0)
                    gridW += 17 /* вертикальная полоса */ + 14 /* padding */
                }
                // командная панель: теги эластичны и переносятся — пол 680 (прежняя ширина панели по умолчанию); её scrollWidth
                // не берём — он зависит от текущей ширины контейнера и давал цикл подбора (IE 2026 09 04 / ODOO-336331)
                w = Math.max(gridW, 680, MIN_W)
                w += this.settingsPanel_favWidth(dd) // Favorites справа (ширина измерена в широком режиме, кэш)
                w = Math.round(w + 4)
                w = Math.max(MIN_W, Math.min(w, maxW))
            }
            // IE 2026 09 04 / ODOO-336331: если Favorites справа не помещается в границы — она уйдёт под список,
            // тогда высота панели должна вместить и её
            const favW = this.settingsPanel_favWidth(dd)
            const narrow = w < MIN_W + favW - 2
            if (narrow) { let fh = 0; for (const f of fav) fh = Math.max(fh, f.offsetHeight || 0); h += (fh || 120) + 2 }
            h = Math.max(MIN_H, Math.min(h, maxH))
            if (narrow !== this.sdNarrow) this.sdNarrow = narrow
            this._sdAutoW = w; this._sdAutoH = h
            this._sdAutoAt = performance.now() // IE 2026 09 04 / ODOO-336331: метка автоподбора для наблюдателя ресайза
            ;(this._sdLast = this._sdLast || {})[mode] = { w, h } // IE 2026 09 04 / ODOO-336331: прошлый размер режима — мгновенно при следующем открытии
            ;(this._sdLockW = this._sdLockW || {})[mode] = w // IE 2026 09 04 / ODOO-336331: фиксация ширины (см. lockedW)
            ;(this._sdLastRows = this._sdLastRows || {})[mode] = nVis
            ;(this._sdHeightPass = this._sdHeightPass || {})[mode] = !!lockedW // после полного подбора — ещё один проход только по высоте
            const style = { ...(this.dropdownStyle || {}), width: w + 'px', height: h + 'px' }
            if (style.width !== this.dropdownStyle?.width || style.height !== this.dropdownStyle?.height) this.dropdownStyle = style
        },
        settingsPanel_onWinResize() {
            if (this._sdWinRaf) clearTimeout(this._sdWinRaf)
            this._sdWinRaf = setTimeout(() => { this._sdWinRaf = null; this._sdLockW = {}; this._sdHeightPass = {}; this.settingsPanel_autoSize('window') }, 120) // IE 2026 09 04 / ODOO-336331: ресайз окна — полный подбор заново
        },
        settingsList_attrs() {
            // IE 2026 09 04 / ODOO-336331: оба списка (тумблеры My/hidden/details действуют на оба)
            return [this.settingsListAttr, this.variantsListAttr].filter(Boolean)
        },
        // IE 2026 08 20 (заказ Игоря): по умолчанию только колонка Title,
        // детали (Tags/Owner/Updated/Private) — по тумблеру sl-details
        settingsList_applyDetailCols(gridV) {
            const grids = gridV ? [gridV] : [this.settingsList_grid('settings'), this.settingsList_grid('variants')].filter(Boolean)
            const details = ['tags', 'created_by', 'updated_at', 'private'] // IE 2026 09 04 / ODOO-336331: Default — всегда видна
            for (const g of grids) {
                if (!g?.flex) continue
                for (const col of g.flex.columns) {
                    if (details.includes(col.binding) && col.visible !== this.settingsListDetails) {
                        col.visible = this.settingsListDetails
                    }
                }
            }
        },
        settingsList_toggleDetails() {
            this.settingsListDetails = !this.settingsListDetails
            for (const a of this.settingsList_attrs()) {
                const b = a.groupMenu?.commandPanel?.find(x => x.name === 'sl-details')
                if (b) b.active = this.settingsListDetails
            }
            this.settingsList_applyDetailCols()
        },
        settingsList_current(mode) {
            const g = this.settingsList_grid(mode)
            const sel = g?.flex?.selection
            const it = sel && sel.row >= 0 ? g.flex.rows[sel.row]?.dataItem : null
            if (!it?.id) this.store.show_notification({ text: mode === 'variants' ? this.t('Select a variant row first') : this.t('Select a setting row first'), status: 'warning' })   // IE 2026 09 23 / ODOO-341407: i18n
            return it?.id ? it : null
        },
        settingsList_choose(event, action) {
            const mode = action?.mode || 'settings'
            const it = this.settingsList_current(mode)
            if (!it) return
            this.showDropdown = false
            // IE 2026 09 04 / ODOO-336331 (заказ Игоря): явный выбор — бэк не подменяет запись на основной
            // вариант (variant_explicit едет в reload). Вариант открывается ЗАПИСЬЮ виджета, WIDGET.widget
            // остаётся id основной настройки (страница ссылается на неё)
            // IE 2026 09 16 (вопрос Игоря «почему не открылся вариант по умолчанию»): явный выбор — только на вкладке Variants (вариант или
            // строка «(main)»); выбор настройки на вкладке Settings открывает её вариант по умолчанию (Me → All), как при открытии страницы
            // IE 2026 10 08 / ODOO-5800 (жалоба Чуклиной: клик по «Країни::Баланс за горизонтом» в окне «Subjects::Дистриб'ютори» ничего не
            // менял): запись открыта ПОДМЕНОЙ (Me / All основной → эта настройка, WIDGET.settings_main с бэка) — клик по самой ОСНОВНОЙ в дереве
            // Settings есть явный выбор её самой: без variant_explicit бэк подменял её той же целью снова. Прочие строки — по-прежнему
            // с целью по умолчанию (IE 2026 09 16)
            this.WIDGET.variant_explicit = mode === 'variants' || (!!this.WIDGET.settings_main && it.id === this.WIDGET.settings_main)
            if (mode === 'variants' && !it._node?.is_main) {
                this.WIDGET.record.id = it.id
            } else {
                // строка основной настройки в списке вариантов — как выбор в основном дереве (IE 2026 09 04 / ODOO-336331)
                this.WIDGET.record.id = this.WIDGET.widget = it.id
            }
            this.store.executeStoreMethod(this.WIDGET.vueObj, { command: 'executeWidgetMethod', method: 'reload', record_sendToBackend_exclude: ['_doc'] })
        },
        settingsList_openNew(event, action) {
            const mode = action?.mode || 'settings'
            const it = this.settingsList_current(mode)
            if (!it) return
            this.showDropdown = false
            if (mode === 'variants' && !it._node?.is_main) {
                // IE 2026 09 04 / ODOO-336331: свободное окно варианта — виджет основной настройки с записью-вариантом
                this.store.widget_open({ widget: it._node?.variant_of || this.settingsList_mainId(), record: { id: it.id, segment: it.segment }, parentAction: { new: true }, variant_explicit: true })
            } else {
                this.store.widget_open({ widget: it.id, parentAction: { new: true }, variant_explicit: mode === 'variants' })   // IE 2026 09 16: с вкладки Settings — вариант по умолчанию
            }
        },
        settingsList_archive(event, action) {
            const it = this.settingsList_current(action?.mode || 'settings')
            if (!it) return
            // IE 2026 09 23 / ODOO-341407: i18n
            if (it._node?.is_main) { this.store.show_notification({ text: this.t('The main setting is archived from the Settings tab'), status: 'warning' }); return }
            const _title = it.title?.valueStr || it.title
            if (!confirm(action?.mode === 'variants' ? this.t('Archive variant "{title}"? Child variants will be moved up one level', { title: _title }) : this.t('Archive "{title}"? Child settings will be moved up one level', { title: _title }))) return
            this.showDropdown = false
            this.store.archive_settingsTreeNode(this.WIDGET.vueObj || this, it._node)
        },
        // IE 2026 09 04 / ODOO-336331 (заказ Игоря): команды сохранения и основного варианта
        settingsList_saveAsSetting(event, action) {
            this.showDropdown = false
            // IE 2026 09 15 (замечание Игоря, вечер): «Save as new» под деревом — своя (private) копия; кнопка ⋮ панели — как раньше, общая
            this.store.executeStoreMethod(this.WIDGET.vueObj, { command: 'onCloneRecord__Click', params: { clone: true, as_setting: true, private: !!action?.private }, openInPlace: true, saveAfterClone: true })
        },
        // IE 2026 09 15 / ODOO-… (замечание Игоря, вечер): одна команда под деревом: Settings — новая настройка (моя копия), Variants — новый вариант (мой)
        settingsList_saveAsNew() {
            if (this.settingsPanelMode === 'variants') this.settingsList_saveAsVariant(null, { mode: 'variants', private: true })
            else this.settingsList_saveAsSetting(null, { private: true })
        },
        // чипсы тегов над списком настроек — скрыты (замечание Игоря 15.09); вернуть: window.feSettings.set('fe.ux.settingsListTags', true)
        settingsList_tagsOn() { try { return this.store.setting('fe.ux.settingsListTags', false) === true } catch (e) { return false } },
        // колонка Me — только когда бэк присылает личную цель (settings_default_me); старый бэк принял бы «me» за «all» (общая база dev02)
        settingsList_meAvail() { const v = this.WIDGET?.settings_default_me; return v !== undefined && v !== null },
        // цель по умолчанию основной настройки: All — doc.default_variant основной (с бэка settings_default_all), Me — запись пользователя
        settingsList_defaultOf(scope) {
            const W = this.WIDGET
            if (scope === 'me') return W.settings_default_me || ''
            if (W.settings_default_all !== undefined && W.settings_default_all !== null) return W.settings_default_all || ''
            const mainId = this.settingsList_mainId()
            return (W.record?.id === mainId ? W.record?.doc?.default_variant : W.variant_main?.default_variant) || ''
        },
        settingsList_saveAsVariant(event, action) {
            // родитель нового варианта — выделенный вариант (список вариантов активен и строка выбрана), иначе текущая запись
            let parent = ''
            if (action?.mode === 'variants') {
                const g = this.settingsList_grid('variants'), sel = g?.flex?.selection
                const it = sel && sel.row >= 0 ? g.flex.rows[sel.row]?.dataItem : null
                if (it?.id) parent = it.id
            }
            this.showDropdown = false
            this.store.executeStoreMethod(this.WIDGET.vueObj, { command: 'onCloneRecord__Click', params: { clone: true, as_variant: true, make_default: !!action?.make_default, private: !!action?.private, parent }, openInPlace: true, saveAfterClone: true })   // IE 2026 09 15: private — «Save as new» под деревом
        },
        settingsList_toggleDefault(item, scope = 'all') {
            // IE 2026 09 04 / ODOO-336331 (заказ Игоря): клик по флагу — эксклюзивное назначение цели по умолчанию (одна на настройку);
            // IE 2026 09 15 / ODOO-… (замечание Игоря, вечер): scope 'all' — doc.default_variant основной, 'me' — запись пользователя;
            // строка самой основной ☑ = «цель не назначена», клик по ней = снять
            if (!item?.id) return
            const mainId = this.settingsList_mainId(), cur = this.settingsList_defaultOf(scope)
            if (item.id === mainId || item.is_main) { if (cur) this.settingsList_defaultCall('clear_default_variant', '', scope); return }
            const on = item.id === cur
            this.settingsList_defaultCall(on ? 'clear_default_variant' : 'set_default_variant', on ? '' : item.id, scope)
        },
        variantChip_tooltip() {
            const W = this.WIDGET
            return this.t('Variant "{variant}" of the main setting "{main}"', { variant: W.variant_label || '', main: W.variant_main?.title || '' })   // IE 2026 09 23 / ODOO-341407: i18n
        },
        settingsList_mainId() {
            const W = this.WIDGET
            return W.variant_main?.id || W.record?.doc?.variant_of || W.record?.id || ''
        },
        settingsList_defaultCall(method, variantId, scope = 'all') {
            const W = this.WIDGET, mainId = this.settingsList_mainId()
            if (!mainId) return
            this.store.executeBackendMethod(W.vueObj || this, { method, params: { main: mainId, variant: variantId, segment: W.record?.segment || '', scope } }, (answer) => {
                // IE 2026 09 04 / ODOO-336331: отказ (права / запись изменена другим пользователем) — список перестроить из
                // прежнего состояния, флаг остаётся как был; текст отказа показывает платформа (notification / TERMINAL)
                if (!answer || answer.status === 'error') { try { this.settingsList_rebuild() } catch (e) { /* панель могла закрыться */ } return }
                if (Array.isArray(answer.variants_tree)) W.variants_tree = answer.variants_tree
                // IE 2026 09 15 / ODOO-… (замечание Игоря, вечер): All — doc.default_variant основной, Me — запись пользователя; оба списка перестроить
                if ('default_me' in answer) W.settings_default_me = answer.default_me || ''
                W.settings_default_all = answer.default_variant || ''
                if (W.record?.id === mainId && W.record.doc) {
                    if (answer.default_variant) W.record.doc.default_variant = answer.default_variant
                    else delete W.record.doc.default_variant
                }
                if (W.variant_main) W.variant_main.default_variant = answer.default_variant || ''
                try { this.settingsList_rebuild() } catch (e) { /* панель могла закрыться */ }
            })
        },
        settingsList_toggleMy() {
            this.settingsListMy = !this.settingsListMy
            for (const a of this.settingsList_attrs()) {
                const b = a.groupMenu?.commandPanel?.find(x => x.name === 'sl-my')
                if (b) b.active = this.settingsListMy
            }
            this.settingsList_rebuild()
        },
        settingsList_toggleHidden() {
            this.settingsListHidden = !this.settingsListHidden
            for (const a of this.settingsList_attrs()) {
                const b = a.groupMenu?.commandPanel?.find(x => x.name === 'sl-hidden')
                if (b) b.active = this.settingsListHidden
            }
            this.settingsList_rebuild()
        },
        settingsList_openList() {
            this.showDropdown = false
            // IE 2026 08 20 (заказ Игоря): открыть с иерархией Parent и сортировкой
            // order, title — как в дереве настроек
            const action = { 'command': 'onShowInList__Click', 'viewAccess': 'access-extraView', settings_tree_view: true }
            // IE 2026 08 20 (заказ Игоря): отбор «только текущее дерево» — корень
            // дерева текущей настройки; отключается снятием чипса в списке
            const root = this.WIDGET.parents_tree?.[0]
            if (root?.id) action.tree_root = { id: root.id, title: root.title || root.id }
            if (this.store.checkAccess(action, this.WIDGET)) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + WIDGET — архив прячет запись только у данных модели (ревью #110599)
                this.store.executeStoreMethod(this.WIDGET.vueObj, action)
            }
        },
        settingsList_resetView() {
            // IE 2026 08 19 (заказ Игоря): сброс вида списка настроек к дефолту —
            // дерево по родителю, все настройки, без тег-фильтров и «скрытых»
            this.settingsListMy = false
            this.settingsListHidden = false
            this.settingsListDetails = false
            this.settingsList_applyDetailCols()
            for (const a of this.settingsList_attrs()) { // IE 2026 09 04 / ODOO-336331: оба списка
                for (const nm of ['sl-my', 'sl-hidden', 'sl-details']) {
                    const b = a.groupMenu?.commandPanel?.find(x => x.name === nm)
                    if (b) b.active = false
                }
            }
            for (const nm of ['settings-list', 'variants-list']) {
                this.store.set_value(this.WIDGET.record, `doc.viewParams.${nm}.CHIPS`, [
                    { segment: 'CHIP-Tree', title: this.t('Parent'), meta: { use: true, pi: 'pi-sitemap' },   // IE 2026 09 23 / ODOO-341407: i18n (groupDescriptions — данные чипса, не переводятся)
                        doc: { groupDescriptions: [{ title: 'Parent', binding: 'parent' }] } },
                ], null, null, null, false)
            }
            this.settingsList_rebuild()
        },
        canArchive_treeNode(item) {
            const node = item._node
            if (!node || node.meta?.predefined || node.predefined) return false
            return this.store.checkAccess({ viewAccess: 'access-admin' })
        },
        onDropdownTabItemArchive(item) {
            const node = item._node
            if (!node?.id) return
            const title = item.node?.valueStr || node.title || ''
            if (!confirm(this.t('Archive "{title}"? Child settings will be moved up one level', { title }))) return   // IE 2026 09 23 / ODOO-341407: i18n
            this.showDropdown = false
            this.store.archive_settingsTreeNode(this.WIDGET.vueObj || this, node)
        },
        canDrag_treeNode(item) {
            return this.canArchive_treeNode(item) // те же права: админ, не predefined
        },
        _treeNode_contains(node, id) {
            for (const child of node.attrs || []) {
                if (child.id === id || this._treeNode_contains(child, id)) return true
            }
            return false
        },
        onTreeNode_dragStart(item, event) {
            this.treeDrag.srcNode = item._node
            event.dataTransfer.effectAllowed = 'move'
            event.dataTransfer.setData('text/plain', item._node?.title || '')
        },
        onTreeNode_dragOver(item, event) {
            const src = this.treeDrag.srcNode
            const target = item._node
            // нельзя дропнуть на себя или внутрь своего поддерева
            if (!src || !target?.id || target.id === src.id || this._treeNode_contains(src, target.id)) {
                this.treeDrag.overId = null
                return
            }
            const rect = event.currentTarget.getBoundingClientRect()
            const ratio = (event.clientY - rect.top) / rect.height
            this.treeDrag.overId = target.id
            this.treeDrag.position = ratio < 0.25 ? 'before' : ratio > 0.75 ? 'after' : 'inside'
            event.preventDefault()
            event.dataTransfer.dropEffect = 'move'
        },
        onTreeNode_dragLeave(item, event) {
            if (event.currentTarget.contains(event.relatedTarget)) return
            if (item._node?.id === this.treeDrag.overId) this.treeDrag.overId = null
        },
        onTreeNode_drop(item, event) {
            event.preventDefault()
            const src = this.treeDrag.srcNode
            const target = item._node
            const position = target?.id && target.id === this.treeDrag.overId ? this.treeDrag.position : null
            this.onTreeNode_dragEnd()
            if (!src || !position) return
            this.store.move_settingsTreeNode(this.WIDGET.vueObj || this, src, target, position)
        },
        onTreeNode_dragEnd() {
            this.treeDrag.srcNode = null
            this.treeDrag.overId = null
            this.treeDrag.position = null
        },
        treeDropClass(item) {
            if (!this.treeDrag.srcNode || !item._node || item._node.id !== this.treeDrag.overId) return ''
            return 'tree-drop-' + this.treeDrag.position
        },
        resolveDropdownItemTitle(item) {
            if (item.attr_type === 'CHIP-Where') return item.leftValue?.valueStr || ''
            if (item.attr_type === 'CHIP-Param') return item.attr?.title || ''
            if (item.attr_type === 'CHIP-Node') return item.node?.valueStr || ''
            if (item.attr_type === 'CHIP-Action') return item.action?.title || ''
            return item.title || ''
        },
        resolveDropdownItemHTML(item) {
            return this._resolveTitle(item, item.attr_type).html
        },
        _resolveTitle(chip, attr_type) {
            if (attr_type === 'CHIP-Where') {
                const leftStr = chip.leftValue?.valueStr || ''
                const leftHTML = this._formatAttrValueHTML(chip.leftValue) || leftStr
                const condition = chip.condition || ''
                if (chip.attrs?.length) {
                    const values = chip.attrs.map(row =>
                        row.rightValue?.valueStr || row.rightValue?.value || ''
                    ).filter(Boolean)
                    const valuesHTML = chip.attrs.map(row =>
                        this._formatAttrValueHTML(row.rightValue) || row.rightValue?.valueStr || row.rightValue?.value || ''
                    ).filter(Boolean)
                    const count = chip.attrs.length
                    const maxVisible = 2
                    if (values.length) {
                        const rest = values.length - maxVisible
                        const rightText = rest > 0
                            ? values.slice(0, maxVisible).join(', ') + ` +${rest}`
                            : values.join(', ')
                        const text = count > 1
                            ? `${leftStr} (${count}): ${rightText}`
                            : `${leftStr}: ${rightText}`
                        const rightHTML = rest > 0
                            ? valuesHTML.slice(0, maxVisible).join(', ') + ` <span class="chip-title-rest">+${rest}</span>`
                            : valuesHTML.join(', ')
                        const html = count > 1
                            ? `<span class="chip-title-left">${leftHTML}</span> <span class="chip-title-count">(${count})</span> ${rightHTML}`
                            : `<span class="chip-title-left">${leftHTML}</span> ${rightHTML}`
                        return { text, html }
                    }
                    const text = `${leftStr} (${count})`
                    const html = `<span class="chip-title-left">${leftHTML}</span> <span class="chip-title-count">(${count})</span>`
                    return { text, html }
                }
                const right = chip.rightValue?.valueStr || ''
                const rightHTML = this._formatAttrValueHTML(chip.rightValue) || right
                const text = right ? `${leftStr} ${condition} ${right}` : leftStr
                const html = right
                    ? `<span class="chip-title-left">${leftHTML}</span> <span class="chip-title-condition">${condition}</span> ${rightHTML}`
                    : `<span class="chip-title-left">${leftHTML}</span>`
                return { text, html }
            }
            if (attr_type === 'CHIP-Param') {
                const title = chip.attr?.title || ''
                const valueStr = chip.attr?.valueStr || chip.attr?.value || ''
                const text = valueStr ? `${title}: ${valueStr}` : title
                const html = `<span class="chip-title-left">${title}</span> ${this._formatAttrValueHTML(chip.attr)}`
                return { text, html }
            }
            if (attr_type === 'CHIP-Node') {
                const valueStr = chip.node?.valueStr || chip.node?.value || ''
                const text = valueStr
                const html = valueStr ? `<span class="chip-title-left">${valueStr}</span>` : ''
                return { text, html }
            }
            if (attr_type === 'CHIP-Action') {
                const title = chip.action?.title || ''
                const pi = chip.action?.pi || ''
                const text = title
                const icon = pi ? `<i class="${pi} mr-1"></i>` : ''
                const html = `${icon}<span class="chip-title-left">${title}</span>`
                return { text, html }
            }
            return { text: '', html: '' }
        },
        _formatAttrValueHTML(attr) {
            if (!attr) return ''
            const valueStr = attr.valueStr || attr.value || ''
            if (!valueStr) return ''
            const attrType = attr.attr_type
            if (attrType === 'AttrLink' && attr.relation_segment) {
                return valueStr
            }
            if (attrType === 'AttrDate') {
                return this.store.formatDateHTML(valueStr, attr.utc_to_local)
            }
            return valueStr
        },
        _resolveChipAttrLinks(chip) {
            if (chip.leftValue?.attr_type === 'AttrLink' && chip.leftValue.relation_segment) {
                this.store.get_valueStr(this, chip.leftValue, chip.leftValue)
            }
            if (chip.rightValue?.attr_type === 'AttrLink' && chip.rightValue.relation_segment) {
                this.store.get_valueStr(this, chip.rightValue, chip.rightValue)
            }
            if (chip.attr?.attr_type === 'AttrLink' && chip.attr.relation_segment) {
                const prev = chip.attr.valueStr
                if (!this.store.get_valueStr(this, chip.attr, chip.attr) && prev) {
                    chip.attr.valueStr = prev
                }
            }
            if (chip.node?.attr_type === 'AttrLink' && chip.node.relation_segment) {
                const prev = chip.node.valueStr
                if (!this.store.get_valueStr(this, chip.node, chip.node) && prev) {
                    chip.node.valueStr = prev
                }
            }
            if (chip.updated_by?.attr_type === 'AttrLink' && chip.updated_by.relation_segment) {
                this.store.get_valueStr(this, chip.updated_by, chip.updated_by)
            }
            if (chip.attrs?.length) {
                for (const row of chip.attrs) {
                    if (row.rightValue?.attr_type === 'AttrLink' && row.rightValue.relation_segment) {
                        this.store.get_valueStr(this, row.rightValue, row.rightValue)
                    }
                    this._resolveChipAttrLinks(row)
                }
            }
            if (chip.attr?.attrs?.length) {
                for (const sub of chip.attr.attrs) {
                    this._resolveChipAttrLinks(sub)
                }
            }
        },
        // МЕТОД, не computed: WIDGET сырой, loading/parents_tree не реактивны
        dropdownTreeLoading() {
            const W = this.WIDGET
            return !W.parents_tree && !!(W.loading || W.firstBackendCheck || W._firstLoading)
        },
        _resolveDropdownAttrLinks() {
            for (const tab of this.dropdownTabs) {
                if (!tab.attrs?.length) continue
                for (const item of tab.attrs) {
                    this._resolveChipAttrLinks(item)
                }
            }
            this.resolveIndex++
        },
        _onDocumentClick(e) {
            if (!this.showDropdown) return
            const dropdown = this.$el.querySelector('.chips-dropdown.widget-settings-dropdown')   // IE 2026 09 23 / ODOO-… (замечание Игоря: в форме ⋯ — те же элементы шапки): именно панель настроек — при бейдже в форме она лежит в .widget-ident-dd после шапки
            const trigger = this.$el.querySelector('.segment-title')
            const triggerBtn = this.$el.querySelector('.btn-widget-dropdown')
            if (dropdown?.contains(e.target) || trigger?.contains(e.target) || triggerBtn?.contains(e.target)) return
            this.showDropdown = false
        },
        print_mvtView_Click(event, action) {
            // кнопка режима мульти-вертикальной таблицы (склейка <-> секции):
            // компоненты регистрируются в WIDGET._mvtObjs по биндингу
            const mvt = this.WIDGET._mvtObjs?.[action?.binding] || this.WIDGET._mvtPrint
            mvt?.mvt_toggleGlued?.()
        },
        print_previewTab_Click() {
            // кнопка печати в заголовке списка/отчёта: переключение на вкладку
            // превью (ленивое заполнение — selectedIndexChanged AttrTabPanel);
            // повторное нажатие возвращает предыдущую вкладку
            const panel = Object.values(this.WIDGET.attrs_vueObj || {}).find(v => v?.tabPanel && ('tabAttrs' in v) && v.tabAttrs)   // IE 2026 09 12 / ODOO-335246 (Igor)
            if (!panel) return
            const idx = panel.tabAttrs.findIndex(t => t?.name === 'tab-print')
            if (idx < 0) return
            if (panel.tabPanel.selectedIndex === idx) {
                const back = this._printTab_prevIndex
                if (back != null && back !== idx) panel.tabPanel.selectedIndex = back
            } else {
                this._printTab_prevIndex = panel.tabPanel.selectedIndex
                panel.tabPanel.selectedIndex = idx
            }
        },
        async attr_loadPyodide() {
            const vueObj = this
            this.store.attr_destroyPyodide(this)

            this.attr_loadPyodide_promise = this.store.attr_loadPyodide(this).then(() => {
                this.attr_loadPyodide_promise = null;
                if (vueObj.WIDGET?.record?._meta?.clone && !vueObj.WIDGET?.record?._meta?.widget__afterClone_done) {
                    vueObj.process_py('widget__afterClone')
                    vueObj.WIDGET.record._meta.widget__afterClone_done = true
                }

                // if (vueObj.WIDGET?.record?._meta?.new && !vueObj.WIDGET?.record?._meta?.widget__afterCreate_done) { << run on backend
                //     vueObj.process_py('widget__afterCreate')
                //     vueObj.WIDGET.record._meta.widget__afterCreate_done = true
                // }
            });
        },
        async process_py(fnName) {
            const store = this.store
            const pyodide = store.pyodide;
            if (!pyodide) return;

            // дождаться инициализации питон-кода для виджета
            if (this.attr_loadPyodide_promise) await this.attr_loadPyodide_promise;

            // если функции нет (не загрузилась/ошибка) — выходим
            if (!this[fnName]) return;

            try {
                // изолированный namespace виджета
                const mod = this._pyMod

                // актуальный контекст в модуль (а не в globals)
                mod.__dict__.set('widget', this.WIDGET?.record || {});
                mod.__dict__.set('WIDGET', this.WIDGET || {});

                // вызов python-функции из модуля виджета
                let result = this[fnName]();

                // если вдруг вернулся PyProxy — конвертируем
                if (result && typeof result.toJs === 'function') {
                    const jsVal = result.toJs();
                    result.destroy?.();
                    result = jsVal;
                }

                // перерисовать грид
                return result;

            } catch (err) {
                console.error(String(err));
                this[fnName] = null;
            }
        },

    },
    computed: {
        // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2): текст карточки вида ячеек — ожидание данных режима / частичный ответ
        cellViewWait_text() {
            const w = this.WIDGET?._cellViewWait
            if (w) return this.t('Computing data for the view {view}…', { view: this.t(cellView_get(w)?.title || w) })
            return this.WIDGET?._cellViewNote ? this.t('Cell view data is partial: the time budget ran out') : ''
        },
        // IE 2026 10 23 / ODOO-348705 (заказ Игоря: иконка чипа карточки элемента виджета списков): выключатель fe.ux.formChipFolderOpen (дефолт ВКЛ; выкл — чип карточки WIDGET-LIST с иконкой сегмента, как раньше)
        // IE 2026 11 01 / ODOO-350449 (заказ Игоря: папка з шестернею для віджета сегмента, відкрита папка для списку): поверх — форма сегмента → ie-ico-segment-meta,
        // виджет списка → pi-folder-open; выключатель fe.ux.segmentMetaIcon (дефолт ВКЛ; выкл — иконки сегмента, как раньше)
        headerChip_pi() { void this.store?._settingsEpoch; return segMeta_headerPi(this.WIDGET, formChip_pi(this.WIDGET, this.store?.setting('fe.ux.formChipFolderOpen', true) !== false), this.segMetaIcon_on()) },   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: папка з шестернею для віджета сегмента, відкрита папка для списку)   // IE 2026 10 23 / ODOO-348705 (заказ Игоря: иконка чипа карточки элемента виджета списков)
        // IE 2026 10 07 / ODOO-5800 (поручение Igor 07.10): выключатель fe.ux.widgetHeaderOverflow (по умолчанию вкл.) — реактивен по эпохе настроек
        hdrOverflowOn() { void this.store?._settingsEpoch; return widgetHeaderOverflow_on(this.store) },
        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p223 заголовок неактивного виджета — на всю ширину шапки): выключатель fe.ux.titleFullWidthInactive (по умолчанию вкл.), правило — utils/widgetTitleFit.js
        titleFullOn() {
            void this.store?._settingsEpoch
            return titleFull_on({ flag: titleFlag_on(this.store, TITLE_FULL_FLAG), hdrOverflow: this.hdrOverflowOn, active: this.isActiveWidget, mainArea: this.isMainArea,
                inForm: this.identInForm, minMode: !!this.WIDGET?.styleWidget?.minMode, mobile: !!this.store?.mobileUi?.on })
        },
        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок — «…» и продолжение по наведению, как в ячейках): выключатель fe.ux.titleEllipsisTail (по умолчанию вкл.)
        titleTailOn() { void this.store?._settingsEpoch; return titleFlag_on(this.store, TITLE_TAIL_FLAG) },
        // IE 2026 09 24 / ODOO-341407: заголовок панели «Widget settings» — локализованный title записи (правило translate: meta.title_{lang} → база)
        settingsPanel_recordTitle() {
            const rec = this.WIDGET?.record
            if (!rec) return ''
            try { return this.store.get_value_localized(rec, 'title') || rec.title || '' } catch (e) { return rec.title || '' }
        },
        // IE 2026 08 28 / ODOO-5800: копия из теста данных — id теста из store (кладёт вотчер AttrChips;
        // прямое чтение record.doc.params здесь давало несбрасываемый кэш computed — цепочка не реактивна)
        refBadge_test() { return this.store.refBadge_by_widget?.[this.WIDGET?.id] || '' },
        // ---- IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита) ----
        adf_diff() {
            void this.adfTick; void this.store?._settingsEpoch
            const d = this.WIDGET?.audit_diff
            return (d && typeof d === 'object' && adf_on((k, v) => this.store.setting(k, v))) ? d : null
        },
        adf_against() { void this.adfTick; return adf_againstOf(this.adf_diff) },
        adf_view() {
            void this.adfTick
            let stored = null
            try { stored = window.localStorage?.getItem(ADF_VIEW_KEY) } catch (e) { stored = null }
            return adf_viewOf(this.adf_diff, stored)
        },
        adf_block() { return this.adf_diff ? adf_block(this.adf_diff, this.adf_against) : null },
        adf_idx() { return this.adf_block ? adf_index(this.adf_block, this.adf_against) : null },
        adf_badge() { return this.adf_block ? adf_status(this.adf_block, this.adf_against) : null },
        adf_targets() { return this.adf_idx?.ok ? this.adf_idx.targets() : [] },
        adf_nav() { void this.adfTick; return adf_navTargets(this.WIDGET?.view, this.adf_targets, this.adf_langs()) },   // IE 2026 10 31 / ODOO-349799: достижимые цели ‹ › и число целей вне формы
        adf_entries() { return (this.adf_idx?.ok && this.adf_view === 'full') ? this.adf_idx.entries() : [] },
        // строка «с какой версией»: id строки журнала, когда, кто (поля бэка other_* или prev_* / next_*)
        adf_otherInfo() {
            const b = this.adf_block
            if (!b || typeof b !== 'object') return ''
            const side = this.adf_against
            const id = b.other_audit_id ?? b[side + '_audit_id']
            const at = b.changed_at ?? b[side + '_updated_at']
            const by = b.changed_by ?? b[side + '_updated_by']
            if (id == null && !at && !b.other_live) return ''
            const head = side === 'next' ? this.t('Next version') : this.t('Previous version')
            const ref = b.other_live ? ' (' + this.t('current record') + ')' : (id != null ? ' [' + id + ']' : '')
            const who = [at, by].filter(Boolean).map(x => adf_valueText(x)).join(' · ')
            return head + ref + (who ? ' · ' + this.t('changed {who}', { who }) : '')
        },
        adf_viewItems() {
            return [{ id: 'badges', title: this.t('Mark changes'), icon: 'pi-flag' }, { id: 'diff', title: this.t('Differences only'), icon: 'pi-filter' },
                { id: 'full', title: this.t('Full comparison'), icon: 'pi-arrow-right-arrow-left' }]
        },
        adf_againstItems() {
            return [{ id: 'next', title: this.t('Next version (what this event changed)') }, { id: 'prev', title: this.t('Previous version') }]
        },
        // меню режимов уже пришло с бэка (AttrMenu с executeVueObjMethod 'auditDiff_setView') — своё не рисуем
        adf_beMenu() {
            if (!this.adf_diff) return false
            const seen = new Set()
            const walk = (a, depth) => {
                if (!a || typeof a !== 'object' || depth > 5 || seen.has(a)) return false
                seen.add(a)
                if (Array.isArray(a)) return a.some(x => walk(x, depth + 1))
                if (a.method === 'auditDiff_setView') return true
                return walk(a.attrs, depth + 1) || walk(a.items, depth + 1)
            }
            return walk(this.WIDGET?.groupMenu?.commandPanel, 0)
        },
        refBadge_info() {
            if (!this.refHover) return {} // зависимость от refHover: пересчёт при каждом открытии панели
            const rec = this.WIDGET?.record
            const rb = rec?._doc?.reference_badge
            if (rb) return rb
            const info = rec?.doc?._compare_info || this.WIDGET?._cmpInfo_keep || {}
            return { test_title: info.reference_title, saved_at: info.reference_saved_at }
        },
        // IE 2026 08 20 / ODOO-5512 (заказ Игоря): табы ВИДА для ховер-оверлея
        // при скрытой строке табов (styleWidget.hideTabs) — первый контейнер
        // вкладок (AttrTabPanel/AttrTabGrid) из view виджета
        // IE 2026 08 27 / ODOO-5800 (заказ Игоря): зона-граница есть только когда табы
        // скрыты и есть что показать (те же условия, что в tabsHover_show); на телефоне
        // hover нет — зоны нет

        // IE 2026 09 14 / ODOO-… (замечание Игоря: парящий заголовок): режим островков — явный флаг viewParams.floatHeader; без него — карта без полосы табов
        // IE 2026 09 15 / ODOO-… (заказ Игоря): чекбокс селектора экземпляра тиража — значения строки-источника (поля selector_set
        // списка-источника, иначе первое поле) в глобальном селекторе стола: on = все значения уже в строке селектора
        floatHeaderOn() {
            const sw = this.WIDGET?.styleWidget || {}
            return sw.floatHeader ?? !!(this.WIDGET?._geomap && sw.hideTabs)
        },
        // IE 2026 09 22 / ODOO-5800 (поправка Игоря): бейдж сегмента + тайтл в первом ряду формы «⋯» — когда шапка скрыта (иначе они и так в шапке)
        topLeftIdent() {
            const sw = this.WIDGET?.styleWidget
            return !!(sw && sw.hideHeader && !sw.show_hidden && !this.store.mobileUi?.on && this.store.setting('fe.ux.topLeftIdent', true) !== false)
        },
        // IE 2026 09 23 / ODOO-… (замечание Игоря: в форме ⋯ — те же элементы шапки): бейдж и заголовок нужны в форме — шапка скрыта и форма «⋯» открыта; сам телепорт (identInForm)
        // включается тиком позже (watch identWant), когда слот уже в DOM. Id слота и цели панели — по номеру открытия
        identWant() { return this.topLeftIdent && this.show_commandPanel_topLeft },
        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета): облегчённая форма угла (десктоп, fe.ux.widgetCornerMenuLite не выключен) — ряд частых команд; кнопка «Налаштування й варіанти» — при выборе настроек / вариантов
        cornerLite() { return cornerMenuLite_on(this.store) },
        cornerLiteHead() { return this.cornerLite ? cornerRow(this.commandPanel_topLeft1, this.commandPanel_Scale) : [] },
        cornerVariantsOn() { return this.cornerLite && cornerVariants_on(this.dropdownApplies, this.dropdownTabs?.length) },
        identSlotId() { return 'wti-' + String(this.widget_id).replace(/[^A-Za-z0-9_-]/g, '_') + '-' + this.identEpoch },
        identDdId() { return 'wtid-' + String(this.widget_id).replace(/[^A-Za-z0-9_-]/g, '_') + '-' + this.identEpoch },
        // пока телепорт выключен, цель — body: она есть при монтировании (иначе dev-предупреждение Vue «Failed to locate Teleport target» на каждый
        // виджет); настоящая цель подставляется в том же рендере, что и включение, — Vue ищет её в этот момент (ветка «target changed»)
        identTo() { return this.identInForm ? '#' + this.identSlotId : 'body' },
        identDdTo() { return this.identInForm ? '#' + this.identDdId : 'body' },
        // IE 2026 09 15 / ODOO-… (замечание Игоря): ⋯-форма в Float — под островком заголовка (topLeftForm_place)
        topLeftFormStyle() {
            if (this.topLeftTop == null && this.topLeftLeft == null) return null
            const st = {}
            if (this.topLeftTop != null) st.top = this.topLeftTop + 'px'
            if (this.topLeftLeft != null) st.left = this.topLeftLeft + 'px'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета)
            return st
        },
        // островок заголовка — по ширине текста (замер titleFit_measure), а не на всю рамку
        titleFitStyle() {
            // IE 2026 09 23 / ODOO-… (замечание Игоря: в форме ⋯ — те же элементы шапки): поле заголовка в слоте формы — по ширине текста, ужимается «…» вместе со слотом
            if (this.identInForm) return this.titleFitWidth ? { width: this.titleFitWidth + 'px', flexGrow: 0, flexShrink: 1, minWidth: '0' } : ''
            const stopMax = this.stopClearMax != null ? this.stopClearMax + 'px' : null   // IE 2026 09 28 / ODOO-341407: пока виден Stop — заголовок до панели кнопок (stopClear_measure)
            if (!this.floatHeaderOn || this.WIDGET?.styleWidget?.minMode || !this.titleFitWidth) return stopMax ? { maxWidth: stopMax } : ''   // IE 2026 09 28 / ODOO-341407
            // IE 2026 09 15 (замечание Игоря, вечер): на вкладке визуализации островок легенды стоит в строке заголовка — заголовок уступает ему место («…»)
            // IE 2026 09 27 / ODOO-341407: предел — по замеру островка кнопок (vizTitle_measure), !important — и при наведении заголовок не заходит на кнопки
            // (полный текст — в подсказке поля; в правке заголовка — раскрывается по наведению, как раньше); без замера — прежний запас 200px
            const vizMax = this.vizTitleMax != null ? this.vizTitleMax + 'px' + (this.isEditingHeader ? '' : ' !important') : 'calc(100% - 200px)'   // IE 2026 09 27 / ODOO-341407
            return { width: this.titleFitWidth + 'px', flexGrow: 0, flexShrink: 1, maxWidth: this.vizTab ? vizMax : (stopMax ? 'min(calc(100% - 8px), ' + stopMax + ')' : 'calc(100% - 8px)') }   // IE 2026 09 27 / ODOO-341407: vizMax; IE 2026 09 28 / ODOO-341407: stopMax
        },
        hoverViewTabs() {
            void this.resolveIndex
            const containers = []
            const walk = (arr) => {
                for (const a of arr || []) {
                    if (!a || typeof a !== 'object') continue
                    if ((a.attrs || []).some(x => x?.attr_type === 'AttrTab')) containers.push(a)
                    else if (a.attrs) walk(a.attrs)
                }
            }
            const view = this.WIDGET?.view
            walk(Array.isArray(view) ? view : view?.attrs || [])
            const g = containers[0]
            if (!g) return []
            // вложенный AttrTabPanel (напр. tab-settings с под-табами CODE/
            // CORRECTIONS/...) — тоже таб строки (заказ Игоря 20.08)
            const tabs = (g.attrs || []).filter(a =>
                (a?.attr_type === 'AttrTab' || a?.attr_type === 'AttrTabPanel') && a.use !== false)
            const sel = g.selectedIndex ?? 0
            return tabs.map((t) => ({
                title: t.title || t.tooltip || t.name || '',
                tooltip: t.tooltip || '',
                pi: t.pi || 'pi pi-stop',
                binding: t.binding || t.name,
                active: (g.attrs || []).indexOf(t) === sel,
                // IE 2026 08 20 (заказ Игоря): бейджи как у строки табов
                // (AttrTabPanel: attrTab.countItems + hide-countItems)
                count: (t.countItems && !t['hide-countItems'])
                    ? (this.store?.formatCount ? this.store.formatCount(t.countItems) : t.countItems) : '',
            })).filter(t => t.binding)
        },
        dropdownTabs() {
            void this.resolveIndex
            const currentId = this.WIDGET.record?.id
            const flattenTree = (nodes, depth, result) => {
                for (const node of nodes) {
                    if (!node._updated_by) {
                        node._updated_by = { value: node.updated_by, attr_type: 'AttrLink', relation_segment: 'USER' }
                    }
                    result.push({
                        attr_type: 'CHIP-Node',
                        isCurrent: node.id === currentId,
                        depth,
                        _node: node,
                        node: { value: node.id, valueStr: node.title, segment: node.segment },
                        updated_by: node._updated_by,
                        updated_at: { value: node.updated_at, attr_type: 'AttrDate', utc_to_local: true },
                    })
                    if (node.attrs?.length) {
                        flattenTree(node.attrs, depth + 1, result)
                    }
                }
                return result
            }
            // IE 2026 09 04 / ODOO-336331 (заказ Игоря): тумблер Settings | Variants — одна из двух вкладок
            const _mode = this.settingsPanelMode
            const _tabs = this.dropdown_data.filter(tab => tab.name === 'variants_tree' ? _mode === 'variants'
                : tab.name === 'parents_tree' ? _mode !== 'variants' : true)
            return _tabs.map(tab => {
                // parents_tree: populate from WIDGET.parents_tree
                if (tab.name === 'parents_tree' && this.WIDGET.parents_tree?.length) {
                    const treeAttrs = flattenTree(this.WIDGET.parents_tree, 0, [])
                    const staticAttrs = (tab.attrs || []).map(item => {
                        if (!item.attr_type && tab.default_segment) return { ...item, attr_type: tab.default_segment }
                        return item
                    })
                    return { ...tab, attrs: [...treeAttrs, ...staticAttrs] }
                }
                if (!tab.default_segment || !tab.attrs?.length) return tab
                const attrs = tab.attrs.map(item => {
                    if (!item.attr_type) return { ...item, attr_type: tab.default_segment }
                    return item
                })
                return { ...tab, attrs }
            })
        },
        // IE 2026 09 08 / ODOO-335246 (Igor): панель настроек (Settings tree / Variants / Favorites) имеет смысл у виджетов
        // (записи WIDGET-*: отчёты, списки, графики …) и у записей, для которых бэк прислал дерево настроек / вариантов
        dropdownApplies() {
            // только виджеты: у задач/сегментов бэк тоже присылает дерево настроек стола, но панель там не нужна (Igor 08.09)
            const seg = String(this.WIDGET?.record?.segment || this.WIDGET?.segment || '')
            return seg.startsWith('WIDGET')
        },
        // IE 2026 09 10 / ODOO-… (заказ Игоря): индикатор каскада в чипе сегмента (шапка виджета, верхний левый угол) — тот же
        // механизм, что бейдж вкладки «Calculation cascade» (AttrTabPanel: badgeBinding / badgeStateBinding): бэк кладёт в запись
        // формы _doc.cascade_badge = 'on' (флаг Use in calculation cascade у самой записи или её источники под каскадом) и
        // _doc.cascade_badge_state = 'dirty' (на источниках / под записью есть грязные узлы), обновляет онлайн
        // (cascade_state_refresh → updateDoc). Вторая визуализация того же состояния: белая пилюля с иконкой каскада,
        // жёлто-коричневая при грязных узлах; подсказка — тексты вкладки (badgeTitle / badgeDirtyTitle), если вкладка есть
        cascadeInd() {
            const rec = this.WIDGET?.record
            if (!rec) return { on: false, dirty: false, title: '' }
            let badge = '', state = ''
            try { badge = this.store.get_value(rec, '_doc.cascade_badge'); state = this.store.get_value(rec, '_doc.cascade_badge_state') } catch (e) { /* записи нет */ }
            const dirty = state === 'dirty'
            const on = !!badge || dirty
            if (!on) return { on, dirty, title: '' }
            const tab = this.cascadeInd_tab()
            const title = dirty   // IE 2026 09 23 / ODOO-341407: i18n
                ? (tab?.badgeDirtyTitle || this.t('Calculation cascade: dirty nodes in the sources — the data may be stale'))
                : (tab?.badgeTitle || this.t('Takes part in the calculation cascade: Use in calculation cascade is on, or the sources are under the cascade'))
            return { on, dirty, title }
        },
        // IE 2026 10 07 / ODOO-335246 (Igor): показывать ли жёлтую плашку cascade_stale_sources под заголовком (по умолчанию — нет: хватает индикатора каскада в шапке)
        cascadeBannerOn() {
            try { void this.store?._settingsEpoch; return this.store.setting('fe.ux.cascadeStaleBanner', false) === true } catch (e) { return false }   // IE 2026 10 07 / ODOO-335246
        },
        // IE 2026 10 07 / ODOO-335246: текст уведомления cascade_stale_sources, если оно сейчас в виджете ('' — другое уведомление / нет)
        cascadeStaleNtfText() {
            const n = this.WIDGET?.notification   // IE 2026 10 07 / ODOO-335246
            return n && n.code === 'cascade_stale_sources' ? String(n.text ?? '') : ''   // IE 2026 10 07 / ODOO-335246
        },
        isDataSourceRecord() {
            return String(this.WIDGET?.record?.segment || '').startsWith('DATA-SOURCE')
        },
        mvMode() {
            return !!this.WIDGET?.record?.doc?.params?.mv_create
        },
        isReadOnly() {
            return this.WIDGET.isReadOnly||false // TODO WIDGET.isReadOnly
        },
        isActiveWidget() {
            return this.store.activeWIDGET === this.WIDGET
        },
        // IE 2026 08 23 (заказ Игоря): единственный виджет АКТИВНОЙ страницы —
        // карточка на весь экран (страничная проверка отсекает скрытые v-show
        // виджеты других страниц: класс носит только виджет текущего экрана)
        mobOnlyCardFull() {
            return this.store.mobileUi?.on && this.isOnlyWidgetOnPage
                && this.WIDGET?.page === this.store.activeWORKSPACE?.activePAGE?.page
        },
        isOnlyWidgetOnPage() {
            const ws = this.WIDGET?.workspace
            const pg = this.WIDGET?.page
            if (!ws || !pg) return false
            return (this.store.WORKSPACES[ws]?.ALL_WIDGETS ?? [])
                .filter(w => w.page === pg && !w._softClosed && !w.close).length === 1
        },
        navRecord() {
            const W = this.WIDGET
            if (W._nav?.siblings?.length) {
                const nav = W._nav
                return { show: true, canPrev: nav.currentIndex > 0, canNext: nav.currentIndex < nav.siblings.length - 1 }
            }
            if (W.widget === 'widget-row' && W.record?._meta?.type === 'widget-row') {
                const meta = W.record._meta
                const parentWIDGET = this.store.findWidget(W.parentWIDGET?.id)?.WIDGET
                if (!parentWIDGET?.vueObj) return { show: false }
                const flex = parentWIDGET.vueObj.get_flex(meta.binding)
                if (!flex?.rows?.length) return { show: false }
                // плоская позиция по flex.rows (как в navigate_record): полный iroot, без учёта иерархии
                const currentItem = this.store.get_widgetRow_currentItem(meta, parentWIDGET)
                if (!currentItem) return { show: false }
                const rows = flex.rows
                const currentIdx = rows.findIndex(r => r.dataItem === currentItem)
                if (currentIdx < 0) return { show: false }
                const hasNav = (delta) => {
                    for (let i = currentIdx + delta; i >= 0 && i < rows.length; i += delta) {
                        if (rows[i].dataItem && rows[i].isVisible) return true
                    }
                    return false
                }
                return { show: true, canPrev: hasNav(-1), canNext: hasNav(1) }
            }
            return { show: false }
        },
        isLoading() {
            return this.WIDGET.loading || this.WIDGET.firstBackendCheck;
        },
        // isMainArea() {
        //     return this.WIDGET.area === 'main-area'
        // },
    },
    watch: {
        // IE 2026 09 11 (Igor): зелёное/жёлтое сообщение виджета (обновление данных) гаснет само через 8 с;
        // error/critical/pending — остаются до крестика
        'WIDGET.notification': { deep: true, handler(n) { this.notificationAutoHide(n) } },
        cascadeStaleNtfText: { immediate: true, handler(v) { if (v) this.cascadeStaleLast = v } },   // IE 2026 10 07 / ODOO-335246 (Igor): запомнить текст — плашка может погаснуть / смениться другим уведомлением
        // IE 2026 08 23: заголовок сменился (ответ бэка/правка) — перемерить отступ
        'WIDGET.title'() { this.$nextTick(() => { this.mobTitleInsetCheck(); this.titleFit_measure() }) },   // IE 2026 09 14 / ODOO-… (замечание Игоря: парящий заголовок): и островок заголовка
        floatHeaderOn() { this.$nextTick(() => { this.titleFit_measure(); this.floatPad_check() }) },   // IE 2026 09 14 / ODOO-… (замечание Игоря: парящий заголовок)
        'WIDGET.styleWidget.hideTabs'() { this.$nextTick(() => this.floatPad_check()) },   // IE 2026 09 14 / ODOO-… (замечание Игоря: Float — кнопки содержимого ниже островков)
        // IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: активация виджета — обновить
        // контекст viz-кнопки и применить мобильное скрытие номеров к его гридам
        isActiveWidget(v) {
            if (!this.store.mobileUi?.on) return
            if (!v) {
                // IE 2026 08 21 (замечание Игоря 22:20): виджет потерял активность —
                // его панель команд грида и лист табов закрываются
                this.mobileBarOpen = false
                this.mobileTabsOpen = false
                return
            }
            this.$nextTick(() => { this.mobileVizRefresh(); this.applyMobileGridHeads(); this.mobTitleInsetCheck(); this.mobileBarRefresh() }) // IE 2026 09 04 / ODOO-336291 (mobile UX): B-33
        },
        mobileBarOpen(v) { this.mobileBarOutside_sync(!!v) }, // IE 2026 09 04 / ODOO-336291 (mobile UX): B-04 — слушатель тапа снаружи
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-33 — панель команд грида появляется после ответа бэка; B-15 — низ панели управления → --mob-panel-b
        'WIDGET.loading'(v) {
            // IE 2026 09 15 (замечание Игоря, вечер): холст визуализации появляется после загрузки данных — режим viz-вкладки (кнопки шапки,
            // островок легенды) пересчитать по завершении загрузки, а не только по наведению
            if (!arguments[0]) { this.$nextTick(() => this.floatPad_check()); setTimeout(() => this.floatPad_check(), 900); setTimeout(() => this.floatPad_check(), 2500) } if (!v && this.store.mobileUi?.on && this.isActiveWidget) this.$nextTick(() => this.mobileBarRefresh()) },
        // IE 2026 10 25 / ODOO-345044 (hotfix: ✕ под курсором после ховера угла): момент открытия формы — для взвода (topLeftArm_guard); закрыта — сброс
        show_commandPanel_topLeft(v) { this._tlOpenedAt = v ? Date.now() : null; this._tlArmDown = false; cornerFormGuard.sync(this, v); if (this.store.mobileUi?.on) this.$nextTick(() => this.mobPanelSync()); if (!v) { this.cornerPct = false; this.cornerCtx_drop() } else { cornerMenuStats.rowOpened++; this.cornerLite_place() } },   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета): закрытая форма открывается снова одним рядом; IE 2026 09 28 / ODOO-… (замечание Игоря: зависает меню угла виджета): открытая форма — под присмотром стража (закрыть, когда курсор ушёл из зоны, открылась панель-меню, окно потеряло фокус …)
        // IE 2026 09 23 / ODOO-… (замечание Игоря: в форме ⋯ — те же элементы шапки): телепорт бейджа и заголовка в форму включается ПОСЛЕ того, как форма (и слот в ней)
        // отрисована — цель телепорта ищется по id в момент включения; новый id на каждое открытие (identEpoch). Выключается сразу:
        // те же узлы возвращаются в шапку (форма закрыта / шапка показана); панель, открытая из формы, при этом закрывается
        identWant(v) {
            if (!v) { this.identInForm = false; return }
            this.identEpoch++
            this.$nextTick(() => { if (this.identWant && !this.identInForm && document.getElementById(this.identSlotId)) this.identInForm = true })
        },
        identInForm(v) {
            if (!v && this.showDropdown) this.showDropdown = false
            this.$nextTick(() => this.titleFit_measure())   // поле заголовка в слоте — по ширине текста; в шапке — как прежде (Float / нет)
        },
        // IE 2026 08 20 / ODOO-5512 (заказ Игоря): открытый дропдаун выбора
        // настроек не должен перекрываться свободными (popout) виджетами —
        // раз кликнул, работаю с ним. На время открытия поднимаем контейнер
        // виджета-хозяина выше всех popout (их z = popout_baseZ..+N), при
        // закрытии возвращаем: popout переранжирует checkPopout_zIndex,
        // докнутому z снимается.
        showDropdown(open) {
            const store = this.store, W = this.WIDGET
            // IE 2026 08 23: лист настроек как экран-меню — маркер для CSS
            if (store.mobileUi?.on) document.body.classList.toggle('mob-settings-open', !!open)
            // IE 2026 09 04 / ODOO-336331 (заказ Игоря): пока панель открыта — пересчёт размера при ресайзе окна
            if (open) {
                if (!this._sdWinResize) { this._sdWinResize = () => this.settingsPanel_onWinResize(); window.addEventListener('resize', this._sdWinResize) }
            } else if (this._sdWinResize) {
                window.removeEventListener('resize', this._sdWinResize); this._sdWinResize = null
                this._sdUserResized = false
                this._sdNeedSize = null; this.sdSizing = false // IE 2026 09 04 / ODOO-336331
                if (this._sdFallbackTimer) { clearTimeout(this._sdFallbackTimer); this._sdFallbackTimer = null }
            }
            if (!W) return
            if (open) {
                this._dropdownRaisedZ = true
                store.setWIDGET_style(W, { zIndex: (store.popout_baseZ + 200) + '' }, false)
            } else if (this._dropdownRaisedZ) {
                this._dropdownRaisedZ = false
                if (W.styleWidget?.dock === 'popout') {
                    store.checkPopout_zIndex()
                } else {
                    store.setWIDGET_style(W, { zIndex: '' }, false)
                }
            }
        },
        isLoading(newVal) {
            // если загрузка началась, запускаем таймер
            if (newVal) {
                // очистим старый, если был
                clearTimeout(this.loadingTimer);
                    // через полсекунды — включаем класс
                    this.loadingTimer = setTimeout(() => {
                    this.delayedLoading = true;
                }, 500);
            } else {
                // как только загрузка закончилась - сбрасываем всё моментально
                clearTimeout(this.loadingTimer);
                this.delayedLoading = false;
                this._resolveDropdownAttrLinks()
            }
        },
        // 'WIDGET.record._meta.modified'(newVal, oldVal) {
        //     if (!this.store.hide_console) console.log(12)
        // },
        // loading(new_loading, old_loading) {
        //     if (!this.store.hide_console) console.log('change loading')
        //     $('#WIDGET'+this.widget_id)[0].classList.toggle("header_loading")
        // }
    },
}
</script>

<style>
/* IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2): ожидание данных вида ячеек — грид приглушён (прокрутка и группировки работают), карточка поверх без перехвата событий */
.widget-cellview-wait .widget-content .wj-flexgrid { opacity: .55; transition: opacity .15s; }
.cellview-wait-card { position: absolute; left: 50%; top: 45%; transform: translate(-50%, -50%); z-index: 20; pointer-events: none;
    display: inline-flex; align-items: center; gap: 8px; padding: 8px 14px; border-radius: 8px; background: #fff; color: #455a64;
    box-shadow: 0 2px 10px rgba(0, 0, 0, .18); font-size: 13px; white-space: nowrap; max-width: calc(100% - 24px); overflow: hidden; text-overflow: ellipsis; }
.cellview-wait-card.cellview-note { top: auto; bottom: 12px; transform: translateX(-50%); background: #fff8e1; color: #6d4c41; }
.widget-header {
    all: unset;
}
.header_loading {
    background-color: lightyellow;
}
.widget-active {
    font-weight: bold;
}
.widget-border-active {
    outline: 3px solid #9da9f6;
}
/* активный виджет — рамка в тон акценту схемы (classic оставляет индиго) */
body[class*="cscheme-style"] .widget-border-active {
    outline-color: var(--cs-accent);
}
@keyframes animation-widget-flash-border {
    0%   { outline: 3px solid #9da9f6; }
    25%  { outline: 4px solid #647eff; }
    50%  { outline: 3px solid #9da9f6; }
    75%  { outline: 4px solid #647eff; }
    100% { outline: 3px solid #9da9f6; }
}
.widget-border-flash {
    animation: animation-widget-flash-border 0.5s ease-in-out;
}

@keyframes animation-loading-WIDGET-border {
    0% { border-top-color: #42d3926d; }
    45% { border-top-color: #647eff69; }
    100% { border-top-color: #42d3926d; }
}
.widget-loading-border {
    border-top: 7px solid;
    animation-name: animation-loading-WIDGET-border;
    animation-duration: 7s;
    animation-iteration-count: infinite;
    animation-direction: normal;

    position: absolute;
    top: -5px;
    width: 30%;
    height: 5px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    z-index: 0;
    transition: all 0.3s;
    border-radius: 0.5rem;
    left: 25px;
}

.widget-loading {
    animation-name: animation-loading-WIDGET;
    animation-duration: 7s;
    animation-iteration-count: infinite;
    animation-direction: normal;
    /* background-color: #42d3926d; */
}

.widget-content-inactive::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(169, 169, 169, 0.016);
    z-index: 2;
    pointer-events: none;
}
.widget-content-inactive {
    filter: grayscale(50%);
    /* opacity: 0.5; */
}
.widget-text-loading {
    position: absolute;
    margin-left: inherit;
}
/* Стоп-кнопка в шапке: в тон текста «Loading…» (animation-loading-text,
   базовый #647eff), не красная — просьба Игоря 2026-07-28 */
.widget-stop-loading {
    color: #647effa8 !important;
}
.widget-stop-loading:hover {
    color: #647eff !important;
}
/* IE 2026 09 28 / ODOO-341407 (находка ie-demo7 §16.1): пока виден Stop, а панель кнопок вне потока (неактивный / узкий виджет) — заголовок уступает место
   (предел из Widget.stopClear_measure), Stop стоит левее панели; меню ≡ обычной шапки прижато вправо (в Float оно и так margin-left: auto).
   Stop — поверх панели: если места на шапке не хватило (панель шире шапки), он всё равно нажимается */
.widget-container.widget-stop-clear > .widget_menu { margin-left: auto; }
/* IE 2026 09 28 / ODOO-341407 (замечание 3 ревью ie-dm7): когда места нет (панель шире шапки) или узкому виджету оставлен читаемый минимум заголовка
   (utils/stopClear.js, TITLE_READ), Stop на время загрузки закрывает левые кнопки панели — обычно ⇄ (меню сравнения), реже ⟳ Refresh / папку
   (IE 2026 09 28 / ODOO-341407: уточнено по замеру ревью ie-dm7 review_fe3 1.2); это размен
   ради нажимаемого Stop и читаемого заголовка. «Hide empty» и кнопки правее неё не закрываются: предел заголовка — до её левого края */
.widget-container.widget-stop-clear > .widget-stop-loading { z-index: 3; margin-right: 0 !important; }   /* IE 2026 09 28 / ODOO-341407: без поля справа — Stop вплотную к панели: щель рвала наведение на узкую панель (показ по наведению на шапку) */
.widget-text-loading:after {
    position: absolute;

    animation-name: animation-loading-text;
    animation-duration: 7s;
    animation-iteration-count: infinite;
    animation-direction: normal;
    content: "Loading";

    font-family: helvetica, sans-serif;
    font-weight: bold;
    font-size: smaller;
    position: absolute;
    margin-left: 10px;
    
    left: 30px;
    top: -15px;
}
/* R15c (dm 2026 08 04): текст прогресса экспорта — тем же стилем, что Loading..,
   но содержимое из данных (проценты), псевдоэлемент с анимацией глушим */
.widget-text-progress {
    font-family: helvetica, sans-serif;
    font-weight: bold;
    font-size: smaller;
    color: #42d392;
    margin-left: 10px;
    left: 30px;
    top: -15px;
}
.widget-text-progress:after {
    content: none;
    animation-name: none;
}
@keyframes animation-loading-text {
    0% { content: "Loading"; color: #647eff69; }
    15% { content: "Loading."; }
    30% { content: "Loading.."; }
    45% { content: "Loading..."; color: #42d3926d; }
    55% { content: "Loading"; }
    70% { content: "Loading."; }
    85% { content: "Loading.."; }
    100% { content: "Loading..."; color: #647eff69; }
}
@keyframes animation-loading-WIDGET {
    0% { background-color: #42d3926d; }
    45% { background-color: #647eff69; }
    100% { background-color: #42d3926d; }
}
.wj-control {
    border: none;
    color: var(--text-color);
}
.wj-dropdown {
    border: dotted lightgray;
}
.widget_menu .wj-dropdown {
    border: none;
}
.grid-menu .wj-dropdown {
    border: none;
}
/* .wj-control .wj-template {
    display: none !important;
} */
.my_right {
    margin: 0 -0.7rem 0 0;
}
.buttons {
    color: lightslategray;
}
/* IE 2026 08 21 (заказ Игоря): десктопная кнопка разворота в правом верхнем углу */
.widget-max-corner {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    flex: none;
    margin-left: 2px;
    cursor: pointer;
    color: lightslategray;
    border-radius: 4px;
}
.widget-max-corner:hover {
    background-color: #e2e8f0;
    color: #445;
}
/* IE 2026 08 21 (замечание Игоря): кнопка видна только на ховере виджета или у
   активного — на неактивном без мыши не мельтешит; цвет в тон кнопок панели */
.widget-max-corner {
    opacity: 0;
    pointer-events: none;
    transition: opacity .15s;
}
.WIDGET:hover .widget-max-corner,
.widget-max-corner.widget-max-corner-active {
    opacity: 1;
    pointer-events: auto;
}
body[class*="cscheme-style"] .widget-max-corner {
    color: var(--cs-panel-btn);
}
.buttons-inactive {
    color: lightslategray;
}
.buttons-inactive .wj-control {
    color: #8ea0ff !important;
}
.widget-container .wj-menu {
    background: transparent;
}
.widget-container {
    position: relative;
    min-height: 37px;
    color: var(--cs-accent, #647eff);
}
/* IE 2026 09 14 / ODOO-… (замечание Игоря: карта — одно значение, островки; вечер — парящий заголовок как универсальная настройка Float):
   заголовок (слева) и командная панель / меню (справа) лежат островками на прозрачной шапке; при скрытой полосе табов шапка ложится
   поверх содержимого (карта / график под всей рамкой виджета), как легенда и кнопки масштаба у карты внизу */
.WIDGET.widget-float-header > .widget-container {
    background: transparent; border-bottom: none; pointer-events: none;
}
.WIDGET.widget-float-header.widget-hide-tabs > .widget-container {
    /* IE 2026 09 15 (замечание Игоря: островок кнопок графика поверх дерева настроек): шапка — контекст наложения, в ней живёт панель
       настроек (.chips-dropdown, fixed, z 9999) — z шапки выше любых островков и окон содержимого (островки 6…12, легенда графика 20,
       дропдауны чипсов 9999); сама шапка прозрачна и мышь не ловит (pointer-events: none) */
    position: absolute; top: 4px; left: 4px; right: 4px; z-index: 10000; min-height: 0;
}
.WIDGET.widget-float-header > .widget-container > * { pointer-events: auto; }
/* IE 2026 09 15 / ODOO-… (замечание Игоря: угол в Float): островок заголовка начинается правее угла ⋯ (.resizer-top-left: left 5px, 15px) —
   бейдж сегмента не накрывает зону наведения, а ⋯-форма открывается под островком (Widget.topLeftForm_place), её первая строка
   (закрыть / перечитать) — островком, как остальные */
.WIDGET.widget-float-header > .widget-container { padding-left: 18px; }
.WIDGET.widget-float-header .widget-commandPanel-top-left .widget-commandPanel-1 {
    display: inline-block; padding: 2px 4px; margin-bottom: 4px; border-radius: 10px;
    background: rgba(255, 255, 255, 0.86); -webkit-backdrop-filter: blur(4px); backdrop-filter: blur(4px); box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.WIDGET.widget-float-header > .widget-container .widget-header {
    background: rgba(255, 255, 255, 0.86); border-radius: 8px; padding: 0 8px; box-sizing: border-box;
    -webkit-backdrop-filter: blur(4px); backdrop-filter: blur(4px); box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    /* IE 2026 09 16 (замечание Игоря): островки верхней полосы одной высоты, содержимое по центру */
    height: var(--float-island-h, 34px); line-height: calc(var(--float-island-h, 34px) - 4px);
}
.WIDGET.widget-float-header { --float-island-h: 34px; }
.WIDGET.widget-float-header > .widget-container { align-items: center; }
.WIDGET.widget-float-header .widget-commandPanel-top-left .widget-commandPanel-1 { height: var(--float-island-h, 34px); box-sizing: border-box; display: inline-flex; align-items: center; margin-bottom: 0; }
.WIDGET.widget-float-header.widget-hide-tabs:not(.widget-hide-header) .corner-island:not(.corner-island-bl):not(.corner-island-br):not(.ant-flow-player) { height: var(--float-island-h, 34px); box-sizing: border-box; }
/* IE 2026 09 15 / ODOO-… (замечание Игоря): островок заголовка в Float не выходит за рамки виджета — по остатку места, текст «…» */
.WIDGET.widget-float-header > .widget-container { max-width: 100%; box-sizing: border-box; }
.WIDGET.widget-float-header > .widget-container .widget-header { max-width: calc(100% - 54px); min-width: 0; overflow: hidden; }
.WIDGET.widget-float-header > .widget-container .widget-header input { min-width: 0; text-overflow: ellipsis; overflow: hidden; }
/* островок заголовка — по ширине текста (Widget.titleFit_measure), панель кнопок и меню прижаты вправо */
.WIDGET.widget-float-header > .widget-container > .buttons { margin-left: auto; margin-right: 4px; }   /* IE 2026 09 15 / ODOO-…: зазор до островка меню */
.WIDGET.widget-float-header > .widget-container > .widget_menu { margin-left: auto; }
/* IE 2026 09 15 / ODOO-… (замечание Игоря): меню виджета ≡ — всегда в правом верхнем углу. Панель кнопок в потоке (активный широкий
   виджет) стоит слева от меню; панель absolute (неактивный / узкий виджет — показ по наведению, базовый right:30px) — вплотную слева
   от островка меню (right = ширина островка 27 + отступ mr-2 7 + зазор 4). Раньше правило «.buttons ~ .widget_menu { margin-left: 0 }»
   снимало прижим и при absolute-панели: меню висело посреди шапки поверх панели, а панель кончалась за 30px до края */
.WIDGET.widget-float-header > .widget-container > .buttons:not([class*="widget-container-buttons-"]) ~ .widget_menu { margin-left: 0; }
.WIDGET.widget-float-header > .widget-container > .buttons[class*="widget-container-buttons-"] { right: 38px; margin-right: 0; }
.WIDGET.widget-float-header > .widget-container > .buttons,
.WIDGET.widget-float-header > .widget-container > .widget_menu {
    background: rgba(255, 255, 255, 0.86); border-radius: 10px; padding: 0 6px;
    -webkit-backdrop-filter: blur(4px); backdrop-filter: blur(4px); box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    height: var(--float-island-h, 34px); box-sizing: border-box; display: flex; align-items: center;   /* IE 2026 09 16 (замечание Игоря): одна высота, по центру */
}
.WIDGET.widget-float-header.widget-hide-tabs > .widget-content { position: absolute; inset: 0; }
/* IE 2026 09 14 / ODOO-… (замечание Игоря: Float — кнопки содержимого ниже островков): при скрытых табах шапка лежит поверх содержимого — шестерёнки/легенды графика, пузырькового графика, графа, карты и
   TreeMap опускаются под островки (44px), их панели — ниже кнопок; грид/лист/форма (widget-float-pad, Widget.floatPad_check)
   получают отступ сверху, чтобы строка командной панели и заголовки колонок не прятались под шапкой */
/* IE 2026 09 15 / ODOO-… (замечание Игоря, вечер): виджет-список на вкладке визуализации (widget-viz-tab, Widget.floatPad_check):
   кнопки панели команд шапки скрыты; островок легенды / шестерёнки (corner-island верхний правый) — в строке заголовка левее меню ≡;
   островок заголовка режется «…» (inline max-width из titleFitStyle) и раскрывается по наведению поверх островка */
.WIDGET.widget-viz-tab.widget-float-header > .widget-container > .buttons { display: none !important; }
.WIDGET.widget-viz-tab.widget-float-header.widget-hide-tabs:not(.widget-hide-header) .corner-island:not(.corner-island-bl):not(.corner-island-br):not(.ant-flow-player) { top: 6px !important; right: 44px !important; }   /* IE 2026 09 16: в одну линию с островками заголовка и меню (замер: они на +6px) */
/* IE 2026 09 16 (замечание Игоря): на viz-вкладке панель кнопок скрыта — меню ≡ всегда у правого края, и когда панель в потоке (активный виджет) */
.WIDGET.widget-viz-tab.widget-float-header > .widget-container > .buttons ~ .widget_menu { margin-left: auto !important; }
/* IE 2026 09 16 (глюк у Игоря): плеер Flow Map — тоже .corner-island, но живёт слева внизу (bottom/left): правило строки заголовка выше
   давало ему top 5px + right 44px и растягивало островок на весь виджет */
.WIDGET.widget-viz-tab.widget-float-header > .widget-container > input.widget-header { text-overflow: ellipsis; }
.WIDGET.widget-viz-tab.widget-float-header > .widget-container > input.widget-header:hover { max-width: calc(100% - 54px) !important; position: relative; z-index: 2; }
/* IE 2026 09 27 / ODOO-341407 (ревью ie-dm7 #47608): урезанный заголовок раскрывается по наведению плашкой ПОД своим островком — кнопки островка холста
   (легенда, шестерёнка) не накрываются (предел поля — inline !important, см. titleFitStyle); длинный текст переносится в пределах шапки, мышь плашка не ловит */
.WIDGET.widget-viz-tab.widget-float-header > .widget-container > .viz-title-full {
    display: none; position: absolute; top: calc(100% + 4px); width: max-content; height: auto; min-height: 0; line-height: 1.3; padding: 4px 8px;
    white-space: normal; overflow: visible; text-overflow: clip; pointer-events: none; z-index: 3; flex: none;
}
.WIDGET.widget-viz-tab.widget-float-header > .widget-container > input.widget-header:hover + .viz-title-full { display: block; }
/* IE 2026 09 28 / ODOO-341407: бейдж уступил заголовку весь текст (Widget.vizBadgeBare) — остаются иконки и шеврон, текст прячется целиком (visibility: ширина полного текста
   для замера — scrollWidth — остаётся), без обрезка глифа в доле пикселя */
.WIDGET.widget-viz-tab.widget-float-header > .widget-container > .segment-title.viz-badge-bare .segment-title-text { visibility: hidden; }
/* IE 2026 09 15 / ODOO-… (заказ Игоря): угловые кнопки содержимого — островки .corner-island; при скрытых табах — под островками шапки */
/* IE 2026 09 15 / ODOO-… (замечание Игоря): без заголовка виджета (Header выкл.) островки не опускать — парящей шапки над ними нет */
.WIDGET.widget-float-header.widget-hide-tabs:not(.widget-hide-header) .corner-island { top: 48px; }
.WIDGET.widget-float-header.widget-hide-tabs .attr-graph-links { top: 52px; }
.WIDGET.widget-float-header.widget-hide-tabs .attr-geomap-panel,
.WIDGET.widget-float-header.widget-hide-tabs:not(.widget-hide-header) .attr-treemap-panel { top: 80px; }
.WIDGET.widget-float-header.widget-hide-tabs.widget-float-pad:not(.widget-hide-header) > .widget-content { padding-top: 48px; box-sizing: border-box; }
.widget-container-buttons-max-inactive{
    position: absolute;
    right: 30px;
    visibility: hidden;
    text-shadow:
            /* many shadows blur out the area around the text */
            0 0 1px #a9a9a9,
            0 0 2px #a9a9a9,
            0 0 3px #a9a9a9,
            0 0 4px #a9a9a9,
            0 0 5px #a9a9a9,
            0 0 6px #a9a9a9,
            0 0 7px #a9a9a9,
            0 0 8px #a9a9a9,
            0 0 9px #a9a9a9,
            0 0 10px #a9a9a9
}
.widget-container-buttons-min{
    position: absolute;
    right: 30px;
    visibility: hidden;
    text-shadow:
            /* many shadows blur out the area around the text */
            0 0 1px white,
            0 0 2px white,
            0 0 3px white,
            0 0 4px white,
            0 0 5px white,
            0 0 6px white,
            0 0 7px white,
            0 0 8px white,
            0 0 9px white,
            0 0 10px white
}
.widget-container-buttons-min-inactive{
    position: absolute;
    right: 30px;
    visibility: hidden;
    text-shadow:
            /* many shadows blur out the area around the text */
            0 0 1px #a9a9a9,
            0 0 2px #a9a9a9,
            0 0 3px #a9a9a9,
            0 0 4px #a9a9a9,
            0 0 5px #a9a9a9,
            0 0 6px #a9a9a9,
            0 0 7px #a9a9a9,
            0 0 8px #a9a9a9,
            0 0 9px #a9a9a9,
            0 0 10px #a9a9a9
}
.WIDGET:hover .widget-container-buttons-max-inactive{
    visibility: visible;
}
/* IE 2026 08 27 / ODOO-5800 (заказ Игоря): кнопка-меню шапки (хост wj-menu — DIV, напр. ⇄ «варианты
   сравнения» отчёта) наследовала text-shadow-«ореол» (10 серых теней) от .widget-container-buttons-*-inactive
   и выглядела затемнённой; соседние <button> (p-button) ореол не наследуют (UA-стиль text-shadow:none) */
/* IE 2026 10 07 / ODOO-5800 (поручение Igor 07.10): все кнопки панели шапки не поместились (остались только в ≡) — пустой остров панели не рисуется */
.widget-container > .buttons.widget-buttons-none { display: none !important; }
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p223 заголовок неактивного виджета — на всю ширину шапки): у НЕактивного виджета панель кнопок вне потока — у меню ≡ поверх хвоста заголовка (видна по наведению: App.vue .WIDGET:hover .buttons),
   фон непрозрачный — текст заголовка под ней не просвечивает; поле заголовка занимает всю шапку, при наведении его ширина не меняется (Widget.titleFullOn) */
.WIDGET > .widget-container > .buttons.buttons-over-title { position: absolute; top: 0; bottom: 0; right: 30px; z-index: 2; background: #fff; padding-left: 6px; }
.WIDGET.widget-float-header > .widget-container > .buttons.buttons-over-title { right: 38px; top: 50%; bottom: auto; margin-top: calc(var(--float-island-h, 34px) / -2); background: rgba(255, 255, 255, 0.96); }
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок — «…» и продолжение по наведению, как в ячейках): пока над видимой частью заголовка показано его продолжение — панель под ним спрятана (выше / ниже слоя кнопки не торчат); мышь ушла с заголовка — панель снова видна */
.WIDGET > .widget-container > .buttons.buttons-over-title.buttons-under-tail { visibility: hidden; }
/* меню ≡ — у правого края, как при панели в потоке */
.WIDGET > .widget-container > .buttons.buttons-over-title ~ .widget_menu { margin-left: auto; }
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p224 заголовок — «…» и продолжение по наведению, как в ячейках): не поместившийся заголовок — «…» в конце (в правке — обычная прокрутка поля); продолжение по наведению — Widget.titleTail_enter */
.WIDGET .widget-container input.widget-header.title-ellipsis[readonly] { text-overflow: ellipsis; }
.widget-container > .buttons > .hdr-cmd { display: flex; align-items: center; }   /* IE 2026 10 07 / ODOO-5800: обёртка кнопки панели шапки (см. шаблон) */
.widget-container .buttons .commandPanel-buttons-menu {
    text-shadow: none;
}
.widget-container:hover .widget-container-buttons-min{
    visibility: visible;
}
.widget-container:hover .widget-container-buttons-min-inactive{
    visibility: visible;
}
.widget-container:hover .button-more{
    visibility: hidden;
}
.widget_menu {
	display: flex;
    align-items: center;
    z-index: 2;
    padding-left: 5px;
	cursor: pointer;
}
/* IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2): кнопка ≡ панели функций (виджет и таблица) — цвет как у прежнего хоста wj-menu, у неактивного виджета — голубой */
.widget_menu .widget-menu-btn {
    color: var(--text-color);
}
.buttons-inactive .widget-menu-btn {
    color: #8ea0ff !important;
}
.pi-header {
    font-size: 1.3rem;
    font-weight: bold;
    padding-right: 0.3rem;
    padding-left: 0.3rem;
    opacity: 0.75;
}
.pi-header-pi {
    font-weight: bold;
    transform: scaleX(0.9);
}
.widget-hidden {
    /* visibility: hidden; !make flash to bottom */
    /* height: 0; */
    /* виджет целиком не прячем: рамка и шапка видны сразу (пользователь видит,
       что виджет «в работе», + Loading-индикатор); до раскладки скрыто только тело */
    /* transition: opacity 0.1s ease, visibility 0.1s ease; */
}
.widget-hidden .widget-content {
    opacity: 0;
}
/* R10: docked-виджет до применения px раскладкой (calculateWidget_px → _placed)
   рендерится в потоке неспозиционированным — прячем целиком: появится сразу
   на своём месте одним кадром */
.WIDGET.widget-unplaced {
    visibility: hidden;
}
.WIDGET.widget-reveal-pending {
    /* ⚠ ТОЧКА КОНФЛИКТА ДВУХ ЗАДАЧ — менять только осознанно (reveal-tradeoff):
       Задача 1 «анти-моргание» (исходная widget_deferReveal): держать окно
         НЕВИДИМЫМ (opacity:0) до ответа widget_open или widgetReveal_delay,
         чтобы сырой каркас не мигал и не «перескакивал» в рабочий кадр.
       Задача 2 «мгновенный отклик» (перф-оптимизация открытия): рамка+шапка+
         скелетон видны с ПЕРВОГО кадра, пустоты нет.
       Текущее состояние = задача 2, НО анти-моргание НЕ откачено, а решено
       другим слоем: сырое тело скрыто (.widget-first-loading .widget-content
       visibility:hidden) и вместо него CSS-скелетон — «сырой» контент не виден,
       появляется одним кадром уже готовым. Механизм deferReveal (флаги/таймер
       в mainStore.widget_deferReveal) сохранён и снова заработает как полный
       скрыватель, если вернуть здесь opacity:0 — тогда потеряется мгновенный
       отклик. Щит от сквозного клика (задача 8) действует в обоих вариантах:
       видимое окно ловит клики само, невидимому нужен opacity:0 (не visibility).
    */
    opacity: 1;
}
/* Скелетон-полосы чистым CSS (::after) на время загрузки. Нарочно БЕЗ
   собственного DOM/v-if-узла: привязан к платформенным классам
   widget-first-loading / widget-reveal-pending, которые ставятся и снимаются
   штатным циклом (флаги местами пишутся в raw-объект мимо реактивности —
   отдельный v-if-узел на них залипал). Снялся класс → скелетон исчез. */
/* Якорь и слой: .widget-content внутренний контейнер — смена static→relative
   для него безопасна (в раскладке страницы он не участвует). visibility:visible
   на ::after перекрывает visibility:hidden контента в first-loading. */
.widget-first-loading:not(.widget-hidden) .widget-content,
.widget-reveal-pending:not(.widget-hidden) .widget-content {
    position: relative;
}
.widget-first-loading:not(.widget-hidden) .widget-content::after,
.widget-reveal-pending:not(.widget-hidden) .widget-content::after {
    content: '';
    visibility: visible;
    position: absolute;
    top: 6px;
    left: 6px;
    right: 6px;
    bottom: 6px;
    z-index: 1;
    pointer-events: none;
    border-radius: 4px;
    background: repeating-linear-gradient(
        180deg,
        #e9edf2 0px, #e9edf2 13px,
        transparent 13px, transparent 24px
    );
    /* мягкое затухание полос к низу */
    -webkit-mask-image: linear-gradient(180deg, #000 55%, transparent 95%);
    mask-image: linear-gradient(180deg, #000 55%, transparent 95%);
    animation: sk-pulse 1.2s ease-in-out infinite;
}
@keyframes sk-pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.45; }
}
.widget-first-loading .widget-content {
    /* «фриз» до первого ответа бэка: шапка и Loading-индикация видны, тело пустое;
       с приходом данных содержимое появляется одним кадром уже заполненным.
       visibility (не display) — layout и замеры размеров работают */
    visibility: hidden;
}

.widget-visible {
    visibility: visible;
    opacity: 1;
    /* transition: opacity 0.1s ease, visibility 0.1s ease; */
}
.pi-bold {
    font-size: 1.1rem;
    font-weight: bolder;
}
.doc-modified {
    background-color: yellow;
    color: #778899;
    border-radius: 6px;
    border: 1px solid #dddddd;
    padding: 3px 5px;
    font-weight: bold;
    margin-right: 5px;
}
.widget-commandPanel .pi.btn-widget-close {
    background: #ff5f57 !important;
    color: white !important;
    border-radius: 50%;
}
.widget-commandPanel .pi.btn-widget-dropdown {
    background: #8ea0ff !important;
    color: white !important;
    border-radius: 50%;
}

.widget-commandPanel .pi.btn-widget-minimize {
    background: #ffbc2d !important;
    color: white !important;
    border-radius: 50%;
}
.widget-commandPanel .pi.btn-widget-maximaze {
    background: #28cc42 !important;
    color: white !important;
    border-radius: 50%;
}
.widget-commandPanel .btn-hide-header,
.widget-commandPanel .btn-hide-tabs,
.widget-commandPanel .btn-hide-gridpanel {
    background: rgba(40, 204, 67) !important;
    color: white !important;
    border-radius: 4px;
}
.WIDGET.widget-hide-header0 .widget-commandPanel .btn-hide-header,
.WIDGET.widget-hide-tabs0 .widget-commandPanel .btn-hide-tabs,
.WIDGET.widget-hide-gridpanel0 .widget-commandPanel .btn-hide-gridpanel {
    color: rgba(40, 204, 67) !important;
    background: white !important;
    border-radius: 4px;
}
/* IE 2026 09 14 / ODOO-… (замечание Игоря: парящий заголовок): кнопка Float — белая, когда режим выключен, зелёная — когда включён */
.widget-commandPanel .btn-float-header {
    color: rgba(40, 204, 67) !important;
    background: white !important;
    border-radius: 4px;
}
.WIDGET.widget-float-header0 .widget-commandPanel .btn-float-header {
    background: rgba(40, 204, 67) !important;
    color: white !important;
}
/* IE 2026 09 15 / ODOO-… (замечание Игоря): кнопка Free в ⋯-форме — тумблер как Float: белая с зелёным текстом — виджет в сетке страницы,
   зелёная — свободное положение (pop-out) */
.widget-commandPanel .btn-free-widget {
    color: rgba(40, 204, 67) !important;
    background: white !important;
    border-radius: 4px;
}
.widget-commandPanel .btn-free-widget.btn-free-widget-on {
    background: rgba(40, 204, 67) !important;
    color: white !important;
}
.widget-commandPanel .pi.btn-widget-size {
    color: white !important;
    border-radius: 0%;
}

.widget-commandPanel-top-left {
    position: absolute;
    top: 3px;
    left: 3px;
    z-index: 100;
    cursor: pointer;
}
/* IE 2026 11 02 / ODOO-350449 (заказ Игоря: p217 кнопка Σ — річні підсумки за опцією, типово вимкнено): кнопка Σ полосы опций — квадратная, символ суммы вместо иконки primeicons (pi-sigma в primeicons 7 нет) */
.commandPanel-buttons.yt-sigma { width: 31px; min-width: 31px; justify-content: center; padding-left: 0 !important; padding-right: 0 !important; }   /* IE 2026 11 02 / ODOO-350449 (проба dev02 p217: aspect-ratio не сработал — 16 × 31 px): квадрат по высоте кнопок полосы */
.commandPanel-buttons.yt-sigma::before { content: 'Σ'; font-size: 15px; font-weight: 600; line-height: 1; }
.grid-commandPanel-top-right {
    position: absolute;
    right: 30px;
    z-index: 100;
    cursor: pointer;
}
.top-buttons-1 {
    top: 36px;
}
.widget-commandPanel-2 {
    border: 1px dotted lightslategray;
    border-radius: 0.5rem;
    background: rgba(255, 255, 255);
    backdrop-filter: blur(7px);
}
.widget-commandPanel-bottom-right {
    position: absolute;
    bottom: 3px;
    right: 3px;
    z-index: 100;
    cursor: nwse-resize;
}
.widget-commandPanel .pi {
    width: 30px;
    color: lightslategray !important;
    font-size: larger;
    font-weight: bolder;
}
.widget-commandPanel-row {
    display: flex;
    align-items: center;
}
/* IE 2026 09 22 / ODOO-5800 (поправка Игоря): бейдж сегмента + тайтл в первом ряду формы «⋯» при скрытой шапке */
/* IE 2026 09 23 / ODOO-… (замечание Игоря: в форме ⋯ — те же элементы шапки): .widget-topleft-ident — СЛОТ телепорта, в нём стоят САМИ элементы шапки (.segment-title с дропдауном
   и input.widget-header): раскладка бейджа — как у .widget-container > .segment-title, поле заголовка — по тексту (titleFitStyle), при тесноте
   ужимается «…» поле, а не бейдж; правило иконок формы .widget-commandPanel .pi (30px, серый, крупнее, жирнее — для её кнопок) внутри слота снято:
   именно оно вместе с max-width 45 % узкого слота резало бейдж копии до «≡[⌄». :where — та же специфичность (0,2,0), что у правила формы, позже в
   каскаде; правила самих элементов сильнее (0,2,1) остаются, правила в (0,1,0) повторены явно */
.widget-commandPanel-top-left .widget-topleft-ident { display: inline-flex; align-items: center; gap: 8px; margin-left: 6px; padding-right: 8px; min-width: 0; flex: 1 1 auto; max-width: 560px; cursor: auto; }
.widget-commandPanel-top-left .widget-topleft-ident:empty { display: none; }
.widget-commandPanel-top-left .widget-topleft-ident > .segment-title:not(.segment-mode) { display: inline-flex; align-items: center; max-width: 260px; box-sizing: border-box; flex: none; vertical-align: middle; }
.widget-commandPanel-top-left .widget-topleft-ident > .segment-title:not(.segment-mode) .segment-title-text { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.widget-commandPanel-top-left .widget-topleft-ident > .segment-title:not(.segment-mode) .cascade-ind { position: static; top: auto; vertical-align: baseline; flex: none; }
.widget-commandPanel-top-left .widget-topleft-ident > .segment-title:not(.segment-mode) .dropdown-chevron { flex: none; margin-left: 2px; }
.widget-commandPanel-top-left .widget-topleft-ident > .segment-title.segment-mode { flex: none; }
.widget-commandPanel-top-left .widget-topleft-ident :where(.pi) { width: auto; color: inherit !important; font-size: 1rem; font-weight: normal; }   /* 1rem — как .pi темы PrimeVue */
.widget-commandPanel-top-left .widget-topleft-ident :where(.pi-header-pi) { font-weight: bold; }
.widget-commandPanel-top-left .widget-topleft-ident :where(.dropdown-chevron) { font-size: 9px; }
.widget-commandPanel-top-left .widget-topleft-ident :where(.variant-label-pi) { font-size: 11px; }
.widget-commandPanel-top-left .widget-topleft-ident > input.widget-header { flex: 1 1 auto; min-width: 0; max-width: 100%; }
/* в шапке поле заголовка наследует цвет .widget-container (акцент); :where — правило гамм body[class*=cscheme-style] .widget-header (--cs-title) сильнее, как в шапке */
.widget-commandPanel-top-left .widget-topleft-ident > :where(input.widget-header) { color: var(--cs-accent, #647eff); }
/* цель телепорта панели Settings | Variants при бейдже в форме: ниже формы (z 99 < 100) — первый ряд с бейджем накрывает кромку панели, как ярлык в шапке */
.WIDGET > .widget-ident-dd { position: absolute; left: 0; top: 0; width: 0; height: 0; z-index: 99; overflow: visible; }
/* пока панель открыта из формы, прочие ряды формы невидимы (место остаётся): панель лежит под ними и была бы накрыта */
.widget-commandPanel-top-left.ident-dd-open > :not(.widget-commandPanel-1) { visibility: hidden; }
.widget-commandPanel-top-left.ident-dd-open { pointer-events: none; }   /* сама рамка формы мышь не ловит — панель под ней доступна */
.widget-commandPanel-top-left.ident-dd-open > .widget-commandPanel-1 { pointer-events: auto; }
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета): облегчённая форма угла (класс corner-lite, флаг fe.ux.widgetCornerMenuLite) — монохром
   правых верхних кнопок (.widget-corner-btn): кнопка 26 × 26, радиус 6, иконка 13 px, цвет #4b5563, наведение — фон rgba(47, 59, 82, .10), ширина при наведении не меняется;
   «вкл.» (открыта панель настроек, Free) — лёгкая заливка акцента + подчёркивание 2 px; Закрити — красный только при наведении. Цветные круги прежней формы
   (.widget-commandPanel .pi.btn-widget-close …) перебиты специфичностью (0,4,0)+ с !important. Тёмная тема — filter: invert(1) на корне приложения, отдельные цвета не нужны */
.widget-commandPanel-top-left.corner-lite {
    --cl-ink: #4b5563; --cl-ink-h: #111827; --cl-hover: rgba(47, 59, 82, 0.10); --cl-line: #dfe2e8;
    --cl-acc: var(--cs-accent, #647eff); --cl-on: color-mix(in srgb, var(--cl-acc) 14%, transparent);
    background: var(--surface-card, #fff); border: 1px dotted #8f97a3; border-radius: 10px; padding: 3px 4px; box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12); cursor: default;
}
.widget-commandPanel-top-left.corner-lite .widget-commandPanel-1 { min-height: 0; padding-bottom: 0; }
.WIDGET.widget-float-header .widget-commandPanel-top-left.corner-lite .widget-commandPanel-1 { display: block; height: auto; padding: 0; margin: 0; background: transparent; box-shadow: none; -webkit-backdrop-filter: none; backdrop-filter: none; border-radius: 0; }
.widget-commandPanel-top-left.corner-lite .widget-commandPanel-2 { border: 0; border-top: 1px solid var(--cl-line); border-radius: 0; background: transparent; -webkit-backdrop-filter: none; backdrop-filter: none; margin-top: 3px; padding-top: 3px; }
.widget-commandPanel-top-left.corner-lite .corner-lite-row { gap: 2px; min-height: 28px; flex-wrap: nowrap; }
.widget-commandPanel-top-left.corner-lite .p-button.commandPanel-buttons,
.widget-commandPanel-top-left.corner-lite .corner-lite-btn {
    flex: none; box-sizing: border-box; width: 26px; min-width: 26px; height: 26px; padding: 0 !important; margin: 0 !important; border: 0 !important; border-radius: 6px !important;
    background: transparent !important; color: var(--cl-ink) !important; box-shadow: none !important; font-size: 13px !important; font-weight: normal !important;
    display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: background-color 0.12s, color 0.12s;
}
.widget-commandPanel-top-left.corner-lite .corner-lite-btn .pi { width: auto; font-size: 13px; font-weight: normal; color: inherit !important; }
.widget-commandPanel-top-left.corner-lite .p-button.commandPanel-buttons:hover,
.widget-commandPanel-top-left.corner-lite .corner-lite-btn:hover { background: var(--cl-hover) !important; color: var(--cl-ink-h) !important; }
.widget-commandPanel-top-left.corner-lite .p-button.commandPanel-buttons.btn-widget-close.pi-times:hover { background: rgba(178, 59, 59, 0.10) !important; color: #b23b3b !important; }
.widget-commandPanel-top-left.corner-lite .corner-lite-btn.is-on { background: var(--cl-on) !important; color: var(--cl-acc) !important; box-shadow: inset 0 -2px 0 var(--cl-acc) !important; }
/* ряд полей W / H / X / Y и Free (≡ › Розкладка › «Ширина / висота, %…»): Free — текстом, «вкл.» — заливка акцента + подчёркивание (перебивает и зелёный прежней формы, и цвет
   текстовых кнопок темы .opt-chips-theme … :has(> span:not(:empty))) */
.widget-commandPanel-top-left.corner-lite .layout-pct-row { padding: 2px 4px 3px; color: var(--cl-ink); }
.widget-commandPanel-top-left.corner-lite .layout-pct-row input[type="number"] { border-color: var(--cl-line); }
.WIDGET .widget-commandPanel-top-left.corner-lite .layout-pct-row .p-button.p-button-white.commandPanel-buttons.btn-free-widget { width: auto; padding: 0 8px !important; margin-left: 4px !important; font-size: 12px !important; color: var(--cl-ink) !important; }
.WIDGET .widget-commandPanel-top-left.corner-lite .layout-pct-row .p-button.p-button-white.commandPanel-buttons.btn-free-widget.btn-free-widget-on { background: var(--cl-on) !important; color: var(--cl-acc) !important; box-shadow: inset 0 -2px 0 var(--cl-acc) !important; }
.WIDGET .widget-commandPanel-top-left.corner-lite .layout-pct-row .p-button.p-button-white.commandPanel-buttons.btn-free-widget:hover { background: var(--cl-hover) !important; color: var(--cl-ink-h) !important; }
.widget-commandPanel-1 {
    min-height: 28,5px;
    padding-bottom: 5px;
}
.layout-pct-row {
    gap: 4px;
    padding: 3px 6px 5px;
    color: lightslategray;
    font-size: 12px;
}
.layout-pct-row label {
    display: flex;
    align-items: center;
    gap: 2px;
    cursor: default;
}
.layout-pct-row input[type="number"] {
    width: 44px;
    padding: 1px 2px;
    border: 1px solid lightslategray;
    border-radius: 4px;
    color: inherit;
    font-size: inherit;
}
.layout-pct-free {
    margin-left: 2px;
}
.resizer-bottom-right-active {
    position: absolute;
    bottom: 0px;
    right: 0px;
    width: 20px;
    height: 20px;
    background: linear-gradient(
        135deg,
        transparent 50%,
        lightslategray 50%,
        lightslategray 60%,
        transparent 60%
      ),
      linear-gradient(
        135deg,
        transparent 70%,
        lightslategray 70%,
        lightslategray 80%,
        transparent 80%
      );
    background-size: 100% 100%;
    background-repeat: no-repeat;
    cursor: pointer;
    z-index: 99;
}
.resizer-bottom-right {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 20px;
    height: 20px;
    background: linear-gradient(
        135deg,
        transparent 50%,
        #999 50%,
        #999 60%,
        transparent 60%
      ),
      linear-gradient(
        135deg,
        transparent 70%,
        #999 70%,
        #999 80%,
        transparent 80%
      );
    background-size: 100% 100%;
    background-repeat: no-repeat;
    cursor: pointer;
    z-index: 99;
}
/* ⚠ z-index обеих «точек» ОБЯЗАН быть выше .wj-tabheaders (sticky, z-index:100
   с pinnedHeader): при скрытом заголовке (hideHeader) панель вкладок
   поднимается на самый верх виджета и накрывала точки — их не было ни видно,
   ни навести (командная панель и показ скрытого не открывались). */
.resizer-top-left {
    position: absolute;
    top: 3px;
    left: 5px;
    width: 15px;
    height: 30px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    z-index: 102;
    border-top: 3px dotted #9da9f5;
}
.resizer-top-right {
    position: absolute;
    /* точки на одном уровне с resizer-top-left (top:3px + border-top) */
    top: 3px;
    right: 7px;
    width: 15px;
    /*width: calc(100% - 46px);*/
    height: 12px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    z-index: 101;
    border-top: 3px dotted #9da9f5;
    transition: all 0.3s;
}

.resizer-top-left-short {
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    cursor: pointer;
    z-index: 99;
}
.button-1 {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.button-lt {
    position: absolute;
    right: 0px;
    cursor: pointer;
}
/* IE 2026 09 15 / ODOO-… (заказ Игоря): островки угловых кнопок содержимого (шестерёнка / легенда графика, пузырьков, карты, TreeMap,
   парящая шестерёнка графа) — как кнопки масштаба карты: полупрозрачная подложка, рамка, тень; кнопки внутри — в потоке островка */
.corner-island {
    position: absolute; top: 4px; right: 4px; z-index: 10;
    display: inline-flex; align-items: center; gap: 2px; padding: 2px 4px;
    background: rgba(255, 255, 255, 0.86); -webkit-backdrop-filter: blur(4px); backdrop-filter: blur(4px);
    border: 1px solid rgba(47, 59, 82, 0.18); border-radius: 10px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.corner-island > .button-lt, .corner-island > .button-1 { position: static !important; top: auto !important; right: auto !important; left: auto !important; }
/* IE 2026 09 22 / ODOO-5800 (Igor): островок скрытой шапки по наведению на правый верхний угол — сегмент, тайтл, развернуть, показать шапку; в стиле Float */
.widget-corner-island { top: 4px !important; right: 6px !important; z-index: 103 !important; gap: 6px; padding: 2px 6px 2px 4px; height: 30px; box-sizing: border-box; max-width: 70%; background: rgba(255, 255, 255, 0.96); }
.widget-corner-island .widget-corner-seg { display: inline-flex; align-items: center; max-width: 160px; margin: 0; }
.widget-corner-island .widget-corner-seg .segment-title-text { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.widget-corner-island .widget-corner-title { font-weight: 600; font-size: 13px; color: #2f3b52; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 0; }
.widget-corner-island .widget-corner-btn { flex: none; width: 24px; height: 24px; display: inline-flex; align-items: center; justify-content: center; border-radius: 6px; cursor: pointer; color: #4b5563; }
.widget-corner-island .widget-corner-btn:hover { background: rgba(47, 59, 82, 0.1); color: #111827; }
.widget-corner-island .widget-corner-btn .pi { font-size: 13px; }
/* IE 2026 09 15 / ODOO-… (замечание Игоря): островки нижних углов (масштаб пузырькового графика) — не опускаются правилом Float (top: 48px) */
.corner-island.corner-island-bl { top: auto !important; right: auto !important; bottom: 8px; left: 8px; }
.corner-island.corner-island-br { top: auto !important; left: auto !important; bottom: 8px; right: 8px; }
/* IE 2026 09 15 / ODOO-… (заказ Игоря): чекбокс селектора у экземпляра тиража (перед заголовком) */
.multiply-sel { display: inline-flex; align-items: center; margin: 0 2px 0 4px; cursor: pointer; color: var(--cs-accent, #647eff); opacity: 0.7; font-size: 1.05rem; }
.multiply-sel:hover, .multiply-sel-on { opacity: 1; }
.WIDGET.widget-float-header > .widget-container > .multiply-sel { background: rgba(255, 255, 255, 0.86); border-radius: 8px; padding: 4px 6px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); }
/* IE 2026 09 24 / ODOO-341407: глобус «Translations» справа от названия в шапке */
.i18n-globe { display: inline-flex; align-items: center; margin: 0 2px 0 4px; cursor: pointer; color: var(--text-color-secondary, #6c757d); opacity: 0.5; font-size: 0.95rem; flex: none; }
.i18n-globe:hover { opacity: 1; color: var(--cs-accent, #647eff); }
.WIDGET.widget-float-header > .widget-container > .i18n-globe { background: rgba(255, 255, 255, 0.86); border-radius: 8px; padding: 4px 6px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); }

.btnYellow {
    background-color: #ffe7cc !important;
}
.btnHover {
    background-color: #cce7ff !important;
}
.transformUp {
    transform: rotate(180deg);
    direction: rtl;
    writing-mode: vertical-lr;
}
.segment-title {
    font-stretch: ultra-condensed;
    color: white;
    background: #8ea0ff;
    border-radius: 3px;
    cursor: pointer;
}
.dropdown-chevron {
    font-size: 9px;
    opacity: 0.7;
}
/* IE 2026 09 08 / ODOO-335246 (Igor): бейдж без дропдауна (не виджет) — обычный курсор; тумблер DS | MV в шапке DATA-SOURCE */
.segment-title-static { cursor: default; }
/* IE 2026 09 15 / ODOO-… (замечание Игоря): бейдж сегмента — одна строка, не выше обычного, не шире 40 % шапки; длинный текст
   (имя основной настройки варианта, метка расшифровки) режется «…» внутри .segment-title-text, иконки и шеврон остаются */
.widget-container > .segment-title:not(.segment-mode) { display: inline-flex; align-items: center; max-width: 40%; box-sizing: border-box; flex-shrink: 0; vertical-align: middle; }
.widget-container > .segment-title:not(.segment-mode) .segment-title-text { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.widget-container > .segment-title:not(.segment-mode) .cascade-ind { position: static; top: auto; vertical-align: baseline; flex: none; }
.widget-container > .segment-title:not(.segment-mode) .dropdown-chevron { flex: none; margin-left: 2px; }
/* IE 2026 11 01 / ODOO-350449 (заказ Игоря: відступ між іконкою і назвою сегмента в бейджі) — будь-яка іконка бейджа (pi-folder-open, pi-github, шестерня, ie-ico-segment-meta, іконка REPORT2) липла до тексту; статичний відступ 4px (як лівий відступ cascade-ind), без :hover — ширина кнопки не змінюється; cascade-ind після іконки без свого лівого відступу, щоб зазор не подвоївся */
.segment-title > .pi-header-pi { margin-right: 4px; }
.segment-title > .pi-header-pi + .cascade-ind { margin-left: 0; }
/* IE 2026 11 02 / ODOO-350449 (заказ Игоря: p216 бейдж виду віджета — тиха іконка, плашка при наведенні):
   в покое — контурная иконка вида без заливки, текста и стрелки (якорь в потоке, ширина постоянная — наведение её не меняет); списки / источники —
   приглушённый серый, отчёты, задачи, формы, графики — акцент темы. Прежняя плашка — position: absolute поверх якоря (kindIcon_place), видна при наведении
   на шапку (у docked-виджета шапку накрывает полоса-захват .popout-grab-top — её :hover и mouseenter тоже) и при открытой панели настроек;
   название виджета не сдвигается. Выключатель fe.ux.widgetKindBadgeIcon = false — прежняя плашка в потоке */
.widget-container > .kind-badge-ico { display: inline-flex; align-items: center; justify-content: center; vertical-align: middle; width: 1.25rem; min-width: 1.25rem; height: 1.3rem; margin-right: 0.35rem; flex-shrink: 0; position: relative; background: none; border: none; }
.widget-container > .kind-badge-ico > i { font-size: 1rem; line-height: 1; }
.widget-container > .kind-badge-ico-muted { color: var(--text-color-secondary, #8a8f98); }
.widget-container > .kind-badge-ico-accent { color: var(--cs-accent, var(--primary-color, #647eff)); }
.widget-container > .kind-badge-ico-dirty::after { content: ''; position: absolute; right: 0; top: 1px; width: 6px; height: 6px; border-radius: 50%; background: #c98a12; }   /* грязные узлы каскада — точка, как цвет .cascade-ind-dirty */
.widget-container > .segment-title.kind-badge-overlay { position: absolute; z-index: 5; transform: translateY(-50%); visibility: hidden; pointer-events: none; white-space: nowrap; }
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p226 полегшене монохромне меню кута віджета) (поправка Игоря 03.11 «вместо А1»): непрозрачный чипс (fe.ux.kindBadgeOpaque) по наведению на шапку не показывается — только иконка; виден лишь при открытой
   панели Settings | Variants (ярлык панели). Выключатель выкл. — прежняя полупрозрачная плашка поверх якоря по наведению, как было */
.widget-container:hover > .segment-title.kind-badge-overlay:not(.kind-badge-opaque),
.popout-grab-top:hover ~ .widget-container > .segment-title.kind-badge-overlay:not(.kind-badge-opaque),
.widget-container > .segment-title.kind-badge-overlay.segment-title-open { visibility: visible; pointer-events: auto; }
.widget-container > .kind-badge-ico.kind-badge-ico-click { cursor: pointer; }
.widget-container > .segment-title.kind-badge-overlay.segment-title-open { z-index: 10000; }
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p220/p221/p222 шапка віджета): p222 — плашка вида при наведении: непрозрачный монохромный чипс НАД шапкой (низ — на верхней кромке виджета, заходит
   в шапку на 2 px), а не полупрозрачная заливка на начале заголовка (скрин 324: .pi-header opacity .75 + фон акцента поверх текста); сверху места нет —
   под строкой шапки (.kind-badge-below). Текст заголовка не перекрывается: двойной клик по началу заголовка снова попадает в поле (p221).
   Выключатель fe.ux.kindBadgeOpaque = false — прежняя плашка поверх якоря */
.widget-container > .segment-title.kind-badge-overlay.kind-badge-opaque {
    transform: none; opacity: 1; z-index: 103;   /* выше точек угла ⋯ (z 102), чипс с ними не пересекается: точки — ниже кромки на 3 px */
    background: var(--surface-card, #ffffff); color: var(--text-color, #2f3b52);
    border: 1px solid var(--surface-border, #d5d9e2); border-radius: 6px; box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
    font-size: 12px; font-weight: 600; line-height: 18px; padding: 1px 8px; font-stretch: normal;
}
.widget-container > .segment-title.kind-badge-overlay.kind-badge-opaque .pi-header-pi { font-size: 12px; }
.widget-container > .segment-title.kind-badge-overlay.kind-badge-opaque.segment-title-open { z-index: 10000; }
/* IE 2026 11 03 / ODOO-350449 (заказ Игоря: p220/p221/p222 шапка віджета): p220 — край виджета → глиф иконки вида → текст заголовка: равные 8 px (было 5,9 и 8,4 px — замер dev02 fe-…-144);
   ширина якоря и высота строки прежние, наведение ничего не сдвигает. Выключатель fe.ux.widgetHeaderSpacing = false — прежние отступы.
   Отступ слева: 8px − padding шапки (0.3rem) − поле якоря вокруг глифа ((1.25rem − 1rem) / 2); справа: 8px − поле якоря − padding поля заголовка (0.125rem) */
.WIDGET:not(.widget-float-header) > .widget-container.hdr-spacing > .kind-badge-ico { margin-left: calc(8px - 0.425rem); margin-right: calc(8px - 0.25rem); }   /* открытая панель — инверсия ярлыка над панелью, как у .segment-title-open */
/* IE 2026 09 10 / ODOO-… (заказ Игоря): индикатор каскада в чипе сегмента — как бейдж вкладки каскада: пилюля с иконкой,
   жёлто-коричневая (#c98a12, как .badge-dirty) при грязных узлах на источниках */
.segment-title .cascade-ind { display: inline-flex; align-items: center; justify-content: center; margin: 0 2px 0 4px; width: 15px; height: 15px; padding: 0; box-sizing: border-box; border-radius: 50%; background: rgba(255, 255, 255, .92); color: var(--cs-accent, #647eff); font-size: 9px; line-height: 1; font-stretch: normal; cursor: pointer;
    /* IE 2026 09 10 (замечание Игоря «не по центру»): чип — блок с font-size 1.3rem и line-height normal (≈1.15em → 21px);
       пилюля выравнивается по верху строки и сдвигается на половину разницы высот (в rem: em здесь — 9px самой пилюли);
       vertical-align: middle ставил её ниже центра на 1,5px */
    vertical-align: top; position: relative; top: calc(0.75rem - 7.5px); }
.segment-title .cascade-ind i { display: block; width: 9px; height: 9px; font-size: 9px; line-height: 9px; text-align: center; position: relative; left: -1px; }   /* IE 2026 09 10 / ODOO-… (заказ Игоря): глиф share-alt (два узла справа) на 1px влево — оптический центр */
.segment-title .cascade-ind.cascade-ind-dirty { background: #c98a12; color: #fff; }
.segment-title.segment-mode .cascade-ind { margin: 0; position: static; top: auto; vertical-align: baseline; }   /* чип DS | MV — flex, центрирует сам */
.segment-title.segment-mode { cursor: default; display: inline-flex; align-items: center; gap: 0.3rem; padding: 0 0.3rem; box-sizing: border-box; min-height: 1.15em; }   /* высота = обычный бейдж сегмента (font 1.3rem, line-height normal ≈ 21 px) */
.segment-mode .segment-mode-switch {
    display: inline-flex; align-items: center; align-self: center; border: 1px solid rgba(255, 255, 255, .8);
    border-radius: 10px; overflow: hidden; font-size: 11px; line-height: 16px; font-weight: 600; font-stretch: normal; background: rgba(255, 255, 255, .25);
}
.segment-mode .dropdown-panel-mode-btn { padding: 0 7px; color: #fff; }
.segment-mode .dropdown-panel-mode-btn:hover { background: rgba(255, 255, 255, .25); }
.segment-mode .dropdown-panel-mode-active, .segment-mode .dropdown-panel-mode-active:hover { background: #fff; color: var(--cs-accent, #647eff); }

/* transition */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter-from {
  opacity: 0;
}
.fade-slide-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* dropdown */
/* IE 2026 08 19 / ODOO-5512 (заказ Игоря): встроенный табличный список настроек */
.chips-dropdown:has(.dropdown-settings-grid) {
    max-height: 90vh; /* IE 2026 09 04 / ODOO-336331: высоту задаёт автоподбор в границах виджета (было 620px) */
    /* IE 2026 08 19 (заказ Игоря п.3): скроллит только сама таблица —
       второй (внешний) горизонтальный скролл контейнера убран */
    overflow: hidden;
}
/* IE 2026 08 19 (заказ Игоря): дропдаун настроек — узнаваемая панель селектора,
   а не «свободный виджет без заголовка»: окантовка как у выделенного виджета,
   «вытекающая» из segment-title (триггер — вкладка, слитая с панелью).
   Строка-шапка «Widget settings» скрыта по просьбе Игоря (код оставлен) */

.dropdown-tabs-row {
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
}
.chips-dropdown:has(.dropdown-settings-grid) .dropdown-tabs-row {
    overflow: hidden;
}
.dropdown-panel-header {
    display: none; /* IE 2026 08 19: «не совсем то» — пока скрыта (Igor) */
    /* display: flex; */
    align-items: center;
    gap: 0.45rem;
    flex: none;
    padding: 0.35rem 0.6rem;
    background: var(--surface-100, #f3f5f8);
    border-bottom: 1px solid var(--surface-border, #dee2e6);
    font-size: 0.82rem;
    color: var(--text-color-secondary, #6c757d);
    cursor: default;
}
.dropdown-panel-header > .pi-sliders-h {
    color: var(--cs-accent, #647eff);
}
/* IE 2026 09 04 / ODOO-336331 (заказ Игоря): тумблер Settings | Variants в заголовке вкладки панели.
   Стоит СРАЗУ ЗА заголовком, а не прижат к правому краю: шапка вкладки шириной с грид (920px / ширина
   панели при ресайзе) шире видимой области панели, и правый край с тумблером уходил за обрез
   (overflow hidden) — тумблер был в DOM, но не на экране (IE 2026 09 04 / ODOO-336331). */
.dropdown-tab-header .dropdown-panel-mode {
    display: inline-flex; margin-left: 10px; border: 1px solid var(--surface-border, #cbd5e1);
    border-radius: 12px; overflow: hidden; font-size: 11px; line-height: 18px; font-weight: 500; flex: none;
}
.dropdown-panel-mode-btn { padding: 0 9px; cursor: pointer; color: var(--text-color-secondary, #64748b); user-select: none; }
.dropdown-panel-mode-btn:hover { background: rgba(0, 0, 0, .05); }
.dropdown-panel-mode-active, .dropdown-panel-mode-active:hover { background: var(--cs-accent, #647eff); color: #fff; }
/* IE 2026 09 04 / ODOO-336331 (заказ Игоря): счётчик вариантов — бейджем-кружком в правом верхнем углу кнопки,
   как счётчик на чипсе (.chip-badge в AttrChips); белое кольцо — виден и на активной (акцентной) кнопке */
.dropdown-panel-mode-btn { position: relative; }
.dropdown-panel-mode-count {
    position: absolute; top: -7px; right: -6px;
    min-width: 14px; height: 14px; padding: 0 4px; box-sizing: border-box;
    border-radius: 10px; border: 1px solid #fff;
    background: var(--cs-accent, #647eff); color: #fff;
    font-size: 9px; font-weight: 700; line-height: 12px; text-align: center;
    display: inline-flex; align-items: center; justify-content: center;
    opacity: 1; z-index: 1; pointer-events: none;
}
.dropdown-tab-header .dropdown-panel-mode { overflow: visible; }
/* IE 2026 09 04 / ODOO-336331 (заказ Игоря): чекбокс Default в списке вариантов — обычный вид, а не блёклый disabled
   (колонка read-only: переключение идёт через cellClick_method, клик по инпуту отдаём ячейке) */
.settings-list-grid .wj-cell input[type=checkbox] { opacity: 1; accent-color: var(--cs-accent, #647eff); pointer-events: none; cursor: pointer; }
.variant-label { font-weight: 500; }
.variant-label-pi { font-size: 11px; margin-right: 3px; opacity: .8; } /* IE 2026 09 04 / ODOO-336331: иконка варианта в чипе */
.dropdown-panel-title {
    font-weight: 600;
    color: var(--text-color, #495057);
    white-space: nowrap;
}
.dropdown-panel-widget {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    opacity: 0.8;
}
.dropdown-panel-close {
    flex: none;
    cursor: pointer;
    padding: 2px;
    border-radius: 3px;
}
.dropdown-panel-close:hover {
    background: var(--surface-200, #e9ecef);
}
.segment-title-open {
    /* ИНВЕРСИЯ ярлыка при открытой панели (заказ Игоря 20.08, IE 2026 08 20 /
       ODOO-5512): тёмный текст на белом, рамка ЦВЕТА ЯРЛЫКА (--sd-acc из
       toggleDropdown) обтекает таб и переходит в рамку панели; под табом
       бордюра нет (белая маска ::before гасит верхнюю границу панели и линию
       шапки виджета), справа снизу — скругление-переход в границу панели
       (::after). Отрицательные маргины компенсируют толщину рамки, чтобы
       ярлык не прыгал. z выше панели (у неё 9999). */
    position: relative;
    z-index: 10000;
    /* important: темы красят .segment-title своим фоном/радиусом селектором
       сильнее каскада — без important инверсия превращалась в сплошной блоб
       (реальный случай в теме Игоря 20.08) */
    background: white !important;
    color: var(--sd-acc, var(--cs-accent, #647eff)) !important;
    border: 2px solid var(--sd-acc, var(--cs-accent, #647eff)) !important;
    border-bottom: none !important;
    border-radius: 8px 8px 0 0 !important;
    margin: -2px -2px 0;
}
.segment-title-open .pi-header-pi,
.segment-title-open .dropdown-chevron {
    color: inherit !important;
}
/* шва и дуги-скругления больше нет: панель поднята на 2px под таб (top =
   rect.bottom − 2), белое тело таба с z выше само накрывает её границу и
   линию шапки — стык чистый в любой теме (заказ Игоря 20.08: цвета рамок
   разные / нижний бордюр / артефакты под скруглением) */
/* IE 2026 08 20 (заказ Игоря): тултипы кнопок ВНУТРИ дропдауна настроек —
   wj-tooltip имеет z-index 1500 и рисовался ПОД панелью (z 9999) */
.wj-tooltip {
    z-index: 20001 !important;
}
/* IE 2026 08 20 (заказ Игоря): ховер-оверлей табов при скрытой строке табов */
/* IE 2026 08 23 / ODOO-5884: бейдж COW-копии / рабочей версии */
.cow-badge { position: relative; display: inline-flex; align-items: center; gap: 4px; margin: 0 6px 0 2px; padding: 1px 7px; border-radius: 10px;
    font-size: 11px; font-weight: 600; letter-spacing: .2px; cursor: pointer; user-select: none; white-space: nowrap; }
.cow-badge i { font-size: 11px; }
.cow-badge-copy { background: #e3f1ff; color: #1d5fa8; border: 1px solid #9cc5f0; }
.cow-badge-working { background: #f3f3f3; color: #555; border: 1px solid #c9c9c9; }
/* IE 2026 08 28 / ODOO-5800: бейдж «Reference view» (копия из теста данных) — зелёный, «эталон» */
.cow-badge-refview { background: #e8f7ec; color: #1e7b34; border: 1px solid #9ed7ae; }
/* IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита): бейдж «⇄ N» формы аудита и меню режимов — индиго, как сравнение */
.adf-badge-ok, .adf-menu-btn { background: #eef2ff; color: #4f46e5; border: 1px solid #c7d2fe; }
.adf-badge-none, .adf-badge-first { background: #f3f3f3; color: #555; border: 1px solid #c9c9c9; }
.adf-badge-pending { background: #eef2ff; color: #6366f1; border: 1px dashed #c7d2fe; }
.adf-badge-unavailable { background: #fef3c7; color: #b45309; border: 1px solid #fcd34d; }
.adf-pop { min-width: 380px; max-height: 60vh; overflow: auto; }
.adf-pop-close { float: right; cursor: pointer; color: #888; }
.adf-nav-pos { align-self: center; color: #666; }
.adf-mode { color: #666; }
.adf-list { border-collapse: collapse; width: 100%; margin-top: 8px; font-size: 11px; }
.adf-list th, .adf-list td { text-align: left; padding: 2px 6px; border-bottom: 1px solid #eee; white-space: nowrap; max-width: 220px; overflow: hidden; text-overflow: ellipsis; }
.adf-list th { color: #777; font-weight: 600; }
.adf-list-go { cursor: pointer; }
.adf-list-go:hover td { background: #eef2ff; }
.adf-menu { min-width: 240px; padding: 4px 0; }
.adf-menu-cap { color: #888; font-size: 11px; padding: 4px 12px 2px; }
.adf-menu-item { display: flex; align-items: center; gap: 8px; padding: 4px 12px; cursor: pointer; }
.adf-menu-item:hover { background: #eef2ff; }
.adf-menu-item.adf-on { color: #4f46e5; font-weight: 600; }
.adf-menu-item .pi-circle { visibility: hidden; }
.ref-badge-link { color: #2a62d9; cursor: pointer; text-decoration: underline; }
.ref-badge-link:hover { color: #1d4fb8; }
.cow-pop { position: absolute; top: 20px; left: 0; z-index: 1200; min-width: 360px; max-width: 560px; padding: 10px 12px; background: #fff; color: #333;
    border: 1px solid #cfd8e3; border-radius: 6px; box-shadow: 0 6px 18px rgba(0,0,0,.18); font-weight: 400; font-size: 12px; line-height: 1.45; white-space: normal; cursor: default; }
.cow-pop-title { font-weight: 600; margin-bottom: 6px; }
.cow-pop-row { margin: 2px 0; }
.cow-delta { padding: 4px 6px; border-radius: 4px; margin: 6px 0; font-weight: 600; }
.cow-delta-positive { background: #e8f7ec; color: #1e7b34; }
.cow-delta-negative { background: #fdecec; color: #b42318; }
.cow-pop-actions { display: flex; gap: 8px; margin-top: 8px; flex-wrap: wrap; }
/* IE 2026 08 23 / ODOO-5884 (заказ Игоря): свои кнопки панели — стабильный размер (без ховер-анимаций темы), отступ иконка/текст */
.cow-btn { display: inline-flex; align-items: center; gap: 7px; font-size: 12px; font-weight: 600; line-height: 1.2; padding: 6px 10px;
    border-radius: 4px; border: 1px solid transparent; cursor: pointer; white-space: nowrap; transition: background-color .15s, border-color .15s; }
.cow-btn i { font-size: 12px; }
.cow-btn-white { background: #fff; color: #2a62d9; border-color: #b9c8dd; }
.cow-btn-white:hover { background: #eef4ff; border-color: #9cc5f0; }
.cow-btn-apply { background: #1f9d55; color: #fff; border-color: #1f9d55; }  /* IE 2026 08 25 / ODOO-5884 */
.cow-btn-apply:hover { background: #1b8a4b; border-color: #1b8a4b; }
.cow-btn-danger { background: #e24c4c; color: #fff; border-color: #e24c4c; }
.cow-btn-danger:hover { background: #cf3d3d; border-color: #cf3d3d; }
/* IE 2026 08 27 / ODOO-5800 (заказ Игоря): невидимая полоса-граница шапка/тело (8px: 4px в
   паддинге шапки + 4px тела) — держит мышь → оверлей табов; клики не перехватывает по смыслу
   (пустая кромка), pointer-events даёт .widget-container > * */
.tabs-hover-zone {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -4px;
    height: 8px;
    z-index: 5;
    cursor: default;
    background: transparent;
}
.tabs-hover-pop {
    position: fixed;
    z-index: 10001;
    display: flex;
    align-items: center;
    gap: 2px;
    padding: 4px 6px;
    background: white;
    border: 1px solid var(--surface-border, #dee2e6);
    border-radius: 8px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
}
.tabs-hover-item {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 8px;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
    color: var(--text-color, #495057);
    font-size: 12px;
}
.tabs-hover-item:hover {
    background: var(--surface-hover, #e9ecef);
}
.tabs-hover-item.tabs-hover-active {
    background: var(--surface-200, #e9ecef);
    font-weight: 600;
}
.tabs-hover-item {
    position: relative;
}
.tabs-hover-badge {
    /* как .badge строки табов (AttrTabPanel) */
    position: absolute;
    top: -3px;
    right: -2px;
    background-color: var(--cs-accent, rgba(100, 119, 239, 0.6));
    color: #ffffff;
    border-radius: 12px;
    padding: 1px 4px;
    font-size: 7px;
    font-weight: bold;
    line-height: 10px;
    z-index: 1;
}
/* IE 2026 08 20 (заказ Игоря): шрифт таблицы настроек попроще — групповые
   (родительские) строки дерева wijmo по умолчанию жирные, здесь почти каждая
   строка групповая и весь список выглядел жирным */
.settings-list-grid .wj-cell,
.settings-list-grid .wj-cell.wj-group {
    /* important: wijmo/тема красят групповые строки жирным сильнее каскада */
    font-weight: 400 !important;
}
/* IE 2026 08 19 (заказ Игоря): «осталась подчёркивание в первой колонке» —
   горизонтальные пунктиры секций дерева гасим только в этой таблице;
   вертикальные пунктиры (выделение подчинённых) и зазоры секций остаются */
.settings-list-grid .cell-delivery-top-border {
    display: none;
}
/* IE 2026 08 20 (заказ Игоря): «внизу лишняя полоса горизонтальной прокрутки» —
   псевдоэлемент полосы выделения (.wj-marquee::after, right:-100000px) раздувал
   scrollWidth скроллера wijmo; в этой таблице полоса-подчёркивание и не нужна */
.settings-list-grid .wj-marquee::after {
    content: none;
}
/* IE 2026 08 20: бордюры строк убирает универсальное свойство таблицы
   borders:'None' (grid-borders-none в AttrGrid), спец-CSS не нужен */
.dropdown-settings-grid {
    /* IE 2026 09 04 / ODOO-336331 (заказ Игоря): ширина/высота — от панели (вкладка .dropdown-tab-grid тянется),
       а не фиксированные 920px / inline-height: раньше грид был шире и выше видимой области панели, панель
       (overflow hidden) срезала его правый край вместе с вертикальной полосой прокрутки и низ */
    width: auto;
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 4px 6px 6px;
}
/* IE 2026 09 15 / ODOO-… (замечание Игоря, вечер): строка «Save as new» под деревом настроек / вариантов */
.dropdown-settings-footer { flex: none; border-top: 1px solid var(--surface-border, #dee2e6); margin-top: 4px; padding: 4px 2px 0; }
.dropdown-settings-footer .dropdown-settings-save { display: inline-flex; align-items: center; gap: 6px; padding: 4px 8px; border-radius: 6px; cursor: pointer; font-size: 13px; }
.dropdown-settings-footer .dropdown-settings-save:hover { background: var(--surface-hover, #e9ecef); }
/* IE 2026 09 04 / ODOO-336331 (заказ Игоря): узкая панель (ширина < список 680 + Favorites) — Favorites ПОД списком:
   строка вкладок становится колонкой с прокруткой, список тянется и держит минимум ~2 строки + панель команд */
.chips-dropdown.widget-settings-dropdown.sd-narrow .dropdown-tabs-row {
    flex-direction: column;
    overflow: hidden auto;
}
.chips-dropdown.widget-settings-dropdown.sd-narrow .dropdown-tab.dropdown-tab-grid {
    flex: 1 1 auto;
    min-height: 150px;
    border-right: none;
}
.chips-dropdown.widget-settings-dropdown.sd-narrow .dropdown-tab:not(.dropdown-tab-grid) {
    flex: none;
    border-right: none;
    border-top: 1px solid var(--surface-border, #dee2e6);
}
.chips-dropdown.widget-settings-dropdown.sd-narrow .dropdown-settings-grid {
    min-height: 110px;
}
.chips-dropdown.widget-settings-dropdown.sd-narrow .dropdown-settings-grid > .attr-grid > .wj-flexgrid {
    min-height: 100px;
}
/* вкладка со списком: колонка на всю панель; соседняя Favorites остаётся flex:none */
.dropdown-tab.dropdown-tab-grid {
    flex: 1 1 auto;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
}
.dropdown-tab.dropdown-tab-grid > .dropdown-tab-header { flex: none; }
/* хост FlexGrid внутри .attr-grid — ровно оставшаяся высота (иначе wijmo растёт по содержимому,
   и прокрутки нет — её съедал overflow панели) */
.dropdown-settings-grid > .attr-grid {
    display: flex;
    flex-direction: column;
}
.dropdown-settings-grid > .attr-grid > .wj-flexgrid {
    flex: 1 1 auto;
    min-height: 0;
    height: auto;
}
.dropdown-settings-grid > * {
    /* IE 2026 08 20 (заказ Игоря «выровнять кверху»): AttrGrid — Vue-фрагмент
       из нескольких корневых узлов; flex 1 1 auto растягивал и декоративные
       (grid-top-line съедал ~230px над строками). Тянется ТОЛЬКО контейнер грида */
    flex: 0 0 auto;
    min-height: 0;
}
.dropdown-settings-grid > .attr-grid {
    flex: 1 1 auto;
    min-height: 0;
}
.dropdown-settings-grid > .grid-top-line {
    /* это КОМАНДНАЯ ПАНЕЛЬ грида (кнопки+чипсы+теги; базово opacity:0 до ховера);
       flex:0 0 auto выше уже не даёт ей растягиваться, а в дропдауне она
       видима всегда */
    opacity: 1;
}
.chips-dropdown {
    position: fixed;
    z-index: 9999;
    background: white;
    border: 1px solid var(--surface-border);
    border-radius: 6px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.15);
    display: flex;
    max-width: 90vw;
    max-height: 400px;
    overflow: auto;
}
/* IE 2026 08 20: рестайл ТОЛЬКО дропдауна настроек виджета (классом
   widget-settings-dropdown) — базовый .chips-dropdown общий с глобальным
   дропдауном чипсов (AttrChips), рестайл базового ломал его раскладку
   (вертикальный блок Params ложился вниз) */
/* IE 2026 09 04 / ODOO-336331 (заказ Игоря): до первого подбора размера (нет прошлого) панель невидима — без «ползания» */
.chips-dropdown.widget-settings-dropdown.sd-sizing { visibility: hidden; }
.chips-dropdown.widget-settings-dropdown {
    /* окантовка ЦВЕТА ЯРЛЫКА (--sd-border из toggleDropdown), «вытекающая»
       из segment-title (заказ Игоря; IE 2026 08 20 / ODOO-5512) */
    border: 2px solid var(--sd-border, var(--cs-accent, #647eff));
    border-radius: 0 10px 10px 10px;
    /* IE 2026 08 20 (заказ Игоря): адекватная ширина по умолчанию + ресайз
       МЫШКОЙ (нативный уголок; размер запоминается на время сессии виджета) */
    width: 680px;
    /* IE 2026 09 04 / ODOO-336331: min-width 680 — уже этой ширины секция Favorites ложится поверх списка
       (ручной ресайз до 520px ломал вёрстку); min-height = шапка + командная панель + 2 строки */
    min-width: 680px;
    min-height: 220px;
    max-height: 82vh; /* база ограничивала 400px — мешало ресайзу вверх */
    resize: both;
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.2);
    flex-direction: column;
}
.dropdown-tab {
    flex: none;
    white-space: nowrap;
    border-right: 1px solid var(--surface-border, #dee2e6);
}
.dropdown-tab:last-child {
    border-right: none;
}
.dropdown-tab-header {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 12px;
    font-weight: 600;
    font-size: 14px;
    border-bottom: 1px solid var(--surface-border, #dee2e6);
    color: var(--text-color);
}
.dropdown-tab-header-action {
    cursor: pointer;
}
.dropdown-tab-header-action:hover {
    background-color: var(--surface-hover, #e9ecef);
}
.dropdown-tab-header i {
    font-size: 14px;
}
.dropdown-tab-items {
    padding: 4px 0;
}
.dropdown-tab-item {
    display: flex;
    align-items: center;
    padding: 6px 12px;
    cursor: pointer;
    font-size: 13px;
    position: relative;
}
.dropdown-tab-item-nested {
    padding-left: 24px;
}
.dropdown-tab-subtitle {
    padding: 6px 12px 2px;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-color-secondary, #999);
    border-top: 1px solid var(--surface-border, #dee2e6);
    margin-top: 4px;
}
.dropdown-tab-item:hover {
    background-color: var(--surface-hover, #e9ecef);
}
.dropdown-tab-item-check {
    cursor: pointer;
    margin-right: 6px;
    font-size: 14px;
    color: var(--primary-color, #2196f3);
}
.dropdown-tab-item-check.pi-stop {
    color: var(--text-color-secondary, #999);
}
.dropdown-tab-item-title {
    flex: 1;
}
.dropdown-tab-item-current {
    font-weight: 600;
}
.dropdown-tab-item-current-icon {
    position: absolute;
    left: 0px;
    font-size: 10px;
}
.dropdown-tab-item-meta {
    margin-left: 12px;
    font-size: 11px;
    color: var(--text-color-secondary, #999);
    white-space: nowrap;
}
.dropdown-tab-item-clone {
    margin-left: 8px;
    font-size: 12px;
    color: var(--text-color-secondary, #999);
    opacity: 0;
    flex-shrink: 0;
}
.dropdown-tab-item:hover .dropdown-tab-item-clone {
    opacity: 0.5;
}
.dropdown-tab-item-clone:hover {
    opacity: 1 !important;
    color: var(--primary-color, #2196f3);
}
.dropdown-tab-item-current-icon {
    color: #f59e0b;
    filter: drop-shadow(0 0 4px #f59e0b88);
    animation: pulse-glow 1.8s ease-in-out infinite;
}

@keyframes pulse-glow {
    0%, 100% { filter: drop-shadow(0 0 3px #f59e0b88); }
    50%       { filter: drop-shadow(0 0 7px #f59e0bcc); }
}
.dropdown-tab-item.tree-dragging {
    opacity: 0.4;
}
.dropdown-tab-item.tree-drop-before::before,
.dropdown-tab-item.tree-drop-after::after {
    content: '';
    position: absolute;
    left: var(--drop-indent, 12px);
    right: 8px;
    height: 2px;
    border-radius: 1px;
    background: var(--primary-color, #2196f3);
    pointer-events: none;
}
.dropdown-tab-item.tree-drop-before::before {
    top: -1px;
}
.dropdown-tab-item.tree-drop-after::after {
    bottom: -1px;
}
.dropdown-tab-item.tree-drop-inside {
    background-color: var(--primary-50, #e3f2fd);
    box-shadow: inset 0 0 0 2px var(--primary-color, #2196f3);
    border-radius: 4px;
}
/* IE 2026 09 03 / ODOO-11316: диалог несохранённых правок на теле виджета */
.widget-unsaved-ask {
    position: absolute; inset: 0; z-index: 90;
    display: flex; align-items: center; justify-content: center;
    background: rgba(255, 255, 255, .55); backdrop-filter: blur(1.5px);
}
.widget-unsaved-ask-box {
    max-width: 26rem; padding: .9rem 1.1rem; background: #fff;
    border: 1px solid #e3e6ef; border-radius: .5rem;
    box-shadow: 0 6px 24px rgba(60, 70, 110, .18);
}
.widget-unsaved-ask-box .wua-title { font-weight: 600; margin-bottom: .35rem; color: #b58900; font-size: .9rem; }
.widget-unsaved-ask-box .wua-title .pi { margin-right: .35rem; }
.widget-unsaved-ask-box .wua-text { font-size: .82rem; color: #495057; margin-bottom: .7rem; }
.widget-unsaved-ask-box .wua-buttons { display: flex; gap: .4rem; flex-wrap: wrap; }
.widget-unsaved-ask-box .wua-btn {
    border: 1px solid #ced4da; background: #fff; color: #495057;
    border-radius: .35rem; padding: .3rem .6rem; font-size: .8rem; cursor: pointer; white-space: nowrap;
}
.widget-unsaved-ask-box .wua-btn:hover { background: #f4f6fb; }
.widget-unsaved-ask-box .wua-save { background: #5e72e4; border-color: #5e72e4; color: #fff; }
.widget-unsaved-ask-box .wua-save:hover { background: #4c61d8; }
.widget-unsaved-ask-box .wua-save .pi { margin-right: .3rem; font-size: .75rem; }
.widget-unsaved-ask-box .wua-discard { color: #c0392b; border-color: #e5b8b2; }
.widget-unsaved-ask-box .wua-discard:hover { background: #fbeeec; }
</style>
